export const WebPages = [
    `<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1
                    </td>
                    <td>
                        Былыргы быһылааннаах дьыл <span class="description" id="1">мындаатыгар</span>,<br>
                        Урукку охсуһуулаах дьыл <span class="description" id="2">уорҕатыгар</span>,<br>
                        Алдьархайдаах ааспыт дьыл анараа кытыытыгар<br>
                        Сир-сибиир хайдах үөскээбит диэммин<br>
                        Эргитэ-урбата көрбүтүм:<br>
                        <span class="description" id="3">Сири иһит</span> <span class="description" id="4">сиксигин</span> курдук,<br>
                        Ситэн эргичийэн үөскээбит эбит.<br>
                        Тииҥ кыылым тиҥилэҕин тириитин<br>
                        Тэнитэ тарпыт курдук,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        10
                    </td>
                    <td>
                        Тэнийбит, тэлгэммит эбит.<br>
                        Ураанай <span class="description" id="5">кыылым</span> туоһахтатын ойуутун<br>
                        Ууннары тарпыт курдук,<br>
                        Унаарыйан туругуран үөскээбит эбит.<br>
                        Хаһыытаатар да кыайан <span class="description" id="6">халбалдьыйбат</span><br>
                        Хара таас хаппахтаммыт,<br>
                        Сыстахха да кыайан <span class="description" id="7">сылааньньыйбат</span><br>
                        <span class="description" id="8">Ньыгыл</span> таас сыттыктаах эбит,<br>
                        Тэбиэлээтэххэ да кыайан <span class="description" id="9">тэлгэлдьийбэт</span><br>
                        Дэриэспэ таас тэлгэхтэммит эбит.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        20
                    </td>
                    <td>
                        Устата биллибэт Ураабыл муора<br>
                        Ойоҕостоммут эбит,<br>
                        Түгэҕэ биллибэт Түмэри байҕал<br>
                        Түгэхтэммит эбит.<br>
                        Үөһээ өттүн өрө көрбүтүм:<br>
                        Киирбэт күндүл маҕан күннээх,<br>
                        Саспат сандал маҕан ыйдаах,<br>
                        <span class="description" id="10">Сиэмэлэс мас</span> эккиннээх,<br>
                        <span class="description" id="11">Сиибиктэ</span> күөх от үктэллээх,<br>
                        Сиэркилэ уу <span class="description" id="12">түһэлгэлээх</span>,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        30
                    </td>
                    <td>
                        Хара тыа <span class="description" id="13">олбохтоох</span>,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        31
                    </td>
                    <td>
                        Сиртэн <span class="description" id="14">ситии</span> саҕа ситимнээх,<br>
                        Халлаантан сап саҕа тардыылыктаах<br>
                        Аҕыс <span class="description" id="15">иилээх-саҕалаах</span>,<br>
                        <span class="description" id="16">Атааннаах-мөҥүөннээх</span>,<br>
                        <span class="description" id="17">Алы-намык</span>, <span class="description" id="18">айгыр-силик</span><br>
                        Аан ийэ дойду аатыран<br>
                        Айгыстан үөскээбитэ эбитэ үһү.<br>
                        Ити үөскээбитин —<br>
                        Ото-маһа хайдаҕый эбит диэммин,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        40
                    </td>
                    <td>
                        Уоннаах оҕо сылдьаммын<br>
                        <span class="description" id="19">Очуос</span> таас хайатын үрдүгэр таххан* тураммын,<br>
                        Уоннаах хаччы саҕа уу харахпынан<br>
                        <span class="description" id="20">Олоор-молоор</span> одуулаан көрбүтүм,<br>
                        Арҕаа баһыгар бараммын<br>
                        Алталаах оҕо эрдэхпиттэн<br>
                        Алтан хаччы курдук<br>
                        <span class="description" id="21">Арылхай</span> көмүс харахпынан<br>
                        Арадьдьыта уларыта көрөн турбутум —<br>
                        Уот-татай, оҕолоор,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        50
                    </td>
                    <td>
                        Тоҕо көрбүккүнүй диэтэргит,<br>
                        Кэлэр <span class="description" id="22">кэнэҕэски</span> ыччакка кэпсээри,<br>
                        Кэпсэл да оҥостоойобун диэммин<br>
                        Кэриччи көрбүтүм эбээт, доҕоор!<br>
                        Мэссээн нууча кыргыттара<br>
                        Биэлэй күөх солкоттон тутуһан<br>
                        Биэрэк сиргэ киирэннэр үҥкүүлээн<br>
                        <span class="description" id="23">Мэтэлдьиһэн</span>  эрэллэрин курдук<br>
                        <span class="description" id="24">Бэрдьигэс мастаах</span> эбит ээ!<br>
                        Атыыһыт саха кыргыттара
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        60
                    </td>
                    <td>
                        Аалай күөх солкоттон тутуһан,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        61
                    </td>
                    <td>
                        Ааттаах сир аартыгар ас биэрэн<br>
                        Айбалдьыһан эрэллэрин курдук<br>
                        Аалай солко хахыйахтаах эбит, ээ!<br>
                        Кытай омук сириттэн<br>
                        <span class="description" id="25">Кылбаҕар</span> бэйэлээх,<br>
                        <span class="description" id="26">Кынталлыбыт</span> быһыылаах,<br>
                        <span class="description" id="27">Кылдьыылаах</span> харахтаах,<br>
                        Кырааскалаах тумустаах,<br>
                        <span class="description" id="28">Кырыымпанан</span> куоластаах
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        70
                    </td>
                    <td>
                        Кыталык кыыл кэлэн<br>
                        Сэттэ түүннээх күнү мэлдьи<br>
                        Кытыытын кырыйа көтөн,<br>
                        Кынтас кына түһэн,<br>
                        Кырыылаах тумсунан<br>
                        Кыһыл чиэрбэни<br>
                        Кыайан <span class="description" id="29">кытаахтаан</span>  сиэбэтэх,<br>
                        <span class="description" id="30">Кырпа</span>  бөҕө кыайан сыстыбатах<br>
                        <span class="description" id="31">Кыйдам маҕан</span><br>
                        <span class="description" id="32">Кырдаллардаах</span> эбит, эбээт!
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        80
                    </td>
                    <td>
                        Түүр омук дойдутуттан<br>
                        <span class="description" id="33">Дуодаллыбыт</span> сотолоох,<br>
                        <span class="description" id="34">Дьоҥхоҕор</span> уҥуохтаах,<br>
                        <span class="description" id="35">Чоккуруос</span> харахтаах,<br>
                        Оҥоруу көмүс тумустаах,<br>
                        <span class="description" id="36">Сомоҕо көмүс</span> түүлээх,<br>
                        <span class="description" id="37">Хормуоньньа</span> курдук куоластаах<br>
                        Туруйа кыыл обургу<br>
                        Тоҕус түүннээх күнү мэлдьи<br>
                        Тула көтөн кэлэн
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        90
                    </td>
                    <td>
                        <span class="description" id="38">Дуокарыс гына</span>  олоро түһэн,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        91
                    </td>
                    <td>
                        Тойон тумсунан<br>
                        Токур чиэрбэни<br>
                        Тоҥсуйан булан сиэбэтэх,<br>
                        Тобурах тохтооботох,<br>
                        <span class="description" id="39">Дьулаагыр маҕан</span><br>
                        <span class="description" id="40">Толооннордоох</span>  эбит, эбээт!<br>
                        Бу курдук <span class="description" id="41">босуомнанан</span>,<br>
                        <span class="description" id="42">Буолунай</span> бөҕө толооннонон,<br>
                        <span class="description" id="43">Быйаҥнаах</span> бөҕө <span class="description" id="44">дьаарбаҥнанан</span> 
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        100
                    </td>
                    <td>
                        Бу аан ийэ дойду<br>
                        <span class="description" id="45">Буолатынан</span> үүнэн<br>
                        Бостуочунай Сибиир буолан<br>
                        Буолунай үөскээбит эбит.<br>
                        Ис өттүн көрбүтүм:<br>
                        <span class="description" id="46">Илэ-бодо</span> иэйэхсит бөҕө<br>
                        Иэнигийэн ооньньуур<br>
                        Иччилээх <span class="description" id="47">иэримэ</span> хонуулаах эбит.<br>
                        <span class="description" id="48">Ала-бааччы</span> айыыһыт бөҕө<br>
                        Аргыстаһан түһэн
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        110
                    </td>
                    <td>
                        <span class="description" id="49">Ахталыйан</span> ооньньуур<br>
                        Араҕас маҕан хонуулаах эбит.<br>
                        Ити тас өттүгэр<br>
                        Туруйа тохтуур <span class="description" id="50">тунаарыкта</span><br>
                        Толооннорун туораталаан,<br>
                        Кыталык кыстыыр <span class="description" id="51">кылбаарыкта</span><br>
                        Кырдалларын чиэрэстэтэлээн,<br>
                        Кэтэх өттүн кэриччи көрбүтүм —<br>
                        Кинээс бөҕө дьоннор<br>
                        Кэккэлэһэ хаамсан иһэллэрин курдук
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        120
                    </td>
                    <td>
                        <span class="description" id="52">Кэрискэ</span> хара тииттэрдээх эбит.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        121
                    </td>
                    <td>
                        Ол уҥуоргу өттүн одуулаабытым —<br>
                        <span class="description" id="53">Кулуба</span> тойон дьоннор<br>
                        Холбоһон хаамсан иһэллэрин курдук<br>
                        <span class="description" id="54">Куруҥ</span> хара ойуурдаах эбит.<br>
                        Бу ойуур уҥуоргу өттө —<br>
                        Хаҥалас улууһун дьахталлара<br>
                        Дьааһыктаах <span class="description" id="55">хампа</span> солколорун<br>
                        Хаалларбакка таҥнан,<br>
                        Урууга, ыһыахха бардыбыт диэн
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        130
                    </td>
                    <td>
                        <span class="description" id="56">Бааралаан</span> хаамсан,<br>
                        <span class="description" id="57">Лагладьдьыһан</span>* иһэллэрин курдук<br>
                        Арыынан <span class="description" id="58">алла турар</span><br>
                        <span class="description" id="59">Арыы чаллах чараҥнардаах</span> эбит.<br>
                        Ити кэтэх өттө —<br>
                        Киэҥ Килээбир үрэх буолан<br>
                        <span class="description" id="60">Кэҥкэйэн</span> <span class="description" id="61">кэриҥнэнэн</span> түспүт эбит.<br>
                        Ол уҥуоргу өттө —<br>
                        Уһун Улаабыр үрэх буолан<br>
                        Уһаан, улаатан түспүт эбит.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        140
                    </td>
                    <td>
                        Ол анараа өттө:<br>
                        <span class="description" id="62">Мотуок уута</span><br>
                        Булкуйан барыа диэн<br>
                        Буор хайанан <span class="description" id="63">боҕускаламмыт</span> эбит.<br>
                        Таас <span class="description" id="64">тарыҥ уута</span><br>
                        Алдьатан кээһэн ааһыа диэн<br>
                        Таас хайанан <span class="description" id="65">дьайыҥнаммыт</span> эбит.<br>
                        Ол уҥуоргу өттө,<br>
                        Тоҥус киһи <span class="description" id="66">туут хайыһарын</span><br>
                        Туруорута аспыт курдук,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        150
                    </td>
                    <td>
                        Туруук таас хайа буолан
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        151
                    </td>
                    <td>
                        Туруорута үүнэн тахсыбыт эбит, ээ.<br>Ол үөһээ өттө,<br>Киҥкиниир киэҥ халлаан диэкиттэн<br>Булчут киһи балаакката<br>Таҥнары намылыйан<br>Түһэн турарын курдук,<br>Халлааны кытта аалсыһан<br><span class="description" id="67">Хабырыһан</span> көрсөр<br>Хара таас хайа буолан барда эбээт.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        160
                    </td>
                    <td>
                        Ити кэлин өттүнэн:<br>«Бу маннык бэйэлээх алааһы,<br>Уот-татай, оҕолоор!» — дии санаан<br>Дөксө даҕаны чугуйан,<br>Оннубун булан туран,<br>Олоор-молоор одуулаан көрдүм.<br>Бу <span class="description" id="68">чугуйан</span> туран көрбүтүм —<br>Тоҕустуур саастаах<br><span class="description" id="69">Дуолан</span> атыыр оҕустар<br>Харсыһаары <span class="description" id="70">күрдьүөтэһэн</span> 
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        170
                    </td>
                    <td>
                        Туралларын курдук,<br>Тоҕус туой <span class="description" id="71">саар булгуньньах</span> <br>Толооннорун оттотугар<br><span class="description" id="72">Суксуруһан</span> үүммүттэр эбит, ээ.<br>Бу уҥа өттүгэр —<br><span class="description" id="73">Күннүк</span> төгүрүччүлээх,<br><span class="description" id="74">Көс</span> уорҕалаах<br>Улахан баараҕай<br>Туой саар булгуньньах<br>Туруору үүнэн тахсыбыта баар эбит ээ.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        180
                    </td>
                    <td>
                        Бу булгуньньах уу <span class="description" id="75">дьулайын</span>  одуулаабытым:
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        181
                    </td>
                    <td>
                        Сиртэн ситии саҕа ситимнээх,<br>Халлаантан сап саҕа тардыылыктаах<br>Аҕыс салаалаах<br>Аал Дуук Мас барахсан<br>Аатыран, айгыстан тахсыбыт эбит.<br>Маны көрбүтүм —<br>Кыһыл көмүс киистэлээх,<br>Үрүҥ көмүс <span class="description" id="76">туораахтаах</span>,<br>Хара көмүс хатырыктаах,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        190
                    </td>
                    <td>
                        <span class="description" id="77">Дьапта көмүс</span> туостаах,<br><span class="description" id="78">Аалыы көмүс</span> өҥнөөх<br>Ийэ дойду иччитэ кэлэн<br>Эриллэ ооньньуур, кырдьык да,<br>Ийэ хара тиитэ эбит ээ,<br>Аан дойду айыыһыттара кэлэн<br><span class="description" id="79">Саатыыр</span>, саһа ооньньуур<br>Аҕыс салаалаах<br>Аал Дуук Мас эбит, ээ.<br>Аҕыс салаатыгар
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        200
                    </td>
                    <td>
                        Хотун дьахтар тэллэҕин<br>Быһаҕаһын быһыта сыньньан<br>Таҥнарыта ыйаталаабыт курдук<br>Сиэрэй солко сэбирдэхтээх эбит.<br>Тойон киһи кымыс иһэр<br>Оһуор ойуулаах,<br><span class="description" id="80">Бочугурас</span> ойоҕостоох,<br><span class="description" id="81">Томторҕолоох</span> айахтаах <br><span class="description" id="82">Чороон ымыйаларын</span> <br>Таҥнарыта туппут курдук
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        210
                    </td>
                    <td>
                        <span class="description" id="83">Лоһуор  көмүс</span> туораахтаах эбит.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        211
                    </td>
                    <td>
                        Бу аҕыс салаата<br>Аҕыс ааттаах үрэх баһыгар тиийэннэр<br>Таҥнарыта намылыһан түспүттэр эбит.<br>Бу түһэн туран<br><span class="description" id="84">Араҥас илгэнэн</span> <br><span class="description" id="85">Чаллырҕаччы</span> таммалаабыта,<br><span class="description" id="86">Сөҥ</span> сүөгэйинэн<br><span class="description" id="87">Чөллүргэччи</span> сүүрүгүрбүтэ,<br><span class="description" id="88">Хаардаах бугул саҕа</span> буолан
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        220
                    </td>
                    <td>
                        Үрүҥ күүгэнинэн<br>Өрө үллүбүтэ.<br>Бу үллэн баран<br>Араҥас илгэ буолан<br>Сайылгылаан түспүт.<br>Бу түспүтүттэн<br>Аҕыс ааттаах үрэх бастара<br>Айгыстан, аатыран үөскээбиттэр.<br>Бу үөскээбититтэн<br>Эһэ, бөрө кэлэн маны аһаан-сиэн
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        230
                    </td>
                    <td>
                        Тэнигийэн элбээбит эбит.<br>Таба, тайах тарҕанан үөскээбит.<br>Итинтэн сир-дойду <span class="description" id="89">сииктэтэ</span> буолан<br>Тэнийэн-тэлгэнэн барбыта,<br>Буор дойду <span class="description" id="90">болбуктата</span> буолан<br><span class="description" id="91">Муҥутаан</span> тарҕаммыта.<br>Бу үөскээбититтэн —<br>Тоҥус, чукча туругурбут,<br>Киһи-сүөһү тэнийбит,<br>Аһаан-сиэн, атан-бөтөн олорбуттар,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        240
                    </td>
                    <td>
                        Үс саха онтон үөскээбит,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        241
                    </td>
                    <td>
                        Аҕыс саха онтон аатырбыт.<br>Орой салаатын өйдөөн көрбүтүм:<br>Үөһээ өттө <span class="description" id="92">үөр</span> туллук<br>Өрө көтөн тахсан иһэрин курдук<br>Үлүскэннээх Үүт Дьөһүөл <span class="description" id="93">аартыгынан</span> <br>Өрө үнэн тахсан барда.<br>Бу тиийэн туран көрбүтэ,<br>Чугуйан тохтоон толкуйдаабыта:<br>«Оорт-татай, оҕолоор!
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        250
                    </td>
                    <td>
                        Орто дойду аналлаах тиитэ буолан<br>Аан дойду иччититтэн ананан үөскээтэҕим,<br>Орто дойду кэлэр кэнчээри ыччатын<br>Харыстыахпын үчүгэй этэ.<br>Өрө көрдөххө —<br><span class="description" id="94">Өрөҕөтө</span> көҕөрөн көстөр<br><span class="description" id="95">Өндөл маҕан халлаан</span> <br>Үрүт өттүгэр үөскээбит<br><span class="description" id="96">Үлүскэннээх</span> үс <span class="description" id="97">бииһин ууһа</span> обургулар<br>Олороллор эбит ээ.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        260
                    </td>
                    <td>
                        Хара сылгы хабарҕатын<br>Хайа баттаабыт курдук<br>Хааннаах <span class="description" id="98">саньылҕа</span> хаан аартыктаах,<br>Илги-талгы <span class="description" id="99">талаһалаах</span>,<br>Тиэрэ-таары <span class="description" id="100">күргэлээх</span>,<br>Хара <span class="description" id="101">хорообуска</span> хонуулаах,<br><span class="description" id="102">Үөрбэ долоҕодоһун</span> олохтоох,<br><span class="description" id="103">Үҥүү</span>-<span class="description" id="104">батас</span> үктэллээх,<br><span class="description" id="105">Саа-саадах</span> кымньыылаах,<br>Бэлэһин төрдүгэр биэстээх сылгы
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        270
                    </td>
                    <td>
                        Тиэрэ түһэн сытарын курдук
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        271
                    </td>
                    <td>
                        <span class="description" id="106">Иҥсэ төрдө</span> дьиэлэммит,<br>Уолугар уоннаах оҕо<br>Умса түһэн утуйа сытарын курдук<br><span class="description" id="107">Обот иччитэ</span> олохсуйбут,<br>Сутуруо быатын саҕа<br>Сутурдаччылаах оботтоох,<br>Этэрбэс быатын саҕа<br><span class="description" id="108">Идэмэрдээх</span> иҥсэлээх<br>Уолуйан-таалыйан уһуктар
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        280
                    </td>
                    <td>
                        Улуу Хаан Тойон оҕоньньор<br>Улахан уола обургуну<br>Үөһээ үс бииһин уустара<br>Эриллэҕэс илиилэринэн илии баттааннар,<br>Сөрүөстүгэс <span class="description" id="109">сөмүйэлэринэн</span> сөбүлээннэр,<br>Такыр тарбахтарынан таланнар<br>Кинээс, кулуба оҥороору олордохторуна,<br>Эмэһэтин үүтүнэн тобулу үүнэн киирэн,<br>Төбөтүн оройунан дьөлө үүнэн тахсаммын<br>Сыптараҥ-дьөлгөрөҥ өлүү оҥоруом дуу?
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        290
                    </td>
                    <td>
                        Үөһээ үс бииһэ обургулары<br><span class="description" id="110">Үөдэн-таһаан</span> оҥороммун<br>Өлөрөн-сүтэрэн үүнэн тахсыам дуу?» — диэтэ.<br>Бу санаан баран<br>Тохтоон-чугуйан<br>Толкуйдаан турда.<br>«Орт-татай, оҕолоор!<br>Орто дойдуттан үүммүт мас буоллаҕым,<br>Өлүскэннээх үс бииһэ обургулар<br><span class="description" id="111">Кырыыстаах-таныардаах</span> буолуохтара
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        300
                    </td>
                    <td>
                        Бу кыраатахтарына,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        301
                    </td>
                    <td>
                        Сэбирдэхпиттэн хагдарыйаммын,<br>Үйэбин кылгатаммын<br>Охтон түһүөх бэйэкэм буоллаҕа.<br>Ол кэриэтин —<br><span class="description" id="112">Сиэр сылгы</span> сиэллээх кутуругун<br>Силэйэ баттаабыт курдук,<br><span class="description" id="113">Сиэл күрүҥ</span> аартыктаах,<br>Ситии <span class="description" id="114">эрэдэһиннээх</span>,<br>Чороон ымыйа <span class="description" id="115">дьуолкалаах</span>,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        310
                    </td>
                    <td>
                        Маньньыат хаччы <span class="description" id="116">далбарҕалаах</span>,<br>Көмүс хаччы <span class="description" id="117">дьөллүргэлээх</span> <br>Сылгы-сүөһү иэйэхситин*<br>Киэҥ тэлгэһэтигэр,<br>Аан <span class="description" id="118">алаһатыгар</span> <br>Алтан сэргэ буоламмын<br>Аньньыллан турдаҕым.<br>Саамай <span class="description" id="119">нуоҕай</span> <span class="description" id="120">кылааммын</span> <br>Дьөһөгөй иэйээхсиккэ<br>Оттоку түмүгүн үрдүнэн
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        320
                    </td>
                    <td>
                        Дьөлө үүнэн киирэммин<br>Үтүлүктээх бэргэһэтин ыйыыр<br>Үрүҥ көмүс <span class="description" id="121">көхө</span> буоламмын<br>Үтүрү* үүнэн турдаҕым», — дии санаатаҕа.<br>Ити үтүрү үүнэн турбутугар<br>Бу сылгы-сүөһү иэйээхситэ<br>Араҥас далбарга<br>Түүлээх <span class="description" id="122">түһүлгэ</span> <br>Уордаах Дьөһөгөй оҕоньньор<br>Үс төгүл үрүҥ көмүһүнэн
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        330
                    </td>
                    <td>
                        Төгүрүйэ күрүөлүү баттаан ылбыт.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        331
                    </td>
                    <td>
                        Үөһээ үс бииһин ууһун<br>Абааһытыгар да тыыттарбатах,<br>Аан дайды айыытыгар да көрдөрбөтөх,<br>Бэйэтин <span class="description" id="123">бирээмэлээх</span> күнүгэр<br>Бэлэх биэрэ турда,<br>Маанылаах күнүгэр<br>Ас биэрэ турда.<br>Бу турбут кэскилиттэн<br>Кэлэр кэнэҕэски кэнчээри ыччат дьон
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        340
                    </td>
                    <td>
                        Ааттаах сир аартыгар<br>Сатыы киһи тайаҕын тамнааттыыр,<br>Аттаах киһи кымньыытын быраҕаттыыр,<br>Ситии тардаллар,<br>Сиэл баайаллар эбит<br>Күн бүгүнүгэр дылы.<br>Ити кэнниттэн аллараа өттүн<br>Адаар силиһин сэһэргээтэхпинэ;<br>Киэҥ Килээгир үрэх кэлин өттүнэн,<br>Устата биллибэт
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        350
                    </td>
                    <td>
                        Улаабыр үрэх ортотунан,<br>Кыталык кыстыыр<br>Кылбаарытта кырдалыгар,<br>Туруйа тохтуур<br>Тунаарыкта толоонугар,<br>Иэйэхситтээх иэримэ хонуутугар,<br>Айыыһыттаах араҕас маҕан хочотугар,<br>Баһын атаҕын быһыта сыспыт<br>Маҕан <span class="description" id="124">баайтаһын биэ</span> <br>Бүүтүйэлии түһэн сытарын курдук,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        360
                    </td>
                    <td>
                        Өрө хоппуһардаан таҕыста.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        361
                    </td>
                    <td>
                        Бу гынан баран<br>Хаардаах бугул саҕа<br>Үрүҥ күүгэнинэн <span class="description" id="125">сахсаччы</span> үлүннэ,<br>Араҕас арыынан алла сытта,<br>Сөҥ сүөгэйинэн сүүрдэ турда.<br>Бу сүүрүгүрбүтэ —<br>Көлүйэ күөллэр буолан<br><span class="description" id="126">Үрүмэтийбэт</span> үүт уулар үөскээтилэр,<br><span class="description" id="127">Арылы чэлгиэ алаастар</span> буолан
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        370
                    </td>
                    <td>
                        Ахталыйан, аатыран үөскээтилэр.<br>Бу үөскээбиттэригэр —<br><span class="description" id="128">Тыылаах</span> <span class="description" id="129">тылбыҥнаата</span>,<br><span class="description" id="130">Илимнээх</span> <span class="description" id="131">илбирээтэ</span>,<br><span class="description" id="132">Туулаах</span> <span class="description" id="133">чуоҕуйда</span>,<br><span class="description" id="134">Ардьаахтаах</span> арбаҥнаата.<br>Адаар муостаах,<br><span class="description" id="135">Атырдьах туйахтаах</span>,<br><span class="description" id="136">Суҥ иһэгэй</span> түүлээх<br><span class="description" id="137">Анах сүөһү</span> аһаан-сиэн
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        380
                    </td>
                    <td>
                        Аата-ахса суох элбээтэ.<br><span class="description" id="138">Сыспай сиэллээх</span> <br>Сылгы сүөһү кэлэн,<br>Халлаан сулуһун курдук,<br><span class="description" id="139">Халаана суох</span> элбээтэ.<br><span class="description" id="140">Үс саха</span> кэлэн<br>Кэлин өттүлэригэр<br><span class="description" id="141">Ньохчойо</span> сүгэ-сүгэ <span class="description" id="142">ньөкөрүстүлэр</span>,<br>Илин өттүлэригэр<br><span class="description" id="143">Марайа-марайа</span> көтөҕөн бардылар.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        390
                    </td>
                    <td>
                        Мантан атаҕа суох киһи атахтанна,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        391
                    </td>
                    <td>
                        Илиитэ суох киһи кэлэн илиилэннэ,<br>Хараҕа суох мантан харахтанна,<br><span class="description" id="144">Соххор-доҕолоҥ</span> манна муньньуһунна.<br><span class="description" id="145">Чаабыргыыр</span> бөҕө <span class="description" id="146">чыккымай</span> кустаммыт,<br><span class="description" id="147">Маатыргыыр</span> бөҕө <span class="description" id="148">көҕөн</span> кустаммыт,<br><span class="description" id="149">Кыыбыргыыр</span> кыталык кыылламмыт,<br><span class="description" id="150">Чуубургуур</span> бөҕө туруйа кыылламмыт.<br>Салыйбат <span class="description" id="151">сардаммыт</span>*,<br>Элийбэт <span class="description" id="152">элиэлэммит</span>,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        400
                    </td>
                    <td>
                        Барбат <span class="description" id="153">бараахтаммыт</span>,<br>Көппөт <span class="description" id="154">көнчөх</span>* кустаммыт.<br>Бу мас манна кэлэн —<br><span class="description" id="155">Үрүҥ илгэнэн</span> өрө үллэн<br>Буурдук турбут эбээт.<br>Орой салаата туһааннаах<br>Тус хоту диэки<br>Дьөлү үүнэн истэ,<br>Үс күннүк сиргэ тиийэн<br>Тохтоон, чугуйан толкуйдуу турда.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        410
                    </td>
                    <td>
                        Бу толкуйдаан:<br>«Оорт-татай, оҕолоор!<br>Орто дойдуга үүммүт мас буолларгын,<br>Тоҕус <span class="description" id="156">дьуоҕалаах</span>,<br>Сэттэ <span class="description" id="157">биттэхтээх</span>,<br><span class="description" id="158">Кэйбэлдьийбэт кэй барааҥҥа</span>*<br>Түгэҕэр дьөлө үүнэн түһэммин,<br>Тоҕус бииһин ууһун<br>Туйгуна буолбут<br><span class="description" id="159">Тоноҕос эриэн</span> быалаах,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        420
                    </td>
                    <td>
                        Туора саастаах
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        421
                    </td>
                    <td>
                        Томторҕолоох тойон сэргэлээх.<br>Тоноҕоһуттан өйөнөн үөскээбит<br>Тоҕус чиэппэр муостаах<br>Дуолан Харсаат улууһун<br><span class="description" id="160">Элэҥниир</span> бөҕөтүн эспит,<br><span class="description" id="161">Барыҥныыр</span> бөҕөтүн бараабыт,<br><span class="description" id="162">Сүөдэҥниир</span> бөҕөтүн сүтэрбит<br>Буор Моҕой Тойон оҕоньньору<br>Түннүгүн <span class="description" id="163">үөлэһин</span> бүөлүү үүнэн түһэммин
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        430
                    </td>
                    <td>
                        Төбөтүн оройунан дьөлө үүнэн киирэммин,<br>Өлөрөн-сүтэрэн,<br>Үөдэн-таһаан оҥорон<br>Ааһыам дии, оҕолоор?!<br>Ону ааһаммын<br>Аҕыс бииһин ууһун<br><span class="description" id="164">Арбаҕаһын</span> бүрүнэн төрөөбүт,<br><span class="description" id="165">Адаҕатын</span> кэппитинэн кэлбит,<br>Арбыйа налбаҕар тиистээх<br>Арсан Дуолай оҕоньньор ааттаахтарыгар
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        440
                    </td>
                    <td>
                        Үөлэстэрин үүтүн бүөлүү үүнэммин,<br><span class="description" id="166">Дьүлэй</span>-<span class="description" id="167">сыҥсаар</span> ыарыы оҥоттооммун<br>Өлөрөн-сүтэрэн ааһыам, дии?!<br>Бу орто туруу дойду<br>Кэлэр кэнэҕэски ыччаттарын,<br>Кэлэр киһилэрин<br>Кэҕиннэрэ сылдьыахтара,<br>Төрүүр сүөһүлэрин<br>Төнүннэрэр буолуохтара,<br><span class="description" id="168">Күн улууһун</span> көмүскүүргэ
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        450
                    </td>
                    <td>
                        Көрүллэн үөскээбит,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        451
                    </td>
                    <td>
                        <span class="description" id="169">Айыы ууһун</span> аһынарга анаммыт<br>Аһыныгас санаалаах<br>Аал Дуук Мас буоллаҕым.<br>Орт-татай, оҕолоор!<br>Аҕыс бииһин атамаана,<br>Тоҕус бииһин туйгуна өстөнөннөр —<br>Чугас ыалларын<br>Туллах-туллах ыстаан тобоҕолообут,<br>Ыраах ыалларын
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        460
                    </td>
                    <td>
                        Ыллах-ыллах ыстаан ыраастаабыт,<br><span class="description" id="170">Буус</span> болуо тыыннаммыт дьон,<br><span class="description" id="171">Аҕаларын ууһа</span> бэт <span class="description" id="172">айаҕымсах</span> <br><span class="description" id="173">Ийэлэрин ууһа</span> бэт <span class="description" id="174">иҥсэлээх</span>,<br>Улуустара баҕайы бэт <span class="description" id="175">оботтоох</span>,<br>Өй-сүрдээх дьоннор.<br>Сыыһа сананаары гынным быһыыта —<br>Аллараа аҕыс адаар сиксигиттэн<br>Өрө кыраан таһаарыахтара,<br><span class="description" id="176">Сэт-сэлээн</span> туолуоҕа,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        470
                    </td>
                    <td>
                        <span class="description" id="177">Сэмэ-суҥха</span> ситиэҕэ,<br>Кэм-кэрдии кэлиэҕэ,<br>Эмэх буолан хаалыаҕым —<br>Сыыһаны санаабыппын», — диэтэ.<br>Күн өттүлэринэн күөйэ үүнэн түстэ.<br>Аллараа аҕыс бииһин уустара<br>Тахсан алдьатымаайаллар диэн,<br>Күскэс Буурайы <span class="description" id="178">күрдьүгүн</span> аанынан<br>Күөйэ үүнэн түстэ.<br>Дагдас Буурайы <span class="description" id="179">даллатын</span> аанынан
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        480
                    </td>
                    <td>
                        Аһары үүнэн ааста.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        481
                    </td>
                    <td>
                        Кубас ынахтаах Кубаадай эмээхсини<br>Хотугу өттүнэн курдаата.<br>Ханыы хара ынахтаах<br>Хабаадай эмээхсини<br>Хаҥас өттүнэн халыйда.<br>Бу тиийэн —<br><span class="description" id="180">Бытта</span> <span class="description" id="181">бырааннаах</span>,<br><span class="description" id="182">Хатта</span> хайалаах,<br>Сыа сыһыылаах,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        490
                    </td>
                    <td>
                        <span class="description" id="183">Эдьэгэй</span> <span class="description" id="184">эрбэһиннээх</span>*,<br><span class="description" id="185">Сүүмэх</span> <span class="description" id="186">тураҥнаах</span>,<br><span class="description" id="187">Үргүньньэх</span> үрүйэлээх,<br>Айах халдьаайылаах,<br><span class="description" id="188">Киргил</span> кинээстээх,<br><span class="description" id="189">Тоҥсоҕой</span> тойонноох,<br><span class="description" id="190">Кукаакы</span> кулубалаах,<br><span class="description" id="191">Соноҕос сылгы</span> тумулаттардаах,<br><span class="description" id="192">Кытыт сылгы</span> кырдаллардаах,<br>Батыган маччаагыйа
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        500
                    </td>
                    <td>
                        <span class="description" id="193">Кунана</span> бараалаабыт,<br>Тураньньак тураҕачыак<br>Соноҕоһо чуоҕуйбут,<br>Ууланьньаҥ улаанчык<br>Кытыта олохсуйбут,<br>Сир иччитэ Сибиэ баай,<br>Дойду иччитэ Толомон баай,<br>Күрүө <span class="description" id="194">бүлгүн</span>,<br>Көмүс <span class="description" id="195">хоҥоруу</span>,<br>Күн күбэй
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        510
                    </td>
                    <td>
                        Түүлээх- биһэгэй
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        511
                    </td>
                    <td>
                        Аан-Бичик эмээхсин<br>Хотонун хотугу муннугунан<br>Дьөлү үүнэн киирдэ.<br>Бастакы баттах <span class="description" id="196">маҕанатыгар</span> <br>Батары саайылынна,<br>Арыы сыа ыйыыр<br>Алтан <span class="description" id="197">сатанах</span>* буолан аньньылынна.<br>Маны бу сир иччитэ<br>Үс хос төгүрүйэ курдуу баттаан ылла,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        520
                    </td>
                    <td>
                        Ситии ыйаата,<br>Сиэл баайда,<br>Аллараа дойду аҕыс бииһин<br>Абааһытыгар тыыттарбата,<br>Тоҕус бииһин ууһун<br>Туйгунун олох чугаһаппата,<br>Ситии бөҕөнү баайда,<br>Сиэл бөҕөнү ыйаата.<br>Бириэмэлээх күнүгэр бэлэх биэрэр,<br>Аналлаах күнүгэр ас биэрэр.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        530
                    </td>
                    <td>
                        Ол <span class="description" id="198">төккөтүнэн</span> кэлэр кэнэҕэски<br>Кэнчээри ыччат дьон<br><span class="description" id="199">Сайылыктарыгар</span> тахсалларыгар<br>Уоттарыгар ас биэрэр,<br><span class="description" id="200">Титииктэригэр</span> ситии ыйыыр,<br>Сиэл баайар гына<br>Кэнчээри ыччат<br>Кэскилэ тэриллибит эбит!<br>Ити кэлин кырыытыттан<br>Эриэн <span class="description" id="201">элэмэс сылгы</span> тириитин
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        540
                    </td>
                    <td>
                        Тиирэ таппыт курдук
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        541
                    </td>
                    <td>
                        <span class="description" id="202">Эбир дуоссун</span> хонууга кэлэн<br>Элээр-мэлээр одуулаабытым:<br>Сэттэлээх ат сылгы<br>Кыайан таба тирэнэн кэлбэтинэн<br><span class="description" id="203">Ииччимэрдээх</span> тэлгэһэлээх эбит,<br>Аҕыстаах ат сылгы<br>Ааһа айаннаан ааспатынан<br>Таас <span class="description" id="204">таалыйа</span> хонуулаах эбит.<br>Тоҕустаах дьоруо ат
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        550
                    </td>
                    <td>
                        Кыайан дугуйдаан барбатынан<br><span class="description" id="205">Оҕоруктаах</span> түөлбэ олохтоох эбит.<br>Утары көрөн кэбиспитим —<br>Тоҕус тойон киһи<br>Утарыта хаамсан киирэн<br>Дорообо бэрсэн эрэллэрин курдук<br>Тойон <span class="description" id="206">баабыр</span> сэргэтэ*<br><span class="description" id="207">Бачыгырайан</span> көһүннэ.<br>Күн диэки өттүнэн<br><span class="description" id="208">Күөкэс</span> кыммыкка дылы
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        560
                    </td>
                    <td>
                        Күөкэримэ диэн күрүөлээх,<br>Халлаан диэки өттүнэн<br><span class="description" id="209">Хаҥхас</span> кыммыкка дылы<br>Халларыма диэн хаһаалаах эбит.<br>Итинтэн буоллаҕына<br>Күннүк сир төгүрүмчүлээх,<br>Көс сир уорҕалаах<br>Күндүл көмүс күөчэҥсэ балаҕан<br>Өрө кылбаһыйан көһүннэ.<br>Иһигэр олорор киһи
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        570
                    </td>
                    <td>
                        Таһыттан курдаттыы көстөр,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        571
                    </td>
                    <td>
                        Таһыгар кэлбит киһи<br>Иһиттэн курдаттыы көстөр<br>Күлүмүрдүүр көмүс<br>Курустаал таас дьиэ эбит.<br>Тас <span class="description" id="210">чаампытын</span> ааныгар<br>Хоро Саабылыскай обургу<br>Уохтаах оруому<br>Олус иһэн кэбиһэн баран,<br><span class="description" id="211">Кутуран</span> хоккулла олорорун курдук
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        580
                    </td>
                    <td>
                        <span class="description" id="212">Ыҥыыр</span> ыйыыр мастаах эбит.<br>Ходоро кыыһа хотука,<br>Бадыр кыыһа баҕадьы,<br>Ааныкалыыр аллаах,<br>Тэллэкэлиир киһи,<br>Итириктээх испиири<br>Дэлби иһэн кэбиһэн баран<br><span class="description" id="213">Иирэ-мэнэрийэ</span> олорорун курдук<br>Саадах ыйыыр мастаах эбит.<br>Сэбирдэх дьиэни сэгэччи тардан,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        590
                    </td>
                    <td>
                        <span class="description" id="214">Амыньньыар</span> модьоҕону атыллаан<br>Ис өттүгэр көтөн түстүм.<br>Ити киирэн туран<br>Алтан хаччы курдук<br>Арылхай көмүс харахпынан<br>Аралыччы көрөн турдум.<br>Чахчы бааччы<br>Баай Барыылаах бэйэтинэн түһэн<br>Маҕаналаан оҥорбут эбит.<br>Илэ бодо Эйиэн Иэйээхсит
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        600
                    </td>
                    <td>
                        Истиэнэлээн оҥорбут эбит.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        601
                    </td>
                    <td>
                        Үрүҥ Айыыһыт үрүттээн саппыт.<br>Адьдьаххайдаах холлорук<br>Аллараа өттүттэн<br>Адьдьатан-кээһэтэн тахсыа диэн,<br>Аҕыс хос <span class="description" id="215">адарай көмүс</span> муосталаабыттар.<br>Орто дойду күүстээх<br>Көй хара <span class="description" id="216">холлоруга</span> <br><span class="description" id="217">Көҥүтэ</span> сыньньан барыа диэн,<br>Сэттэ хос сибиэнэй көмүс истиэнэлээбиттэр.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        610
                    </td>
                    <td>
                        Үөһээ дойду гиэнэ<br>Үлүгэрдээх күүстээх <span class="description" id="218">үргүөһүнэ</span> <br>Дьөлүтэ сыньньан түһүө диэн,<br>Үс хос үрэллибэт<br>Үрүҥ көмүс үрүттээбиттэр эбит.<br>Хаҥас диэки көрбүтүм:<br><span class="description" id="219">Харамталаах</span> алаас саҕа<br>Хаҥас диэкилээх эбит.<br><span class="description" id="220">Кэтэҕириин</span> көрбүтүм:<br>Кэтэбиллээх алаас саҕа
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        620
                    </td>
                    <td>
                        Кэтэҕэриин диэкилээх эбит.<br>Бэт алаас саҕа<br>Бичиктээх <span class="description" id="221">биллэриктээх</span>,<br>Улахан алаас саҕа<br>Уҥа диэкилээх,<br>Сурахтаах алаас саҕа<br><span class="description" id="222">Суол аанылаах</span>,<br>Үтүө алаас саҕа<br><span class="description" id="223">Үгэхтээх</span> эбит.<br>Биир өттүгэр биэс уон
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        630
                    </td>
                    <td>
                        Сиэркилэ таас түннүктээх,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        631
                    </td>
                    <td>
                        Аҥаар өттүгэр аҕыс уон<br><span class="description" id="224">Айдаан таас</span> түннүктээх,<br>Соҕотох өттүгэр тоҕус уон<br><span class="description" id="225">Сөлүүдэ таас</span> түннүктээх.<br>Сиилинэй бухатыыр тэбинэн сэгэлдьитэн киирэр<br>Сэттэ уон <span class="description" id="226">тиһэх эһэ</span>*<br>Тириитинэн тигэн дьаптайан оҥоһуллубут<br><span class="description" id="227">Лип-хаан</span> <span class="description" id="228">халҕаннаах</span> эбит.<br><span class="description" id="229">Буолунай</span> бухатыыр киһини кыайан <span class="description" id="230">суоһатар</span> 
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        640
                    </td>
                    <td>
                        Суостуганнаах Суо Хаан<br>Аан Күҥкэй диэн оһохтоох эбит.<br>Хааман кэлэр <span class="description" id="231">хамыйахтаах</span>,<br>Кыыран кэлэр <span class="description" id="232">кытыйалаах</span>,<br>Сүүрэн кэлэр сүгэлээх,<br>Эккирэтэн кэлэн<br>Тиэрэ баран түһэр<br>Эт эттиирдээх эбит.<br>Ыллыыр <span class="description" id="233">лааппылаах</span>,<br>Олоҥхолуур остуоллаах,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        650
                    </td>
                    <td>
                        Сэҥээрэн биэрэр <span class="description" id="234">сэбиргэллээх</span>,<br>Сөбүлүү турар <span class="description" id="235">сөбүргэнэлээх</span>*,<br>Бэйэтиттэн күөһү күөстүүр<br><span class="description" id="236">Көкөөнөй</span> уолаттардаах эбит.<br>Уотун оттор<br>Остуорас кыргыттардаах эбит.<br>Ити кэлин өттүгэр —<br>Маннык бэйэлээх<br>Иэримэ дьиэ иччитэ<br>Кимий эбитий диэн көрбүтүм,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        660
                    </td>
                    <td>
                        Маннык бэйэлээх
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        661
                    </td>
                    <td>
                        <span class="description" id="237">Бабаарыма</span> балаҕан<br>Баараҕайа хайдаҕый эбитий диэммин<br>Аралдьыта көрбүтүм:<br>Баар эбит, доҕоор,<br>Үрдүгэ үс <span class="description" id="238">бэчээтинэй</span> үтүө киһи,<br>Алын тилэҕэ быһыйга быһыылаах,<br>Оттоку уҥуоҕа бодьуйга <span class="description" id="239">боруобалаах</span>,<br>Үрүт уҥуоҕа <span class="description" id="240">модьуга</span> <span class="description" id="241">мөссүөннээх</span>,<br>Үс түһэ кэбиһэ <span class="description" id="242">былас</span> 
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        670
                    </td>
                    <td>
                        <span class="description" id="243">Үөкэйэр</span> өттүктээх эбит,<br>Биэс былас <span class="description" id="244">биэкэйэр</span> <span class="description" id="245">бииллээх</span>,<br>Алта былас <span class="description" id="246">дарайар</span> сарыннаах,<br><span class="description" id="247">Суллаабыт тиит</span> курдук сотолоох,<br><span class="description" id="248">Уолах мас</span> курдук уллуктаах,<br><span class="description" id="249">Хастаабыт мас</span> курдук харылаах,<br>Бысталаабыт тиит курдук былчыҥнаах,<br>Сыарҕалаах от курдук<br>Сырыылаах сырайдаах,<br><span class="description" id="250">Балтарыктаах</span>* от курдук
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        680
                    </td>
                    <td>
                        <span class="description" id="251">Малаҕаркаан</span> <span class="description" id="252">мөссүөннээх</span>,<br>Уон <span class="description" id="253">уоттаах саһылы</span> <br>Утарыта туппут курдук<br><span class="description" id="254">Толбонноох</span> <span class="description" id="255">ньуурдаах</span>,<br><span class="description" id="256">Кэрэмэс саһыл</span> <span class="description" id="257">ньилбэгин</span> тириитин<br><span class="description" id="258">Тиирэ</span> таппыт курдук<br>Кэрэмээттээх иэдэстээх,<br><span class="description" id="259">Аллаах ат</span> харытын уҥуоҕун<br>Таҥнары туппут курдук<br><span class="description" id="260">Хаҥсаардаах</span> муруннаах.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        690
                    </td>
                    <td>
                        <span class="description" id="261">Эрэдэһиннээх үүн тиэрбэһин</span> курдук
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        691
                    </td>
                    <td>
                        Икки <span class="description" id="262">эрилкэй</span> көмүс харахтаах.<br><span class="description" id="263">Куртуйах улар</span> кутуругун курдук<br>Куударалаах баттахтаах.<br><span class="description" id="264">Эрдэҕэс улар</span> кутуругун курдук<br>Эриллэҕэс чанчыктаах.<br>Атыыһыт киһи <span class="description" id="265">аалыскай иҥнэтин</span> курдук<br>Аалыы көмүс кыламаннаах.<br>Уон атыыр кырынааһы<br>Атахтаһыннары туппут курдук
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        700
                    </td>
                    <td>
                        Уон <span class="description" id="266">баҕыы көмүс</span> <br>Тарбахтаах эбит.<br>Оот-татай, оҕолоор!<br>Маннык бэйэлээх киһи<br>Таҥнар таҥаһа<br>Хайдаҕый эбитий диэммин<br>Эргитэ-урбата көрбүтүм:<br><span class="description" id="267">Сарыы</span> дьаахтааҕын<br>Саныйан таҥныбыт,<br><span class="description" id="268">Түнэ</span> <span class="description" id="269">бүүппүктээҕин</span>*
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        710
                    </td>
                    <td>
                        Дьөнүйэн бүрүммүт,<br><span class="description" id="270">Үүс-киис киргиллээҕин</span> <br>Кичэйэн туран кэппит.<br>Үүс-киис тириитэ биэтэстээх<br>Бөрө <span class="description" id="271">саҥыйахтааҕын</span> <br><span class="description" id="272">Нэллэгэйдии</span> кэппит.<br>Үүс-киис тириитэ<br>Үллүк саҕа бэргэһэтин<br><span class="description" id="273">Кырыыбылыы</span> ууруммут.<br>Оот-татай, оҕолоор!
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        720
                    </td>
                    <td>
                        Маннык бэйэлээх киһи
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        721
                    </td>
                    <td>
                        Туттар сэбэ-сэбиргэлэ<br>Хайдаҕый эбитий диэммин<br>Өйдөөн-дьүүллээн көрбүтүм:<br>Кытыл уҥуортан<br>Кылбайбытынан кэлэр<br>Кыыс-дьахтар <span class="description" id="274">имнээх хааныгар</span> <br>Хатарыллан оҥоһуллубут <span class="description" id="275">кылааннаах</span> <br>Хараарар <span class="description" id="276">хара дьиэрэҥкэй</span> <br>Үҥүүлэрдээх эбит.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        730
                    </td>
                    <td>
                        Уҥуоргу тыаттан <span class="description" id="277">олодуйан</span> кэлэр<br>Уолан киһи уостаах тииһин хааныгар<br>Уһааран-кэхтэрэн оҥорбут<br>Уорааннаах уһун тайба батастаах эбит.<br>Сэттэ уон <span class="description" id="278">бууттаах</span> <br>Бэт тимиртэн оҥоһуллубут<br><span class="description" id="279">Дэлэбиир</span> мээчиктэрдээх эбит.<br>Тоҕус уон бууттаах<br>Тутаахтаах <span class="description" id="280">чомпу сүлүгэстээх</span> эбит.<br>Кимиэхэ да суох
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        740
                    </td>
                    <td>
                        Китиэн-итиэн дойду<br><span class="description" id="281">Киилэ</span> кииллээх,<br>Туохха да суох<br>Тумаан-имээн дойду<br>Туоһа туостаах,<br>Хатыан-итиэн дойду<br>Хатыҥа хатыҥнаах,<br>Өлүү хаһыытыыр хахай кыыл<br>Хаана кырааскалаах,<br>Үөгүлүүр <span class="description" id="282">өксөкү кыыл</span>.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        750
                    </td>
                    <td>
                        Көхсүн хаана <span class="description" id="283">умунуохтаах</span>*,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        751
                    </td>
                    <td>
                        <span class="description" id="284">Хатыыс балык</span> <br>Хабаҕын сыата <span class="description" id="285">силимнээх</span>,<br>Улуу тайах кыыл<br>Устар уорҕатын тириитэ <span class="description" id="286">бүрэдэһиннээх</span>*,<br><span class="description" id="287">Өлүү дьэрэбинэ балык</span> <br>Иэнин иҥиирэ <span class="description" id="288">иҥэрээлээх</span> эбит.<br><span class="description" id="289">Өлүү даарда балык</span> <br>Чиккэйэр сиһин үөһэ <span class="description" id="290">киристээх</span>*,<br>Тайырҕаннаах Таатта эбэ хотун
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        760
                    </td>
                    <td>
                        Оттоку илии үрэҕэ<br><span class="description" id="291">Тоҕойдуу</span> түһэн турарын курдук<br>Тарбаҕынан тардан эһэр,<br>«Даҥ» гынан эстэр<br><span class="description" id="292">Чаачар</span> саалардаах эбит.<br>Сайыҥҥы <span class="description" id="293">кулун кымыһыгар</span> ооньньуур<br><span class="description" id="294">Бойон киһи</span> сототун уҥуоҕун<br>Сулуйа баттаабыт курдук,<br>Хонуоһуннаах <span class="description" id="295">кулан-дьорҕоон</span> <br>Оноҕостордоох эбит.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        770
                    </td>
                    <td>
                        Сайыҥҥы <span class="description" id="296">саамал кымыска</span> ооньньуур<br>Улуу тайах кыыл саннын уҥуоҕун<br>Субуйа тардан ылбыт курдук,<br>Сандалы көмүс оноҕостордоох эбит.<br>Булка-алка туттар<br><span class="description" id="297">Тииньньит</span> ыал дьиэтин<br>Тиэритэ кэбиэлээбит курдук,<br>Тимир <span class="description" id="298">тэмэлгэн</span> оноҕостордоох эбит.<br>Балыксыт ыалым<br>Барайан-сарайан оҥостубут
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        780
                    </td>
                    <td>
                        Мас балаҕанын
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        781
                    </td>
                    <td>
                        Таҥнарыта аньньыалаабыт курдук,<br>Мас <span class="description" id="299">маалтааныка оноҕостордоох</span> эбит.<br>Этиһиигэ-охсуһууга туттар оноҕоһо<br>Илин өттүгэр торбос быарын саҕа<br>Хара бөлүөх хаан<br>Туора быллаччы ытырыылаах,<br>Кэлин өттүгэр турар киһи саҕа<br>Субай хаан <span class="description" id="300">сөгөлөөннөөх</span>,<br>Өһөх төбө, хаан бас,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        790
                    </td>
                    <td>
                        <span class="description" id="301">Тимир тиҥсилики</span>,<br>Сылбырҕа кутурук<br>Күүстээх дьорҕой оноҕостоох эбит.<br><span class="description" id="302">Оот-татай</span>, оҕолоор!<br>Бу маннык бэйэлээх киһи<br><span class="description" id="303">Кирдик</span> даҕаны<br>Илэ-бодо <span class="description" id="304">иэйээхсиккэ</span> тэҥнэбиллээх<br>Үтүө киһи эбит диэммин,<br>Чахчы-бааччы айыыһыкка <span class="description" id="305">бараалаах</span> <br>Киһи бэрдэ эбит диэммин
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        800
                    </td>
                    <td>
                        Өйдөөн, дьүүллээн, санаан<br>Уунан тиийбэт үрдүк аата<br>Ким-хайа буоллаҕай диэммин,<br>Ийэм уруутуттан ирдээн көрдүм,<br>Аҕам уруутуттан араҥалаан көрдүм.<br>Ол көрбүтүм, доҕоттоор,<br>Сэттэ уон иэнигийэн түһэр<br>Иэйээхсит биэрэгин айаҕар<br>Дьиэлэнэн үөскээбит,<br>Аҕыс уон айыыһыт
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        810
                    </td>
                    <td>
                        <span class="description" id="306">Ахталыйан</span> түһэр
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        811
                    </td>
                    <td>
                        <span class="description" id="307">Дьаарбаҥын</span> ааныгар<br>Арҕахтанан үөскээбит,<br>Тоҕус уон суккуллан түһэр<br>Хотой айыыһыт <span class="description" id="308">оппуоһун</span> ааныгар<br>Олоҕуран төрөөбүт<br>Тыллаах-өстөөх Хара Кулун аттаах<br>Сылгы уола Дыырай бөҕө диэн<br>Үөмэн тиийбэт үрдүк ааттаах,<br>Уунан тиийбэт дьоһун-билэ сурахтаах эбит.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        820
                    </td>
                    <td>
                        Оот-татай, оҕолоор!<br>Маннык бэйэлээх<br>Аһыныылаах санаалаах,<br>Арҕаһыттан тардыылыктаах<br>Айыы аймаҕын аҥаарыйар үтүөтэ,<br>Көхсүттэн тэһииннээх<br>Көмүскэллээх сүрэхтээх<br>Күн айыы оҕотун<br>Күөгэйэр үтүөтэ буолан баран,<br>Халлаантан түспүтэ буоллар
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        830
                    </td>
                    <td>
                        Хаардаах буолуо этэ,<br>Сиртэн тахсыбыта буоллар<br>Буордаах буолуо этэ.<br>Аҕаттан төрөөбүтэ буоллар<br>Туруору уҥуохтаах,<br>Дьохсоллубут быһыылаах,<br><span class="description" id="309">Толоонноох</span> быһыылаах,<br>Дорҕоонноох саҥалаах,<br><span class="description" id="310">Торумтуйбут</span> бытыктаах,<br>Тойон киһи
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        840
                    </td>
                    <td>
                        Аар тойон аҕата
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        841
                    </td>
                    <td>
                        Ханныгый диэммин,<br>Аралдьыта көрө сатаан кэбистим —<br>Ханна да суох эбит.<br>Ийэттэн төрөөбүтэ буоллар<br>Хаҥас диэкки өттүгэр<br>Хаар маҕан баттахтаах,<br><span class="description" id="311">Хабайакаан</span> курдук эттээх,<br>Халааннаах саҥалаах,<br>Күбэй хаан хотун ийэтэ
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        850
                    </td>
                    <td>
                        Ханна да көстүбэт эбит.<br>Ханталлыбыт этэрбэстээх<br><span class="description" id="312">Халы-мааргы</span> быһыылаах,<br>Хабарҕатын төрдүгэр<br><span class="description" id="313">Хабараан</span> саҥалаах,<br><span class="description" id="314">Халаастаһан</span> кэпсэтэр<br>Хамначчыт дьахталлара диэн<br>Ханна да суох эбит.<br>Уҥа диэкки өттүгэр<br><span class="description" id="315">Оньньоллубут</span> этэрбэстээх,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        860
                    </td>
                    <td>
                        Уолугун төрдүгэр уолусхан тыллаах<br>Омуннаах кэпсээннээх,<br>Оспуордаһан кэпсэтэр<br><span class="description" id="316">Оноллубут</span> быһыылаах<br>Уолан киһи <span class="description" id="317">оруодьата</span> диэн<br>Олох долуой суох эбит.<br>Халдьаайы тыа маһын курдук<br>Хамаандата суох,<br>Куула тыа ойуурун курдук<br><span class="description" id="318">Оруолдьута</span> суох эбит.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        870
                    </td>
                    <td>
                        Уҥа диэкки өттүгэр
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        871
                    </td>
                    <td>
                        Тоҕус уон <span class="description" id="319">субан</span> туруйа курдук<br>Уолаттара суох.<br>Хаҥас диэкки өттүгэр<br>Сэттэ уон тыһы кыталык курдук<br>Кыргыттара суох эбит.<br>Тэллэххэ сытар<br>Тэҥнээх кэргэнэ диэн<br>Мэличчи биллибэт,<br><span class="description" id="320">Хоойҥо сытар</span> 
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        880
                    </td>
                    <td>
                        Холоонноох доҕоро<br>Долуой суох киһи эбит.<br>Субу гынан баран<br>Баай бөҕө талымнаах,<br>Тот бөҕө күскэмнээх —<br>Хара түүлээҕэ<br>Хара тыа <span class="description" id="321">Хамчаакы</span> тоҥуһугар<br>Халтаҥ ойоҕосторунан<br><span class="description" id="322">Хабырыһан</span> тахсыбыттарын<br>Хамыйан сиэбиттэрин иһин
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        890
                    </td>
                    <td>
                        Барамматах талым үгүс<br>Баайдаах эбит.<br>Үрүҥ түүлээҕэ —<br>Үрэх баһын Өймөкөөнүн тоҥуһугар<br>Үтүрүһэн тиийбиттэрин<br>Үөлэн сиэбиттэрин иһин<br>Көҕүрээбэт элбэх<br>Күдэн баайдаах эбит.<br>Аҕыс <span class="description" id="323">тиил</span> ампаары толору астаах,<br>Тоҕус тиил ампаары толору үптээх,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        900
                    </td>
                    <td>
                        Кыланар бөҕө кылааттаах,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        901
                    </td>
                    <td>
                        Маҥырыыр бөҕө маньньыаттаах,<br>Үөгүлүүр бөҕө үптээх эбит.<br>Оот-татай, оҕолоор,<br>Бу киһи бу гынан баран<br>Саамал кымыһынан <span class="description" id="324">санаатын тарҕатан</span>,<br><span class="description" id="325">Көҕүөр</span> кымыһынан <span class="description" id="326">көхсүн көньньүөрдэн</span>,<br>Халыҥ хаһанан хаччы кэбиһэн,<br>Суон саалынан <span class="description" id="327">суомас</span> кэбиһэн,<br>Дьоһун <span class="description" id="328">мүһэнэн</span> <span class="description" id="329">мохсуо</span> уурунан,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        910
                    </td>
                    <td>
                        Аһаан-сиэн, атан-бөтөн<br>Аһайан-чачайан олордо, эбээт!<br>Бу олорон эрэн<br>Тоҕус тарбаҕын тосту баттаан<br>Туран толкуйдаан көрө олордо:<br>«Аат-татай, оҕолоор!<br>Дьоллоох-соргулаах<br><span class="description" id="330">Хордоҕой</span> хотун алааспар<br>Өрүү бу курдук<br>Үчүгэйдик олордорбун ханнык,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        920
                    </td>
                    <td>
                        Бу тыал түспэтэх<br>Сылаас быттыгар кыбылламмын,<br>Холорук хоммотох<br>Дьоллоох хонноҕор хорҕойоммун,<br>Үйэм туххары олорорум буоллар,<br>Төһө эрэ үчүгэй буолар этэ.<br>Үөһээ үс бииһин-ууһа обургулар<br>Үрдүк дьоһун ааппын ааттаан,<br><span class="description" id="331">Мөрүөҥнээх</span> көхсүлэригэр дылы<br>Өҥөйөн көрбөтөллөр үчүгэй этэ.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        930
                    </td>
                    <td>
                        Аллараа аҕыс бииһин-ууһун ааттаахтара
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        931
                    </td>
                    <td>
                        <span class="description" id="332">Албан-дьаҕан</span> ааппын ааттаан,<br>Өрө быган харахтарын <span class="description" id="333">чарапчыланан</span> <br>Көрбөтөллөр үчүгэй этэ.<br>Бөлөнөхпөр мөскөйөн,<br>Тарбар дагдайан,<br>Олордорбун үчүгэй этэ!» — диэн баран,<br>Тоҕус тиит толуута<br><span class="description" id="334">Туут хайыһарын</span> кэтэн,<br><span class="description" id="335">Эргэнэ хара тыаны</span> эргийэ сүүрэн,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        940
                    </td>
                    <td>
                        Баай-хара тыаны хайыта хааман,<br>Эһэ кыылы иэдэһиттэн <span class="description" id="336">илибирэччи</span> тутан,<br>Таба кыылы таныытыттан <span class="description" id="337">талыбыраччы</span> тутан,<br><span class="description" id="338">Буур</span> кыылы муннуттан сиэтэн,<br>Иннигэр-кэннигэр эриэ-дэхси<br>Илибирэччи-салыбыраччы сүгэн<br>Дьиэтигэр киирэн,<br>Аһаата-сиэтэ, атта-бөттө.<br><span class="description" id="339">Бичиктээх</span> биллэригэр,<br>Ойуулаах оронугар,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        950
                    </td>
                    <td>
                        Дьэрэкээннээх тэллэҕэр,<br><span class="description" id="340">Чыҥырҕастаах сыттыгар</span>,<br>Дуобаттаах суорҕаныгар<br>Тиэрэ баран түһэн<br>Утуйан <span class="description" id="341">баччыгыныы</span> сыппыт.<br>Сассыарда өттүгэр<br><span class="description" id="342">Тыҥ</span>, тыһы бараах түөһүн курдук,<br>Кылбайа сырдаан кэллэ,<br>Халлаан, атыыр бараах түөһүн курдук,<br>Сырдаан таҕыста.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        960
                    </td>
                    <td>
                        Аламай маҕан күнэ
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        961
                    </td>
                    <td>
                        Араҕас маҥан халлаан<br>Арҕаһыгар ахталыйа ойон таҕыста.<br><span class="description" id="343">Толомон</span>  маҕан күнэ,<br>Туналы маҕан халлаан<br>Туонатыгар тутуллан-туоллан,<br>Тэгэлийэн таҕыста.<br>Күн тахсыыта<br>Күөмэйэ көбүөх гынан,<br>Халлаан сырдыыта
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        970
                    </td>
                    <td>
                        Таныыта тартах гынан,<br>Уһуктан турда,<br>Олоро түстэ.<br>Сэбирдэх дьиэтин<br>Сэгэччи баттаан таҕыста,<br><span class="description" id="344">Амыньньыар</span> модьоҕотун<br>Атыллыы охсон таҕыста,<br>Талааннаах дьаҕыл дьаарбаҥын ортотунан<br>Хайа хааман барда,<br>Дьоллоох-уруйдаах толоонун ортотунан
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        980
                    </td>
                    <td>
                        Тобулу хааман таҕыста.<br>Бу тахсан туран<br><span class="description" id="345">Халааныскай ыстаанын</span> иитин төлө тардан,<br>Элгээн күөл уутун курдук<br>Ииктээн <span class="description" id="346">эҥиһитэ</span> турда.<br>Бу туран<br>Сүүһүн аннынан <span class="description" id="347">сүргүччү</span> көрөн турда,<br>Муннун аннынан <span class="description" id="348">сурулаччы</span> тыынна,<br>Соҕуруу халлаан соҕуруу <span class="description" id="349">улахатыттан</span>,<br>Эриэн <span class="description" id="350">элэмэс</span> сылгы
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        990
                    </td>
                    <td>
                        Тириитин тиирэ тарпыт курдук,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        991
                    </td>
                    <td>
                        Иэримэ-дьиэримэ былыттар<br>Иэнигийэн таҕыстылар,<br>Күтүр баҕайы күүстээх бааллар<br>Көҥүтэ охсон кэллилэр.<br>Ити гынан баран<br>Итии салгын эргийдэ,<br>Ибир хара самыыр түстэ.<br>Ити кэнниттэн,<br>Тыстаах баттахтаах сырҕан эһэ
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1000
                    </td>
                    <td>
                        Тириитин тиирэ тарпыт курдук,<br>Уулаах най-хара былыт<br>Өрө сүүрэн таҕыста.<br>Өрө сүүрэн таҕыста да,<br>Били ииктии турар киһини<br>Төбөтүн оройугар кэлэн<br>Туорайдыы баттаан турда.<br>Бу турбутуттан куттанан<br>Ити киһи кэннинэн<br>Күннүк сир холобурдааҕы
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1010
                    </td>
                    <td>
                        <span class="description" id="351">Чугурус</span> гына түстэ.<br>Бу туран эрэн<br>Өйдөөн өрө көрөн турда<br>Били най-хара былыт диэкки:<br>Бу турдаҕына бу былыт<br>Оттотунан дьөлө ыстанан хаалла,<br>Төбөтүнэн хайы баран хаалла.<br>Халлаан түөт өттүн диэкки<br>Түөт хамса буруота буолан<br>Унаарыс гына түспүтэ.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1020
                    </td>
                    <td>
                        Ол оттотуттан
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1021
                    </td>
                    <td>
                        Кылбайар кыһыл сыгыньньах киһи<br>Си-тура бэйэтэ туруору<br>Дьэ таҥнары түһэн<br>Кылыһыйан иһэр эбит.<br>Ириэнэх сири иэччэҕин хараҕар дылы<br>Ибили түһэн кэбистэ,<br>Тоҥмут сири тобугун хараҕар дылы<br>Тобулу түһэн кэбистэ.<br>Маны көрбүтэ —
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1030
                    </td>
                    <td>
                        <span class="description" id="352">Иҥиир тараһаламмыт,<br>Этирик түөстэммит</span>,<br>Этэ-хаана бараммыт киһи буолла.<br>Сэттэ уон сиикэй баастаах,<br>Таҥас-сап бараммыт киһитэ эбит.<br>Бу түһэ сытан эрэн<br>Ый-ыырын ытыы сытар,<br>Кыһыл көмүс кыламанын быыһыттан<br>Имин быһаҕаһыгар дылы<br>Икки хараҕын уута,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1040
                    </td>
                    <td>
                        Курустаал чөмчүүк курдук,<br>Кылбайа сүүрэ сытта.<br>Бу гынан баран<br>Аҥаар атаҕын <span class="description" id="353">сөһүргэстээтэ</span>,<br>Аҥаар атаҕынан үктэннэ,<br>Дорообо биэрэн эрэр киһи быһыытынан<br>Тоҥхос гынарга дылы гынна,<br>Икки ытыһынан сырайын саба хаппахтанна.<br>Бу гынан баран<br>Өрөөбүт уоһун өһүлэ олордо,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1050
                    </td>
                    <td>
                        Хоммут уоһун хоҥуннарда,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1051
                    </td>
                    <td>
                        Үрүҥ көмүс күөмэйин көбүөхтэттэ,<br>Алтан дьаакы айаҕын аппаҥнатта,<br>Ытаата-соҥоото,<br>Ыллаата-туойда:<br>— Ээ, доҕорум, дорообото тут!<br>Нөҥүө улуус <span class="description" id="354">нөрүөннээҕэ</span> буоллаҕыҥ,<br>Атын улуус ааттааҕа буоллаҕыҥ,<br>Туспа дойду дьоһуннааҕа буоллаҕыҥ!<br>Мин диэтэх киһи
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1060
                    </td>
                    <td>
                        Этэр тылым эгэлгэтин иһит:<br>Соруктанан тутан кэлбит<br>Соругум тугуй диэҥҥин<br>Бэлэспиттэн эппиэттээ,<br>Айахпыттан дакаастаа,<br>Тумсубуттан тутан <span class="description" id="355">топпуруостаа</span>,<br>Ол топпуруостуур буолларгын,<br><span class="description" id="356">Чиэски</span> нэһилиэктээх,<br>Тэйиччи тэлгэһэлээх,<br>Ыраах ыырдаах киһи кэллим.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1070
                    </td>
                    <td>
                        Сирим-сибиирим буоллаҕына,<br>Көтөр кынаттаах кыылым<br>Үс төгүл сымыыттаан тиийэр,<br>Сүүрэр атахтаах кыылым<br>Сэттэ төгүл тугуттаан тиийэр<br>Ыраах ыырдаах киһибин.<br>Кимтэн кииннээххиний,<br>Хантан хааннааххыный,<br>Туохтан тутаахтааххыный диир буоллаххына,<br>Хаҥырыыр Хаан тойон аҕалаах,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1080
                    </td>
                    <td>
                        Кыҥырыыр Хаан эмээхсин ийэлээх,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1081
                    </td>
                    <td>
                        Алталаах атыыр сылгы аттаах,<br>Иккилээх оҕо Эрбэхтэй Бэргэммин.<br>Соҕуруу халлаан соҕуруу өттүгэр<br><span class="description" id="357">Суодуйан</span> улаатан үөскээбит,<br>Сор муоһун тосту үктээн төрөөбүт<br>Соллон Туйгун обургу<br>Сиэри сирдэммитэ,<br>Аһаары аһыйбыта<br>Тоҕус сыла томточчу туолла.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1090
                    </td>
                    <td>
                        Итиниэхэ аллараа түгэх дьалын-ыырайга<br>Сүргүөхтээх балык сүүс дьүһүннээҕэ буоламмын<br>Куота сатаан кэбистим.<br>Бу отто дойдуга тахсаммын<br>Сүүс сүүрэр атахтаах кыыл<br>Сүүс дьүһүннээҕэ буоламмын,<br>Кубулунан куота сатаан кэбистим.<br>Үөһээ дойдуга тахсаммын,<br>Өрө көрдөххө өрөҕөтө көҕөрөн көстөр<br>Үс хаттыгастаах
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1100
                    </td>
                    <td>
                        <span class="description" id="358">Өндөл</span> маҕан халлаан үрдүгэр<br>Көтөр кынаттаах сүүс дьүһүннээҕэ буоламмын,<br>Кубулунан куота сатаан кэбистим.<br>Барар сирим баҕана үүтэ буолла,<br>Кэлэр сирим <span class="description" id="359">кэлии</span> үүтэ буолла,<br>Киэҥҥэр хорҕот,<br>Кыараҕаскар кыбыт, — диэн<br>Ытыы-соҥуу сытта.<br>Икки ытыстарынан сырайын саба туттан<br>Үллэ-үллэ ытыы сытта...
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1110
                    </td>
                    <td>
                        «Улаатыгар, оҕолоор, бу!
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1111
                    </td>
                    <td>
                        Сэттэ уон эйиэн иэйэхсит биэрэгэр<br>Дьиэлэммитим дии санаммытым,<br>Аҕыс уон аргыстанан түһэр<br>Айыыһыт дьаарбаҥын ааныгар<br>Арҕахтаах курдук санаммытым,<br>Тоҕус уон суккуллан түһэр<br>Хотун иэйэхсит оппуоһун ааныгар<br>Олохтоохпун оҥостуммутум.<br>Ол баара бу орто дойдуга
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1120
                    </td>
                    <td>
                        Уһугунан үктэммит,<br>Ортотунан курдаммыт,<br>Босхо бастаах,<br>Уһаты муруннаах,<br>Туора харахтаах<br>Буор, салгын тыыннаах<br>Боролуйар бороҥ урааҥхайы<br>Утары туран көссүбэтэҕим.<br>Көрөөрү көрөммүн<br>Киэҥ халлаантан
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1130
                    </td>
                    <td>
                        Кытарар кыһыл сыгыньньах киһи<br>Түһэн кэлбитэ сүрдээҕин, оҕолоор!<br>Хайтах гыныах бэйэкэм буолла» — диэн,<br>Биһиги киһибит саныы турда.<br>Итиниэхэ үөһээттэн түспүт киһи,<br>Иккиһин умса түһэ сытан,<br>Ытыы-соҥуу, ыллыы-туойа сытар:<br>— Чэ, туспа улуус туһааннааҕа убайыам,<br>Нөҥүө улуус нөрүөннээҕэ доҕоруом,<br>Атын дойду ааттааҕа атаһыам,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1140
                    </td>
                    <td>
                        Ытык тылбын ыкка сиэтимэ,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1141
                    </td>
                    <td>
                        Дьоһун тылбын суорга тоҥсуттарыма!<br>Абааһы бухатыырын ааттааҕа баҕайы<br>Кэлэн сиэн-аһаан кэбистэҕинэ,<br>Кылгас уҥуоҕум<br>Кыс мас буолан<br><span class="description" id="360">Кыдьымахтанан</span> хаалыа буоллаҕа,<br>Уһун уҥуоҕум урусхал мас буолан<br>Устан хаалыа буоллаҕа.<br>Ол хаалбытын кэннэ
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1150
                    </td>
                    <td>
                        Эн муҥ сатаатар<br>Кырамта уҥуохпун хомуйан ылаҥҥын<br>Хоту диэки турар<br>Урааньньыктаах дуорай тумулуҥ үрдүгэр<br>Күрүө иини хаһаҥҥын<br>Кырамтабын кыбытаар эрэ!<br>Хаарыан бэйэлээх<br>Хаҥырыыр Хаан Тойон аҕам,<br>Бырадыйа бырастыы буоллун.<br>Кыҥырыыр Хаан эмээхсин ийэм,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1160
                    </td>
                    <td>
                        Быралыйа бырастыы буоллун!<br>Ол кэнниттэн —<br>Аҕыс былас аалай солко суһуохтаах<br>Арылы Куо диэн хотун балтым,<br>Быралыйа бырастыы буоллун!<br>Көмүскүүрүм <span class="description" id="361">көмүскэм</span> уута буолла,<br>Харыһыйарым диэн хараҕым уута буолла,<br>Ыый-ыйбын, аай-айбын!<br>Ыллаатахпын-туойдахпын эминэ тугуй,<br>Ытаатахпын-соҥоотохпун эминэ тугуй!
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1170
                    </td>
                    <td>
                        Аны кэлэн туохтаах буоламмын
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1171
                    </td>
                    <td>
                        Туоҕум көмүскүө баарай!<br>Өлөр күнүм үтүрүйэн кэллэ,<br>Хаалар күнүм хахалаан кэллэ! — дии сытар.<br>Ити сыттаҕына биһиги киһибит<br>Сылгы уола Дыырай бухатыыр<br>Сыаналаан көрдө:<br>«Уот-татай, оҕолоор!<br>Айыы аймаҕын<br>Аҥаарыйар үтүөтэ быһыылаах эбит,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1180
                    </td>
                    <td>
                        Күн улууһун<br>Күөгэйэр бэрдэ эбит ээ!<br>Бу аҕалаах ийэтэ да<br>Үтүө-төрүт дьоннор эбит, быһыыта,<br>Бу бииргэ төрөөбүт балта да,<br>Ааттыын-суоллуун да иһиттэххэ,<br>Үчүгэй дьахтар эбит, быһыыта,<br>Аҕыс былас аалай солко суһуохтаах<br>Арылы Куо диэн<br>Үчүгэй үтүө-мааны дьахтар эбит ээ!
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1190
                    </td>
                    <td>
                        Айыы киһитэ буолан бараммын,<br>Айыы киһитин абырыахпын сөп эбит.<br>Икки харахпынан көрөн тураммын,<br>Абааһыга да сиэтэн кэбиһэр диэн,<br>Сүрэ бэт буоссу.<br>Бу Дыырай бухатыыр көрөн туран<br>Алталаах атыыр сылгы аттаах<br>Иккилээх Эрбэхтэй Бэргэни<br>Абааһыга сиэтэн кэбиспит диэннэр,<br>Хойут утуйар дьон
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1200
                    </td>
                    <td>
                        Хоһоон оҥосто сылдьыахтара,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1201
                    </td>
                    <td>
                        Эрдэ турар дьон<br>Элэк гына сылдьыахтара,<br><span class="description" id="362">Күөрт</span> ыттар<br>Күлүү гына сылдьыахтара,<br>Эриэн ыттар<br>Элэк гына сылдьыахтара.<br>Бу киһини мин абыраатаҕым», —<br>Дии санаата да, уун-утары<br>Үтүрү-батары хааман кэллэ.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1210
                    </td>
                    <td>
                        Умса түһэ сытар киһини<br>Илиититтэн туруору тардан ылла,<br>Соҕуруу диэки соноҕос сылгы<br><span class="description" id="363">Дьохсооттуу</span> турарын курдук<br><span class="description" id="364">Урааньньыктаах</span> дуурай маҕан тумулугар<br>Өрө сиэтэн <span class="description" id="365">дэллэкэччитэн</span> таһааран<br>Тоҥмут сири тобугун хараҕар дылы<br>Тобулу үктээн баран<br>Арыйа тэбэн кэбистэ.<br>Бу арыйбытыгар;
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1220
                    </td>
                    <td>
                        Аҕыс уон былас төгүрүмтэлээх иин<br>Аана аралыс гына түстэ.<br>Киһитин иин иһигэр умсары аньньан<br><span class="description" id="366">Дьөгдьөрүс гыннаран</span> кэбистэ.<br>Иинин аанын сир кырсынан саба тарта,<br>Ытыһыгар силлээн баран<br>Төттөрү-таары имэрийтэлээн кэбистэ,<br>Үс салаалаах үкэр күөх от<br>Өрө үүнэн <span class="description" id="367">өрөкүс</span> гына түстэ.<br>Били гынан баран
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1230
                    </td>
                    <td>
                        Бэйэтэ көй киинигэр, көмүс уйатыгар
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1231
                    </td>
                    <td>
                        Төттөрү сүүрэн кэллэ.<br>Бу сүүрэн кэлэн<br>Бухатыырга таҥнар таҥас диэн<br>Таҥнан кэбистэ,<br>Бухатыырга туттар сэп диэн<br>Сэбилэнэн кэбистэ,<br>Хааннаах <span class="description" id="368">дапсылҕата</span> диэни<br>Таҥнары тайахтанна,<br>Өһөхтөөх сөгөлөөнө диэни
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1240
                    </td>
                    <td>
                        Өрө тутта:<br>Аҕыс салаалаах Аал Дуук Маһын төрдүгэр<br>Муҥ сүүрүүнэн тиийдэ.<br>Бу тиийэн иһиллээн турда.<br>Бу иһиллээн туран:<br>— Абааһы абааһыга дылы<br>Харахпар көстүбэккэ кэлэн<br>Аһаан-сиэн кэбиһиэх бэйэкэтэ буоллаҕа, — дии турда.<br>«Ити эрээри, илин диэкиттэн<br>Нэлэйэ сиэлэн кэлэрэ эбитэ буоллар,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1250
                    </td>
                    <td>
                        Арҕаа диэкиттэн<br>Арбайа сүүрэн көстөрө буоллар,<br>Соҕурууттан <span class="description" id="369">суодайа</span> сүүрэн,<br>Хотуттан <span class="description" id="370">ходьойо</span> сүүрэн<br>Харахпар көстөн кэлэрэ буоллар,<br>Суон куолайыгар үҥүүлээх батаспын<br>Туора тутаммын<br>Тоһуйсан көрүөм эбээ» — дии саныы турда.<br>Туһааннаах тус соҕуруу диэкиттэн<br>Үлүгэрдээх, өлөссүүлээх,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1260
                    </td>
                    <td>
                        Үлүскэннээх холорук
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1261
                    </td>
                    <td>
                        Соҕотохто түһэн кэбистэ,<br>Алдьархайдаах харбаһыылаах<br>Ала буурай хара холорук<br>Соҕотохто түһэн айдаарда,<br>Охсуһуулаах <span class="description" id="371">содуомнаах</span> <br>Тоҕус <span class="description" id="372">хараҕалаах</span>,<br>Дуолан хара холорук<br>Түһэн түнүйэн кэбистэ.<br>От-мас иэн иҥиирин курдук
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1270
                    </td>
                    <td>
                        Таҥнары сыыйыллан барда.<br>Үөһэ дойдуттан, бороҥ куобах баттаҕын<br>Хайыта сыспыт курдук,<br>Муустаах буордаах<br>Тобурах хаар<br>Түһэн туналыппытынан барда.<br>Ити кэнниттэн<br>Тутуспут киһи тутуспутунан мунан барар<br>Тумана баҕайы түһэн<br>Туоллан-тунуйан кэбистэ.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1280
                    </td>
                    <td>
                        Харбаспыт киһи харбаспытынан мунан барар<br>Өлүү балай хараҥата<br>Соҕотохто барыс гына түстэ.<br>Ол кэнниттэн өйдөөн көрбүтэ:<br>Туһааннаах тус соҕуруу диэкиттэн<br>Сүрдээх кытаанах кынат тыаһа<br>Кыыгынаан түһэн иһэр,<br>Сүрдээх хомуһуннаах <span class="description" id="373">хотоҕой</span> тыаһа<br>Куугунаан түһэн кэллэ.<br>Ити кэлбитин көрбүтэ:
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1290
                    </td>
                    <td>
                        Кынаттаах кыыл гиэнэ
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1291
                    </td>
                    <td>
                        Кырдьаҕаһа быһыылаах,<br>Хотоҕойдоох кыыл гиэнэ<br>Хорсуна быһыылаах.<br>Илин өттүгэр үс хос бастаах эбит.<br>Үс баһыгар былыргы киһи хотуурун<br>Туруору охсон тахсыбытын курдук<br>Үс чай дьойуо тумустаах эбит.<br>Бу үс баһа баҕадьы<br>Үс <span class="description" id="374">чаан олгуй</span> саҕа эбит.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1300
                    </td>
                    <td>
                        Үс баһыгар үс чааскы саҕа<br>Үс харахтаах баҕайы эбит.<br>Үс хос <span class="description" id="375">быһычча</span> быһах курдук,<br>Тимир <span class="description" id="376">чыллырыыт</span> түүлээх.<br>Тэлэмэн тыс курдук кынаттаах,<br>Түгэх туоһун төлө үктээбит курдук<br>Буруо түптэлээх кутуруктаах эбит.<br>Икки атаҕар уон харалаабыт аньньыыны<br>Хардарыта туппут курдук<br>Уон тимир <span class="description" id="377">лааҕыра</span> тыҥырахтаах эбит.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1310
                    </td>
                    <td>
                        Бу кыыл обургу<br>Бу аан ийэ дойдуну<br>Үс төгүл тула көтөн эргийдэ.<br>Ити гынан баран<br>Аҕыс салаалаах Аал Дуук Мас<br>Аҕыс салаатыттан түөт салаатын<br>Холбуу хомуйа тардан ылла,<br>Олорон логлорус гына түстэ.<br>Ол олбохтонон олорон,<br>Илин арҕаа диэкки
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1320
                    </td>
                    <td>
                        Иҥнэс-таҥнас гынна,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1321
                    </td>
                    <td>
                        Тумсун уоһун оҥоһунна,<br>Биһи киһибит диэкки<br><span class="description" id="378">Эрэлик-турулук көрдө</span>.<br>Онуоха баара Аал Дуук Мас<br><span class="description" id="379">Иэҕэлдьийэргэ</span> дылы гынна.<br>Биһи киһибит мантан<br>Куттанан-уолуйан<br>Кыһыл <span class="description" id="380">кыппыайкатыгар</span>,<br>Таас таалайа хонуутугар
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1330
                    </td>
                    <td>
                        Кэннинэн чугурус гына түстэ.<br>Ити гынан баран<br>Уолуйбут, куттаммыт киһи быһыытынан<br>Кини диэкки өрө көрөн турда.<br>Ити турдаҕына били кыыла баҕадьы	<br><span class="description" id="381">Хоро тойугун</span> туойа олордо,<br>Аан чаҕаат ырыатын ыллыы олордо:<br>— Аат татай, доҕор!<br>Сэттэ киирэр эйиэн иэйэхсит биэрэгэр дьиэлэммит,<br>Аҕыс уон айгыстан түһэр
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1340
                    </td>
                    <td>
                        Атыыһыт дьаарбаҥын ааныгар арҕахтаммыт,<br>Тоҕус уон <span class="description" id="382">суккуллан</span> түһэр<br>Хатай иэйэхсит оппуоһун ааныгар олохсуйбут,<br>Тыллаах-өстөөх Хара Кулун аттаах<br>Сылгы уола Дыырай Бөҕө,<br>Дьэ, дорообо буоллун!<br>Дьэ, доҕоор,<br>Сыаллаах соругум,<br>Санаалаах наадам тугуй диэтэргин;<br>Кыҥырыал Хаан эмээхсин ийэлээх,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1350
                    </td>
                    <td>
                        Хаҥырыал Хаан тойон оҕоньньор аҕалаах,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1351
                    </td>
                    <td>
                        Алталаах атыыр сылгы аттаах<br>Иккилээх Эрбэхтэй Бэргэни<br>Сиэри сирдэммитим,<br>Аһаары аһайдаммытым<br>Тоҕус төгүрүк сыла томточчу туолла.<br>Таҥнары дайбыырбар<br>Дабыдалын силиитэ <span class="description" id="383">чэлгэх</span> буолла,<br>Умсары дайбыырбар<br><span class="description" id="384">Оҥкумалын</span> силиитэ уу буолла.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1360
                    </td>
                    <td>
                        Ону баара эн диэтэх киһи<br><span class="description" id="385">Киэлитэ</span> биллибэт киэҥ дойдугар<br>Тиийэн кэлэн баран<br>Суол бөҕөтө сүттэ.<br>Эн киһини туохтан<br>Киэҥҥэр хорҕотор буолаҕын?<br>Кыараҕаскар кыбытар буолаҕын?<br>Көр, мин диэтэх киһи,<br>Истиэххин тиэтэйдэргин,<br>Иһит үрдүн испит
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1370
                    </td>
                    <td>
                        <span class="description" id="386">Идэмэрдээх</span> ийэлээхпин,<br>Ас үрдүн аһаабыт<br><span class="description" id="387">Адьынаттаах</span> аҕалаахпын.<br>Аҕам буоллаҕына<br><span class="description" id="388">Адаҕалаах</span> ампаар айах<br>Тимир Лаҥкырдаан диэн<br>Аар тойон аҕам буолар.<br>Ийэм буоллаҕына<br>Иҥсэлээх идэмэрдээх,<br>Илбистээх бэлэстээх
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1380
                    </td>
                    <td>
                        Ытык Куоҕайдаан эмээхсин диэн
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1381
                    </td>
                    <td>
                        Ийэ хотун буолар.<br>Соҕуруу халлаан улахатыгар<br><span class="description" id="389">Кинээс-кулуба</span> дуоһунастаммыт,<br>Сор муоһун тосту үктээбит<br>Сордоох соллоҥ туйгун<br>Сүрдээх Сүҥ Дьааһын диэн мин буолабын.<br>Эрбэхтэй Бэргэн эрэйдээҕи<br>Итии хаанын<br>Итиитинэн иһиэм диэммин,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1390
                    </td>
                    <td>
                        Буһуу хаанын<br>Буһуутунан боруобалыам диэммин,<br>Толкуйданан кэлбит киһи этим.<br>Мас курдук, батары киһини аҕал!<br>Биэрдэргин да ылар киһи кэллим,<br>Биэрбэтэргин да ылар киһи кэллим.<br>Үгүс тыл сымсах,<br>Аҕыйах тыл миньньигэс!<br>Үтүө киһи тыла биир,<br>Үчүгэй ат кымньыыта соҕотох.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1400
                    </td>
                    <td>
                        Биэрбэт күннээх буоллаххына,<br>Бэйэҕин кытта мэлитиэм! —<br>Иньньэ диэтэ даа, кыһыл кыппыайкаҕа,<br>Таас <span class="description" id="390">таалаҕа</span> <br>Таҥнары сатыылаан түстэ.<br>Үс төгүл таҥнары холоруктаата,<br>Далаадыйар долуу өксөкүтүн тириитин<br>Киэр илгистэн кэбистэ.<br>Итини биһиги киһибит<br>Өйдөөн-дьүүллээн көрөн турда.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1410
                    </td>
                    <td>
                        Итини көрбүтэ:
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1411
                    </td>
                    <td>
                        Килэгир тимир киһи быһыылаах,<br>Туох да <span class="description" id="391">дьиэгэ</span> суох<br>Мүлү-мүлүр илгистэн кэбиһэр,<br>Лэп-лэп эккириир.<br>Итини көрөн баран<br>Биһиги киһибит сонун тэллэҕэ<br>Илибирэс буолуор дылы куттанна.<br>Одуулаан көрбүтэ:<br>Самаҕын туорайыттан үүммүт
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1420
                    </td>
                    <td>
                        Соҕотох сор күлүк<br>Сотолоох эбит,<br>Тоҕус мастаах оҥочону<br>Умсары бырахпыт курдук<br>Сабарай таас уллуҥахтаах эбит,<br>Түөһүн бүттэҕиттэн мүччү сүүрэн түспүт<br>Былаа хара биир эрэ илиилээх эбит,<br>Муус харбыыр хоппо күрдьэх курдук<br>Хомуһуннаах куорай далай соҕотох ытыстаах,<br>Сыыр сиҥнибитин курдук
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1430
                    </td>
                    <td>
                        <span class="description" id="392">Сылластыгас</span> сымыһахтаах,<br>Быраан быстыбытын курдук<br><span class="description" id="393">Былластыгас</span> уостаах,<br>Хайа хайдыбытын курдук<br><span class="description" id="394">Ханьньастыгас</span> айахтаах.<br>Икки таҥалайыттан хардарыта үүнэн киирбит<br>Баай ыал <span class="description" id="395">арбыйалаах</span> дьаастыгын<br>Хардарыта туппут курдук<br>Дьэбиннээх күөх наалый тиистээх,<br>Уолбут ойбон курдук <span class="description" id="396">оҥойо</span> сытыйбыт
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1440
                    </td>
                    <td>
                        Суо-соҕотох таныы үүттээх,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1441
                    </td>
                    <td>
                        Сирэйин хабыллар хаба оттотугар<br>Көлүйэ күөл көспүтүн курдук<br>Көмүскэ оруннаах,<br>Көмүскэтин хаба оттотугар<br><span class="description" id="397">Дэриэтиньньик</span> киһи <span class="description" id="398">дьэс</span> тэриэлкэтин<br>Тиэрэ таппыт курдук<br>Дьэбиннээх сиикэй <span class="description" id="399">эт бэргэ харахтаах</span>,<br>Хараҕын үрүт өттүгэр<br>Өрүскэ киһи үтэһэтин курдук
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1450
                    </td>
                    <td>
                        Тимир дьалааҥкы кыламаннаах,<br>Төбөтүн оройугар сатыы ойууру<br>Өрт уота быһыта салаан барбытын курдук<br><span class="description" id="400">Абына-табына</span> баттахтаах,<br>Сэттэ илии дьэбиннээх иэдэстээх,<br>Аҕыс илии <span class="description" id="401">амынахтаах</span> сырайдаах,<br>Тоҕус илии <span class="description" id="402">көлбөхтөөх</span> ньуурдаах,<br>Сытамматах сырайдаах,<br>Табыллыбатах <span class="description" id="403">таһаалаах</span>,<br>Тупсубатах <span class="description" id="404">ньуурдаах</span>,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1460
                    </td>
                    <td>
                        Улуу киһи, <span class="description" id="405">урааҥхай</span> бөҕө быһыылаах.<br>Тоҕус уон бууттаах<br>Мунду муҥхатын саҕа<br>Борук хара ыстааннаах.<br>Аҕыс өттүнэн аҕыс кырыылаах<br>Аҕыс уон бууттаах<br>Тимир <span class="description" id="406">халымыайка</span> хахтаах сонноох,<br>Сэттэ уон бууттаах дьэс сирэдэһиннээх бэргэһэлээх,<br>Биэс уон бууттаах тарбахтаах үтүлүктээх.<br>Итиниэхэ Сылгы уола Дыырай тыл кэпсии
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1470
                    </td>
                    <td>
                        Өрөөбүт уоһун өһүллэ,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1471
                    </td>
                    <td>
                        Хоммут уоһун хомуйда,<br>Алтан дьаакыр айаҕын аппаҥнатта,<br>Үрүҥ көмүс сүөлэгэй күөмэйин көбүөлэттэ.<br>Уоһа <span class="description" id="407">хороҥноото</span>,<br>Уолуга <span class="description" id="408">томтолдьуйда</span>,<br>Үҥүү батас курдук<br>Үтүрү-батары көрөн кэбистэ,<br>Быһах <span class="description" id="409">хатат</span> курдук<br>Быһа-таһа көрөн кэбистэ:
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1480
                    </td>
                    <td>
                        — Дьэ-буо! Дьэ-дуо!<br>Туох дойдуттан туран тиийэн кэлбит<br><span class="description" id="410">Солоҕой</span> уола буллаҕыҥ буолуой?<br>Хайа дойдуттан халбарыйан хамсаан кэлбит<br><span class="description" id="411">Дьалаҕай</span> уола таарыйан тураргын<br>Бэйэм да кыайан билбэтим.<br>Мин диэтэх киһи<br>Иэйэхситтээх <span class="description" id="412">иэримэ</span> хонуубар<br><span class="description" id="413">Чиччик</span> бөҕөҕүн тэнитимэ.<br>Киэр <span class="description" id="414">күдүө</span> бара тат!
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1490
                    </td>
                    <td>
                        Мин диэтэх киһи<br>Айыыһыттаах араҕас маҕан хонуубар<br><span class="description" id="415">Чалаҕайгын</span> тарҕатыма!<br>Кэлбит сириҥ ханнаный,<br>Киэр күдүө бара тат!<br>Ол барбат күннээх буоллаххына,<br>Халыҥ тириигин хайыта сыньньаммын*,<br>Хара балай хааҥҥын <span class="description" id="416">халдьыгыраччы</span> сүүрдүөм,<br>Чэгиэн эккин <span class="description" id="417">сэймэктиэм</span>,<br><span class="description" id="418">Өлүөр</span> эккин <span class="description" id="419">үөрэҕэстиэм</span>,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1500
                    </td>
                    <td>
                        Кыһыл эккин кырбастыам,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1501
                    </td>
                    <td>
                        Үрүт өргөс <span class="description" id="420">кылааҥҥын</span> <span class="description" id="421">сарбыйыам</span>,<br>Алын түгэх <span class="description" id="422">нэлбэйбиккин</span> <span class="description" id="423">кырадаһынныам</span>,<br>Киһи буолар кэскилгиттэн <span class="description" id="424">кэбэлитиэм</span>,<br>Сүөһү буолар төлкөҕүнэн төнүннэриэм,<br>Уһун соргугун сарбыйыам,<br>Дьол бөҕөҕүн тоҕута сыньньыам,<br>Күлэ-күлэ күлгүн буккуйуом,<br>Ооньньуу-ооньньуу уоккун умуруоруом!
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1510
                    </td>
                    <td>
                        Онуоха абааһы бухатыыра дьөксө күлэрдээх:<br>— Ии һа-һа-һаах!<br>Бу <span class="description" id="425">дураан</span> <span class="description" id="426">чубучу</span> тылын көрүҥ эрэ,<br>Көр да <span class="description" id="427">маҥай аллаах</span>,<br>Иннигиттэн көрдөххө <span class="description" id="428">иһэх*</span> саҕа эбиккин,<br>Кэннигиттэн көрдөххө <span class="description" id="429">кэһэх*</span> саҕа эбиккин,<br>Тылыҥ-өһүҥ тоҕо чобуотай?<br>Саҥаҥ-иҥэҥ тоҕо мэнигэй?<br>Мин диэтэх киһи<br>Биэс билир балтабар*<br>Биллиэҥ да суох буолбаккын дуо?
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1520
                    </td>
                    <td>
                        Таллан таас таҥалайбар<br>Табыллыа да суох буолбаккын дуо?<br>Айаҕыҥ абатын,<br>Бэлэһиҥ бэтэтин,<br>Куолайыҥ сүлүһүнүн<br>Көрбөккүөн, маҥай аллаах! — диэтэ да,<br>Борооску баһын саҕа сутуругун<br><span class="description" id="430">Болточчу тутан</span> кэбистэ,<br>Барык бэс салаатын курдук<br>Ынырыктаах ыдьыа-быдьыа харытын
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1530
                    </td>
                    <td>
                        Өрө тутан кэбистэ,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1531
                    </td>
                    <td>
                        Таҥнары сутурҕалаан охсуталаан барда.<br>Итиниэхэ биһиги киһибит баара —<br>Кытыл уҥуортан <span class="description" id="431">кылбай</span>бытынан кэлэр<br>Кыырыктаах хара <span class="description" id="432">дьиэрэҥкэй үҥүү</span>түнэн<br>Хараарар хара быарын туһа манан буолуо диэн,<br>Хаһытыы-хаһытыы кэйиэлии испитэ,<br>Уйан иэмэх курдук<br>Кэдэрги өҕүллэн хаалла,<br>Ону кэннинэн эһэн кэбистэ;
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1540
                    </td>
                    <td>
                        Уҥуоргу тыаттан <span class="description" id="433">олодуй</span>ан кэлэр<br>Уорааннаах уһун субуйа <span class="description" id="434">болот</span>унан<br>Суон мооньньун төрдүгэр <span class="description" id="435">куһурҕа</span>тта,<br>Тоһута сыньньан кэбистэ,<br>Ону кэннинэн эһэн кэбистэ.<br>Сэттэ уон бууттаах<br>Бэт тимир дэлэмир мээчигинэн<br>Хараарар хара быара буолаарай диэн,<br>Хаһыытыы-хаһыытыы тамнааттаан истэ,<br>Албын дьахтар алаадьытын курдук,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1550
                    </td>
                    <td>
                        Хаптаччы барыталаан хааллылар.<br>Тоҕус уон бууттаах<br>Тутаахтаах <span class="description" id="436">чомпо сүллүгэһинэн</span> <br>Өрө көтө түһэ-түһэ<br>Уу <span class="description" id="437">дьулайга</span> охсуталаата,<br>Тоһута сыньньан кэбистэ.<br>Түүтүн баһа хомуллубат киһи буолан биэрдэ,<br>Тириитин таһа <span class="description" id="438">сынтарыйбат</span> киһи буолан биэрдэ<br>Ити кэнниттэн —<br><span class="description" id="439">Боппууда</span> бурдук холобурдаах
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1560
                    </td>
                    <td>
                        Сомоҕо көмүс сутуругунан
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1561
                    </td>
                    <td>
                        <span class="description" id="440">Битигирэйэн</span> тиийэн муннун анныгар<br>«Кокуоска бу баар» — диэн аспыта,<br>Хонноҕун анныгар дылы көтүтэн түһэрдэ.<br>Мантан соһуйан абааһы бухатыыра<br>Иттэннэри кэҕис гына түстэ,<br>Таныытын үүтүн биир харыс холобурдааҕы<br>Хайа тардан <span class="description" id="441">дьаллас гыннаран</span> кэбистэ.<br>Итинтэн биһиги киһибит эргичийэ түстэ.<br>Хаҥас диэки <span class="description" id="442">дьаргыл таас харытынан</span>,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1570
                    </td>
                    <td>
                        Ньыгыл көмүс ытыһынан<br>Иэдэс тааска биэрэн кэбистэ.<br>Абааһы уола биир илиитинэн сири харбаан<br><span class="description" id="443">Бэрикичис гынан</span> ылла.<br><span class="description" id="444">Харсыылаах оҕус</span> курдук<br>Хапсаҕай харыларыттан<br>Хабыта тыытыһан ыланнар,<br>Хатыһан киирэн бардылар,<br>Иэн иҥиирин курдук<br>Эриссэн, сыссан* бардылар.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1580
                    </td>
                    <td>
                        Кытаанах кыргыһыы буолла,<br>Улахан охсуһуу турда,<br><span class="description" id="445">Дирбиэн тииһик</span> буолла,<br>Уйуулаах-хайыылаах тойугу туойдулар,<br>Ыһыылаах-хаһыылаах ырыаны ыллаатылар,<br>Дирбиэн тииһигин түһэрдилэр.<br>Эрбии биитин курдук<br>Тэбис-тэҥ дьон буоллулар.<br>Ый аахпыт отут хонуга<br>Томтойо туолуор дылы охсустулар.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1590
                    </td>
                    <td>
                        Кыһыл <span class="description" id="446">кыппыайканы</span> 
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1591
                    </td>
                    <td>
                        Таас <span class="description" id="447">таалыйа</span> хонууларын<br>Ооҕуй оҕус бадарааннаан хаамар гына<br>Кута намылҕата оҥорон,<br><span class="description" id="448">Күөгэлдьиччи</span> үктээн бардылар.<br>Устата биллибэт <span class="description" id="449">улаабыр</span> муораны<br><span class="description" id="450">Тордуйалаах</span> уу курдук<br>Тобуктарын хараҕар дылы<br>Тоҕута тэпсэн таһаардылар.<br><span class="description" id="451">Арылы хара далай күөлүн</span> 
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1600
                    </td>
                    <td>
                        <span class="description" id="452">Атыйахтаах</span> уу курдук<br><span class="description" id="453">Ньайбалдьыччы</span> тэпсэн бардылар.<br>Отто дойдуну үөһээ үрүт курдуутунан<br>Үрүҥ <span class="description" id="454">күдэн</span> өрүкүс гына түстэ,<br>Аан дойдуларын отто курдуутунан<br>Хара күдэн барыкыс гынан таҕыста.<br>Итиниэхэ дылы икки ый гиэнэ<br>Аахпыт алта уон хонуга<br><span class="description" id="455">Аччайа</span> туолла.<br>Биһиги киһибит буоллаҕына
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1610
                    </td>
                    <td>
                        Икки сотото<br><span class="description" id="456">Тардыылаах оҕус</span> <span class="description" id="457">буулаҕатын</span> курдук<br>Таҥнары <span class="description" id="458">маадьайан</span> түһэн барда,<br>Иэнин иҥиирэ киил мас курдук<br>Кэдэрги тардан барда,<br>Хатан мас курдук<br>Ханаччы тардан барда,<br>Чанчыгын баттаҕа<br>Чоноччу тардан барда.<br>Төбөтүн оройуттан сиэрэ уотун курдук
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1620
                    </td>
                    <td>
                        Күөх унаар уоттар
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1621
                    </td>
                    <td>
                        Өрө күүрэн таҕыстылар,<br>Хараҕын уота <span class="description" id="459">хатат</span> уотун курдук<br><span class="description" id="460">Сардырҕаччы</span> таммалыы сырытта,<br>Күүс быччыҥнарын бастара<br>Көмүс луосканы таҥнары туппут курдук<br><span class="description" id="461">Логлорута</span> ойон тахсыталаата.<br>«Уот-татай, оҕолоор!<br>Кини атаҕа соҕотох этэ эбээт,<br>Илиитэ биир эрэ этэ» — дии санаата.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1630
                    </td>
                    <td>
                        «Хайтах-хайтах тутта<br>Хапта сылдьабын!» — диэтэ.<br>Хаһыытыы-хаһыытыы<br>Халбарыйан киирэн барда,<br>Кылана түһэ-түһэ<br>Кыйгыһахтаан истэ,<br>Үөгүлүү-үөгүлүү өттүктээтэ,<br>Аан дойдуттан араара тутан барда,<br>Улуу дойдуттан уларыссы* тутан истэ,<br>Киэҥ дойдуттан <span class="description" id="462">кэйбэччи</span> тутта,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1640
                    </td>
                    <td>
                        Мастан бардамнатта,<br>Оттон олустатан барда.<br>Тииттээх сиртэн <span class="description" id="463">тэбиэһирдэн</span> киллэрдэ,<br>Кыланан баран өрө кэдэрис гына түстэ.<br>Түөһүгэр сөрөөн көтөхтө,<br>Өттүгэр мииннэрдэ,<br>Тула <span class="description" id="464">тэлэкэчиттэ</span>.<br>Үүнэн эрэр ойууру<br>Үрдүнэн сүүрэкэлэттэ,<br>Сылдьар былыты
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1650
                    </td>
                    <td>
                        Аннынан тэлэкэчиттэ,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1651
                    </td>
                    <td>
                        Эргитэн аҕалан тиэрэ бырахта,<br>Сири сэттэ <span class="description" id="465">бэчээтинэй</span> дэлби кэбиһэн түһэрдэ,<br>Түөһүттэн миинэ түстэ.<br><span class="description" id="466">Кыын</span> быатын быһыта сүүрэн тахсар,<br><span class="description" id="467">Кытахтаах</span> эти эргийэ сүүрэр,<br><span class="description" id="468">Байтаһын</span> биэ хаһатын хайа сүүрэн тахсар,<br>Сэттэ <span class="description" id="469">болгуоттан</span>* <span class="description" id="470">чээрэлээн</span> ылбыт,<br>Отут болгуоттан <span class="description" id="471">оргуньньуктаан</span> ылбыт<br><span class="description" id="472">Ылыр-чылыр быһыйа</span> быһахтаах эбит.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1660
                    </td>
                    <td>
                        Онтун баара сулбу <span class="description" id="473">сүүдүйэн</span> ылла даа,<br><span class="description" id="474">Өҥүргэс</span> хабарҕатын хайа баттаата,<br>Үрүҥ сүньньүн туора олуйан таһаарда.<br>Уҥа илиитинэн тардыалаан <span class="description" id="475">чинэлдьиттэ</span>,<br>Хаҥас өттүнэн батары саайда,<br><span class="description" id="476">Харыс</span> кэриҥин хайа <span class="description" id="477">сиэлийэн</span> ылла,<br>Хаҥас диэкки сиэхтээх илиитин батары биэрдэ,<br>Чиккэйэн турар сиһин үөһүн харбаата,<br>Тардыалаан чиккэлдьиттэ.<br>Абааһы бухатыыра кэтэҕинэн чиэстэннэ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1670
                    </td>
                    <td>
                        Тирэҕинэн тэбиннэ,<br>Үс түүннээх күн мөҕөн <span class="description" id="478">лиһиргэттэ</span>.<br>Бу сылдьан ый ытыыны ытыы сырытта,<br>Суон соҥууну <span class="description" id="479">соҥуу</span> сырытта,<br>Хараҕын уута түннүк мууһун курдук<br><span class="description" id="480">Лөһүгүрэччи</span> тоҕунна.<br>Итиэннэ ити курдук тойуктаах сырытта,<br>Бэт куһаҕаннык «Ыы-аа» — диэн ынчыктаата.<br>Ити кэнниттэн:<br>— Тойокоо, тойокоом!
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1680
                    </td>
                    <td>
                        Тохтоо, болҕой!
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1681
                    </td>
                    <td>
                        Мин эрэйдээҕи<br>Өлөрөҥҥүн-сүтэрэҥҥин даҕаны<br>Үтүө аат кэлиэ суоҕа.<br><span class="description" id="481">Махчаччы</span> тэбинэн тураммын<br>Маһы бэккэ мастыыр баҕадьыбын,<br>Оту бэккэ охсор баҕадьыбын.<br>Этэрбэс куурдар<br>Идэлээх киһи гынан<br><span class="description" id="482">Иэгэдьдьитэн</span> көрүөххүн
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1690
                    </td>
                    <td>
                        Төһөлөөх-хаччалаах буолуой?<br>Уоту оттор<br>Үлэлээх уол оҥостуоҥ этэ.<br>Күөһү күөстүүр<br><span class="description" id="483">Көкөөнөй</span> уол буоламмын<br><span class="description" id="484">Көкөлдьүйэн</span> көрүөм этэ?!<br>Ийэлээх аҕам, бырастыы,<br>Бар дьонум, бырастыы,<br>Аан дойдум, бырастыы,<br><span class="description" id="485">Хаан-бадах</span> ыйым, бырастыы,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1700
                    </td>
                    <td>
                        <span class="description" id="486">Өһөх-бадах</span> күнүм, бырастыы,<br>Хара <span class="description" id="487">бэкир</span> дьоннорум, бырастыыларыҥ,<br><span class="description" id="488">Таллан куоҕас</span> оҕоньньотторум, бырастыы,<br><span class="description" id="489">Өндөй бөтүүк</span> эмээхситтэрим, бырастыы,<br>Хаара <span class="description" id="490">лаглаҕар</span> дьахталларым, бырастыыларыҥ,<br>Тимир чырыахы сылгыларым, бырастыыларыҥ,<br><span class="description" id="491">Ап-чарахай</span> ынахтарым, бырастыыларыҥ! —<br>Ити иньньэ дии сырыттаҕына,<br>Биһиги киһибит<br>Үчүгэйи эттиҥ диэн үөрбэтэ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1710
                    </td>
                    <td>
                        Куһаҕаны эттиҥ диэн хомойбото,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1711
                    </td>
                    <td>
                        <span class="description" id="492">Силиргэхтээх</span> титирик саҕа<br>Чиккэйэн турар сиһин үөһүн<br>Быһа тардан <span class="description" id="493">лис гыннаран</span> кэбистэ,<br>Үрүҥ сүньньүн быһа тардан кэбиспитэ —<br>Өлөн чиккэс гына түстэ.<br><span class="description" id="494">Сабарай</span> таас уллуҥаҕыттан<br>Сулбу тардан ылла,<br>Үктүү-үктүү хайыта тыытта,<br>Тута-тута турута тыытта.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1720
                    </td>
                    <td>
                        Сиик гынан <span class="description" id="495">симэлиттэ</span>,<br>Туман гынан <span class="description" id="496">тунуйда</span>,<br>Күдэн оҥорон көтүттэ.<br>Сүрэхтээх быарын<br>Айаҕынан хостуу тардан таһаарда,<br>Үөһээ дойду диэкки<br>Өрө <span class="description" id="497">ыараҥната</span> турда:<br>— Дьэ-эрэ, дьэ дуу!<br>Эриэн <span class="description" id="498">элэмэс</span> былытым<br>Үрүт өттүнээҕи
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1730
                    </td>
                    <td>
                        Ырыа Бээбийдээн обургу,<br>Биэс тарбах<br>Бэриитэ буолар күнэ,<br>Уон тарбах буолан<br>Уунар күнүм буолла,<br>Бэттэх-бэттэх буолуҥ эрэ! —<br>Уонна үөһээ дойдуга<br>Өрө быраҕан кэбистэ.<br>Былыт быыһынан<br>Үс тарбах <span class="description" id="499">элэкис гына</span> түстэ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1740
                    </td>
                    <td>
                        <span class="description" id="500">«Сап» гыннаран</span> илдьэ баран хаалла.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1741
                    </td>
                    <td>
                        — Тыллаах-өстөөх Хара Кулун аттаах<br>Сылгы уола Дыырай бухатыыр<br><span class="description" id="501">Кэнэҕэһин-кэнэҕэс</span>,<br>Хойутун-хойут,<br>Үтүөнү үтүөнэн боруостуом,<br><span class="description" id="502">Быралыйа</span> бырастыы! — диэтэ да, баран хаалла.<br>Ити киһи<br>Ити абааһыны этин-сиинин<br>Устата биллибэт Улаабыр муораҕа
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1750
                    </td>
                    <td>
                        <span class="description" id="503">«Сар» гына</span> бырахта.<br>Охсуһан улааппыт<br>Урусхал хара тиититтэн<br>Ойо тардан ылан<br><span class="description" id="504">Күрүлэччи</span> ытыйан кэбистэ.<br>Бу ытыйан кэбиспитэ<br>Муора уутун устун<br>Сүүрүгү кытта устан бара турда.<br>Ити баран иһэн,<br>Сиһин үөһүн көҥдөйүттэн
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1760
                    </td>
                    <td>
                        <span class="description" id="505">Хоҥкуйар</span> <span class="description" id="506">хоолдьуктарыгар</span> дылы<br>Суоракка уган ылбыт курдук<br><span class="description" id="507">Балай маҥаас</span> <br>Өлүү <span class="description" id="508">харгыйа</span>-хара суордара<br>Үс суор үөһэ дойду диэкки<br>Өрө көтөн тахсан бардылар,<br>Туһааннаах тус соҕуруу диэкки айаннаатылар.<br>Бу баран иһэн үһүөн<br>Биир хоһоонноон хоһоонноохтор эбит:<br>— <span class="description" id="509">Чылыптааммыт-чалыптааммыт</span>!
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1770
                    </td>
                    <td>
                        <span class="description" id="510">Кыыкырдааммыт-хаахырдааммыт</span>!
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1771
                    </td>
                    <td>
                        <span class="description" id="511">Бэйикэй-бэйикэй</span>!<br>Эн диэтэх киһи<br>Умнарыҥ саҕана буоллун,<br>Биһиги диэтэх дьон<br>Саныырбыт саҕана буоллун,<br><span class="description" id="512">Нокой</span> оҕобор, дьэ,<br>Кэлэр сиргэр кэнтик* буолуохпут,<br>Барар суолгар бадаар өлүү буолуохпут,<br>Быралыччы-быдан-<span class="description" id="513">тэгиэ</span> 
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1780
                    </td>
                    <td>
                        Бырастыы буоллун — диэн баран<br>Өрө көтөн тахса турдулар,<br>Тус соҕуруу диэкки<br><span class="description" id="514">Элэй-балай</span> <span class="description" id="515">дайбаан</span> баран хааллылар.<br>Биһиги киһибит онно эттэ:<br>— Үс өлүү харгыйа<br>Хара суордар эрэйдээхтэр,<br>Эһиги баҕас миигин<br>Тугу гынар үһүгүт.<br>Оччотооҕу да хонукка
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1790
                    </td>
                    <td>
                        Мин син баар буолуом, — диэтэ.<br>Көстүбэт күтүр күөх дьайа<br>Сыстыбыта буолуо диэн,<br>Күөх далайыгар киирэн<br><span class="description" id="516">Көҥү</span> сөтүөлээн кэбистэ.<br>Абааһы <span class="description" id="517">сараһын</span> аймаҕын<br>Хараарар хара дьайдара<br>Хатаммыта буолуо диэн,<br>Хара далайыгар киирэн<br>Хастыы суунан таҕыста.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1800
                    </td>
                    <td>
                        Ити гынан баран
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1801
                    </td>
                    <td>
                        Илин диэкки өттүнээҕи<br><span class="description" id="518">Эндэл</span> таас хайатын үрдүгэр<br>Өрө сүүрэн тахсан<br>Күүстээх көй салгыҥҥа<br>Көҥү оҕустарда.<br>Ити гынан баран<br>Били урукку абааһыттан<br>Кистээбит киһитигэр,<br>Соноҕос сылгы
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1810
                    </td>
                    <td>
                        <span class="description" id="519">Дьохсооттоон</span> эрэрин курдук,<br>Ортотунан <span class="description" id="520">урааньньыктаах</span> <br><span class="description" id="521">Дуурай</span> маҕан тумулун үрдүгэр<br>Өрө сүүрэн таҕыста.<br>Тоҥмут сири <span class="description" id="522">тобулу</span> үктээн баран<br>Улуу булгуньньах уу дьулайын<br>Арыйа тэбэн кэбистэ,<br>Били баарыан кистээбит киһитин<br>Туруору тардан таһаарда,<br>Илиилэриттэн сиэттиһэннэр,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1820
                    </td>
                    <td>
                        Эйэлээх дьон буоланнар,<br><span class="description" id="523">Көй кииннэригэр</span>,<br>Көмүс уйаларыгар,<br>Алтан <span class="description" id="524">ньээкэлэригэр</span>,<br>Араҕас ампаардарыгар<br>Аал уоттарыгар<br><span class="description" id="525">Арыаллаһан</span> кэллилэр ээ.<br>Бу кэлэннэр<br>Сүүс киһи сүбэтин<br>Сүбэлэһэ сырыттылар,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1830
                    </td>
                    <td>
                        Отут киһи соргутун
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1831
                    </td>
                    <td>
                        <span class="description" id="526">Соргулаһа</span> олордулар,<br><span class="description" id="527">Көйүү кымыһынан</span> <br>Көхсүлэрин <span class="description" id="528">көньньүөрдэ</span> олордулар,<br><span class="description" id="529">Саамал кымыһынан</span> <br>Санааларын тарҕата сырыттылар,<br>Халыҥ хаһанан хаччы кэбиһэн,<br>Суон <span class="description" id="530">саалынан</span> суомас быраҕан,<br>Дьоһун <span class="description" id="531">мүһэнэн</span> <span class="description" id="532">мохсуо</span> уурунан<br>Аһаан-сиэн, атан-бөтөн
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1840
                    </td>
                    <td>
                        Арайан-чачайан олордулар эбээт.<br><span class="description" id="533">Сарыы</span> <span class="description" id="534">дьаахтааҕын</span> <br>Дьаныйан таҥнан кэбистилэр,<br><span class="description" id="535">Түнэ</span> <span class="description" id="536">бүүппэхтээҕин</span> <br><span class="description" id="537">Дьүлүйэн</span> туран таҥыннылар,<br><span class="description" id="538">Үүс</span>-киис <span class="description" id="539">киргиллээҕин</span> <br>Кичэйэн таҥыннылар,<br>Буобураҕа буккулуннулар,<br>Саһылга састылар,<br>Киис тириитигэр кистэннилэр,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1850
                    </td>
                    <td>
                        <span class="description" id="540">Ини-бии</span> курдук дьон буоллулар.<br>Илин диэкки ытык быраантан<br>Арҕаа таас хайаларыгар<br>Тэбис-тэҥҥэ сыссаллар;<br>Хоту бырааннарыттан соҕуруу диэкки<br>Очуос таас хайаларыгар<br>Тэбис-тэҥҥэ сыссаллар;<br>Тэбэр-тирэх хара тииккэ<br>Өрүтэ тэбиэлэһэн тэбис-тэҥнэр эбит.<br>Уунар уһун <span class="description" id="541">урусхал</span> хара тииттэригэр
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1860
                    </td>
                    <td>
                        Өрүтэ <span class="description" id="542">ууналаһан</span> көрөллөр эбит.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1861
                    </td>
                    <td>
                        Үөмэр үрдүк <span class="description" id="543">өндөл</span> хара тииттэригэр<br>Өрүтэ үөмэлэһэн тэбис-тэҥнэр эбит.<br>Ити гынан бараннар<br>Өр ити үчүгэйдик олорбуттарын<br>Бэйэлэрэ да өйдөөбөтүлэр,<br>Өтөр даҕаны үчүгэйдик олорбуттарын<br>Бэйэлэрэ да билбэккэ бардылар.<br>Кэмнээх күннэрэ киирэн,<br>Киэһэлэрэ кэлэн
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1870
                    </td>
                    <td>
                        Бичиктээх <span class="description" id="544">биллэриктэригэр</span>,<br>Ойуулаах оронноругар,<br><span class="description" id="545">Дьэрэкээннээх</span> тэллэхтэригэр,<br><span class="description" id="546">Чыҥырҕастаах</span> сыттыктарыгар,<br><span class="description" id="547">Дуобаттаах</span> суорҕаннарыгар<br>Тиэрэ баран түһэннэр,<br>Кэккэлэһэ сытаннар утуйан хааллылар.<br>Уруккуттан да өрүү<br>Бу курдук утуйаллар.<br>Алталаах атыыр сылгы аттаах
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1880
                    </td>
                    <td>
                        Иккилээх Эрбэхтэй Бэргэн<br>Уот диэкки утуйар үгэстээх этэ,<br>Урут туран уоту оттор этэ.<br>Арай түүн үөһүн саҕана <span class="description" id="548">былааннаах</span> <br>Сылгы уола Дыырай бухатыыр<br>Утуйа сыттаҕына,<br>Киһи саҥата саҥарар эбээт, доҕоор,<br>Маны иһиллээн сытта:<br>— Дьиэ-буо, — диир саҥа баар, —<br>Сэттэ уон эйиэн иэйэхсит
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1890
                    </td>
                    <td>
                        Биэрэгин ааныгар
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1891
                    </td>
                    <td>
                        Дьиэлээхпин диэн киһиргиигин,<br>Аҕыс уон айыыһыттар<br><span class="description" id="549">Дьаарбаҥнарын</span> ааныгар<br><span class="description" id="550">Арҕахтаахпын</span> диэн айгыстаҕын,<br>Тоҕус уон холбоһон түһэр<br>Хотой Иэйэхсит <span class="description" id="551">оппуоһун</span> ааныгар<br>Олохсуйан олоробун диэҥҥин улаатымсыйаҕын,<br>Эн эрэйдээх ким билбэт киһитэҕиний?<br>Биир ийэлээххин,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1900
                    </td>
                    <td>
                        Биэс уон аҕалааххын,<br>Түүн төрөөбүт,<br><span class="description" id="552">Чөҥөчөккө</span> үҥпүт,<br><span class="description" id="553">Чүөппэҕэ</span> сүрэхтэммит<br>Сиик тэллэхтээх,<br>Туман суорҕаннаах,<br>Көтөҕө сыттыктаах,<br><span class="description" id="554">Сүөк</span> билидээк.<br>Илин өттүгэр <span class="description" id="555">тарайа</span> <span class="description" id="556">көтөх</span> <br>Халыҥ аньыылаах буолбаккын дуо?
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1910
                    </td>
                    <td>
                        Кэлин өттүгэр <span class="description" id="557">бөкчөйө</span> сүгэһэринэн<br>Суон дьоһун буруйдаах буолбаккын дуо?<br>Эн эрэйдээх<br><span class="description" id="558">Хардаҥ</span> оттоох эбиккин,<br><span class="description" id="559">Соппоҥ</span> уулаах эбиккин.<br>Мин диэтэх киһи<br>Бэйэм дойдубар-сирбэр эрдэхпинэ,<br>Харах уччурхайдаах,<br>Хары быччыҥнаах,<br>Суон сааллаах,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1920
                    </td>
                    <td>
                        Хат таманнаах,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1921
                    </td>
                    <td>
                        Халыҥ <span class="description" id="560">куҥнаах</span>,<br>Халыҥ таһаалаах,<br>Кииммэр <span class="description" id="561">хаһалаах</span> этим.<br>Ол кэлэммин иҥиир <span class="description" id="562">тараһаланным</span>,<br><span class="description" id="563">Этирик түөстэнним</span>,<br><span class="description" id="564">Адарай</span> уҥуохтанным,<br>Эн айыыҥ иньньэ буоллун,<br>Мин айыым иньньэ буоллун!<br>Мин диэтэх киһини
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1930
                    </td>
                    <td>
                        Ириэнэх суолбун ирдээҥҥин,<br>Тоҥмут суолбун тордооҥҥун,<br>Батыһар күннээх буоллаххына,<br>Иэҥҥэр <span class="description" id="565">иирэ талаҕы</span> эрчийиэм,<br>Умса уураммын <span class="description" id="566">уорҕаҕар</span> <br><span class="description" id="567">Оруоска</span>* талаҕы уураттыам,<br>Халыҥ тириигин хайытыам,<br>Хара <span class="description" id="568">балай</span> хааҥҥын таһаарыам.<br>Ийэҕэр эппэтэх<br><span class="description" id="569">Элэ-была тылгын</span> этитиэм,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1940
                    </td>
                    <td>
                        Аҕаҕар эппэтэх<br>Араас саҥаҕын саҥардыам.<br>Килбиэннээх сирэйгин киттитиэм,<br>Албан ааккын алдьатыам.<br>Быралыччы бырастыы буоллун! — диэтэ.<br>Тис-тас тэбиннэ,<br><span class="description" id="570">Тиһик-таһык</span> үктэннэ,<br>Халҕан тыаһа «хап» гына түстэ,<br><span class="description" id="571">Дьиэл</span> аанын тыаһа<br>«Лиһигир» гына түстэ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1950
                    </td>
                    <td>
                        Соҕуруу диэкки сүүрэ турда.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1951
                    </td>
                    <td>
                        Итини истэн баран<br>Сылгы уола Дыырай бухатыыр<br>Туран олоро түстэ,<br>Тоҕус тарбаҕын<br>Тосту баттаан олорон,<br>Толкуйдаан көрөн олордо:<br>—	Ылаатыгар, оҕолоор, — диэтэ<br>Ол иһин туох ааньньа киһи буолан<br>Абааһыга сиэтээри эккирэттэрэ сылдьыай?
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1960
                    </td>
                    <td>
                        Сити даҕаны эккирэттэрбитэ<br>Бэйэтин акаарытыттан буолуоҕа.<br>Куһаҕан киһини <span class="description" id="572">сөрөөн</span> аҕалан,<br>Көр, миигин кытары<br>Абааһыга сиэтэ сыста эбээ!<br>Ити акаары<br>Ити миигин кини хаһан билэн<br>Биир ийэлээх,<br>Биэс уон аҕалаах,<br>Түүн төрөөбүт,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1970
                    </td>
                    <td>
                        Чөҥөчөккө үҥпүт,<br>Сиик тэллэхтээх,<br>Туман суорҕаннаах,<br>Сүөк билидээк уолаҕын диэн,<br>Хаһааҥҥыттан билбитэ-көрбүтэ буолуой?<br>Мин кинитээҕэр,<br>Оннооҕор бэйэм ийэбин-аҕабын билбэппин,<br>Бу бэлэһин бэтэтэтин көр эрэ,<br>Бу айаҕын абатын,<br>Бу тииһин тууһун,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1980
                    </td>
                    <td>
                        Куолайын куруһунун.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1981
                    </td>
                    <td>
                        Эккирэтэн тиийдэхпинэ,<br>Иэммэр иирэ талаҕы эргийиэх буолар,<br>Уорҕабар оруоска талах уурталыах буолар,<br>Халыҥ тириигин хайыталыам,<br>Хара-балай хааҥҥын таһаарыам диир.<br>Сибилигин эккирэтэн тиийэммин,<br>Тутан ыламмын<br>Бэйэҥ уорҕаҕар<br>Оруосканы уураттаатаҕым,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        1990
                    </td>
                    <td>
                        Иэҥҥин хастыам,<br>Сэккин ылыам,<br><span class="description" id="573">Эҥэлэйгин</span> этитиэм, — диэтэ да,<br>Орто таҥаһын соҕотохто<br>Өрө тардан кэбистэ,<br>Үрүт таҥаһын<br>Таҥнары тардан кэбистэ.<br>Ити кэнниттэн тахсан<br>Үүнэн эрэр маһы<br>Үрүт өттүнэн сүүрэлээтэ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2000
                    </td>
                    <td>
                        Кырдьан иһэр былыты<br>Алын кырыытынан ыстаҥалаата.<br>Аҕыс иилээх-саҕалаах<br>Атааннаах-мөҥүөннээх<br><span class="description" id="574">Айгыр-силик</span>, <span class="description" id="575">амыл-намыл</span> алааһын<br>Оттотунан хайа сүүрэн таҕыста.<br>Бу тахсан<br>Тоҕус киһи <span class="description" id="576">туут хайыһарын</span> <br>Туруорута аспыт курдук<br>Туруук таас хайатын
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2010
                    </td>
                    <td>
                        Өрө сүүрэн таҕыста.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2011
                    </td>
                    <td>
                        Бу тахсан көрбүтэ —<br>Биирдии биэрэстэ бара-бара<br>Аҥаардыы уллуҥах суола<br>Арыт тааска тэбинэр эбит,<br>Арыт мастан тэбинэр эбит,<br>Сорох сиргэ кумахтан тэбинэр эбит,<br>Бара турбут.<br>Маны көрөн баран:<br>— Аат-татай, оҕолоор!
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2020
                    </td>
                    <td>
                        <span class="description" id="577">Кубулҕаттаах</span> соҕус киһи булбут эбит ээ,<br><span class="description" id="578">Амнахтаах</span> ааттыгы арыйан,<br>Көмнөхтөөх оппуоһу көтөҕөн,<br>Суол тобулан, ыллык тэлэйэн<br>Сатаан эккирэтиэ суохпун ээ.<br>Оот-татай, оҕолоор!<br>Үүрэн сиппэт үрүҥ сүүрүктээх этим,<br>Миинэн барар миҥэм,<br>Көлүнэн барар көлөм,<br>Тардыстар талаһам,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2030
                    </td>
                    <td>
                        Ыйаастар ырыганым,<br>Аналлаах атым<br>Көстүбэт этэ эбээ! — диэн баран,<br>Төттөрү сүүрэн кэллэ дьиэтигэр.<br><span class="description" id="579">Илэ-бодо</span> иэйиэхсит<br>Иэригийэн түһэр<br><span class="description" id="580">Иэримэ</span> хонуутун<br>Илин кырыытыгар турда.<br>Айыыһыт бөҕө кэлэн<br><span class="description" id="581">Ахталыйан</span> <span class="description" id="582">арбахдьыйа</span> ооньньуур
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2040
                    </td>
                    <td>
                        Араҕас маҕан хонуутун
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2041
                    </td>
                    <td>
                        Арҕаа баһыгар кэлэн турунан кэбистэ.<br>Үөһэ диэкки,<br>Туһааннаах тус илин диэкки,<br>Өйдөөн, санаан көрө турда.<br>Үөр туллук өрө көтөн тахсан иһэрин курдук<br>Үрүҥ үлүскэннээх,<br>Үүт <span class="description" id="583">дьөһүөл</span> ааттыгынан<br>Өрө көрөн таһаарда.<br>Бу туран саҥара турда:
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2050
                    </td>
                    <td>
                        — Дьиэ-буо!<br>Сиэр сылгы сиэллээх кутуругун<br><span class="description" id="584">Силэйэ</span> баттаабыт курдук<br>Сиэр <span class="description" id="585">күрдьүгэс</span> ааттыктаах,<br><span class="description" id="586">Кэриэн ымыйа</span> эккээйилээх,<br>Чороон ымыйа <span class="description" id="587">дьуолкалаах</span>,<br>Дьэрэкээн синьньэ тэримдьилээх,<br>Күөгүлээх күөмэй күндүлээх,<br>Синьньэлээх <span class="description" id="588">биһиэйэх</span> тэриирдээх,<br><span class="description" id="589">Матааччах</span> айах баараалаах,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2060
                    </td>
                    <td>
                        <span class="description" id="590">Томторҕолоох</span> чороон чуоҕуйбут,<br>Хаан <span class="description" id="591">дьаралык</span> атыырдаах,<br>Сэлэ түгэҕэ <span class="description" id="592">сэйбэрэ</span> маҕан биэлээх,<br>Күрүөтүгэр киирбэтэх,<br>Көҕүлүттэн туттарбатах,<br><span class="description" id="593">Күрэҥ</span> <span class="description" id="594">дьаҕыл</span> кулун күүлэйдээх,<br>Далларыгар кэлбэтэх,<br>Самыытыттан тайаннарбатах,<br><span class="description" id="595">Саалыр</span> кулун далбарҕалаах<br>Сэлэтигэр киирбэтэх,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2070
                    </td>
                    <td>
                        Сиэлиттэн туттарбатах,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2071
                    </td>
                    <td>
                        Сиэр күрэҥ кулуна <span class="description" id="596">силигилээбит</span>,<br>Араҕас <span class="description" id="597">далбарҕа</span>,<br>Түүлээх түһэлгэ,<br>Уордаах Дьөһөгөй Иэйэхсит Тойон эһэкэм,<br>Дорообо буолуохтун!<br>Ким-хайа кэлэн<br>Дорооботунан тосхойдо диэҥҥин<br>Тумсубуттан тутан <span class="description" id="598">токкоолуур</span>,<br>Айахпыттан тутан дакаастыыр буолларгын,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2080
                    </td>
                    <td>
                        Бэлэспиттэн тутан эппиэттиир буоллаххына,<br>Сэттэ уон иэйээхсит биэрэгэр дьиэлэммит,<br>Аҕыс уон айыыһыт дьаарбаҥын ааныгар арҕахтаммыт,<br>Тоҕус уон хотой айыыһыт<br>Оппуоһун ааныгар олоҕурбут,<br>Тыллаах-өстөөх Хара Кулун аттаах<br>Сылгы уола Дыырай бухатыыр<br>Мин кэлэн этэ-саҥара турабын.<br>Сыаллаах соругуҥ тугуй диэтэргин,<br>Санаалаах наадаҥ тугуй диэтэргин,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2090
                    </td>
                    <td>
                        Көрдөһөр бөҕө <span class="description" id="599">күттүөннээх</span>,<br>Ааттаһар бөҕө албаннаах;<br>Амнахтаах аартыгы<br>Арыйар күнүм буолла,<br><span class="description" id="600">Көмнөхтөөх</span> оппуоһу<br>Көтөҕөр күнүм буолла,<br>Суол бөҕөнү тобуларым кэллэ.<br>Барбыты батыһар,<br>Куоппуту ситэр,<br>Бэрди кытта мэккиһэр,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2100
                    </td>
                    <td>
                        Үтүөнү кытта үтүрүһэр күн үөскээтэ.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2101
                    </td>
                    <td>
                        Миинэр миҥэбин,<br>Көлүнэр көлөбүн,<br>Тардыстар талаһабын,<br>Ыйаастар ырыгаммын,<br>Аналлаах-мэнэллээх аппын<br>Айан-кэрдэн биэриэххин,<br>Төһөлөөх-хаччалаах буолуой?» — диэтэ.<br>Ити кэнниттэн<br>Күнү утары эргийэ хааман ылла.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2110
                    </td>
                    <td>
                        Ити ылан баран<br>Өрө көрөн турда,<br>Ити өрө көрөн турбута:<br>Эриэн-элэмэс сылгы тириитин<br>Тиирэ таппыт курдук,<br><span class="description" id="601">Эбир-дуоссун</span> былыттар<br>Эргичийэн, иэнигийэн түһэн кэллилэр,<br>Итии баҕайы салгын тыаллар<br>Сабыта биэрдилэр.<br>Ибир самыыр <span class="description" id="602">илигирэччи</span> түстэ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2120
                    </td>
                    <td>
                        <span class="description" id="603">Илэҥ-халаҥ</span> быһыы буолла.<br>Үөһээ дойдуттан<br>Сиэр сылгы сиэллээх кутуругун<br>Сэлэйэ баттаабыт курдук<br>Сиэр күрдьүгэс ааттыктан<br>Сылгы сүөһү быһыыта<br>Сиэллээх кутуругун кынаттаммыкка дылы,<br>Икки көхсүн хараҕыттан<br>Күрбүү көмүс кынатынан<br>Таҥнары далайан көтөргө дылы гынар;
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2130
                    </td>
                    <td>
                        Сити икки ардыгар ат сылгы
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2131
                    </td>
                    <td>
                        Түөт <span class="description" id="604">түөрэм</span> көмүс туйаҕа<br>Төгүрүйэн көһүннэ,<br>Сүрдээх күүстээх үлүгэрдик<br>Таҥнары көтөн күүгүнээн түстэ.<br>Бу дьоллоох томторго<br>Уруйдаах улахан толооҥҥо,<br>Түөт түөрэм көмүс туйаҕынан<br>Үктэнэ түспүтүгэр,<br>Бастааҥҥы түһүүтүгэр
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2140
                    </td>
                    <td>
                        От-мас иһирдьэ <span class="description" id="605">үмүрүс гына</span> түспүтэ.<br>Түспүтүн гэннэ<br>От-мас кэдэрги силэллэн биэрдэ.<br>Итини биһиги киһибит<br>Үрүҥ көмүс көнтөһүттэн<br>Сулбу сүүдүйэн ылла.<br>Бу тутан туран<br>Атын сырайын-хараҕын<br>Өйдөөн-дьүүллээн көрө турда;<br><span class="description" id="606">Көнтөс</span> кыайбат <span class="description" id="607">күлүмэх</span> күүстээх,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2150
                    </td>
                    <td>
                        <span class="description" id="608">Тэһиин</span> кыайбат чиччигинэс иҥиирдээх,<br><span class="description" id="609">Дьирим</span> тиийбэт нэлэгэр өллөөх,<br><span class="description" id="610">Холун</span> тиийбэт хос хоҥнуолаах.<br><span class="description" id="611">Көс</span> туоралаах,<br>Күннүк усталаах,<br>Үс хос үрэллибэт<br>Үрүҥ көмүс мүөрсүн түүлээх,<br>Көй салгын аһылыктаах;<br><span class="description" id="612">Кулуба</span> киһи<br><span class="description" id="613">Куоттугунан</span> суруйа охсубутун курдук
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2160
                    </td>
                    <td>
                        <span class="description" id="614">Орохтоох</span> систээх эбит.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2161
                    </td>
                    <td>
                        Кинээс киһи<br>Бэчээтинэн баттаабытын курдук<br>Икки <span class="description" id="615">битийэр</span> санныгар <span class="description" id="616">кирбии</span> дьаҕыллаах.<br>Икки көхсүн хараҕынан<br>Күрбүү көмүс кынаттардаах,<br>Үс күннүк сиртэн <span class="description" id="617">үргүөһүннээх</span> <br><span class="description" id="618">Үөрбэ</span> көмүс <span class="description" id="619">көҕүллээх</span>,<br>Сэттэ күннүк сиртэн,<br>Тэлэкэччитэн охсуллар
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2170
                    </td>
                    <td>
                        <span class="description" id="620">Сээлбиир</span> көмүс сиэллээх;<br>Тоҕус күннүк сиртэн<br>Долгутан охсор<br><span class="description" id="621">Нуоҕайдаах</span> оҥочо көмүс кутуруктаах эбит.<br><span class="description" id="622">Көмөгөйүн</span> анныгар<br><span class="description" id="623">Көччөх</span> кустаах,<br><span class="description" id="624">Көбөҥкү</span> соболоох,<br>Көлүйэ күөллээх.<br>Анды кустаах,<br><span class="description" id="625">Алыһар</span> балыктаах,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2180
                    </td>
                    <td>
                        <span class="description" id="626">Ардьаһыт</span> дьонноох,<br><span class="description" id="627">Аллааҥкы</span> күөллээх.<br><span class="description" id="628">Баргыйа</span> олорор<br>Бар чоҥкур кыыллаах,<br>Баай хара тыалаах.<br><span class="description" id="629">Мунду</span> балыктаах,<br>Туулуур киһилээх,<br><span class="description" id="630">Борбуйугар</span> <span class="description" id="631">боруу</span> күөллээх,<br><span class="description" id="632">Таныытыгар</span> <span class="description" id="633">татыйык</span> чыычаахтаах,<br>Кулгааҕар <span class="description" id="634">кураҕаччы</span> кыыллаах,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2190
                    </td>
                    <td>
                        Кэтэҕэр кэҕэлээх,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2191
                    </td>
                    <td>
                        Уорҕатыгар улардаах,<br>Кутуругар кубалаах,<br>Өрөҕөтүгэр үөр туллуктаах,<br><span class="description" id="635">Быттыгар</span> <span class="description" id="636">быллырыыт</span> чыычаахтаах,<br>Кэтит үлүгэр <span class="description" id="637">липпитэ</span> буутайдаах,<br>Киэҥ халлаан <span class="description" id="638">мөгүөнэ</span> ыҥыырдаах,<br>Кыттыһар былыт <span class="description" id="639">кычымнаах</span>*,<br>Холбоһор былыт холуннаах,<br>Ааһар былыт <span class="description" id="640">чаппараактаах</span>,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2200
                    </td>
                    <td>
                        Ыҥыырын <span class="description" id="641">хоҥсуоччутугар</span>*<br><span class="description" id="642">Хаҥырҕастаах</span>* <span class="description" id="643">тиэрбэстээх</span>,<br>Аҕыс салаалаах<br>Киэҥ халлаан <span class="description" id="644">сапсылҕана</span> <br>Айыы <span class="description" id="645">сандырыыһа</span> кымньыылаах эбит.<br>Ити киһи ити атын үрдүгэр<br><span class="description" id="646">Хадьдьаайыттан</span> көппүт<br>Хара улар курдук<br>Хатана түстэ.<br><span class="description" id="647">Куулаттан</span> көппүт
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2210
                    </td>
                    <td>
                        <span class="description" id="648">Куртуйах</span> улар курдук<br>Олоро түстэ.<br><span class="description" id="649">Эниэттэн</span> көппүт<br><span class="description" id="650">Эрдэҕэс</span> улар курдук<br>Иилистэ түстэ.<br>Үрүҥ туллук курдук<br>Үрдүк <span class="description" id="651">мындаатыгар</span> <span class="description" id="652">чөмчөрүс гына</span> түстэ.<br>Киэҥ халлаан чэллэҥэтэ тэһииниттэн<br>Тэһииннээн кэбистэ.<br>Киэҥ халлаан сапсылҕана буолбут
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2220
                    </td>
                    <td>
                        Хаҥырҕастаах тиэрбэстээх,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2221
                    </td>
                    <td>
                        Аҕыс салаалаах <span class="description" id="653">айгырастаах</span> <br><span class="description" id="654">Аан дапсыыр</span> кымньыытынан<br>Күөс эти көҥү дайбаата,<br>Суон уҥуоҕар туруору саайда,<br>Солуур эти субуччу дайбаата.<br>Ити сылгы <span class="description" id="655">элгээн</span> көлүйэ курдугу<br><span class="description" id="656">Эмти</span> тэбэн кэбистэ.<br><span class="description" id="657">Тыымпы</span> күөл курдугу<br>Тыыра тэбинэн кэбистэ.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2230
                    </td>
                    <td>
                        Көлүйэ күөл курдугу<br>Көҥү үктээн кэбистэ.<br>Алаас-сыһыы саҕаны<br>Хайа тэбинэн кэбистэ.<br>Күрбүү көмүс кынатынан<br>Үөһээ дойду диэкки<br>Өрө далайан көттө.<br>Онуоха баара<br>Суон мутугу тоһута тэппитэ<br>Оҕо дьон буолан
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2240
                    </td>
                    <td>
                        Охсуһан аамайдаһа хааллылар,<br><span class="description" id="658">Уолах</span> маһы ойута тэппитэ —<br>Уолан дьон буолан<br><span class="description" id="659">Улуһа-кэлиһэ</span> сырыстылар,<br><span class="description" id="660">Эмэх</span> маһы эмти тэппитэ —<br><span class="description" id="661">Имииһит</span> эмээхситтэр буолан<br><span class="description" id="662">Иэгэһэ-куоҕаһа</span>,<br><span class="description" id="663">Энэлиһэ</span>  туойа хааллылар.<br>Чөҥөчөгү төрдүнэн түөрэ тэппитэ —<br><span class="description" id="664">Торҕоннообут</span>  бөрө кыыл буолан
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2250
                    </td>
                    <td>
                        Улуйа-кэлийэ хааллылар.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2251
                    </td>
                    <td>
                        <span class="description" id="665">Сыгынаҕы</span> быһыта тэппитэ —<br><span class="description" id="666">Сырҕан</span> эһэ буолан<br>Сысса сырыттылар.<br>Улуу дойдуттан улуһуйбут курдук,<br>Киэҥ дойдуттан <span class="description" id="667">тэлэһийбит</span> курдук,<br>Аан дойдуттан арахсыбыт курдук,<br>Мастаах сиртэн бардамнаан көттө,<br>Тииттээх сиртэн тэбиэһирэн тирэннэ,<br>Уулаах сиртэн олустаан ойдо.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2260
                    </td>
                    <td>
                        Быттыгыттан <span class="description" id="668">быыппаһынна</span>,<br>Хонноҕуттан <span class="description" id="669">хоһуҥураата</span>,<br>Түргэн баҕайы түһүү буолла,<br>Сыыдам үлүгэр сырыы буолла,<br><span class="description" id="670">Аллаах</span> айан, <span class="description" id="671">ахсым</span> сырыы буолла.<br>Итинтэн ити киһи<br>Өйдүү баттаата,<br>Тоҕус тарбаҕын тосту баттаан<br>Толкуйдаан турда.<br>«Оот-татай, оҕолоор!
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2270
                    </td>
                    <td>
                        Аал уоттаах,<br>Алаһа бараан дьиэлээх,<br>Аал Дуук Мастаах<br>Аан-ийэ дойдулаах этим.<br><span class="description" id="672">Амнахтаах</span> аартыгы арыйан,<br><span class="description" id="673">Көмнөхтөөх</span> <span class="description" id="674">оппуоһу</span> көтөҕөн,<br>Суол бөҕөнү тобулан,<br>Аартык бөҕөнү арыйан,<br>Ыллык бөҕөнү тэлэйэн,<br>Бэрди кытта мэккиһэ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2280
                    </td>
                    <td>
                        Үтүөнү кытта үтүрүһэ,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2281
                    </td>
                    <td>
                        Туһунан дойдуга,<br>Атын аартыкка,<br>Айаннаан барар буолан бараммын,<br>Аал уоппар, аан дойдубар<br>Түөрэх кэбиһэн,<br>Төлкө ууран барыам этэ!»— диэн.<br>Хараҕын кырыытынан кэннин диэкки<br>Кынчарыйан көрбүтэ,<br>Торҕо томоон дойдута
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2290
                    </td>
                    <td>
                        <span class="description" id="675">Көньньүөс торҕону</span> тиирэ таппыт курдук<br>Унаарыйан көҕөрөн хаалбыт эбит.<br>Аан ийэ дойдута<br>Хотун дьахтар <span class="description" id="676">дьабакатын</span> туоһахтатын курдук<br>Төгүрүйэн унаарыйан көстөн хаалбыт.<br>Атын эргилиннэрэн кэбистэ.<br>Ол гынан баран кини диэтэх киһи:<br>Китиэн-имиэн дойду<br>Киилэ <span class="description" id="677">кииллээх</span>,<br>Хатыан-имиэн дойду
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2300
                    </td>
                    <td>
                        Хатыҥа хатыҥнаах,<br>Томоон-имиэн дойду<br>Туоһа туостаах,<br>Хаһыытыыр хахай кыылым<br>Көхсүн хаана кырааскалаах,<br>Үөгүлүүр өксөкү кыыл<br><span class="description" id="678">Үөһүн сүмэтэ</span> угунуохтаах,<br><span class="description" id="679">Өлүү дьирибинэ балык</span> <br>Иэнин иҥиирэ <span class="description" id="680">иҥэрчэлээх</span>,<br>Улуу тайах кыыл
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2310
                    </td>
                    <td>
                        <span class="description" id="681">Уорҕатын тириитэ</span> бүрэдэһиннээх,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2311
                    </td>
                    <td>
                        <span class="description" id="682">Өлүү даарда балык</span> <br>Чиккэйэр сиһин иҥиирэ <span class="description" id="683">киристээх</span>,<br>Киэҥ Таатта эбэ хотун<br>Отто улуу үрэҕэ<br>Тоҕойдонон турарын курдук<br>Тарбаҕынан тардар,<br>«Даҥ» гына эстэр,<br><span class="description" id="684">Чаачар</span> саатын<br>Нөҥүө илиитин уһугунан
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2320
                    </td>
                    <td>
                        Нөҥүө кулгаах тааһыгар дылы<br>Иэмэх курдук<br>Төгүрүччү тардан ылла.<br>Сайыҥҥы саамал кымыска ооньньуур<br>Улуу тайах кыыл<br>Саннын уҥуоҕун<br>Субуйа тардан ылбыт курдук<br><span class="description" id="685">Сандаала көмүс оноҕоһун</span> <br>Саатыгар туора тутан<br>Бастыҥ тойон баабыр сэргэтин
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2330
                    </td>
                    <td>
                        Туһаана манан буолаарай диэн,<br>Ыһыктан кэбистэ.<br>Бастыҥ тойон баабыр сэргэтин<br>Мооньньоох баһыгар<br>Биир <span class="description" id="686">харыс</span> кэриҥэ<br>Батары түһэн кэбистэ.<br>Эрбэҕин тыаһа<br>Халлаан түөт өттүгэр,<br>Түөт күүстээх<br>Сүүр этиҥин тыаһа буолан
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2340
                    </td>
                    <td>
                        Өрө ньиргийэ түстэ.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2341
                    </td>
                    <td>
                        Халлаан алын уорҕатын диэкиттэн<br>Сүрдээх сүүнэ улахан<br>Сааллар чаҕылҕан уота<br>Таҥнары сандаарыс гына түстэ.<br>Бу гынан баран<br>Бу курдук ырыалаах буола турда:<br>— Дьээ-буо!<br>Буор хара атыыр оҕус<br>Буору хаһан
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2350
                    </td>
                    <td>
                        Буккулла түһэн сытарын курдук,<br>Модурууннаах модун хаан<br><span class="description" id="687">Модьоҕом</span> иччитэ!<br>Хаардаах бугул от саҕа <span class="description" id="688">саҕаһалаах</span> <br>Хара <span class="description" id="689">тый</span> быарын курдук хататтаах,<br>Эскэл тый быарын курдук эстэриилээх,<br>Уһун буруо уоллаах,<br>Кылгас кыым кыыстаах,<br>Бырдьа бытык,<br>Кыылыр төбө,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2360
                    </td>
                    <td>
                        Чаалыр чанчык,<br>Сээкээн сэһэн,<br>Сүбэ-таҥара,<br>Аҥаарыйар Аан Уххан<br>Тойон оҕоньньор эһэкэм!<br>Мин диэтэх киһи<br>Барбыты батыһа,<br>Куоппуту ситэ,<br>Суол хаан ийэни тобула<br>Айан хаан ийэни
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2370
                    </td>
                    <td>
                        Арыйа барбытым кэннэ;
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2371
                    </td>
                    <td>
                        <span class="description" id="690">Дьаллык</span> <span class="description" id="691">өлүү кыргыттара</span>,<br>Чааньньыктарын тутан кэллэхтэринэ,<br><span class="description" id="692">Сотуун</span> өлүү кыргыттара<br>Солуурдарын тутан кэллэхтэринэ,<br>Кыдьык өлүү кыргыттара<br>Кытыйаланан кэллэхтэринэ,<br>Хамсыык өлүү кыргыттара<br>Хамыйахтанан кэллэхтэринэ,<br>Хаҥырҕастаах тиэрбэстээх,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2380
                    </td>
                    <td>
                        Тоҕус былас усталаах,<br>Кутаа уот,<br><span class="description" id="693">Үөт-түрэх</span> кымньыыгынан<br>Кэлбити кэтэххэ охсор буол,<br>Барбыты баска охсор буол,<br>Куоппуту холго охсор буол,<br>Үчүгэйдик көрөн истэн олор,<br>Быралыйа бырастыы!<br>Ол кэнниттэн эттэхпинэ;<br>Аҕыс салаалаах
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2390
                    </td>
                    <td>
                        <span class="description" id="694">Аал Луук Маһым</span> иччитэ,<br>Ойуу <span class="description" id="695">хоруом</span>,<br>Аҥаарыйар <span class="description" id="696">аан эскэл</span>,<br>Айхал Мичиэл эмээхсин,<br><span class="description" id="697">Чаллах хатыҥ</span> саҕа<br>Айыы дапсылҕата <span class="description" id="698">кымньыыгынан</span> <br>Далбаатана олороор,<br><span class="description" id="699">Дьалаҕай</span> таарыйыаҕа,<br>Соноҕой тунуйуоҕа,<br>Чиччик диэлийиэҕэ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2400
                    </td>
                    <td>
                        Хоптоох <span class="description" id="700">холоҥсолоох</span> улууһуттан
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2401
                    </td>
                    <td>
                        Хоҥнон кэлиэхтэрэ,<br>Үчүгэйдик көрөн-истэн олор,<br>Быралыччы бырастыы!<br>Аҕыс иилээх-саҕалаах<br>Аан ийэ дойдум иччитэ,<br>Түөт төлөрүйбэт ийэ хара <span class="description" id="701">сүллүгэскин</span> <br>Төлөрүтэр буолаайаҕын,<br>Аҕыс хамнаабат алтан дьаакыр халҕаҥҥын<br>Аһан биэрэр буолаайаҕын,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2410
                    </td>
                    <td>
                        Тас өттүгүттэн<br>Тымныы тыыннааҕы<br>Иһидьдьэ киллэрэр буолаайаҕын,<br>Ис өттүгүттэн<br>Сылаас тыыннаахтаргын<br>Таһырдьа таһаарар буолаайаҕын!<br>Мас иччитэ маанылардыыр дьахталлар,<br>От иччитэ оһуордьут уолаттар,<br>Сир дойду иччилэрэ дьэрэкээньньит кыргыттар —<br>Бука барыгыт бүрү-бүттүүн,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2420
                    </td>
                    <td>
                        Дэри-дэхси, быдан тэгил<br>Быралыччы бырастыыларыҥ!<br>Уруй-айхал улааттын!<br>Өрөгөй бөҕө үрдээтин!<br>Алҕаабыт алгыһым арыыланнын! — диэтэ.<br>Ол гынан баран атын<br>Соҕуруу халлаан<br>Соҕуруу улахата буолаарай диэн<br>Эргилиннэри тардан кэбистэ,<br>Түргэнник түһэн истэ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2430
                    </td>
                    <td>
                        Аллаахтык айаннаан истэ,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2431
                    </td>
                    <td>
                        Сыыдамнык сылдьан барда;<br>Этэн кэбиспитэ <span class="description" id="702">эбир былыт</span> буолан<br><span class="description" id="703">Иэнигийэн</span> барда,<br>Хаһыытаан кэбиспитэ —<br>Хатан былыт буолан<br>Хабырыһан барда,<br>Үөгүлээн кэбиспитэ —<br><span class="description" id="704">Үөмэх былыт</span> буолан<br>Дьүөгэлэһэн түстэ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2440
                    </td>
                    <td>
                        Саҥаран кэбиспитэ —<br><span class="description" id="705">Сата былыт</span> буолан<br>Сэргэстэһэн айаннаан истэ.<br>Айыы сирэ баранна быһыылаах,<br>Дойду баһа <span class="description" id="706">чуурукта</span> буолан хаалла,<br>Сир баһа <span class="description" id="707">симилэх</span> ойуур буолла,<br>Үрэх баһа <span class="description" id="708">оҥхолоот</span> буолла,<br>Барбатах балык миинин курдук<br><span class="description" id="709">Барыкы-сарыкы</span> дойду буолла,<br>Буспатах мунду миинин курдук
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2450
                    </td>
                    <td>
                        Борук-сорук дойду буолла,<br>Кэҕэ миинин курдук<br>Кимсиин-имсиин сибиирдэр буоллулар.<br>Тордуохтаах тутуурдаах оттонно,<br>Баччаламмыт <span class="description" id="710">бадаарынай</span> мастанна,<br>Хатыллаҕас хатыҥнанна,<br>Абааһы сирэ <span class="description" id="711">баҕадьы</span> буолла.<br>Бу киһи маныаха дылы<br>Кыһын диэни кырыатынан билэр,<br>Саас кэлбитин хахсаатынан билэр,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2460
                    </td>
                    <td>
                        Сайын кэлбитин самыырынан билэр,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2461
                    </td>
                    <td>
                        Өр да барыытын<br>Өйдөөбөт курдук айаннаата,<br>Өтөр да барыытын<br>Үөмтэлээбэт курдук көтүттэ.<br>Көрөн истэҕинэ<br>Сирэ сибиирэ кубулуйар.<br>Олорор оҕо саҕа<br>Хомурдуостанан барда,<br><span class="description" id="712">Өҕүрүмэр</span> оҕус саҕа
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2470
                    </td>
                    <td>
                        <span class="description" id="713">Күлгэри</span> үөннэннэ,<br><span class="description" id="714">Байтаһын</span> биэ саҕа<br>Баҕалаах буолла,<br><span class="description" id="715">Иирээн-мэнэрик</span> сирин<br>Иилээх кырыыта буолла,<br>Ойуун-удаҕан дойдутун<br>Уҥуоргу өттүгэр тиийдэ,<br>Удаҕан төрөөн көппүт<br>Сэттэ уйалаах <span class="description" id="716">бэчирин</span> бэһин<br>Чиэрэс түстэ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2480
                    </td>
                    <td>
                        Ойуун төрөөн көппүт<br>Тоҕус уйалаах<br>Улахан улуу хара тиити<br>Уҥуоргутугар түһэн кэбистэ.<br>Ол анараа өттө;<br>Аптаах дэриэтиньньик<br>Анараа өттө буолла,<br>Оҕустаах <span class="description" id="717">нэриэтиньньик</span> <br>Уҥуоргу өттө буолла,<br><span class="description" id="718">Куойалаах</span> <span class="description" id="719">маҥкы</span> устата
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2490
                    </td>
                    <td>
                        Суксуруһан куотуһан түһэр
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2491
                    </td>
                    <td>
                        Хомуһуннаах Кудулу байҕал<br>Ойоҕоһугар түһэн<br>Оппуоһугар киирдэ.<br>Бу киирбитэ — Соҕуруу диэкиттэн<br>Хомуһуннаах <span class="description" id="720">оппуос</span> <br>Уун-утары кэлэн олоро түстэ.<br>Ол кэнниттэн<br><span class="description" id="721">Идэмэрдээх</span> биэрэк кэлэн
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2500
                    </td>
                    <td>
                        Тиксиһэ баттаата.<br>Биһиги киһибит буоллаҕына<br>Туһааннаах тус соҕуруу диэкки баран истэ,<br><span class="description" id="722">Кута-намылҕа</span> дойду буолан барда,<br>Бачча-бадараан сибиир буолан барда.<br>Бу баран иһэн көрбүтэ —<br>Иннигэр үс курдуулаах<br>Ураһа дьиэ саҕа<br>Кутаа уот умайа турар эбит.<br>Маны көрбүтэ —
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2510
                    </td>
                    <td>
                        Эһэ кыыл киэнин эмиһин,<br>Таба кыыл киэнин талбатын,<br>Буур кыыл киэнэ муҥутуурун<br>Талах <span class="description" id="723">үтэһэҕэ</span> таҥнарыта үөлэн,<br>Туох да кэмэ суох элбэҕи-үгүһү,<br>Ураһа дьиэ курдук,<br>Уоту тула үөлэн кэбиспиттэр.<br>Дьэ буһан бардьыгыныы-ирдьигинии турар,<br>Туох да кэмэ суох элбэх ас.<br>Маны көрөн баран
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2520
                    </td>
                    <td>
                        Суол киһитэ буолан тутайбыт,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2521
                    </td>
                    <td>
                        Сырыы киһитэ буолан сылайбыт,<br>Айан киһитэ буолан ааспыт,<br>Атыттан түһэ баттаабыт<br>Атын <span class="description" id="724">арыҥах</span> мас гынан тэппит,<br>Сонун тэлгии бырахпыт,<br>Ыҥыырын сыттаммыт,<br>Быһыйа быһаҕын сулбу сүүдүйэн ылбыт,<br>Буспут өттүттэн хайыта баттаабыт,<br>Айаҕын диэкки тамнаабыт.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2530
                    </td>
                    <td>
                        <span class="description" id="725">Түнэ</span> үтүлүк курдугу<br>Түҥ-таҥ ыйыстыбыт,<br>Нэк бэргэһэ курдугу<br>Элэй-балай дайбаппыт,<br>Улахан аҥаарын бары сиэбит,<br>Уот сылааһыгар нуурайан<br>Утуйан барбыт.<br>Кыламанын быыһынан кылатан<br>Кыратык көрө сыппыт.<br>Ити көрө сыттаҕына,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2540
                    </td>
                    <td>
                        Сүрдээх куһаҕан дьүһүннээх<br>Сыгыньньах киһи тиийэн кэллэ.<br>Барыта <span class="description" id="726">марба</span> киһи быһыылаах,<br>Төгүрүччү өттө түөс баҕадьы киһи,<br>Тула өттө эргиччи ис быһыылаах,<br>Курдат-нөҥүө куттах быһыылаах,<br>Чаан-олгуй саҕа саллайбыт бастаах,<br>Чааскы саҕа күлтэйбит харахтардаах киһи эбит.<br>Ити гынан баран<br>Биһи киһибит диэкки
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2550
                    </td>
                    <td>
                        Уулааҕынан-хаардааҕынан
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2551
                    </td>
                    <td>
                        Утарыта көрөр,<br>Бу гэннэ киһи уонна абааһы<br>Икки ардынан ырыалаах буолла:<br>— Ылаатыгар, ылаатыгар!<br>Бу арҕаа халлаан анныгар<br>Аатыран үөскээбит,<br>Сэттэ уон эйиэн иэйэхсит<br>Биэрэгэр дьиэлэммит,<br>Айгыстан түһэр айыан айыыһыт
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2560
                    </td>
                    <td>
                        Ааттыгын ааныгар арҕахтаммыт,<br>Холбоһон түһэр Ходьоҥ айыыһыт*<br>Оппуоһун ааныгар олоҕурбут,<br>Тыллаах-өстөөх<br>Хара Кулун аттаах<br>Сылгы уола Дыырай бухатыыр,<br>Дорообо бокулуон!<br>Мин диэтэх киһини<br>Кимҥиний, хайаҕыный диэҥҥин ыйыттаргын —<br>Ийэм уруутун ирдээн иһит,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2570
                    </td>
                    <td>
                        Аҕам уруутун араҥалаан иһит.<br>Аатым буоллаҕына<br>Аҕыс улуус салааскалаах<br>Атыыр умнаһытын уола<br>Укумал диэн ааттаах киһибин.<br>Бу аһы-үөлү хантан<br>Булбуккунуй, талбыккыный диэтэргин,<br>Баай хара тыа баһаардаах,<br><span class="description" id="727">Куруҥ</span> хара тыа куораттаах,<br>Күөх тииҥ <span class="description" id="728">көтөллөөх</span>,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2580
                    </td>
                    <td>
                        Кыһыл саһыл кымньыылаах,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2581
                    </td>
                    <td>
                        Хара саһыл <span class="description" id="729">хаппардаах</span>,<br>Курупааскы кыыл <span class="description" id="730">туоһахталаах</span>,<br><span class="description" id="731">Бочугурас</span> кыыл <span class="description" id="732">куоттуктаах</span>,<br>Хара улар <span class="description" id="733">сарбыньньахтаах</span>,<br>Эрдэҕэс улар <span class="description" id="734">илбиргэстээх</span>,<br>Куртуйах улар <span class="description" id="735">дьөллүргэлээх</span>,<br>Кырынаас кыыл <span class="description" id="736">бытырыыстаах</span>,<br><span class="description" id="737">Солоҥдо</span> кыыл суһуохтаах<br>Баай хара тыа иччитэ
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2590
                    </td>
                    <td>
                        Аан Байгырдаан<br>Баай Барыылаах тойон оҕоньньор<br><span class="description" id="738">Осхордьут</span> уолаттарыттан,<br><span class="description" id="739">Тыҥкырайдьыт</span> кыргыттарыттан,<br><span class="description" id="740">Элбэрээччик</span> эмээхситтэриттэн,<br>Умналаан-хамналаан аҕалбыт<br>Аспын-үөлбүн<br>Быдьдьаан-талаан сиэҥҥин,<br>Сирэйиҥ баҕайы,<br>Сэтиньньи ыйым
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2600
                    </td>
                    <td>
                        Сэттэ эргэтин курдук,<br>Кытара сытыйан сытара<br>Абаккатын эбитин!<br>Сылгы уола Дыырай бухатыыр,<br>Үтүө киһи буолан баран,<br>Мин аспын-үөлбүн<br>Быдьдьаан-талаан сиэтэ диэммин<br>Сэттэ нэһилиэги тэнитиэм буолуо,<br>Аҕыс улууска тарҕатыам буолуо,<br>Тоҕус улууһу тунуйуом буолуо,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2610
                    </td>
                    <td>
                        Маҕан сирэйгин <span class="description" id="741">баладытыам</span>, 
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2611
                    </td>
                    <td>
                        Килбиэннээх сирэйгин киттитиэм,<br>Ыыйдарбын-аайдарбын!<br>Ити диэбитигэр биһи киһибит:<br>— Бу дойду гиэнэ<br>Отун-маһын иччитэ буоллаҕа дуу?<br>Күтүр дьүһүнэ тоҕо куһаҕанай,<br>Аспын быдьдьаан-талаан<br>Аһаата-сиэтэ диэн<br>Сэттэ нэһилиэккэ
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2620
                    </td>
                    <td>
                        Тэнитэрэ кырдьык буолуо.<br>Ити киһи бука<br>Аҕыс сибииргэ<br>Аатырдара кырдьык буолуо,<br>Тоҕус сибииргэ<br><span class="description" id="742">Тунуйуох</span> баҕадьы буолуо эбээ,<br>Баҕайы аһын аһаабыт<br>Саат-суут буоссу быһыыта.<br>Айаҥҥа ааһаммын,<br>Суолга хоргуйаммын,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2630
                    </td>
                    <td>
                        Ситэри синэ биир,<br>Баһын хампы тутан<br>Өлөрөн ааһыахха, — диэн баран,<br>Хаҥас илиитинэн<br>Сытан эрэн харбаата.<br>Ити харбаабытыгар<br>Аһаран кулахачыс гынан биэрдэ.<br>Уоту харбатан кэбистэ,<br>Суох буолан хаалла,<br>Хараҕыттан сүтэн хаалла.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2640
                    </td>
                    <td>
                        Биһи киһибит туран олоро түстэ.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2641
                    </td>
                    <td>
                        Били аһаабыт аһын тобоҕун<br>Барытын хомуйан ылан сиэн кэбистэ,<br>Биири да ордорбокко.<br>Ити гынан баран<br>Арыҥах мас гынан тэппит атыгар,<br>Үрүҥ туллук курдук,<br>Үрдүк таһаатыгар олоро түстэ,<br>Баран иһэрин курдук баран истэ.<br>Түргэнник түһэн истэ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2650
                    </td>
                    <td>
                        Сыыдамнык сыдьдьан истэ,<br>Аллаахтык айаннаан истэ.<br>Биир сиргэ тиийэн били ата<br>Түөрт түөрэм туйаҕынан<br>Сиргэ тура түстэ,<br>Түөрт атаҕын маҕаналыы тэбэн кэбистэ,<br>Хаардаах бугул саҕаны<br>Сахсаччы саахтаата,<br>Көлүйэ күөлүн курдугу<br>Күүгүнэччи ииктээтэ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2660
                    </td>
                    <td>
                        Иһин түгэҕиттэн үс төгүл<br>Мэҥийэн тыынан кэбистэ.<br>Икки кулгааҕын даллаччы түһэрдэ,<br>Түөрэҥ көмүс туйаҕынан<br>Күрүө иини көҥү табыйда,<br>Тыыр-таар тыбыырда,<br><span class="description" id="743">Үөрбэк-чүөрбэк</span> көрдө.<br>Маныаха иччитэ<br>Атыттан түһэ баттаата.<br>«Дьоллоох-соргулаах соноҕоһум оҕото.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2670
                    </td>
                    <td>
                        Хайдах буоллаҕай?» — диэтэ.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2671
                    </td>
                    <td>
                        Бу сылгы<br>Үөһэ диэкки өрө көрдө,<br>Алтан чааньньык айаҕын аппаҥнатта,<br>Үрүҥ көмүс үөлэгэйин көбүөхтэттэ,<br>Киһи-сүөһү үөскүү илигинэ,<br>Айыы-буруй таарыйа илигинэ,<br>Араҥас майдааннаах<br>Сылгы сүөһү тыллаах эбит,<br>Тыл бөҕө сиикэйдээх,<br>Олоҥхотун олоҥхо омуннаах,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2680
                    </td>
                    <td>
                        Ити сылгы саҥара-иҥэрэ турда:<br>— Тыбыырахпын, тыбыырахпын!<br>Туһааннаах тойон иччикээм,<br>Мин диэтэх киһи<br>Этэр тылым эгэлгэтин<br>Истэн чинчилээн тур!<br>Икки аламай күнүм атылыыта<br>Алаҕаркаан көмүс хараххынан,<br>Икки тэргэн ыйым кэриэтэ<br>Кэрэ чуор кулгааххынан
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2690
                    </td>
                    <td>
                        Истэ сэргэҕэлээ!<br>Мин диэтэх киһи<br>Кимнээхтэн кииннээххиний диэҥҥин,<br>Хантан хааннааххыный диэн,<br>Туох дойдуттан тутаахтааххын диэн<br>Тумсубуттан тутан<br><span class="description" id="744">Токкоолоһон</span> ыйытар буолларгын,<br>Туһааннаах тус илин диэкиттэн<br>Өрө көтөн сүүрэн таҕыстахха,<br>Өрө көрдөххө —
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2700
                    </td>
                    <td>
                        Өрөҕөтө көҕөрөн көстөр
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2701
                    </td>
                    <td>
                        Үс хаттыгастаах<br>Үс нүрүс маҕан халлаан<br>Үрүт өттүгэр үөскээбит-төрөөбүт<br>Эридьиэс кумааҕыны<br>Эргитэ туппут курдук<br>Эл-дул сибиирдээх,<br>Үс суксурҕа<br>Үрүмэтийбэт үүт долгун олохтоох,<br>Үс субуруччу
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2710
                    </td>
                    <td>
                        Үрүҥ көмүс бүлүүскэй куораттаах,<br>Араҥас лаадан буруота түптэлээх,<br>Манаардаах чимэчи уота сардаҥалаах,<br>Алаас-сыһыы саҕа<br>Араҥас <span class="description" id="745">майдааннаах</span>,<br>Көлүйэ күөл курдук<br>Үрүҥ көмүс бүрүстүөллээх,<br>Араҥа туос курдук<br>Аркыыба кумааҕылаах,<br>Сытар ынах саҕа дьыалалаах,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2720
                    </td>
                    <td>
                        <span class="description" id="746">Сымара таас</span> курдук чэрэниилэлээх,<br><span class="description" id="747">Кыдама</span> атырдьах курдук куоссуннаах,<br>Кириэстээх тайахтаах,<br><span class="description" id="748">Өрүөллээх</span> үтүлүктээх,<br>Мэтириэттээх бэргэһэлээх,<br>Биир <span class="description" id="749">бирисээгэлээх</span>,<br>Соҕотох сокуоннаах,<br><span class="description" id="750">Өтөҕөлөөх</span> бэйэлээх,<br>Үүс-аас дьүһүннээх,<br>Үрүҥ Айыы Тойон оҕоньньор,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2730
                    </td>
                    <td>
                        Чыҥырыыр Дьылҕа Хаан,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2731
                    </td>
                    <td>
                        Орулуур Одун Буурай тойон<br>Маанылаах бастыҥ сылгыта<br>Арҕаа халлаан Атыыр Киппэ сылгыта<br>Аар тойон аҕалаахпын.<br>Илин халлаан Илэ-Ньамаҕай биэтэ<br>Ийэлээх сылгыбын.<br>Тыллаах өстөөх<br>Хара Кулун ат буолан<br>Төрөөбүтүм-үөскээбитим.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2740
                    </td>
                    <td>
                        Маска түстэхтээҕи <span class="description" id="751">барысыайым</span>,<br>Окко түспүт оҥоһуум,<br>Сиргэ түспүт <span class="description" id="752">сэрэбиэйим</span>,<br>Эйиэхэ ананан айдарбытым.<br>Эн бэйэҥ буоллаххына<br>Ийэҥ уруутун сэһэргээтэхпинэ,<br>Өтөҕөлөөх Үрүҥ Айыы Тойон оҕоньньор<br>Үс кыыһыттан оччугуй кыыһа<br>Сэттэ айыы кыыһа<br>Эйэлэһэн ииппит
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2750
                    </td>
                    <td>
                        Эдьиэлимэ Куо диэн<br>Үчүгэй үтүө дьахтар<br>Ийэлээх этиҥ.<br>Аҕаҥ буоллаҕына<br>Аҕыс хаттыгастаах<br>Араҥас маҥан халлаан<br>Буойун буолунай бухатыыра буолбут<br>Хаардыыр Мохсоҕол диэн<br>Аар тойон аҕалаах этиҥ.<br>Ол буолан бараммын:
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2760
                    </td>
                    <td>
                        — Тоҕо отто дойду бухатыыра
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2761
                    </td>
                    <td>
                        Буолбуппунуй? — диэтиҥ.<br>Өтөҕөлөөх Үрүҥ Айыы Тойон<br>Кулун кымыһа оҥорон<br>Бар дьонун аһатан олордоҕуна,<br>Үс халлаан суруксута<br>Үс Нүөмэр Маҕан суруксукка<br>Үрүҥ көмүс бүрүстүөлгэ<br>Үөрдэһэн олордохторуна,<br>Бастыҥ <span class="description" id="753">томторҕолоох</span> 
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2770
                    </td>
                    <td>
                        <span class="description" id="754">Чороон ымыйа</span> айахтаах<br>Үөһээ үрүт <span class="description" id="755">көлүөтүнэн</span> <br>Толору араҕас илгэ арыылаах кымыһы<br>Мараччы көтөҕөн баран истэҕинэ,<br>Ийэҥ иһигэр тоҕус ыйдаах сылдьаҥҥын<br><span class="description" id="756">Тараһа</span> бүтэй тэбиэлээҥҥин<br>Чороонноох кымыһы<br>Үс илии быһаҕас түһэрбитиҥ,<br>Сиргэ тоҕо саккыраппытыҥ.<br>Бу саккыраппыккыттан
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2780
                    </td>
                    <td>
                        Өтөҕөлөөх Үрүҥ Айыы Тойон оҕоньньор гиэнэ<br>Төрүүр сүөһүтэ сылы мэлдьи<br>Төрүөҕэ кэлбэккэ төннөр<br>Төлкөтүн аҕалбыт эбиккин,<br>Кэлэр киһитэ үс сылы мэлдьи<br>Кэнчээритэ кэхтэр кэскилин<br>Тэрийбит эбиккин.<br>Ол иннигэр<br>Үрүҥ Айыы Тойон оҕоньньор<br>Айыы Дьаргыл удаҕанынан
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2790
                    </td>
                    <td>
                        Отто дойдуга түһэрэн
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2791
                    </td>
                    <td>
                        Ийэҥ иһиттэн, <span class="description" id="757">ымай киэлититтэн</span>*,<br>Киэҥ <span class="description" id="758">хапчаҕайыттан</span> <br>Эйигин халыҥ айыылааннар,<br>Хараҥа буруйдааннар,<br>Итэҕэс төлкөлөөннөр,<br><span class="description" id="759">Суорума</span> соруктааннар,<br>Сир уларытаннар,<br>Үөһэ сырдык саарыстыбаҕа<br>Сатаан сыдьдьыа суох
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2800
                    </td>
                    <td>
                        Мэник киһи үөскээбит диэннэр,<br>Илбийэн эмэрийэн<br>Отто дойду диэки<br>Алгыстаах аҕата буол диэн,<br>Ийэ дойду гиэнэ<br>Эбээһинэстээх киһитин-сүөһүтүн тэрийэр<br>Кинээһэ буол диэн,<br><span class="description" id="760">Кэнийэн-кэмнээн</span>,<br>Айан-кэрдэн,<br>Анаан-минээн
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2810
                    </td>
                    <td>
                        Оҥорбуттара эбээт,<br>Ону билэҕин дуо? — диэтэ.<br>«Аат-татай, оҕолоор,<br>Аналлаах атым,<br>Мэнэлээх миҥэм,<br>Одун Хаантан оҥоһуулаах,<br>Тыйыс Хаантан дьылҕалаах<br>Дьоннор эбиппит эбээт,<br>Өлөн охтон биэрэр үһүбүөт», — диэн,<br>Киһи киһилии үөрэ-көтө санаата.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2820
                    </td>
                    <td>
                        Атын үрдүк мындаатыгар
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2821
                    </td>
                    <td>
                        Үрүҥ туллук курдук<br>Олорон чөмчөөрүс гына түстэ,<br>Соҕуруу диэкки барбытын курдук<br>Баран истэ.<br><span class="description" id="761">Сиэллэрэн</span> <span class="description" id="762">дьигиһитэн</span> истэ,<br>Хаамтаран халыһытан истэ,<br>Уурдаран оҕустаран истэ.<br>Үрүүмкэ арыгынан күндүлэспит,<br>Чааскы арыгынан тарҕатыспыт,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2830
                    </td>
                    <td>
                        Иһит арыгынан эйэлэспит,<br>Билээгэ арыгынан мааныласпыт,<br>Чиэппэр арыгынан кэһиилэспит,<br>Аҥаар арыгынан айылгыламмыт,<br>Биэдэрэ арыгынан бэриктэммит<br>Киһилээх сиргэ тиийэн кэллэ.<br>Бу ат маны көрөн баран,<br>Күрбүү көмүс кынатына<br>Өрө көтөн даллайан таҕыста,<br>Көҕөрөр күөх былыты
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2840
                    </td>
                    <td>
                        Күөнүнэн кэтиэлээтэ,<br>Бу иһэн саҥара истэ:<br>— Аньыһахпын, аньыһахпын!<br>Тыбыырахпын, тыбыырахпын!<br>Туһааннаах тойон иччикэм,<br>Быралыйбат былыргы дьылга,<br>Уларыйбат урукку хонукка,<br>Айҕаллаах аан дойдуга эрдэххинэ,<br>Абааһы бухатыырын муҥутуура,<br>Ааһар албастааҕын,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2850
                    </td>
                    <td>
                        Куотар <span class="description" id="763">кубулҕаттааҕын</span>,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2851
                    </td>
                    <td>
                        Өлөрбүт-сүтэрбит эбиккин.<br>Ол өлөрбүккүттэн<br>Абааһы этин-хаанын симэһинэ<br>Хоҥкуйар <span class="description" id="764">хоолдьуктарыгар</span> дылы,<br>Суоракка уган ылбыт курдук<br>Балай <span class="description" id="765">маҕаас</span>,<br>Харгыйа хара суора<br>Үс суор үөһэ дойдуга<br>Өрө көтөн тахсыбыттар эбит.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2860
                    </td>
                    <td>
                        Ол кэннэки суор гиэнэ<br>Ааһар алын албаһа,<br>Куотар үрүт кубулҕата<br>Иннитигэр үс үчүгэй дьахтар буолан,<br>Кубулунан туора тоһуйдулар.<br>Сэбирдэҕи тэлгэппиттэр,<br>Аан чэчир аспыттар,<br>Ас астаабыттар,<br>Айылгы тэрийбиттэр.<br>Эр эрэ буолларгын —
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2870
                    </td>
                    <td>
                        Көрбүт хараххын чыпчылыйар буолаайаҕын,<br><span class="description" id="766">Көллүбүт</span> атаххын такыйар буолаайаҕын.<br>Үрүт өттүлэрэ үчүгэй<br>Үүс-киис тириитэ буолан көстүөҕэ,<br>Алын өттүлэрэ абааһы<br>Адьдьархайдаах адьыр уу буолуоҕа,<br>Албас бөҕө булла,<br>Алып бөҕө ылла.<br>Дьэ миигин улаханнык охсуталаан көр,<br>Кытаанахтык кымньыылаан көр! — диэтэ.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2880
                    </td>
                    <td>
                        Улаханнык оҕуста,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2881
                    </td>
                    <td>
                        Кытаанахтык кымньыылаата,<br>— Соноҕоһум оҕото билэн-көрөн эттэҕэ, — диэтэ.<br>Ат туох да олус күүстээхтик<br>Өрө дабайан тахсан истэ.<br>Ити истэҕинэ — үс сайын киэнэ<br>Балай хараҥата түһэн<br><span class="description" id="767">Барыкыс</span> гынна, соҕотохто<br>Сэттэ сайын киэнэ<br>Сиикэй эт мууньньары буһан хаалар
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2890
                    </td>
                    <td>
                        Эмэгэт куйааһа түһэн сырылатта.<br>Киһи киэнэ хараҕа илимнэһэн барар<br>Үлүгэр куйааһа үөдүйдэ,<br>Туох да тулуйуох буолбатах<br>Өҥүрүк куйааһа түстэ.<br>Ити иһэн өйдөөн көрбүтэ:<br>Хара <span class="description" id="768">ыарҕа</span> диэбитэ —<br>Хара сэрии буолан көһүннэ,<br>Үрүҥ ыарҕа диэбитэ —<br>Үрүҥ сэрии буолан үтүрүйдэ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2900
                    </td>
                    <td>
                        Күөх ыарҕа диэбитэ —<br>Күөх сэрии буолан көһүннэ.<br>Үрүҥ көмүс <span class="description" id="769">соппулуот</span> олбуор<br>Күндээрэн көһүннэ,<br>Кыһыл көмүс мэндиэмэннээх дьиэ<br>Кылбаһыйан көһүннэ.<br>Сириэһиннээх <span class="description" id="770">сири иһит</span> диэни<br>Итиннэ сириэдиппиттэр эбит,<br>Сиэллээх <span class="description" id="771">кэриэн айаҕы</span> <br>Итиннэ кэккэлэппиттэр эбит,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2910
                    </td>
                    <td>
                        Матыарыйа ойуулаах <span class="description" id="772">матаарчах</span> айаҕы
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2911
                    </td>
                    <td>
                        Манна бараалаабыттар эбит,<br>Оһуордаах чороон айаҕы<br>Онно чуоҕуппуттар эбит,<br>Бөҕөс диэн онно тустан эрэр эбит,<br>Быһый бөҕө онно сыссан эрэр эбит,<br>Үчүгэй сытыы кылыыһыттар онно кылыйсыбыттар,<br>Былыргы ырыаһыттар онно ыллаабыттар,<br>Олоҥхоһут онно олоҥхолообут,<br><span class="description" id="773">Көр дьаҕыл</span> бөҕө үөскээбит,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2920
                    </td>
                    <td>
                        Күрүөх улуус муньньустубут,<br>Үөрүү-көтүү үөскээбит<br>Дойдутугар тиийэн кэллэ.<br>Бу кыһыл көмүс мэндиэмэннээх дьиэҕэ<br>Мэндиэмэни төгүрүйэ агыраада күрүөлээх эбит.<br>Ол күрүөтүн иһигэр,<br>Этиэхтэн эриэккэс үчүгэй,<br>Саныахтан <span class="description" id="774">салаҥ</span> үчүгэй,<br>Сырдык <span class="description" id="775">ньуурдаах</span>,<br>Ыраас хааннаах,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2930
                    </td>
                    <td>
                        Ыйдаҥа дьүһүннээх<br>Үс үчүгэй дьахтар<br>Үҥкүүлээн үөрэ-көтө туралларын көрдө.<br>Бастакы дьахтар хоһооннуур эбит.<br>Биһиги киһибитин көрө түстүлэр,<br>Хоһооннорун кубулутан ыллыы-туойа сырыттылар.<br>Бастакы дьахтар:<br>Дьэ, хотуйдаар, субу туран көрдөрбүт:<br>Арҕаа халлаан анныгар үөскээбит<br>Тыллаах-өстөөх Хара Кулун аттаах
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2940
                    </td>
                    <td>
                        Сылгы уола Дыырай бухатыыр
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2941
                    </td>
                    <td>
                        Атын улууһум ааттааҕа,<br>Туспа улууһум дьоһуннааҕа,<br>Чиэски сибиир <span class="description" id="776">чиргэллээҕэ</span>, <br>Көмүскэллээх сүрэхтээх күнүм улууһа,<br>Аһыныылаах санаалаах айыым аймаҕа,<br>Туспа улуус убайбыат,<br>Дьэ дорооболор тосхойдулар.<br>Биһиги диэтэх дьону<br>Ас үрдүн аһаабыт,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2950
                    </td>
                    <td>
                        <span class="description" id="777">Ачастааттаах</span> аҕабыт уруутун саҕаттан<br>Аһаабыт аспыт тобоҕун аһаан<br>Айхалы оҥоро турабыт,<br>Ийэбит уруутун саҕаттан<br>Иһит үрдүн испит<br>Испииһэктээх <span class="description" id="778">тэримдьибитин</span> <br>Тэрийэн тэнитэн турабыт.<br>Кэлэр кэнчээрибит<br>Кэскилэ буоллун диэммит,<br>Ийэ биэбитин <span class="description" id="779">этэттээммит</span>,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2960
                    </td>
                    <td>
                        <span class="description" id="780">Кытыылыыр</span> сылгыбытын кымыстааммыт,<br>Улааммыт уйгутун муньньаммыт,<br><span class="description" id="781">Ороһулаан</span> төрөөбүт<br>Оҕо ыччаппыт тускута буоллун диэммит<br>Уруйу-айхалы олохтоон олоробут.<br>Биһиги диэкки<br>Кырыы хараххынан кынчай,<br>Уу хараххынан утары көр.<br>Суол оҕото тутайбытыҥ буолуо,<br>Айан киһитэ ааспытыҥ буолуо,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2970
                    </td>
                    <td>
                        Амтаннаах аста аһаа,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2971
                    </td>
                    <td>
                        Сылаас хоойго сыт,<br>Оттоох ороҥҥо утуй,<br>Тохтоо болҕой эрэ!<br>Тэһиин тутар <span class="description" id="782">дьэллик</span> маҕан уолаттар,<br>Тэһииннэ тута тардыҥ,<br>Тэллэхтэ кэбиһэ охсуҥ,<br>Дьиэ аанын аһыҥ!<br>Олох тоһуйар олооччу уолаттар,<br>Олохто оҥоро охсуҥ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2980
                    </td>
                    <td>
                        Олбохто быраҕыҥ! — диэтилэр.<br>Итини истэ-истэ ат сылгы<br>Үрүҥ көмүс кынатын кыптыыйдаан,<br>Илин өттүлэрин курдары түһэн ааһа турда.<br>Ити киһи итинтэн<br>«Бу үлүгэр көхсүм хаана барылаччы буһан иһэн,<br>Саманна тохтоон аһаан-сиэн,<br>Күлэн-ооньньоон ааһыахха», — дии санаата.<br>Атын айаҕын тардыалаан көрдө,<br>Атын айаҕа буусса күүһүрдэ, кытаатта,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        2990
                    </td>
                    <td>
                        Ыҥыырын сырайыттан тайанан<br>Ыстанан түһээри өгдөҥнөөн көрдө.<br><span class="description" id="783">Быһымах</span> айантан ыҥыыра<br>Быһа иҥэринэн кэбиспит.<br>Кулгааҕын тыаһа куугунаан истэ,<br>Мэйиитин тыаһа чыгынаан истэ.<br>Ааһан хааллылар, бу ааһан баран<br>Кулгааҕын уһугунан иһиттэҕинэ,<br>Кэннин диэки саҥа-иҥэ<br>Өлүү хоро тойугун туойа хааллылар,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3000
                    </td>
                    <td>
                        <span class="description" id="784">Дьаҕа</span> ырыатын ыллыы хааллылар.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3001
                    </td>
                    <td>
                        Ыпсыыта суох ырыа диэни<br>Итиннэ ыллыы хааллылар,<br>Туокката суох тойук диэни<br>Онно туойа хааллылар,<br><span class="description" id="785">Кырыыс</span> кырыы, тыл этэ хааллылар.<br>Биһиги киһибит ааһа баран хаалла.<br>Ити ат ити иһэн<br>Эмиэ саҥалаах буола истэ:<br>— Дьэ, туһааннаах тойон иччикээм!
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3010
                    </td>
                    <td>
                        Этэр тылым эгэлгэтин иһит,<br>Саныыр санаам салаатын сабаҕалаа.<br>Илин өттүбүтүгэр аны биир <span class="description" id="786">буом</span> тоһуйда.<br>Түгэҕэ биллибэт Түмэри байҕал<br>Тус иннибитигэр туора туорайдаата,<br>Аллараа өттө буоллаҕына<br>Түөт түүнүктээх <span class="description" id="787">төргүл</span> үөдэнин айаҕа,<br>Үөһээ өттө буоллаҕына<br>Киҥкиниир киэҥ халлааны<br>Харааччы салыы турар
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3020
                    </td>
                    <td>
                        <span class="description" id="788">Уот Тумары</span> байҕал,<br>Устата-туората биллибэт<br>Уот муора буолла.<br>Аллараа өттүнэн күүдээх кутуйах<br>Сүргүйэн туораан тахсыбат сирэ.<br>Үөһээ өттүнэн көтөр кынаттаах<br>Кыайан чиэрэстээбэт сирэ.<br>Дьэ, туһааннаах тойон иччикээм,<br>Икки дьабадьыбын хайыта илгиэлээн көр,<br>Икки ылгын таас ойоҕоспун
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3030
                    </td>
                    <td>
                        Хардарыта тиҥилэхтээн биэр,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3031
                    </td>
                    <td>
                        Бэрт улаханнык охсуталаа,<br>Кытаанахтык кымньыылыы тарт.<br>Итинтэн буоллаҕына биһиги киһибит<br>Ити киҥкиниир киэҥ халлаан сындыыһа<br>Айыы <span class="description" id="789">сандылыкы</span> кымньыытын<br>Сулбу таһытан ылла да,<br>Көп эти көҥүтэ дайбаата,<br>Сулар этин суулларыта дайбаата,<br>Икки <span class="description" id="790">дьабадьытын</span> кулгаах тааһыгар диэри
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3040
                    </td>
                    <td>
                        Хайыа тардан биэрдэ,<br>Икки ылгын таас ойоҕоһун<br>Иккиэннэрин хардарыта тиҥилэхтээн биэрдэ,<br><span class="description" id="791">Хайырҕахтаах хара быара</span>  хамсаата,<br>Нохтоолоох тойон сүрэҕэ долгуйда.<br>Курбуу көмүс кынатынан<br>Өрө көтөн тахсан истэ,<br>Өрө көдөххө өрөҕөтө көҕөрөн көстөр<br>Үс мүрүс маҕан халлаан үрдүгэр<br>Өрө көтөн күүгүнээн таҕыста эбээ.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3050
                    </td>
                    <td>
                        Бу тахсан баран<br>Кынатын кыптыыйдаата да,<br>Устата биллибэт Уот муора<br>Ортото манан буолаарай диэн,<br>Эргичийэр иэрчэҕин киинэ<br>Туналыйар орто ньуура<br>Саманан буолаарай диэн,<br>Таҥнары дайан түстэ.<br>Бу түһэн иһэн ыллыыр:<br>— Дьиэ буо! Дьэ иһит эрэ!
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3060
                    </td>
                    <td>
                        Туһааннаах тойон иччикээм,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3061
                    </td>
                    <td>
                        Өтөҕөлөөх Үрүҥ Айыы Тойон оҕоньньор<br>Мэҥий маҕан атыыра<br><span class="description" id="792">Сүүллээн</span> <span class="description" id="793">күөһээн</span> үөскэппитэ.<br>Өтөҕөлөөх Үрүҥ Айыы Тойон оҕоньньор<br>Бастыҥ маанылах Кута маҕан биэтэ<br>Үҥнэн хадан төрөппүтэ эбээт.<br>Тыллаах өстөөх Хара Кулун ат<br>Буолан онтон төрөөбүтүм.<br>Бииргэ төрөөбүт быраатым
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3070
                    </td>
                    <td>
                        Ыйдаҥа таас кынаттаах<br>Айыы дугуй ат сылгы<br>Туһааннаах тойон иччитэ,<br>Күөгэйэр Күн Туйгун бухатыыр,<br>Харахтаах буолларгын көр,<br>Кулгаахтаах буолларгын истэ тарт,<br>Өлөр хаалар күн үөскээтэ!<br>Түгэҕэ биллибэт Түмэри байҕал<br>Туналыйар ньууругар бухатыыр киһи<br>Охсуһар чыыстай буолата,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3080
                    </td>
                    <td>
                        Сиртэн халлаантан оҥоһуулаах<br>Таллан таас Табый булгуньньаҕы<br>Уһуллар уу дьулайын кэлин туйахпынан<br>Таба тэбинэн ааһарым буоллар,<br>Айыы улууһа айыыбытыгар аттаныа этибит,<br>Күн улууһа күммүтүгэр<br>Көтөҕүллэн көтүө этибит! — диэтэ.<br>Орулуос кус кынатын тыаһын курдук<br>Куус гына түстэ соҕотохто.<br>Киһи гиэнэ мэйиитин тыаһа
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3090
                    </td>
                    <td>
                        Алтан солуур кылдьыытын курдук
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3091
                    </td>
                    <td>
                        Кыыс гына түстэ,<br>Кулгааҕын тыаһа<br>Уон орулуос кус кынатын тыаһын курдук<br>Куус гына түстэ.<br>Ол иһэн уҥа кулгааҕынан иһиттэҕинэ,<br>Ат сылгы кэлин туйаҕын тыаһа<br>Таас кына туура тэбиннэ быһыылаах.<br><span class="description" id="794">Таллан</span> таас булгуньньах оройуттан тэбинэн<br>Өрө көтөн тахсан истэҕинэ, эмискэ
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3100
                    </td>
                    <td>
                        Били мааҥҥы ыйдаҥа таас кынаттаах<br>Айыы-дугуй аттаах<br>Күн Туйгун бухатыыр иннигэр<br>Субурус гына түстэ,<br>Хантан да кэлбитин көрүмүнэ хааллылар.<br>Кини диэтэх киһи иннилэригэр көтүтэн түһэрдэ.<br>Тоҕус <span class="description" id="795">күннүк</span> сиртэн долгутан охсор<br>Нуоҕайдаах оҥочо көмүс кутуругуттан<br>Кэнники сылгы ытыра баттаан ылла.<br>Икки ат күүһэ холбосто да, сүрдээх түргэнник
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3110
                    </td>
                    <td>
                        Умайа турар уот муора<br>Уҥуоргу оппуоһугар<br>Сулбу ыстанан тура түстүлэр.<br>Үөһээ дойду диэкиттэн<br>Түөрт уон күннүк <span class="description" id="796">төгүрүччүлээх</span>,<br>Отут күннүк уорҕалаах,<br>Килэгир тимир <span class="description" id="797">дэриэспэ</span> таас мээчик<br>Убайа турар уот муораҕа<br>Бар гына түстэ.<br>Баара эрэ үс саһаан мүччү көтөн биэрдилэр,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3120
                    </td>
                    <td>
                        Сыыһа түһэн кэбистэ.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3121
                    </td>
                    <td>
                        Ити мээчик буоллаҕына<br>Үөһээ куоппут үс суор обургулар<br>Айыы бухатыырын уот муораҕа<br>Таҥнары баттатаары баҕарбыттара<br>Сыыһа түһэн кэбистэҕэ.<br>Ити дьон итиннэ кэннилэрин хайыһан көрдүлэр.<br>Тоҕус төгүрүк сууккаҕа<br>Уот муоралара оҥойо уолан барда,<br>Сэттэ түүннээх күҥҥэ
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3130
                    </td>
                    <td>
                        Өрө <span class="description" id="798">дэбилийэн</span> тахса турда.<br>Ити кэнниттэн<br>Сир сиринэн буола түстэ,<br>Дойду дойдунан буола түстэ.<br>Икки айыы бухатыыра<br>Аргыстаһан айаннаан истилэр.<br>Ыйдаҥа таас кынаттаах<br>Айыы Дугуй аттаах<br>Күн Туйгун бухатыыр<br>Бастаан иһэн ырыалаах буолла:
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3140
                    </td>
                    <td>
                        — Дьэ, күн дьүөгэм, көмүс доҕорум!<br>Мин диэтэх киһи<br>Этэр тылым эгэлгэтин иһит.<br>Уон уу харахтаах эйигин утары көрбөтүн,<br>Уон тарбахтаах уумматын,<br>Биэс тарбахтаах <span class="description" id="799">диэлийбэтин</span>.<br>Илин диэки өттүгэр<br>Үс курбуулаах ураһа дьиэ саҕа<br>Дьол-соргу эйигин доҕордостун.<br>Хаҥас дьайыҥҥар
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3150
                    </td>
                    <td>
                        Алталаах саастаах,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3151
                    </td>
                    <td>
                        <span class="description" id="800">Саадьаҕай</span> дьүһүннээх<br>Атыыр оҕус саҕа<br>Талааннаах саргы <span class="description" id="801">дьайаан</span> <br>Аргыстаһан сырыттын.<br>Уҥа диэки өттүгэр<br>Тоҕустаах саастаах,<br>Тураҕас дьүһүннээх,<br>Дьоллоох-соргулаах,<br>Соноҕос атыыр саҕа
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3160
                    </td>
                    <td>
                        Дьол-соргу бөҕө<br>Эйиэхэ доҕордостун!<br>Кэлин диэки өттүгэр<br>Түөрт саастаах<br><span class="description" id="802">Өҕүрүмэр</span> атыыр оҕус курдук<br>Өрөгөй-талаан<br>Эйиэхэ үөрдүстүн!<br>Сэттэ ураһа дьиэ буруотун сириэдит,<br>Аҕыс ураһа дьиэ буруотун аҥаарыт,<br>Тоҕус ураһа дьиэ буруотун унаарыт!
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3170
                    </td>
                    <td>
                        Киһи буолар кэскиллэн,<br>Сүөһү буолар төлкөлөн!<br>Кэнэҕэһин кэнэҕэски сылга,<br>Хойутун хойут да буоллар<br>Умса түстэхпитинэ илин өттүбүтүттэн<br>Өйөөбүл баҕана буолсуохпут,<br>Тиэрэ түстэхпитинэ кэлин өттүбүтүттэн<br>Тирээбил баҕана буолуохпут!<br>Өлөр-хаалар күнүҥ көһүннэҕинэ,<br>Ыйдаҥа таас кынаттаах,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3180
                    </td>
                    <td>
                        Айыы Дугуй аттаах,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3181
                    </td>
                    <td>
                        Күн Туйгун бухатыыр,<br>Кулгаахтаах буолларгын иһит,<br>Харахтаах буолларгын көр диир буолаар.<br>Онуоха мин диэтэх киһи<br>Саха киһи буоламмын<br><span class="description" id="803">Чаачар</span> саабын<br>Тарбахпынан тардан<br>Аҥаабыллаан туруом,<br>Киһи буоламмын
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3190
                    </td>
                    <td>
                        <span class="description" id="804">Кирис</span> сааны эрбэхпинэн тэнитэн,<br>Талах оноҕоспун туора ууран тураммын<br>«Сэп барда, сэрэн» — диэҕим,<br>«Ох барда, оҥоһун» — диэҕим.<br>Ол диэтэхпинэ,<br><span class="description" id="805">Тордохтоох</span> хоҥоруулаах,<br><span class="description" id="806">Чарпаана</span> көмүс дабыдаллаах,<br>Кутуу көмүс <span class="description" id="807">хотоҕойдоох</span>,<br>Мөһүүрэ көмүс түүлээх,<br>Араҕас көмүс кутуруктаах,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3200
                    </td>
                    <td>
                        <span class="description" id="808">Өлбүргэлээх</span> үрүҥ көмүс<br>Мүөрсүн дьүһүннээх,<br>Мооньньугар мойбордоох,<br>Кутуругар кыһыл көмүс<br>Хобо-чуораан <span class="description" id="809">чымадааллаах</span> <br>Киҥкиниир киэҥ халлаан<br>Аҥаарыйар аалай<br>Мохсоҕол кыыла буолаҥҥын<br>Үөһэ үс күннүк сиргэ<br>Өрө көтөн биэрээр эрээ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3210
                    </td>
                    <td>
                        Быралыччы бырастыы!
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3211
                    </td>
                    <td>
                        Ити гынан баран илин диэкки<br>Саха киһи кыайан <span class="description" id="810">арҕары</span> көрөн таһаарбат<br>Саппахтаах сатыы буурай халлаанын<br>Өрө көтөн тахсан бара турда.<br>Эридьиэс кумаахыны эргитэ туппут курдук<br>Эл-дул сибииргэ мэлис гынан баран хаалла.<br>Ити биһиги киһибит<br>Туһааннаах тус соҕуруу барарын<br>Кубулуппакка бара турда:
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3220
                    </td>
                    <td>
                        Сиэллэрэн дьигиһитэн,<br>Хаамтаран халыһытан,<br>Уурдаран оҕустаран истэ.<br>Бэрт үрэхтэр тэҥкэлдьиһэн кэлэн истилэр,<br>Үтүө үрэхтэр өҥкөлдьүһэн көһүннүлэр,<br>Ааттаах алаастары кытта аргыстаһан айаннаата.<br>Хоҥор хаастар холбоһон иһэллэрин курдук<br><span class="description" id="811">Хоҥоруу дуоссун</span> дойду буолла.<br>Ааттаах аты такымынан тардыстар<br>Ача күөх от аҥаарыйан тиийэн кэллэ.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3230
                    </td>
                    <td>
                        Дьоруо ат тобугунан охсуллар<br>Күөх нуоҕай от унаарыйан тиийэн кэллэ.<br>Үтүө аты өттүк баһынан охсуллар<br>Үкэр күөх от өрүкүйэн истэ.<br>Бэт аты сис быһаҕаһынан<br>Бэттиэмэ от буолан барда.<br>Ити кэлин өттүттэн<br>Хантан да кэлбитэ биллибэккэ хаалла.<br>Били былыргы дьылга<br>Хаҥырыыр Хаан тойон аҕалаах,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3240
                    </td>
                    <td>
                        Кыҥырыыр Хаан хотун ийэлээх,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3241
                    </td>
                    <td>
                        Алталаах атыыр сылгы аттаах<br>Иккилээх оҕо Эрбэхтэй Бэргэн<br>Элитэн-халытан кэлэн,<br>Иннигэр көтүтэн түһэрдэ.<br>Бастакы ат самыытыгар,<br>Тыллаах-өстөөх Хара Кулун ат<br>Сыҥааҕын ууран кэбистэ,<br>Айыы атыттан хаалыах ат буолбатах,<br>Субу курдук тус
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3250
                    </td>
                    <td>
                        Соҕуруу диэки түһэн субурустулар.<br>Биһи киһибит ити иһэн<br>Тойонноон-толкуйдаан истэ:<br>«Бу маҕай аллаах, сибилигин<br>Көхсүн хараҕын көҥү ытаммын,<br>Көхсүн хаанын <span class="description" id="812">көҥүстээх</span> үрэх курдук<br>Көҥү сүүрдэ ооньньуом дуо?»<br>Ол гынан баран эмиэ<br>Тоҕус тарбаҕын тосту баттаан<br>Тойонноото-толкуйдаата:
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3260
                    </td>
                    <td>
                        «Көмүскэллээх санаалаах<br>Күн айыы киһитэ буолан бараммын,<br>Аһыныгас санаалаах<br>Айыы аймаҕа буолан бараммын,<br>Айыы аймаҕын өлөрөн-өһөрөн кэбиһэр<br>Айыылаах-сааттаах буолуо буоллаҕа,<br>Дьиэтин-уотун<br>Батыһан баран көрүөхпүн үчүгэй.<br>Аҕыс былас аалай солко суһуохтаах<br>Айталы Куо диэн үчүгэй дьахтар
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3270
                    </td>
                    <td>
                        Балыстаахпын диэбитэ,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3271
                    </td>
                    <td>
                        Батыһан тиийэн<br>Тылынан кэпсэтиэххэ үчүгэй,<br>Аһын аһыахха,<br>Дьиэтин-уотун көрүөххэ,<br>Дьүһүнүттэн көрөн баран,<br><span class="description" id="813">Кирдьик</span> куһаҕан киһи эбит буоллаҕына,<br>Дьиэтигэр да баран кэпсэтээ инибин.<br>Дьэ бачча көрөн бараммын<br>Куоттарар да үһүбүн кинини» — диэн саныы истэ.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3280
                    </td>
                    <td>
                        Ол курдук аргыстаһан айаннаан истилэр.<br>Бу иһэн көрдөҕүнэ,<br>Бэт ыраах сиртэн көстөр эбит<br>Аҕыс салаалаах Аал Дууп Мас.<br>Ол арҕаа өттүгэр<br>Үрүҥ көмүс <span class="description" id="814">күөрэҥсэ</span> балаҕан дьиэ<br>Кылбаһыйан көһүннэ.<br>Тоҕус тойон <span class="description" id="815">баабыр</span> сэргэ<br>Бачыгырыйан көһүннэ.<br>Хотоннорун хотугу муннугунан
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3290
                    </td>
                    <td>
                        <span class="description" id="816">Хотору</span> түһэн истэхтэринэ,<br>Бастыҥ ат бастыҥ сэргэни<br>Батары көрөн айаннаата.<br>Хотон хотугу муннугунан<br>Ыт <span class="description" id="817">холлорооно</span> диэн<br>Холлороон баарынан Симэхсин эмээхсин<br>Баһын батары биэрэн өҥөйөн көрдө.<br>Айаҕын аппыт,<br>Хараҕын көрбүт,<br>Тылын былас ордуга түөс аҥаара таһаарбыт,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3300
                    </td>
                    <td>
                        Дэлэччи-дьиэлигиччи көрбүт,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3301
                    </td>
                    <td>
                        <span class="description" id="818">Буолускай</span> курдугунан боругулдьуччу көрбүт.<br>Этэрбэһин тумса сүүһүн дьөлү аалбыт,<br>Этэрбэһин быата иэнин хастаабыт,<br>Тобугун быата <span class="description" id="819">дьоруо</span> оҥорбут,<br>Атаҕын быата <span class="description" id="820">аллаах</span> оҥорбут,<br>Симэхсин эмээхсин көрө баттаан баран<br>Тойонноох хотунугар сар-сар эккирээн таҕыста.<br><span class="description" id="821">Дьалаана суох</span> саҥаран барда,<br>Ыпсыыта суох ыллаан барда,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3310
                    </td>
                    <td>
                        Этиэн булумуна эппэҥнии сырытта,<br>Саҥарыан булумуна аппаҥныы турда:<br>— Хаҥырыыр Хаан тойон аҕаккам,<br>Кыҥырыыр Хаан хотун ийэккэм!<br>Көрбөтөхпүн көрдүм,<br>Истибэтэхпин иһиттим.<br>Бастакыта былыргы биһиги оҕобут<br>Алталаах атыыр сылгы аттаах<br>Иккилээх Эрбэхтэй Мэргэн кэллэ быһыылаах.<br>Ол кэнниттэн
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3320
                    </td>
                    <td>
                        Күн диэки көрдөххө<br>Көхсө күнү бүөлүүр,<br>Халлаан диэки көрдөххө<br>Санна халлааны хаххалыыр,<br>Сахаттан саһаанынан ордук,<br>Нуучаттан тутумунан ордук,<br>Хайа дойду кинээһин оҕото кэлбитин билбэтим,<br>Туох дойду кулубатын оҕотун бэйэм билбэтим.<br>Тэһиин тутар дьэллик уолаттар,<br>Тэһииннэ тахсан тута тардыҥ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3330
                    </td>
                    <td>
                        Олох тоһуйар олооччу уолаттар,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3331
                    </td>
                    <td>
                        Олохто уура охсуҥ.<br>Күрдьэххэ күллэ,<br>Хамыйахха хаарда,<br><span class="description" id="822">Удьааҕа</span> уута! — диэн баран,<br>Уҥан тиэрэ баран тойтос гына түстэ.<br>Түһэригэр «Моххоо!» — диэн түстэ.<br>Күрдьэххэ уоттаах күл баһан<br>Сырайыгар саба ыстылар,<br>Хамыйахха хаары баһан
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3340
                    </td>
                    <td>
                        Сырайыгар саба ыстылар,<br>Удьаанан уу баһан куттулар,<br>Хотон хотугу муннугар<br>Атаҕыттан соһон кэбистилэр.<br>Үс чаас уҥа сытта,<br>Күүдээк-кутуйах буолан<br>Хотон хотугу муннугунан<br>Субурус гынан хаалла.<br>Онуоха Хаҥырыыр Хаан тойон оҕоньньор:<br>— Ити баҕайы былыр былыргыттан
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3350
                    </td>
                    <td>
                        Сымыйаны эпсибэт этэ ээ!<br>Ол былыр абааһы эккирэтэн барбыта<br>Үс сыл «буолбут» киһи аны кэлэн<br>Тиллэн кэлиэ дуу,<br>Куотан кэлиэ дуу.<br>Тахсан көрүҥ эрэ,<br>Тугу эпсэр баҕайыный? — дии олордо.<br>Тахсан көрбүттэрэ:<br>Бастыҥ баабыр сэргэҕэ<br>Икки айыы бухатыыра
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3360
                    </td>
                    <td>
                        Аттарыттан түһэн эрэллэрин
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3361
                    </td>
                    <td>
                        Өрүһүйэн көрдүлэр.<br>Тэһиин туттулар,<br>Тэллэх кэбистилэр,<br>Олох тоһуйдулар,<br>Олбох уурдулар.<br>Алтан дьаакыр халҕаннарын<br>Арыйа баттаан биэрдилэр.<br><span class="description" id="823">Амыньньыар</span> модьоҕону<br>Атыллаан киирдилэр.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3370
                    </td>
                    <td>
                        Бастаан киирбит киһи<br><span class="description" id="824">Биллэрик</span> оронугар олоро түстэ.<br>Кэнники киирбит киһи<br>Уҥа оронноругар баран олоро түстэ.<br>Бу олорбутугар уҥа орон <span class="description" id="825">сыҥаһатын</span> <br>Оттотунан булгу олорон кэбистэ.<br>Сааппыт киһи быһыытынан<br>Орон <span class="description" id="826">модьоҕотун</span> <br>Сототун бөтөҕөтүнэн өйүү олордо.<br>Отут киһи соргутун соргулаһа олордулар,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3380
                    </td>
                    <td>
                        Сүүс киһи сүбэтин сүбэлэһэ олордулар.<br>Үөрүү-көтүү бөҕө үөскээн барда,<br>Барыы-кэлии бөҕө элбээн истэ.<br>Халыҥ элбэх хамаандалаах ыал быһыылаахтар,<br>Үгүс элбэх норуоттаах дьон быһыылаахтар.<br>Хаҥас диэкки хара сүөһүнү өлөрөн<br>Хардырҕатан бардылар,<br><span class="description" id="827">Кэтэҕэриин</span> кэрэ сүөһүнү өлөрөн<br>Кэмпэйдээн истилэр.<br>Уҥа диэкки <span class="description" id="828">улаан</span> сылгыны охтордулар,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3390
                    </td>
                    <td>
                        Суол ааныгар <span class="description" id="829">суру</span> суоһаттылар.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3391
                    </td>
                    <td>
                        Чугаһы хоболооҕунан хомуйдулар,<br>Ырааҕы барабаанынан ыҥырдылар.<br>Ас-үөл <span class="description" id="830">бөчүөл</span> бөҕөнү оҥордулар,<br>Үс түүннээх күнү мэлдьи.<br>Хонук хонноҕун аайы,<br>Күн өрөөтөҕүн аайы.<br>Алталаах атыыр сылгы аттаах<br>Иккилээх Эрбэхтэй Мэргэн<br>Эһэ сирэйин сирэйдэнэн,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3400
                    </td>
                    <td>
                        Эбэ хараҕын харахтанан,<br><span class="description" id="831">Уодай</span> хаанын хааннанан,<br>Кэтэҕиттэн тардыстан,<br>Биллэрик оронугар<br>Тиэрэ түһэн сытар буолан хаалла.<br>Кэнникинэн кими да кытта<br>Кэпсэппэт буолла.<br>Итини көрөн баран биһиги киһибит<br>Улам-улам кыыһыран,<br>Уохтаах санаата уолугунан киирэн,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3410
                    </td>
                    <td>
                        Бардам санаата баһынан киирэн,<br>Күүстээх санаата <span class="description" id="832">көмөхөйүнэн</span> киирдэ.<br>Эмиэ кыыһырда.<br>Ити кыыһыран баран<br>Дьиэлэрин эргитэ-урбата көрө олордо.<br>«Аҕыс былас сыһыахтаах<br>Айталы Куо диэн балыстаахпын диэбитэ,<br>Эмиэ суоҕу эппит эбит дуу, хайдах?» — диэн<br>Эргитэн-төгүрүтэн санаата.<br>Хаҥырыыр Хаан оҕоньньор,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3420
                    </td>
                    <td>
                        Кыҥырыыр Хаан Хотун эмээхсин
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3421
                    </td>
                    <td>
                        Тоҕус уоннарын туруйалаан туолан,<br>Аҕыс уоннарын алдьыйа туолан<br>Аргыньньахтаан олорон эттилэр:<br>— Хаҥас диэкки өттүгэр сэттэ уон<br>Тыһы кыталык курдук кыргыттарым,<br>Уҥа диэкки өттүгэр тоҕус уон<br><span class="description" id="833">Субан</span> туруйа курдук уолаттарым,<br>Бу чиэрэс нэһилиэк чилгэнин,<br>Туспа улуус туйгунун
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3430
                    </td>
                    <td>
                        Көрүөхпүтүн баҕарабыт,<br>Харахпытын атытан көрдөрүҥ эрэ! — диэтилэр.<br>Итиниэхэ үрүҥ көмүс көхөнөн<br>Эмээхсин халтаһатын<br>Өрө тардан турбут биир кыыс,<br>Оҕоньньору биир субан туруйа курдук<br>Уол киһи көхсүн хараҕынан<br>Өрө сүүрэн таҕыста,<br>Икки санныттан тэбинэн турда,<br>Үрүҥ көмүс көхөннөн
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3440
                    </td>
                    <td>
                        Халтаһатын өрө татта,<br>Үс чаас кэриҥэ көрдөрөн олоттулар.<br>— Абытайбытын, халтаһаларбыт ыарыйдылар,<br>Ыытыҥ эрэ — диэтилэр, онно ыһыктан кэбистилэр,<br>Халтаһалара дьим гына саба түһэн<br>Харахтарын саптылар.<br>Ити гынан баран эмээхсин эттэ:<br>— Оҕоньньоор, атын улуус ааттааҕа<br>Хайдах киһи дии санаатыҥ?<br>Онуоха оҕоньньор:
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3450
                    </td>
                    <td>
                        — Ээ туспа улуус дьоһуннааҕа,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3451
                    </td>
                    <td>
                        Атын улуус ааттааҕа үтүө киһи эбит.<br>Былыргы мин тура-олоро сыдьдьарым<br>Саҕанааҕы курдук киһи эбит, — диэтэ.<br>Онуоха эмээхсин:<br>— Былыргы чамаххааҕыҥ тобоҕо<br>Кэм да баар эбит,<br>Хайа эньигин оччоҕо да киһи көрөрө,<br>Оттоҕунан боччойбут киһи эрэ этиҥ,<br>Хайа ити барахсан эйигинэн оҕустахха,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3460
                    </td>
                    <td>
                        Хол, буут иччитэ барахсан эбит ээ.<br>Маныаха биһи киһибит<br>Кыыһыран дьиэ оттотугар тура түһэр,<br>Ол гынан баран этэр:<br>— Хаҥырыыр Хаан Тойон оҕоньньор,<br>Кыҥырыыр Хаан Хотун эмээхсин,<br>Ити эһиги оҕоҕут<br>Алталаах атыыр сылгы аттаах<br>Иккилээх Эрбэхтэй Бэргэн<br>Мин сибиирбэр тиийэн,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3470
                    </td>
                    <td>
                        Абааһыттан куотан кэлэн<br>Кыһыл <span class="description" id="834">кыппыайкабар</span>,<br>Таас таалыйа хонуубар<br>Умса түһэн сыппыта.<br>Ону үрүҥ тыынын <span class="description" id="835">өллөйдөөбүтүм</span>,<br>Хара тыынын <span class="description" id="836">харыйдаабытым</span>,<br>Ол үтүөтүн, төрдүбүттэн түгэхпэр дылы<br>Үөҕэн-хомуран баран куоппута,<br>Ону ир суолун ирдээммин,<br>Тор суолун тордооммун
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3480
                    </td>
                    <td>
                        <span class="description" id="837">Көй</span> киинигэр,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3481
                    </td>
                    <td>
                        Көмүс уйатыгар кэллим.<br>Ол кэлбиппиттэн кыыһыран,<br>Кэтэҕиттэн тардыстан<br>Кэпсэппэт буолан,<br>Тиэрэ түһэн сытар.<br>Итини мин, арай кинини сибилигин<br>Умса уураммын <span class="description" id="838">уорҕатыттан</span> иэстээммин,<br>Тиэрэ тутаммын бэлэһиттэн эппиэттэтэммин,<br>Халыҥ тириитин сыньньаммын,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3490
                    </td>
                    <td>
                        Хара <span class="description" id="839">балай</span> хаанын таһаараммын,<br>Ийэтигэр эппэтэх<br>Элэ-была тылын этитиэм,<br>Аҕатыгар ахтыбатах<br><span class="description" id="840">Ала-была</span> саҥатын саҥардыам.<br>Миигин кини<br>Эрэй бөҕөбүн эҥээриттэн тутуһуннарда,<br>Буруй бөҕөбүн муннубуттан туттарда,<br>Айаҕыттан дакаастаттаҕым,<br>Тумсуттан доппуруостуур күнүм буолла! — диэтэ.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3500
                    </td>
                    <td>
                        Хааннаах <span class="description" id="841">дапсылҕатын</span> сулбу <span class="description" id="842">сүүдүйэн</span> ылан<br>Сиргэ амырыытыгар дылы батары аньньан баран<br>Өттүгүттэн өйөнөн турда.<br>Маныахаҕа Кыҥырыыр Хаан Хотун эмээхсин<br>Үүс-киис тириитэ дайдаралаах<br>Бөрө саҥыйаҕын нэлбэгэйдии кэттэ,<br>Үүс-киис тириитэ үллүк саҕа<br>Бэргэһэтин <span class="description" id="843">кырыыбалыы</span> уурда,<br>Үрүҥ көмүс тайаҕын тайахтанна:<br>— Дьэ эрэ, Хаҥырыыр Хаан Тойон оҕоньньор,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3510
                    </td>
                    <td>
                        Бу <span class="description" id="844">чиэски</span> нэһилиэк <span class="description" id="845">чиргэлин</span>,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3511
                    </td>
                    <td>
                        Туора улуус туйгунун,<br>Оҕобутун хара тыынын харыйдаабыт киһини,<br>Үрүҥ тыынын өрүһүйбүт киһини<br>Тугунан атах <span class="description" id="846">соболоҥноон</span>,<br>Өттүк харалаан,<br>Илии тутуурдаан,<br>Маанылаан-күндүлээн,<br>Аан дойдутугар атаарар<br>Сүбэҕин <span class="description" id="847">сөксүйэ</span> тур,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3520
                    </td>
                    <td>
                        Санааҕын сахсыйа тур,<br>Аан дойдулаах киһи буолуо,<br>Бар дьонноох барахсан буолуо,<br>Дьэ эрэ, ыыт эрэ, — диэтэ.<br>Онуоха оҕоньньор эттэ:<br>—  Сыат; тугу-тугу эттэҕиҥ буолла,<br>Сылгыта суох буолуо диэн<br>Сылгы чаастаары гыннаҕыҥ дуу?<br>Ынаҕа суох буолуо диэн<br>Ынах чаастаары гынаҕын дуо?
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3530
                    </td>
                    <td>
                        Хаччыта суох буолуо диэн<br>Хаччы биэрэн ыытаары гынаҕын дуу?<br>Бэйэлэрэ эдэр дьон барахсаттар,<br>Тустарыгар чуолка буолуохтара,<br>Үтүөнү үтүөнэн боруостаһыахтара,<br>Уонна тугуй? — диэтэ.<br>Эмээхсин эттэ:<br>— Дьэ хайдах гыныай?<br>Эн биһигиттэн аны кэлэн<br>Итинтэн ордук тахсыа дуо?»
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3540
                    </td>
                    <td>
                        Ити гынан баран биһи киһибитин
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3541
                    </td>
                    <td>
                        Күнү утары үс төгүл<br>Күрүөлүү хааман ылла,<br>Бу гынан баран иннигэр<br>Уун-утары туран кэбистэ,<br>Бу кырдьаҕас баҕайы эмээхсин<br>Этэн энэлийэ турда,<br>Саҥаран салҕалыы турда:<br>— Дьиэ буо! Биэбэккэм,<br>Уохтаах санааҕын уолуккунан утаар,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3550
                    </td>
                    <td>
                        Күүстээх санааҕын көмөҕөйгүнэн күрэт,<br>Кыыһырбыккын кыырай маҕан халлааҥҥа кыйдаа.<br>Мин диэтэх киһи<br>Ийэ биэбиттэн <span class="description" id="848">этэттээн</span> ылбыт,<br>Улаан биэбиттэн уйгулаан ылбыт,<br>Кытыылыыр сылгым кымыһа,<br>Матыарыйа ойуулаах <span class="description" id="849">матаарчах</span> айахха,<br>Малым-салым арыылаах<br>Араҕас илгэбин амсай!<br>Иньньэ гынан баран
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3560
                    </td>
                    <td>
                        <span class="description" id="850">Харылы көмүс</span> хаппахчыттан киирэн,<br><span class="description" id="851">Байтаһын</span> биэ батыччахтаан тахсар,<br>Араҕас илгэ арыылаах кымыһы<br>Көтөҕөн таһаарда.<br>Биһиги киһибитин эмиэ<br>Күнү утары үстэ төгүрүччү хааман ылла:<br>— Кукаам, уруйдаах чороонум<br>Айхаллаах аһын<br>Аһыныылаах санаалаах айыы оҕото,<br>Көмүскэллээх сүрэхтээх күн улууһа,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3570
                    </td>
                    <td>
                        Мин үс төгүл уруйдуоҕум,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3571
                    </td>
                    <td>
                        Эн миигин үтүктэн уруйдаа!<br>Иккиэн үс төгүл уруйдаатылар.<br>— Эмээхсин аһыгар өс суох,<br>Аһы аһыахха, аһы да аһаатарбын<br>Кэпсэтиэм ээ, — диэтэ биһи уолбут.<br>Ол гынан баран кымыһы ылан<br>Айаҕар иҥнэри аньньан кэбистэ.<br>Күүстээх санаата көньньүөрэн хаалла,<br>Уохтаах санаата утаарыллан хаалла.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3580
                    </td>
                    <td>
                        Бу кымыс барахсан<br>Көхсүн санаатын сайа киирдэ,<br>Көхсө көньньүөрэн хаалла,<br>Быара маньньыйан хаалла,<br>Бэрт өртөн да кыыһырбыт киһи этэ<br>Кини урукку өттүгэр,<br>«һуу» — диэн налыс гына түстэ.<br>Эмээхсин дьахтар<br>Харылы көмүс <span class="description" id="852">хаппахчы</span> иһиттэн,<br>Сэттэ сири өҕүлүннэри тутан холбуур
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3590
                    </td>
                    <td>
                        Кыһыл көмүс бииккэлээх,<br>Кыһыл көмүс ньуоскалаах,<br>Кыһыл көмүс тэриэлкэлээх,<br>Хара көмүс солотуулаах<br>Кыһыл көмүс остуолу<br>Ити биһиги киһибит хооньньугар<br>Аҕылыы-аҕылыы уган,<br>Симэн-симэн кэбистэ.<br>Биһи киһибит иһигэр саныы турда:<br>«Оок-сиэ, киһи дьиибэни да көрөр ээ!
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3600
                    </td>
                    <td>
                        Туох-туох малын аҕалан
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3601
                    </td>
                    <td>
                        Киһи хооньньугар симэр<br><span class="description" id="853">Баҕадьы</span> эмээхсинэ», — дии саныы турда.<br>Эмээхсин көлөһүн-балаһын тахсыбыт,<br>Харалы көмүс хаппахчытыгар<br>Эмиэ бэрт түргэнник харбыалаһан тиийдэ,<br>Хаппахчытын иһиттэн эриэн ыт оҕотун<br>Көтөҕөн таһаарда,<br>Киһини эмиэ үс төгүл төгүрүйэ хаамта.<br>Ити сыдьдьан эмээхсин
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3610
                    </td>
                    <td>
                        Сыдьдьарын былаһыгар<br>Өрүү тойуктаах сыдьдьар,<br>Аҕылыы-аҕылыы ытын оҕотун<br>Биһиги киһибит хооньньугар<br>Эмиэ симэн барда,<br>Ол гынан баран маннык диэн<br>Ырыалаах буола турда:<br>— Биэбэккээм, биэбэккээм!<br>Көрдөр хараҕым <span class="description" id="854">дьүккэтэ</span> буолбут,<br>Көтүрдэр тииһим миилэтэ тэҥнээх,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3620
                    </td>
                    <td>
                        Сүрэхпиттэн быстан түспүт<br>Сүрэҕим ытарҕата холобурдаах,<br>Быарбыттан быстан түспүт<br>Быарым тулаайаҕа холоонноох,<br>Уон тарбаҕым сүрэҕэ буолбут<br><span class="description" id="855">Сурт</span> кэриэстээҕин курдук,<br>Өтөх <span class="description" id="856">төҥүргэстээҕин</span> холобура,<br>Уот кыымнааҕын кэриэтэ,<br>Биир эриэн ытым оҕотун,<br>Биэбэйим оҕотоо, эйиэхэ чаастыыбын.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3630
                    </td>
                    <td>
                        Тоҕо чаастыыгын диэтэргин,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3631
                    </td>
                    <td>
                        Мин оҕобун,<br>Алталаах атыыр сылгы аттаах<br>Иккилээх Эрбэхтэй Бэргэни,<br>Үрүҥ тыынын өрүһүйбүт үтүөҥ,<br>Хара тыынын харыһыйбытыҥ хардата —<br>Эриэн ытым оҕотун чаастыыбын.<br>Бу эриэн ытым оҕотун<br>Биирдэ чанчыгыттан тардаҥҥын<br>Сарылатар буолаайаҕын,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3640
                    </td>
                    <td>
                        Биирдэ иэнигэр «лап» гына охсоҥҥун.<br>Биирдэ кыланнарар буолаайаҕын,<br>Киһи быһыыта киһитийиэ,<br>Сүөһү быһыыта сүөһүтүйүө.<br>Дьэ биэбэкээм, эмээхсин баҕадьы<br>Иһити-хомуоһу ирээттээбэтэ диэҥҥин<br>Иһирэхтик саныыр буолаайаҕын,<br>Таҥаһы-сабы саастаабата диэн,<br>Санааргыы саныыр буолаайаҕын,<br>Илин өттүгэр ураҕас тосторунан
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3650
                    </td>
                    <td>
                        Ынах сүөһүнү үүрдэрбэтэ диэҥҥин<br>Өһүргэнэр эрэ буолаайаҕын,<br>Кэлин өттүгэр быа быстарынан<br>Сылгы сүөһүнү кэтит <span class="description" id="857">сэньэлгэни</span> <br>Сиэттэрбэтэ диэҥҥин кыыһырар буолаайаҕын!<br>Аан дойдугар бараргар,<br>Охтооҕор түргэнник,<br>Түүтээҕэр чэпчэкитик<br>Айаннаан иһиҥ эрэ,<br>Кэлин өттүгэр <span class="description" id="858">кэбир</span> сыстыбатын,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3660
                    </td>
                    <td>
                        Илин өттүгэр ибир сыстыбатын
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3661
                    </td>
                    <td>
                        Уон тарбахтаах утары уумматын,<br>Уу харахтаах утары көрбөтүн,<br>Ураһа курдук дьол тосхойдун,<br>Өҕүрүмэр сүөһү курдук өҥ үрдээтин!<br>Аал уоккутун оттон тиийиҥ,<br>Алаһа дьиэҕитин аттаран тиийиҥ,<br>Алтан сэргэтэ аньньыҥ,<br>Дириҥ түһэлгэ буолуҥ,<br>Уолбат уу буолуҥ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3670
                    </td>
                    <td>
                        Чөҥөрө чүөмпэ буолуҥ,<br>Үс-хас үрүҥ көмүс<br>Бүтэй күрүө төгүрүйдүн,<br>Аттаах кымньыыта буолуҥ,<br>Оҕустаах үчэтэ буолуҥ,<br>Сатыы тайаҕа буолуҥ,<br>Киһини ииппиккит киһи төрдө буоллун,<br>Сүөһүнү ииппиккит сүөһү төрдө буоллун,<br>Дьэ, сэгэрдэриэм, быралыччы быраһаай!<br>Биһи киһибит:
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3680
                    </td>
                    <td>
                        — Бу эмээхсин<br>Кыыс биэрбит киһиэхэ дылы<br>Тугу-тугу алгыы турдаҕай,<br><span class="description" id="859">Буокас</span> да эмээхсин доҕор, — диир.<br>Ити гынан баран<br>Тыллаах-өстөөх Хара Кулун атын<br>Үрдүк мындаатыгар<br>Үрүҥ туллук курдук<br>Чөмчөрүс гынан олоро түстэ.<br>Кытаанахтык кымньыылаан истэ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3690
                    </td>
                    <td>
                        Киэҥ дойдуттан <span class="description" id="860">кэйбэйбит</span> курдук,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3691
                    </td>
                    <td>
                        Улуу дойдуттан уларыйбыт курдук,<br>Аан дойдуттан арахсыбыт курдук,<br>Түргэн түһүү буолла,<br>Сыыдам сырыы буолла,<br>Аллаах айан буолла,<br>Ахсымнык барда,<br>Аан дойдутун санаата,<br>Хатаннык хаһыытаата.<br>Ити икки ардыгар —
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3700
                    </td>
                    <td>
                        Олоҥхо буолан баран омуннаах,<br>Тыл буолан баран сиикэйдээх,<br>Сирин оттотугар тиийэн кэллэ быһыылаах.<br>Бу гынан баран санаан көрдө:<br>— Оот-татай, оҕолоор, сүүрэр атахтаах<br>Үстэ тугуттаан тиийэр сиригэр,<br>Үс бухатыыр үйэтэ айанныыр сиргэ,<br>Үс сылынан эргийэн истэҕим.<br>Субу гынан бараммын,<br>Эрэй бөҕөнү
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3710
                    </td>
                    <td>
                        Эҥээриттэн тутан сырыттым,<br>Буруй бөҕөнү<br>Муннуттан тутан сырыттым,<br>Айыы аймаҕын харыһыйдым,<br>Күн улууһун көмүскээтим,<br>Туспа улуус ааттаахтарын,<br>Чиэрэс нэһилиэк чилгэлэрин,<br>Нөҥүө дойду нөрүөннээх дьонугар,<br>Сыдьдьан кэллим, бу гынан баран<br>Атаҕым соболоҥо,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3720
                    </td>
                    <td>
                        Өттүгүм харата,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3721
                    </td>
                    <td>
                        Илии тутуура<br>Хайа тугуй диэтэххэ,<br>Идьдьэ иһэр бэлэҕим туох баарый,<br>Арай биир эриэн ыт оҕолоохпун дуу?<br>Аа-айыа-айыы! Аан дойдубар,<br>Бар дьоммор тиийэн кэллэхпинэ,<br>Сылгы уола Дыырай бухатыыр,<br>Үс төгүрүк сыл эрэйдэнэн баран<br>Эриэн ыт оҕотун аҕалбыт үһү диэннэр,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3730
                    </td>
                    <td>
                        Эриэн ыт элэгэ буолсубун,<br><span class="description" id="861">Күөт</span> ыт күлүүтэ буолсубун,<br>Хойут утуйар хоһооно буолуом,<br>Эрдэ турар элэгэ буолуом,<br>Ыта да суох сылдьыам син,<br>Күтүрү улахан сиэтин,<br>Хооймор ыт оҕолоох буола-буолабын.<br>Илиитин хооньньугар уган баран<br>Ытын оҕотун хостоон таһааран<br>Сиргэ дэлби быраан кэбистэ.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3740
                    </td>
                    <td>
                        Ол гынан баран, баран истэ.<br>Ити гынан баран<br>Ыта ардырҕыы-ардырҕыы<br>Ойоҕолуу сүүрэн кэллэ,<br>Ат ойоҕоһун быһаҕаһар дылы<br>Иччитин диэкки өрүтэ көтүөлүүр.<br>— Сыан, бу эрэйдээҕи,<br>Үчүгэй майгыннаах буолуо эбит ээ,<br>Мин хооньньум сылааһыгар баҕаран,<br>Хооньньубар киирээри, көр эмиэ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3750
                    </td>
                    <td>
                        Өрүтэ көтүөлүүр буоллаҕа,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3751
                    </td>
                    <td>
                        Иччимсэх да эрэйдээх эбит,<br>Саманнык ыт дьиэмсэх буолуо эбит.<br>Көр, ол миигин бар дьон<br>Күлэн даҕаны диэн<br>Тугу гыныахтарай, доҕоор?<br>Уол оҕо хара көлөһүнэ<br>Сир дойду үрдүгэр хаалла дии-дии<br>Барыттан бары саата сырыттахха<br>От тиийиэ дуу, мас тиийиэ дуу? — диэн баран
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3760
                    </td>
                    <td>
                        Ыты өрө күөрэс гынан эрдэҕинэ,<br>Ытыһыгар түһэрэн ылла,<br>Ол ылан хооньньугар уган кэбистэ.<br>Ити гынан баран<br>Эмиэ айаннаан истэ.<br>Барыта үс төгүл<br>Аара сиргэ быраҕан көрдө да,<br>Санаан көрө-көрө аһынан<br>Төттөрү хооньньугар угаттаата,<br>Дьиэтигэр тиийэн кэллэ
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3770
                    </td>
                    <td>
                        Оттубут уота <span class="description" id="862">убайбытынан</span> турар эбит,<br>Сүөһүтэ долуой көҕүрээбэтэх,<br>Оттоку тойон <span class="description" id="863">баабыр</span> сэргэтигэр<br>Түһэн кэбистэ да атын:<br>— Харах <span class="description" id="864">уччурхайдан</span>,<br><span class="description" id="865">Хат таманнан</span>,<br>Халыҥ <span class="description" id="866">хаһалан</span>,<br>Суон <span class="description" id="867">сааллан</span>,<br>Хара быччыҥнан,<br><span class="description" id="868">Хаппар куҥнан</span>, — диэн баран
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3780
                    </td>
                    <td>
                        Атын аан дойдутугар ыытан кэбистэ.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3781
                    </td>
                    <td>
                        Сэбирдэх дьиэтин <span class="description" id="869">сэгэччи</span> баттаан,<br><span class="description" id="870">Амыньньыар</span> <span class="description" id="871">модьоҕотун</span> атыллаан<br>Көтөн түстэ.<br>Били ытын оҕотун хооньньуттан ылан,<br>Остуоллары, тэриэлкэлэри ылан<br><span class="description" id="872">Хаппахчытын</span> иһигэр ыһа <span class="description" id="873">быраан</span> кэбистэ.<br><span class="description" id="874">Саамал кымыһынан</span> санаатын тарҕатта,<br><span class="description" id="875">Көйүү кымыһынан</span> көхсүн аста,<br>Халыҥ хаһанан, суон саалынан аһаата
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3790
                    </td>
                    <td>
                        Бичиктээх <span class="description" id="876">биллиригэр</span>,<br>Дьэрэкээннээх тэллэҕэр,<br><span class="description" id="877">Чыҥырҕастаах сыттыгар</span>,<br><span class="description" id="878">Дуобаттаах суорҕаныгар</span>,<br>Ырбыт-сылайбыт киһи быһыытынан<br>«Дар» гына тиэрэ баран түстэ,<br>Утуйан <span class="description" id="879">баччыгынаан</span> хаалла.<br>Өр да утуйбутун өйдөөбөккө хаалла,<br>Өтөр син утуйбутун бэйэтэ да билбэтэ.<br>Биир күн туран
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3800
                    </td>
                    <td>
                        Уһуктан олоро түстэ.<br>Дьиэтэ диэн ип-итии,<br>Сып-сылаас буолбут,<br>Аһыыр аһа астанан<br>Остуолга бэлэм <span class="description" id="880">өрөһөлөммүт</span>,<br>Таҥаһа оҥоһуллубут,<br>Уота сабыс-саҥа оттуллубут,<br>Умайан <span class="description" id="881">тигинэйэ</span> турар,<br>Тоҕус тарбаҕын тосту баттаан<br>Олорон <span class="description" id="882">тойонноон</span> көрдө:
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3810
                    </td>
                    <td>
                        — Бу утуйа сыттахпына
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3811
                    </td>
                    <td>
                        Ким кэлэн аспын астаабыт,<br>Таҥаспын кэлэн туох оҥорон барбыт,<br>Аспын ким бэлэмнээн бардаҕай,<br>Бу уоту ким отуннаҕай?<br>Бу Аал Луук Мас иччитэ<br>Кэлэн оҥоруо дуо,<br>Суох, бу курдук буолуон сатаммат,<br>Тоҕо кэлэн оҥордоҕой,<br>Урут бэйэм астанар этим,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3820
                    </td>
                    <td>
                        Бу ыт оҕотун дьолугар<br>Бу курдук бэлэмнэнэн хаалла дуо,<br>Туран эрэн? — диэн баран,<br>Ойон тура эккирээтэ,<br>Аһаата-сиэтэ.<br><span class="description" id="883">Таһыдьдьа</span> сүүрэн таҕыста.<br>Тоҕус тиит <span class="description" id="884">чулуута</span> тиит хайыһарын<br>Батарыта <span class="description" id="885">аньньынан</span> кэбистэ атаҕар,<br><span class="description" id="886">Эргэнэ хара тыатын</span> <br>Эргийэ сүүрэ сырытта,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3830
                    </td>
                    <td>
                        Табаны <span class="description" id="887">таныытыттан</span> <span class="description" id="888">талахачыччы</span> тутта,<br><span class="description" id="889">Бууру</span> муннуттан тутан ылан муста,<br>Эһэни иэдэһиттэн тутта,<br>Иннигэр-кэннигэр<br>Илибирэччи-салыбыраччы сүгэн<br>Дьиэтигэр сүүрэн киирдэ.<br>Киирэн көрбүтэ — уруккутунааҕар <span class="description" id="890">бууса</span> <br>Аһа-үөлэ элбээбит,<br>Таҥаһа-саба оҥоһуллубут.<br>Сыта-тура <span class="description" id="891">сыаналана</span> сытта,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3840
                    </td>
                    <td>
                        Аһаан-сиэн утуйда,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3841
                    </td>
                    <td>
                        Ол сытан дуумайдыы сытта.<br>Сассыарда эмиэ уһуктан турда,<br>Бу олорон толкуйга түстэ:<br>«Кыҥырыыр Хаан Хотун эмээхсин<br>Кыыс биэрбит киһи курдук<br>Кыһанан туран алгыыр этэ,<br><b>Көрдөр хараҕым дьүккэтигэр</b> холобурдаах<br><span class="description" id="892">Көтүрдэр тииһим миилэтэ</span> буолбут,<br>Сүрэхпиттэн быстан түспүт
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3850
                    </td>
                    <td>
                        <span class="description" id="893">Сүрэҕим ытарҕата</span> буолбут,<br>Быарбыттан быстан түспүт<br><span class="description" id="894">Быарым тулаайаҕа</span> <span class="description" id="895">холобурдаах</span>,<br>Уон тарбаҕым сүрэҕэр <span class="description" id="896">холоонноох</span>,<br><b>Уот кыымнааҕын</b> кэриэтэ,<br><b>Сурт кэриэстээҕин</b> курдук,<br><span class="description" id="897">Өтөх төҥүргэстээҕин</span> курдук,<br>Биир эриэн ыт оҕолоохпун<br>Эйиэхэ <span class="description" id="898">чаастыыбын</span> диэбитэ.<br>Илин өттүгэр <span class="description" id="899">ураҕас</span> тосторунан
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3860
                    </td>
                    <td>
                        Ынах сүөһүнү, суон дьоһун <span class="description" id="900">үүрбэни</span> <br>Үүрдэрбэтэ диэн<br>Өһүргэнэр буолаайаҕын диэбитэ,<br>Кэлин өттүгэр быа-быстарынан<br>Сылгы сүөһүнү, уһун кэтит <span class="description" id="901">сэньньэлгэни</span> <br>Сиэттэрбэтэ диир буолаайаҕын диэбитэ.<br>Таҥас-сап чаастаабатах,<br>Иһит-хомуос <span class="description" id="902">ирээттээбэт</span> диэҥҥин<br><span class="description" id="903">Кэмчиэрийэр</span> буолаайаҕын.<br>Биирдэ <span class="description" id="904">самыытыгар</span> лап гына охсоҥҥун
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3870
                    </td>
                    <td>
                        Хаһыытатар буолаайаҕын,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3871
                    </td>
                    <td>
                        <span class="description" id="905">Чанчыгыттан</span> тардаҥҥын<br><span class="description" id="906">Кыланнарар</span> буолаайаҕын диэбитэ.<br>Хата, били<br>Аҕыс <span class="description" id="907">былас</span> аалай солко <span class="description" id="908">суһуохтаах</span> <br>Айталы Куо диэн<br>Субу сыдьдьара буолаарай?» — диэн сыаналаата.<br>Ити гынан баран<br>Аһаан-сиэн баран,<br>Таһырдьа тахсыбыта буолла,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3880
                    </td>
                    <td>
                        <span class="description" id="909">Үҥкүрүс</span> гынна,<br><span class="description" id="910">Күөлэһис</span> гына түстэ —<br>Күөх истээх <span class="description" id="911">күүгэс</span> буолла.<br>Тойон <span class="description" id="912">өһүөтүн</span> хайаҕаһыгар<br>«Дыык» гынан <span class="description" id="913">кылаллан</span> көрө сытта.<br>Бу көрө сыттаҕына,<br>Эриэн ыт оҕото<br><span class="description" id="914">Харылы көмүс</span> хаппахчы иһиттэн<br>Ыстанан таҕыста, ытаата-соҥоото,<br>Дьиэни үс-түөрт төгүл
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3890
                    </td>
                    <td>
                        Тула сүүрдэ, <span class="description" id="915">ирдээтэ-тордоото</span>,<br>Ити гынан баран<br>Уҥа ороҥҥо ыстанан таҕыста,<br>Суунна-тараанна.<br>Ити гынан баран көрбүтэ —<br>Эриэн ыт тириитэ <span class="description" id="916">нэмэлис</span> гына түстэ,<br>Ол гынан баран<br>Этиэхтэн эриэккэс үчүгэй,<br>Көрүөхтэн көрө үчүгэй,<br>Ыраас хааннаах,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3900
                    </td>
                    <td>
                        Сырдык <span class="description" id="917">ньуурдаах</span>,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3901
                    </td>
                    <td>
                        <span class="description" id="918">Өрүөллээх</span> көмүс хаччы курдук<br><span class="description" id="919">Үрэйэ-сарайа</span> көрбүт,<br>Уулаабатах <span class="description" id="920">улаан</span> <span class="description" id="921">убаһа</span> курдук<br><span class="description" id="922">Унаарыччы</span> көрбүт.<br>Хараны <span class="description" id="923">ыньыстыбыта</span> <br><span class="description" id="924">Хабарҕатын</span> төрдүгэр<br>Хараарбытынан түһүтэлээтэ,<br>Үрүҥү ыньыстыбыта<br>Күөмэйин төрдүгэр
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3910
                    </td>
                    <td>
                        <span class="description" id="925">Күөдэйбитинэн</span> түһүтэлиир.<br>Эт бүтэй унуоҕа көстөр,<br>Уҥуох бүтэй силиитэ <span class="description" id="926">дьаккыйар</span>,<br>Үчүгэй дьахтар,<br>Көссүө-көссүөтүк көрөн барда,<br>Нарын-нарыннык саҥара сырытта,<br>Астаан-үөллээн <span class="description" id="927">айбалдьыйан</span> барда,<br>Күөстээн-астаан <span class="description" id="928">күөгэлдьийэ</span> сырытта.<br>Итини көрөн баран<br>Били биһиги киһибит
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3920
                    </td>
                    <td>
                        Тоҕус токур ойоҕоһун<br><span class="description" id="929">Дурдаланан</span> үөскээбит,<br><span class="description" id="930">Тутум</span> быалаах <span class="description" id="931">нохтоолоох</span> тойон сүрэҕэ<br>Тулуйбата, <span class="description" id="932">толугураччы</span> мөҕүстэ,<br>Аҕыс <span class="description" id="933">бакыр</span> ойоҕоһун<br>Хаххаланан үөскээбит<br>Харыс быалаах <span class="description" id="934">хайҕахтаах</span><br><span class="description" id="935">Хара быара</span> тулуйбата,<br>Халыгыраччы  мөҕүстэ.<br>Ити гынан баран
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3930
                    </td>
                    <td>
                        Итиннэ кини өһүө баһыгар
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3931
                    </td>
                    <td>
                        <span class="description" id="936">Тойон ыҥырыа</span> буолан хатанан олорон,<br>Онтон ыстанан кэлэн,<br>Дьахтары кууһа түстэ.<br>Дьахтар соһуйан өрө ыстаҥалаата,<br>Тустуу, <span class="description" id="937">лиһигирэһии</span> буолла.<br>Дьахтары бокуойа суох<br>Уураабытын үөһэ уураан барда,<br>Сыллаабытын үөһэ сыллаан барда,<br>Дьахтар түөһүттэн <span class="description" id="938">кэдэрги</span> аньньа сырытта,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3940
                    </td>
                    <td>
                        Мөхсөн <span class="description" id="939">тэлэкэчиһэн</span> уҥа ороҥҥо тиийэн кэллилэр.<br>Эр киһи ороҥҥо тиэрэ баттыырдыы быһыыланар.<br>Эриэн ыт тириитэ сытарын<br>Дьахтар сулбу тардан ылла,<br>Сулбу тардан ылла да,<br>Дьахтар уруккутун курдук<br>Ыт ытынан буолан хаалла.<br>Бу ыт оҕотун биһи киһибит<br>Өрө тута-тута <span class="description" id="940">илигирэттэ</span>,<br>Таҥнары тута-тута сахсыйан салыбыратта.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3950
                    </td>
                    <td>
                        Дьахтар да киһи буолбата,<br>Ыт ытынан буолан хаалла,<br>Кэлэйдэ-сиргэннэ,<br>Сиргэ быраан кэбистэ.<br>Ытыы түһэн баран,<br>Ыт хаппахчытыгар дьылыс гынан хаалла.<br>Тоҕус тиит чулуута<br>Тиит хайыһарын кэтэн кэбистэ,<br>Бултуу-алтыы тыаҕа таххан баран хаалла.<br>Хара тыатын хайыта хаама сырытта,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3960
                    </td>
                    <td>
                        Эргэнэ тыатын эргийэ хаамта,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3961
                    </td>
                    <td>
                        Табаны <span class="description" id="941">талагыначчы</span> тута сырытта,<br>Буур кыылы кум-хам тутта,<br>Эһэ кыылы илибирэччи-салыбыраччы иилиннэ,<br>Дьиэтигэр көтөн-сүүрэн<br>Киэһэ киирэн кэллэ.<br>Аһаата-сиэтэ,<br>Ойуулаах оронугар олоро түстэ,<br>Чыҥырҕастаах сыттыгар сыта баттаата,<br>Оһуор дуобат ойуулаах суорҕанынан
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3970
                    </td>
                    <td>
                        Саба тардынан кэбистэ,<br>Утуйан <span class="description" id="942">баччыгыныы</span> сытта.<br><span class="description" id="943">Тыҥ</span> <span class="description" id="944">тыһы бараах</span> түөһүн курдук<br>Кылбайа хатан таҕыста,<br>Халлаан атыыр бараах түөһүн курдук<br>Арылла сырдаата.<br><span class="description" id="945">Аламай</span> маҕан күнэ<br>Араҕас маҕан халлаан <span class="description" id="946">арҕаһыгар</span> <br><span class="description" id="947">Ахталыйан</span> таҕыста,<br><span class="description" id="948">Толомон</span> маҕан күнэ
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3980
                    </td>
                    <td>
                        <span class="description" id="949">Добун</span> маҕан халлаан<br>Орто суодьатыгар<br>Туоллан-тутуллан<br><span class="description" id="950">Туналыйан</span> таҕыста.<br>Итиниэхэ ити киһи<br>Күөмэйэ <span class="description" id="951">көбүөх гына</span> түстэ,<br>Таныыта <span class="description" id="952">тартах</span> гынна,<br>Туран олоро түстэ.<br>Саамал кымыһынан <span class="description" id="953">санаатын тарҕатта</span>,<br>Көйүү кымыһынан көхсүн <span class="description" id="954">көньньүөртэ</span>,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3990
                    </td>
                    <td>
                        Халыҥ хаһанан хабыалаата,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        3991
                    </td>
                    <td>
                        Суон саалынан <span class="description" id="955">уобалаата</span>:<br>— <span class="description" id="956">Уот-татай</span>, оҕолоор, бу<br>Аҕыс <span class="description" id="957">булас</span> аалай солко суһуохтаах<br>Айталы Куо диэн ааттаах дьахтар<br>Бу кубулунан ыт буола сылдьар эбит.<br>Кинини хайтах кыммыт киһи<br>Дьиҥнээх бэйэ <span class="description" id="958">бодотун</span> тутуо баарай,<br>Бээ, мин эмиэ тыабар тахсыбыта<br>Буолан көрүүм! — диэтэ.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4000
                    </td>
                    <td>
                        Тоҕус тиит чулуута<br>Тиит хайыһарын эмиэ кэттэ,<br>Эттээх сылгы сиэллээх кутуругун<br><span class="description" id="959">Экчи</span> баттаабыт курдук<br>Эргэнэ хара тыатыгар<br><span class="description" id="960">Элийэ-халыйа</span> турда.<br>Бу тиийэн<br>Үҥкүрүс-күөлэһис гына түстэ,<br>Күөх истээх сахсырҕа буолла,<br>Дьиэтигэр төттөрү көтөн дыыгынаан кэллэ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4010
                    </td>
                    <td>
                        <span class="description" id="961">Хараҕаччы</span> мас диэн<br>Маһыгар саһан хаалла.<br>Ити саһа сыттаҕына,<br>Эриэн ыт оҕото<br>Харалы көмүс хаппахчы иһиттэн<br>Мүччү ыстанан таҕыста,<br>Бу таххан дьиэни<br>Биэстэ-алтата тула эргийдэ,<br>Ол-бу диэкки сытырҕалаата,<br><span class="description" id="962">Таһадьдьа</span> ыстанан таҕыста,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4020
                    </td>
                    <td>
                        Дьиэни эргийэ көтө сылдьан,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4021
                    </td>
                    <td>
                        Тумсун сиргэ аньньа сылдьан<br>Ирдээтэ-тордоото.<br>Тириитин сулбу тардан ылла,<br><span class="description" id="963">Кэтэҕэриин</span> орон диэкки эһэн кэбистэ,<br>Үнүргүтүн курдук<br>Үчүгэй дьахтар буолан<br><span class="description" id="964">Күөгэс гына</span> түстэ.<br>Итини көрөн били киһи<br>Сүрэҕэ <span class="description" id="965">тилигирэччи</span> мөҕүстэ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4030
                    </td>
                    <td>
                        Хара быара халыгыраччы хамсаата,<br><span class="description" id="966">Уҥуоҕа халыр босхо</span> барда:<br>«Хайтах туппут киһи<br>Куоттарыа суоҕай, оҕолоор?» — дии санаата.<br>Тойонноон көрө сытта:<br>«Бу албаһа аба буоллаҕа,<br>Бу ийэлээх аҕата<br>Манан албастааннар<br>Былыттаах халлааҥҥа быктарбатахтар эбит ээ,<br>Күннээх халлааҥҥа көрдөрбөтөхтөр эбит ээ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4040
                    </td>
                    <td>
                        Ол иһин <span class="description" id="967">чороон</span> иһиккэ<br><span class="description" id="968">Тоорохойдотоллор</span> эбит,<br>Ыстакааҥҥа <span class="description" id="969">чыыкаанныыр</span> эбит,<br><span class="description" id="970">Бэлкэйгэ</span> бэссэр эбит,<br>Харалы көмүс хаппахчыга хатанар эбит,<br>Маны тириитин былдьаабыт киһи<br>Үчүгэй буолууһу эбээт!»<br>Иньньэ диэбитинэн <span class="description" id="971">суос-соҕотохто</span> <br>Тириитигэр ыстанан түстэ.<br>Дьахтар часкыйбытынан тириитигэр кытта түһүстэ.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4050
                    </td>
                    <td>
                        Киһи тиийдэ да бокуойа суох
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4051
                    </td>
                    <td>
                        Саба харбаан ылан<br>Умайа турар кутаа уокка бырахта.<br>Дьахтар тириитин батыһан<br>Ыстанан кэлэн уокка тэҥҥэ түстэ,<br>Ыт тириитин таһырдьа тарда,<br><span class="description" id="972">Өрүһүйэ</span> сатаата,<br>Эр киһи биэрбэт,<br>Дьахтары хаххалыы көтө сылдьан<br>Тириини уокка симтэ.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4060
                    </td>
                    <td>
                        Тириини хара хоруо гына<br><span class="description" id="973">Харааччы</span> сиэттэ.<br>Дьахтар кыыһырда,<br><b>Эһэ сирэйин сирэйдэннэ</b>,<br><span class="description" id="974">Эбэ хараҕын харахтанна</span>,<br>Сирэйэ <span class="description" id="975">дьэс кыыһан</span> хаалла,<br><span class="description" id="976">Уодай хаанын</span> хааннанна,<br>Сырайын түҥнэри хайыһан кэбистэ,<br>Баай барыылаах маанылаан оҥорбут,<br>Суон <span class="description" id="977">баараҕай</span> <span class="description" id="978">баҕанаҕа</span> 
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4070
                    </td>
                    <td>
                        Баран хам кууһунна,<br>Атаҕынан баҕананы <span class="description" id="979">кыпчыйан</span> <br>Олорунан кэбистэ.<br>Эр киһи баран ааттаһа сатаата,<br>Көрдөһө сатаата,<br>Сыллыы-ууруу сатаата,<br>Ааттаһа-албынныы сатаата,<br>Туох да иһин истибэтэ,<br><span class="description" id="980">Түҥнэри</span> дьигиһийэ олордо.<br>Онтон киһи кууһан баран
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4080
                    </td>
                    <td>
                        Баҕанаттан төлө тардан ылаары
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4081
                    </td>
                    <td>
                        Күүскэ тардыалыы сатаата,<br>Туох да иһин арахсыбат.<br>Улаханнык таттаҕына<br>Оттотунан быстыах быһыылаах,<br>Онтон <span class="description" id="981">бэккиһээн</span> ыытан кэбистэ.<br>«Хас хонукка бу <span class="description" id="982">маҕананы</span> <br>Харабыллыыр үһүгүн,<br>Олордоргун олор» — диэтэ.<br>Били тиит хайыһарын
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4090
                    </td>
                    <td>
                        Эмиэ кэтэн кэбистэ.<br>Дьоллоох-соргулаах<br><span class="description" id="983">Соноҕос сылгы</span> сиэллээх кутуругун<br><span class="description" id="984">Логлорута баттаан</span> ылан<br><span class="description" id="985">Сыыйа-саайа</span> таппыт курдук<br>Олохсуйан үүммүт<br>Ойуур хара тыатыгар<br>Сүүрэ-көтө турда,<br>Бултуу-алтыы баран хаалла.<br>Ити баран хаалбытын кэннэ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4100
                    </td>
                    <td>
                        <span class="description" id="986">Күн отто буолбутун кэннэ</span> <br>Дьиэлэрэ буоллаҕына<br>Тас өттүттэн көрдөххө,<br>Иһигэр баар киһи курдаттыы көстөр,<br>Иһирдьэттэн олорон көрдөххө<br>Таһырдьа баар киһи курдаттыы көстөр<br>Үрүҥ көмүс курустаал таас дьиэ этэ,<br><span class="description" id="987">Көньньүнэн туран төгүрүйэ көтөр</span> дьиэ этэ,<br><span class="description" id="988">Иэрчэҕинэн</span> эргичийэ сүүрэ турар дьиэ этэ.<br>Ити олорон били дьахтар
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4110
                    </td>
                    <td>
                        Туһааннаах тус илин диэкки көрдөҕүнэ,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4111
                    </td>
                    <td>
                        Илин диэккиттэн туох да<br>Көрөртөн <span class="description" id="989">көрө сүөргү</span> <br>Үтүө дьүһүннээх,<br>Бэт диэн <span class="description" id="990">мэтириэттээх</span>,<br>Атын диэн <span class="description" id="991">айылгылаах</span> <br>Айыы киһи аймаҕа,<br>Күн улууһун күөгэйэр үтүөтэ<br>Атын үрүҥ көмүс <span class="description" id="992">тэһииниттэн</span> <br>Уҥа <span class="description" id="993">тоҥоноҕор</span> иилиммит,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4120
                    </td>
                    <td>
                        Хаҥас илиитинэн<br>Үрүҥ көмүс торуоскатынан тайахтаммыт,<br>Киис тириитэ килбэйэр<br><span class="description" id="994">Дайдаралаах</span> <span class="description" id="995">саҕыньньаҕын</span> <span class="description" id="996">нэлбэгэйдии</span> кэппит,<br><span class="description" id="997">Үүс</span> тириитэ үллүк саҕа<br>Бэргэһэтин <span class="description" id="998">кырыыбалыы</span> ууруммут<br>Айыы киһитэ <span class="description" id="999">ааттааҕа</span> быһыылаах,<br>Атын илиитигэр сиэтэн баран<br>Аргыый аҕай <span class="description" id="1000">айгыстан</span> иһэр.<br>Бастыҥ <span class="description" id="1001">томторҕолоох тойон сэргэҕэ</span> 
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4130
                    </td>
                    <td>
                        Кэлэн атын баайан кэбистэ.<br>Ити кэлэн дьиэни<br>Үс төгүл эргийэ хаамта,<br>Аанын булан көрбөтө,<br><span class="description" id="1002">Туспа сибиир киһитэ</span> кэлэ сылдьар.<br>Ити аллараа өттө иэччэҕинэн тэбиэлээн<br>Эргичийэ сүүрэ турар дьиэ этэ,<br>Үөһээ өттө көлөһөнөн охсуллан<br>Төгүрүйэ сүүрэ турар дьиэ этэ,<br>Киирэр аана диэн
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4140
                    </td>
                    <td>
                        Ааттаах бухатыыр киһи
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4141
                    </td>
                    <td>
                        <span class="description" id="1003">Аппалдьытан</span> туран аһар<br>Алтан дьаакыр халыҥ <span class="description" id="1004">халҕана</span> диэн<br>Буолар эбит — икки бэлиэ атахтаһан<br>Тэҥнэһэ түһүүтүн кэтэһэн<br>Төлө тэбэн тахсар-киирэр этэ<br>Биһиги киһибит.<br>Итини сатаан булан киириминэ<br>Кэлбит киһи мунан<br>Төгүрүйэ хаама сылдьар.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4150
                    </td>
                    <td>
                        Уҥа диэкки өттүнээҕи<br>Бастыҥ айдаан тас түннүгүнэн кэлэн<br><span class="description" id="1005">Нүрүйэн</span> туран <span class="description" id="1006">өҥөйөн</span> көрөн турда.<br>Ити туран эрэн<br>Саҥалаах-иҥэлээх,<br>Тыллаах-өстөөх буола турда:<br>— Дьиэ буо!<br>Хаҥырыыр Хаан Тойон аҕалаах,<br>Кыҥырыыр Хаан Хотун ийэлээх,<br>Аҕыс былас аалай солко суһуохтаах
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4160
                    </td>
                    <td>
                        Айталы Куо диэн дьахтар <span class="description" id="1007">дьаалы</span> киһи,<br>Дорообо бокулуон буоллун!<br>Ким хайа кэллиҥ диэтэргин —<br>Көтөр кынаттаах<br>Сэттэтэ сымыыттаан тиийэр сирдээх,<br>Сүүрэр атахтаах тоҕус төгүл<br><span class="description" id="1008">Тугуттаан</span> тиийэр дойдулаах.<br>Итии муора эркиннээх,<br>Ичигэс <span class="description" id="1009">илгэ</span> эҥээрдээх,<br><span class="description" id="1010">Хоҥоруу дуорсун</span> хонуулаах,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4170
                    </td>
                    <td>
                        Араҕас <span class="description" id="1011">баараҕай</span> аартыктаах,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4171
                    </td>
                    <td>
                        <span class="description" id="1012">Иэримэ-дьиэримэ сибиирдээх</span>,<br><span class="description" id="1013">Эндэр</span> таас хайа <span class="description" id="1014">эккиннээх</span>,<br>Эриэн Тойон аҕалаах,<br>Эбириэччин Баай Хотун ийэлээх,<br>Тоҕус <span class="description" id="1015">күннүк</span> сири<br>Тоҕуста дук гынан ылар<br><span class="description" id="1016">Чучугур</span> <span class="description" id="1017">чуоҕур</span> аттаах<br>Тойон Дьобуруонтай бухатыыр кэлэн турабын.<br>Тоҕо кэллиҥ диэтэргин,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4180
                    </td>
                    <td>
                        Куоппуту ситэ, барбыты батыһа,<br>Силискэ тэптэрэн, <span class="description" id="1018">очурга</span> оҕустаран<br>Кэлэн турабын.<br>Аллара өттө иэччэҕинэн<br>Эргичийэ сүүрэ турар,<br>Үөһэ өттө көлөсөннөн охсуллан<br>Төгүрүйэ көтө турар,<br><span class="description" id="1019">Күндүл</span> көмүс <span class="description" id="1020">күөрэҥсэ</span> <br>Ампааргын аанын аһан биэрдэргин<br><span class="description" id="1021">Төһөлөөх-хаччалаах буолуой</span>, хотуой?!
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4190
                    </td>
                    <td>
                        Итиниэхэ дьахтар кыһаммата,<br>Үс хос кутуу көмүс үрдүн<br>Өрө көрөн олорор,<br>Илиитин куустубута куустубутунан,<br>Атаҕын кыпчыйбыта кыпчыйбытынан.<br>Били киһи турбахтаан баран<br>Эппиэт эргийэ хаама сырытта.<br>Ити кэлэн оттоку түннүгүнэн<br>Нүрүйэн туран эмиэ<br>Саҥалаах буола турда:
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4200
                    </td>
                    <td>
                        — Дьиэ-буо! Дьэ, хотуой!
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4201
                    </td>
                    <td>
                        Айан киһитэ ааһаммын,<br>Сырыы киһитэ сылайан турабын,<br>Суол киһитэ <span class="description" id="1022">тутайан</span> турабын,<br>Тыл кэпсэтиэм диэн кэлбитим,<br>Ас аһаан <span class="description" id="1023">салҕаныам</span> диэн кэлбитим,<br>Үтүө сураххытын <span class="description" id="1024">сураан</span> <br>Кэлэн турабын,<br>Бэт ааккытын ааттаан<br>Кэлэн турабын,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4210
                    </td>
                    <td>
                        Уһун улахан сураххытын<br><span class="description" id="1025">Сураҕалаан</span> кэллим.<br>Хонук <span class="description" id="1026">өрөөн</span> сыньньанан<br>Ааһаары кэлэн турабын.<br>Курустаал таас дьиэҥ аанын<br>Аһан биэриэххин хайдах буолуой?<br>Дьахтар кыһаммата,<br>Олорбутун курдук олорор.<br>Эмиэ эргиччи хаама сатаата,<br>Ити гынан баран <span class="description" id="1027">кэтэҕэриин истиэнэнэн</span> 
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4220
                    </td>
                    <td>
                        Нүрүйэн көрөн турда.<br>Итиэннэ эмиэ үсүһүн<br>Ырыанан саҥалаах буола турда:<br>— Бу көньньүнэн сүүрэр<br>Курустаал таас дьиэҥ аанын<br>Аһан биэрдэххинэ киирэммин даҕаны,<br>Дьэ, хотуой,<br>Таптыырга наада буолумуна турабын,<br>Сыллыырга кыһаммакка турабын,<br>Кыныым диэн кыһайыам суох этэ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4230
                    </td>
                    <td>
                        Аньньыым диэн ааттаһыа суох этим.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4231
                    </td>
                    <td>
                        Ааҥҥын аһан биэриэххин<br>Төһөлөөх-хаччалаах буолуой?!<br>Эмиэ дьиэтин эргийэ хаама сырытта.<br>Ити кэнники ыллаабыт ырыатын<br><span class="description" id="1028">Кыыһыра былаан</span> туран<br>Ыллаабыт быһыылаах,<br><span class="description" id="1029">Нөҥүө</span> үрэх баһыгар сылдьан<br>Сылгы уола Дыырай бухатыыр<br>Били саҥатын дуораанын иһиттэ.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4240
                    </td>
                    <td>
                        Сэттэ көс сиртэн истэр<br><span class="description" id="1030">Көр чуор</span> кулгаахтаах <span class="description" id="1031">баҕадьы</span> этэ,<br>Үс күннүк сиртэн көрөр<br><span class="description" id="1032">Кэкэ чолбон</span> харахтаах киһи этэ.<br>Көрө-истэ баттаата,<br><span class="description" id="1033">Үлүһүйэн</span> түргэтээн дьиэтин диэкки<br>Сүүрэн-көтөн кэллэ.<br>Били бултаабыт <span class="description" id="1034">буллун</span> <br>Иннигэр-кэннигэр сүгэн<br>Үгүһү <span class="description" id="1035">өтөҕөлөөбүт</span> этэ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4250
                    </td>
                    <td>
                        Быата быстара<br>Быата быстан түһүтэлээтэ,<br><span class="description" id="1036">Мүччү барара</span> <br>Мүччү баран түһүтэлээтэ,<br>Үгүс өттө тыаҕа хаалла,<br>Сороҕун мас тардан хаалла,<br>Үүнэн эрэр ойуурум<br><span class="description" id="1037">Үрүт өттүнэн</span> сүүрэн кэллэ.<br>Ити кэлэн ампаарын<br>Арҕаа өттүнэн кэрийэ көрдө.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4260
                    </td>
                    <td>
                        Били Тойон Дьобуруонтай бухатыыр
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4261
                    </td>
                    <td>
                        Хоту өттүнэн <span class="description" id="1038">кэрийэ</span> кэлэн иһэр эбит.<br>Ампаартан <span class="description" id="1039">хаххалатан</span>,<br>Хайалара да хайаларын да көрбөтө.<br>Соҕуруу муннук <span class="description" id="1040">эргийиитигэр</span> <br>Икки бухатыыр <span class="description" id="1041">күөннэринэн</span> аньньыһа түстүлэр,<br><span class="description" id="1042">Уолуйбут-соһуйбут</span> дьон быһыытынан<br>Кэннилэринэн <span class="description" id="1043">сугуһа</span> түстүлэр.<br>Бэйэ-бэйэлэрин <span class="description" id="1044">одуулаһан</span> кэбистилэр,<br>Хайаларыттан да хайалара да хаалсыбат,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4270
                    </td>
                    <td>
                        <span class="description" id="1045">Эрбии биитин</span>, <span class="description" id="1046">ини-бии</span> курдук<br>Тэбис-тэҥ дьон буолан биэрдилэр.<br>Сылгы уола Дыырай бухатыыр:<br>«Таптыам диэн наһыйыам суоҕа,<br>Сыллыам диэн кыһаныам суоҕа» —<br>Диэбитин истибитэ.<br>Итинтэн кыыһыран <span class="description" id="1047">тымтан</span> туран<br>Ыллыы турбута, аҕыйах тылынан,<br>Этиһэр киһи быһыытынан<br>Этэн-саҥаран турда:
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4280
                    </td>
                    <td>
                        — Дьэ, доҕоор,<br>Бу хайа дойду киһитэ кэлэҥҥин<br>Хараҕыҥ халлааны билбэккэ,<br><span class="description" id="1048">Уллуҥаҕыҥ</span> сири билбэккэ,<br>Дьиэни тула хаама сылдьаҕын,<br>Хайа дойду <span class="description" id="1049">тайҕатын</span> кыыла,<br><span class="description" id="1050">Далайын акаарыта</span> <span class="description" id="1051">мэнээк</span> <br>Эргийэ хаама сылдьаҕын? — диэтэ<br>Онуоха биирдэрэ эттэ:<br>— Дьэ, доҕоор!
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4290
                    </td>
                    <td>
                        Миигиннээҕэр бэйэҥ эн
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4291
                    </td>
                    <td>
                        <span class="description" id="1052">Акаарыны оҥоро сылдьар</span> эбиккин.<br>Кыҥырыыр Хаан Хотун ийэлээх,<br>Хаҥырыыр Хаан Тойон аҕалаах<br>Аҕыс былас аалай солко суһуохтаах<br>Айталы Куону<br>Эн иннигинэ кэпсэппит киһибин.<br>Кимтэн кэпсэппиккиний диэтэххинэ,<br>Бэйэтин бииргэ төрөөбүт убайа<br>Алталаах <span class="description" id="1053">атыыр</span> сылгы аттаах
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4300
                    </td>
                    <td>
                        Иккилээх Эрбэхтэй Бэргэнтэн<br><span class="description" id="1054">Халыым</span> диэни <span class="description" id="1055">халыччы</span> биэрэн,<br><span class="description" id="1056">Сулуу</span> диэни <span class="description" id="1057">субуччу</span> төлөөн,<br>Киһи буолар <span class="description" id="1058">кэскил</span> буоллун диэн,<br>Сүөһү буолар <span class="description" id="1059">төлкөнү</span> төрүттээн,<br>Ылыах буолбутум эбээт.<br>Ону эн тиийэҥҥин<br>Ити киһини акаарылыыгын да,<br>Хата бэйэҥ акаарыны оҥороҥҥун,<br>Өлөттөөрү гынан тураҥҥын
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4310
                    </td>
                    <td>
                        Былдьаан-талаан аҕалбыт буолбаккын дуо?<br>Акаарыны оҥоро сылдьаҥҥын<br>Киһи акаарылааххын, — диир.<br>Биһиги киһибит туран:<br>— Эн да буолларгын буол,<br><span class="description" id="1060">Дөксө</span> акаарылааххын,<br>Эн хата<br>Халыым-сулуу биэрбитиҥ дуо?<br>Мин киһи киэнин<br>Үрүҥ тыынын <span class="description" id="1061">өллөйдөөн</span>,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4320
                    </td>
                    <td>
                        Хара тыынын харыһыйан,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4321
                    </td>
                    <td>
                        Сырдык тыынын <span class="description" id="1062">сыдьаайдаан</span><br>Киһини <span class="description" id="1063">өрүһүйбүт</span> үтүөбэр<br>Төрөөбүт ийэтиттэн бараммын,<br>Эриэн ыт оҕотун биэрбиттэрин<br>Киһи-сүөһү оҥороойобун диэн эрдэхпинэ,<br>Эн кэлэҥҥин сымыйанан этэн дуу,<br><span class="description" id="1064">Кидьдьик</span> этэн дуу ылан барыаҥ дуо?<br>Киһи буолара дуу, буолбата дуу<br>Билигин даҕаны биллибэккэ сылдьар.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4330
                    </td>
                    <td>
                        Анараа киһи итинтэн кыыһыран<br>Алтан дьаакыр <span class="description" id="1065">харытынан</span> <br><span class="description" id="1066">Аҥаабыллаабытынан</span> барда.<br><span class="description" id="1067">Сомоҕо</span> көмүс сутуругунан<br><span class="description" id="1068">Сутурҕалаабытынан</span> кэллэ.<br>Биһиги киһибит кыыһырда.<br>Тутуһан туран охсуспутунан барда.<br>Ый аахпыт орулуур отут хонуга<br><span class="description" id="1069">Томтойо туолуор дылы</span> охсуһа сырыттылар,<br>Ыһыы-хаһыы буолла,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4340
                    </td>
                    <td>
                        <span class="description" id="1070">Ыһыылаах</span> ырыаны ыллаан бардылар,<br>Хаһыылаах тойугу туойан бардылар,<br><span class="description" id="1071">Биилээх</span> бөҕөнөн бэссиһэ сырыттылар,<br><span class="description" id="1072">Уһуктаах</span> бөҕөнөн <span class="description" id="1073">утассан</span> истилэр,<br><span class="description" id="1074">Кырыылаах</span> бөҕөнөн кыргыһа турдулар,<br><span class="description" id="1075">Иэн иҥиирин курдук</span> <br>Эрийсэ-сыыйса сырыттылар.<br>Таас Таалыйа хонууну наймылдьыттылар,<br>Кыһыл <span class="description" id="1076">кыппыайка</span> <span class="description" id="1077">быһыттан</span> түстэ.<br>Улуу муора уута <span class="description" id="1078">долгулдьуйа</span> турда,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4350
                    </td>
                    <td>
                        <span class="description" id="1079">Далай муора</span> уута <span class="description" id="1080">дьалкыйан</span> таҕыста.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4351
                    </td>
                    <td>
                        Алта уон хонук <span class="description" id="1081">аччайа туолла</span>.<br><span class="description" id="1082">Чэгиэн</span> эттэрэ <span class="description" id="1083">сэймэктэнэн</span> барда,<br>Үрүҥ эттэрэ <span class="description" id="1084">үөрэҕэстэнэн</span> истэ,<br>Кыһыл эттэрэ <span class="description" id="1085">кырбастана</span> турда,<br>Хара хааннара тоҕунна.<br>Аан ийэ дойдуларын<br><span class="description" id="1086">Үөһээ курдуутунан</span> <br>Үрүҥ <span class="description" id="1087">күдэни</span> <span class="description" id="1088">өрүкүттүлэр</span>,<br>Хара күдэни көтүттүлэр.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4360
                    </td>
                    <td>
                        <span class="description" id="1089">Сыа дьоннор</span> сылайан бардылар,<br>Уҥуох дьоннор <span class="description" id="1090">уйадыйан</span> бардылар,<br>Эт дьоннор <span class="description" id="1091">элэйэн</span> киирэн бардылар.<br><span class="description" id="1092">Өҥүргэс</span> <span class="description" id="1093">хабарҕаларын</span> бобута тутуһан ыллылар.<br>Тэбэр <span class="description" id="1094">тирэх</span> хара тииккэ<br><span class="description" id="1095">Тэмтээкэйдэһэн</span> тиийдилэр,<br>Өйөнө түстүлэр.<br>Бу өйөнөн турдахтарына,<br>Айахтарыттан үрүҥ күүгэн<br><span class="description" id="1096">Чаллырҕаччы</span> таммалыы турда.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4370
                    </td>
                    <td>
                        Тымырдара хамныы,<br>Тыыннара хааттара турдулар.<br>Бу туран эрэн<br>Тойон Дьобуруонтуй бухатыыр<br>Аҕыйахтык айаҕынан саҥара турар,<br>Ыллыыр киэҥ-кэрэх суох киһитэ:<br>—	Дьэ, нокоо, мин эйигиттэн<br><span class="description" id="1097">Үрүт уйалаах</span> киһибин,<br>Хайата да буоллар<br>Эйиэхэ бу дьахтары
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4380
                    </td>
                    <td>
                        <span class="description" id="1098">Кэбиһэ барбат</span> киһибин.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4381
                    </td>
                    <td>
                        Биирдэрэ этэр:<br>— Дьэ эн төһө да үрүт уйаланнаргын,<br><span class="description" id="1099">Ордук мутуктаннаргын</span>,<br><span class="description" id="1100">Сыыйыы тимир</span> <span class="description" id="1101">сындааһыным</span> <br><span class="description" id="1102">Сыыйылла</span> илигинэ,<br><span class="description" id="1103">Эрийии тимир</span> иҥиирим<br>Эриллэ илигинэ биэрэн ыыппат киһибин.<br>Хааным хааппыла саҕа<br>Хаалыар диэри охсуһа туруом!
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4390
                    </td>
                    <td>
                        Анарааҥҥыта этэр:<br>— Оо дьэ, нокоо,<br>Оччоҕо эт илиибитинэн,<br>Өлөрсөрбүтүн аастыбыт быһыылаах,<br>Ыһыктыһан кэбиһэн баран<br>Саабытынан ытыһан өлөрсүөх.<br>Дьэ биирдэрэ, биһиги киһибит<br>Сылгы уола Дыырай бухатыыр:<br>— Дьэ буоллун.<br>Биһиги диэтэх дьону
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4400
                    </td>
                    <td>
                        <span class="description" id="1104">Ыйаах бөҕө ытыспытыгар,<br>Сокуон бөҕө сутурукпутугар буоллаҕа,<br>Эбээһинэс бөҕө илиибитигэр буоллаҕа</span>.<br>Икки өттүттэн өһүргэспэккэ өлөрсөргө<br>Эбээһинэстэ оҥорсуох,<br>Хааннаах хабалата тутуһуох.<br>Буруйа-айыыта<br>Хайабыт да тиийбэт гына<br>Бэйэбит сокуонна оҥорсуох.<br><span class="description" id="1105">Сэрэтиспэккэ</span> <span class="description" id="1106">сиэспиттэр</span> диэн,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4410
                    </td>
                    <td>
                        Өйдөтүспэккэ өлөрсүбүттэрэбит диэн
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4411
                    </td>
                    <td>
                        Ынырыктаах <span class="description" id="1107">ыйаахтаах</span>,<br>Сүрдээх <span class="description" id="1108">дьүүллээх</span>,<br>Соҕотох сокуоннаах,<br>Биир бирисээгэлээх,<br><span class="description" id="1109">Үүс-аас</span> бэйэлээх,<br><span class="description" id="1110">Өтөҕөлөөх</span> Үрүҥ Айыы Тойон<br>Биир ордон хаалбыппытын<br><span class="description" id="1111">Сэмэҕэ-суҥхаҕа</span> тиэрдэ<br>Сылдьыаҕа, баҕар.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4420
                    </td>
                    <td>
                        Хайабытын да <span class="description" id="1112">баспытын</span> билээччи<br>Киһи буолуо, ону өйдөө! — диэтэ<br>Сылгы уола Дыырай бухатыыр.<br>Анараа киһи:<br>— Бэт сөпкө этэҕин, — диэтэ.<br>Ыһыктыһан кэбистилэр,<br>Хаҥас <span class="description" id="1113">ылгыннарын</span> хайыта баттастылар,<br>Хаан таһаарыстылар,<br>Хааннарынан <span class="description" id="1114">араҥа туоска</span> <br>Хабала бөҕөнү сүүртүлэр,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4430
                    </td>
                    <td>
                        <span class="description" id="1115">Эр-биир</span> хабалаларын атастаһан туттулар,<br><span class="description" id="1116">Хармааннарыгар</span> уктулар.<br>Ити гынан бараннар<br>Дьэ хайабыт <span class="description" id="1117">бастыыр</span> дэсиһэ турдулар.<br>— Илин <span class="description" id="1118">ырай</span> киһитэ<br>Ордук киһибин диигин дуу,<br>Эн бастаа эрэ, — диир биһи киһибит.<br>— Бэт сор, <span class="description" id="1119">буоллар буоллун</span>, —<br>Диэтэ анараа киһи.<br><span class="description" id="1120">Илин киһи</span> саатын-саадаҕын туппутунан
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4440
                    </td>
                    <td>
                        Илин <span class="description" id="1121">быраан</span> диэкки барда,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4441
                    </td>
                    <td>
                        Биһи киһибит <span class="description" id="1122">арҕаа киһи</span> <br>Арҕаа быраан диэкки барда.<br>Китиэн-итиэн дойду<br><span class="description" id="1123">Киилэ</span> кииллээх,<br>Хатыан-итиэн дойду<br>Хатыҥа хатыҥнаах,<br>Тутуон-итиэн дойду<br>Туоһа туттарыылаах,<br>Хаһыытыыр хахай кыыл
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4450
                    </td>
                    <td>
                        Хаана кырааскалаах,<br><span class="description" id="1124">Үөгүлүүр</span> <span class="description" id="1125">өксөкү кыыл</span> <br><span class="description" id="1126">Үөһэ</span> <span class="description" id="1127">силимнээх</span>,<br>Өлүү <span class="description" id="1128">дьэрибинэ</span> балык<br><span class="description" id="1129">Иэнин иҥиирэ</span> <span class="description" id="1130">иҥэрчэлээх</span>,<br>Улуу тайах кыыл<br><span class="description" id="1131">Уорҕатын тириитэ</span> <span class="description" id="1132">бүрэдэһиннээх</span>,<br>Тимир наахта балык<br><span class="description" id="1133">Чиркэйэр</span> <span class="description" id="1134">сиһин үөһэ</span> <span class="description" id="1135">киристээх</span>,<br>Улахан Суола эбэ хотун
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4460
                    </td>
                    <td>
                        <span class="description" id="1136">Тоҕойдуу</span> түһэн турарын курдук,<br>Тарбаҕынан таарыйдахха «даҥ» гынан эстэр<br>Чаачар саатын сулбу <span class="description" id="1137">сүөдүйэн ылан</span> <br>Өлөссүүгэ туттар <span class="description" id="1138">өһөхтөөх</span> <br><span class="description" id="1139">Кулан дьорҕоот</span> <span class="description" id="1140">оноҕоһун</span> туора ууран,<br>Саатын нөҥүө <span class="description" id="1141">кулгаах тааһыттан</span> <br>Нөҥүө кулгаах тааһыгар дылы<br>Иэмэх курдук <span class="description" id="1142">иҥнэри тардан</span>,<br>Биһиги киһибит арҕаа<br><span class="description" id="1143">Туруук</span> таас хайатыттан
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4470
                    </td>
                    <td>
                        Сэп кэлэрин кэтэһэн турар.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4471
                    </td>
                    <td>
                        Анараа киһи<br><span class="description" id="1144">Хайҕахтаах хара быара</span> <br>Манан буолаарай диэн <span class="description" id="1145">аҥаабыллаан</span>,<br><span class="description" id="1146">Нохтоолоох</span> тойон сүрэҕэ<br>Манан буолаарай диэн <span class="description" id="1147">туһаайан</span>,<br>Чиркэйэн турар сиһин үөһүн<br><span class="description" id="1148">Быһа көтүттэрбин</span> диэн ыһыктан кэбистэ.<br><span class="description" id="1149">Эрбэҕин</span> тыаһа халлаан<br>Түөрт өттүгэр түөрт күүстээх
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4480
                    </td>
                    <td>
                        <span class="description" id="1150">Сүүл этиҥин</span> тыаһа буолан<br>Таҥнары <span class="description" id="1151">ньиргийэн</span> түстэ.<br>Онуоха биһиги киһибит<br>Үс <span class="description" id="1152">саһаан</span> усталаах<br>Түөрт өттүнэн кырыылаах,<br>Икки өттүнэн уһуктаах,<br>Үрүҥ көмүс <span class="description" id="1153">үөрбэ</span> буолан<br>Аллараа диэкки <span class="description" id="1154">күннүк сир</span> холобурдааҕы<br><span class="description" id="1155">Сулбу сириэдийэн</span> биэрдэ.<br>Ол биэрбитин
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4490
                    </td>
                    <td>
                        Туруук таас хайатын<br>Үрэн-үрэн көрдөххө,<br>Үрүҥ <span class="description" id="1156">хоруоҥка</span> саҕа суох гына<br><span class="description" id="1157">Үнтү тэптэрэн</span> кэбистэ.<br>Онтон биһиги киһибит<br>Улахан үрэх тоҕойдуу түһэн турарын курдук<br><span class="description" id="1158">Хомуһуннаах</span> <span class="description" id="1159">кураахтаах саатын</span> <br>Эмиэ нөҥүө кулгаах тааһыттан<br>Нөҥүө кулгаах тааһыгар дылы<br><span class="description" id="1160">Иэмэх</span> курдук иҥнэри тардан турда.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4500
                    </td>
                    <td>
                        <span class="description" id="1161">Тииҥньит</span> ыал дьиэтин
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4501
                    </td>
                    <td>
                        <span class="description" id="1162">Тиэритэ</span> тэбиэлээбит курдук<br>Тимир тэмэлгэн оноҕоһун<br><span class="description" id="1163">Туорайдыы ууран</span> турда.<br><span class="description" id="1164">Хайҕахтаах хара быара</span> буолаарай диэн,<br><span class="description" id="1165">Хабарҕатын</span> алын өттө буоллун диэн,<br>Хаһыыра түһэн баран ыһыктан кэбистэ.<br><span class="description" id="1166">Эрбэҕин</span> тыаһа таҥнары <span class="description" id="1167">ньиргийэ</span> түстэ,<br><span class="description" id="1168">Чаҕылҕан уота</span> <span class="description" id="1169">өрө харбаһан</span> таҕыста,<br>Илин диэкки <span class="description" id="1170">эндэр</span> таас хайатын
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4510
                    </td>
                    <td>
                        Үрэн-үрэн көрдөххө<br>Үрүҥ <span class="description" id="1171">күүгэс</span> саҕа суох гына<br><span class="description" id="1172">Үнтү</span> ытан кэбистэ.<br>Итиниэхэ анараа киһи<br><span class="description" id="1173">Тордохтоох</span> <span class="description" id="1174">хоҥоруулаах</span>,<br><span class="description" id="1175">Кутуругар хоболоох</span>,<br><span class="description" id="1176">Мооньньугар мойбордоох</span> <br><span class="description" id="1177">Киҥкиниир</span> киэҥ халлаан<br><span class="description" id="1178">Аҥаарыйар атыыр</span> налык чыычааҕа буолан<br><span class="description" id="1179">Күннүк</span> холобурдаах сири
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4520
                    </td>
                    <td>
                        Өрө көтөн биэрбит эбит.<br>Итинтэн анараа киһи ытар күнэ кэллэ.<br>Саатын эмиэ уруккутун курдук<br><span class="description" id="1180">Иэмэх</span> курдук тардан,<br>Оҕун туора ууран туран<br>Толкуйдуу турда.<br>«Көр, бу<br>Хотугу ырай киһитэ буолан<br>Аллара <span class="description" id="1181">сириэдийэр</span> эбит ээ, бадаҕа,<br>Алларааннан тоһуйа тутан
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4530
                    </td>
                    <td>
                        Алларааннан ыһыктан көрүөххэ үчүгэй», — диэтэ.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4531
                    </td>
                    <td>
                        <span class="description" id="1182">Биэрэстэ</span> холобурдаах сири<br>Аллараннан ыһыктан кэбистэ.<br>Итиниэхэ биһиги киһибит<br>Уруккутун курдук үрүҥ <span class="description" id="1183">үөрбэ</span> буолан<br>Аллараа түһэн кэбистэ.<br>Эрбэҕин тыаһа халлаан түөрт өттүгэр<br>Таҥнары ньиргийэ түстэ,<br>Чаҕылҕан уота күлүм гына түстэ.<br>Биһиги киһибит аллараа дойдуга
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4540
                    </td>
                    <td>
                        Таҥнары сириэдийэн биэрдэ эмиэ,<br>Сириэдийэн түһэн истэҕинэ,<br><span class="description" id="1184">Нохтоолоох</span> тойон сүрэҕин<br>Алын өттүнэн,<br><span class="description" id="1185">Хайҕахтаах</span> хара быарын<br>Үөһээ өттүнэн,<br><span class="description" id="1186">Чиккэйэн</span> турар сиһин үөһүн<br>Аҥаар өттүнэн<br>Курдары сулбу көтүтэн таһаарда.<br>Биһиги киһибит өлөөрү <span class="description" id="1187">үөкэйдэ</span>,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4550
                    </td>
                    <td>
                        Быстаары быакайда.<br>Ити гынан баран<br>Били <span class="description" id="1188">туруук</span> таас хайатын<br>Аҥаар <span class="description" id="1189">эҥэригэр</span> <br>Тоҥоноҕунан өйөнөн турда,<br><span class="description" id="1190">Кыргыһыыга</span> туттар <span class="description" id="1191">кыырыктаах</span> <span class="description" id="1192">оноҕоһун</span> <br>Туора тутан турда.<br>Бу гынан баран<br>Хоту халлаан диэкки<br>Өрө көрөн турда.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4560
                    </td>
                    <td>
                        Хаалыаҕынааҕар эрэ саҥара турда,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4561
                    </td>
                    <td>
                        Буолуоҕунааҕар эрэ диэн<br>Тойук туойа турда:<br>— Дьиэ-буо!<br><span class="description" id="1193">Хомуһуннаах</span> оноҕоһум оҕотоо,<br><span class="description" id="1194">Холоҥсолоох</span> хоту дойдуга<br>Тоҕус улуу ойун<br>Туойан тиийэр сиригэр,<br>Остоолбо хайа <span class="description" id="1195">обургу</span> оройугар,<br>Тоҕус ойунунан туоттараммын,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4570
                    </td>
                    <td>
                        Соҕотох атахтаах,<br>Үс <span class="description" id="1196">өксөкүлүү</span> бастаах,<br>Түҥнэри холорук,<br><span class="description" id="1197">Кэдэрги</span> <span class="description" id="1198">иэччэх</span>,<br>Дуоҕал хара остуолу<br><span class="description" id="1199">Тобулу</span> сааттаран туруоттарбытым,<br>Бу туруоттаран бараммын,<br>Тоҕус туора <span class="description" id="1200">туоһахталаах</span>,<br>Үрүҥ <span class="description" id="1201">өрөҕөлөөх</span>,<br><span class="description" id="1202">Уйуллаах</span> кутуруктаах,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4580
                    </td>
                    <td>
                        Үс төгүл үс хаардаах,<br><span class="description" id="1203">Куочай кугас</span> ынах сүөһүнү,<br>Сүрдьүүлээх сүрэхтээх быарын<br>Тыыннаахтыы хостотон ыламмын,<br>Дуоҕал хара остуол обургуну<br>Малааһын тэриттэрбитим эбээт,<br>Тоҕус төгүл тоҕус<br><span class="description" id="1204">Кыыда</span> маҕан кыламаннаах,<br><span class="description" id="1205">Урааньньыктаах</span> <span class="description" id="1206">хоҥоруулаах</span>,<br>Сиикэй тумустаах,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4590
                    </td>
                    <td>
                        Токур кутуруктаах,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4591
                    </td>
                    <td>
                        Тоҕус хаардаах<br>Дьэҥкир муостаах,<br>Таҥнары тараах туйахтаах,<br><span class="description" id="1207">Хаччаҕай</span> маҥаас  сырайдаах,<br>Атыыр оҕус сүөһүнү,<br>Отто дойду <span class="description" id="1208">уйгута</span>,<br>Киэҥ дойду кэһиитэ,<br><span class="description" id="1209">Куйбаҥныыр</span> кутуруктааҕа,<br><span class="description" id="1210">Хоҥкуйар</span> хоолдьуктааҕа,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4600
                    </td>
                    <td>
                        Субу бааллар диэн,<br>Сүргүүлээх сүрэхтээх быардарын<br>Сылаастык хостоон<br>Дуоҕал хара остуолга<br>Оттотугар уурдаран тураммын,<br>Бөтүүктээх Бөтүөхэй хотун<br><span class="description" id="1211">Бөтөстөрүн</span> таһааттааммын,<br>Кууруксалаах Куллурҕай эмээхсин<br>Хоһууннарын  мустараммын,<br>Сыарҕалаах Сыылаҥхай хотун
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4610
                    </td>
                    <td>
                        <span class="description" id="1212">Сыыдамнарын</span> ыҥыттараммын,<br>Дуолан хара остуолга<br>Уурдаран тураммын,<br>Хомуһуннаах <span class="description" id="1213">кулан</span> <span class="description" id="1214">дьорҕоот</span> оноҕоспор<br>Эн обургу хааҥҥа хайыһар<br>Хаан бас дэттэрэн,<br>Өһөххө түһэр<br>Өһөх төбө буол дэттэрэн,<br>Илин өттүгэр<br>Торбос быарын саҕа
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4620
                    </td>
                    <td>
                        <span class="description" id="1215">Субай</span> <span class="description" id="1216">бөлүөх</span> хааны
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4621
                    </td>
                    <td>
                        Айаххар туора быллаччы ытыттараммын,<br>Кэлин өттүгэр<br>Туруору урааҥхай курдук<br>Субай хаан <span class="description" id="1217">сөгөлөөннөтөн</span>,<br>Мооньньоох баскыттан төбөҥ оройугар дылы<br>Сүрдээх тоҕус абааһы кыыһын<br>Аҕыс алгыстаах ойунун аҕаттараммын,<br>Абааһы аймаҕын батары силлэппитим,<br>Эккэ эргийэр буол дэтэн,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4630
                    </td>
                    <td>
                        Хааннаахха хайыһар буолуҥ диэн,<br>Абааһы аймаҕа диэн дьаарҕаммат гына,<br>Күн дьоно диэн көмүскээбэт гына<br>Дьөлө силлэппитим эбитэ.<br>Ол төлөбүрүн хойутун хойут,<br>Кэнэҕэһин-кэнэҕэс,<br>Аллараа аҕыс биис уустара,<br>Туоһахталаах сүөһүнү<br>Туора бааттарар буолуохтара.<br>Ити кэлин өттүттэн кэпсээтэхпинэ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4640
                    </td>
                    <td>
                        Туһааннаах тус соҕуруу дойдуга<br>Сурахтаах ойун тоҕус кэдии оҥорон<br>Туойан тахсан тохтуур сирэ<br><span class="description" id="1218">Дьукдьуур</span> чучумаас хайа уу <span class="description" id="1219">дьулайыгар</span> <br>Икки бастаах,<br>Сэттэ кутуруктаах,<br>Сылбараҥ маҕан остуолу<br>Ойун төрөөн көппүт<br>Тоҕус уйалаах уйуук  хара тиититтэн<br>Үрүт мутугун ойуҥҥа уруйдатан аҕаламмын,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4650
                    </td>
                    <td>
                        Сэттэ <span class="description" id="1220">кыталык элэмэс</span> дьүһүннээх,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4651
                    </td>
                    <td>
                        <span class="description" id="1221">Чоккуруос</span> харахтаах,<br>Аҕыс <span class="description" id="1222">ардайдаах сиэллээх</span>,<br>Таҥнары тараах туйахтаах,<br><span class="description" id="1223">Чоҥкуруун</span> кутуруктаах,<br><span class="description" id="1224">Томторуктаах</span> хоҥоруулаах<br>Ытык сылгыны<br>Сүргүүлээх сүрэхтээх быарын<br>Тыыннаахтыы хостотон<br>Сылбараҥ маҕан сибиэ остуолу
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4660
                    </td>
                    <td>
                        Малааһыннатан тураммын,<br>Сэттэ ырыалаах былыт кыыһын<br>Төбөҥ оройугар, мооньньоох баскар,<br>Эккэ эргийэр буолуҥ,<br>Хааҥҥа хайыһар буолуҥ диэн,<br>Абааһыттан саспат гына,<br>Айыыттан куттаммат гына,<br>Силлэтэн иҥэттэрбитим эбитээ.<br>Ытык тылбын ыкка ытыттарымаҥ,<br>Дьоһун тылбын суорга тоҥсуттарымаҥ.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4670
                    </td>
                    <td>
                        Дьэ эрэ, Үрүҥ Эриэн тойон аҕалаах,<br>Эбириэччин хотун ийэлээх,<br>Тоҕус <span class="description" id="1225">күннүк</span> сири дук гынан ааһар,<br>Чучугур-<span class="description" id="1226">чуоҕур</span> аттаах<br>Тойон Дьобуруонтай бухатыыры<br>Нохтоолоох тойон сүрэҕэ буолуо диэн,<br>Тобулу түһэн көрүҥ эрэ,<br>Хайҕахтаах хара быара буолуо диэн,<br>Хайа түһэн көрүҥ эрэ,<br>Чиккэйэр сиһин үөһэ буоллун диэн,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4680
                    </td>
                    <td>
                        Оттотунан быһа түһүөххүтүн
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4681
                    </td>
                    <td>
                        Төһөлөөх-хаччалаах буолуой!<br>Дьэ-эрэ, дьэ эрэ!<br><span class="description" id="1227">Кырыыс</span> баһа хааннаннын эрэ,<br>Сэттээх тыл ситтин эрэ! — диэн баран<br>Халлаан диэкки<br><span class="description" id="1228">Чаачар</span> саатын иэмэх курдук<br>Токуруччу тардан турда:<br>— Саҥарбыт саҥам саталаннын,<br>Эппит тылым иччилэннин! — диэтэ
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4690
                    </td>
                    <td>
                        Ол гынан баран<br>Үөһэ диэкки ыһыктан кэбистэ.<br>Өрө көрдөххө<br>Өрөҕөтө көҕөрөн көстөр<br>Үс хаттыгастаах<br><span class="description" id="1229">Өндөл</span>-маҕан халлааҥҥа,<br>Дьирбии-дьиэримэ  маҕан былыкка<br>Тахсан <span class="description" id="1230">уһаты</span> түһэн хаалла.<br>Ити кэлин өттүттэн<br>Үс <span class="description" id="1231">хараҕалаах</span> түргэн холорук
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4700
                    </td>
                    <td>
                        Дьүөрэлэһэн түстэ бу оноҕос үрдүгэр,<br>Сэттэ хараҕалаах сипсиэр буурай холорук<br>Оноҕос үрдүгэр дьиэлэнэн түстэ,<br>Тоҕус хараҕалаах буурай хара холорук<br>Оноҕос үрдүгэр <span class="description" id="1232">сохсолоһон</span> түстүлэр,<br>Ити кэлин кырыытыттан оноҕос буоллаҕына<br>Былыты быыһынан аллараа диэкки<br>Субурус гына түстэ,<br>Хоту диэкки эргийэн көрөр,<br>Арҕаа диэкки хайыһан көрөр,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4710
                    </td>
                    <td>
                        Илин диэкки эргилиннэ,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4711
                    </td>
                    <td>
                        Аллара сиргэ түһээри гыныах курдук<br>Буола-буола,<br>Кэннинэн арҕаа диэкки бара турда.<br>Ити гынан баран<br>Бэйэтиттэн бэйэтэ күүһүрэн барда,<br>Салгыныттан салгына кытаатан барда,<br>Сипсиэр хара тыал сирдьиттэнэн барда,<br>Буурай хара холорук доҕуһуолланан барда,<br>Мастан бардамнаата,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4720
                    </td>
                    <td>
                        Ууттан олустаата,<br>Тииттэн тэбиэһирдэ,<br>Тус илин диэкки<br>Бэт күүстээхтик күрүлээн түстэ.<br>Бу иһэрин көрөн баран<br>Тойон Дьобуруонтуй бухатыыр<br>Үөһээ дойдуга үс күннүк сиргэ<br>Өрө көтөн даллас гынан биэрдэ,<br>Оноҕос үөһэ диэкки<br>Өрө кэҕис гынан биэрдэ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4730
                    </td>
                    <td>
                        Хайҕахтаах хара быарын<br>Хайы түһэн кэбистэ,<br>Нохтоолоох тойон сүрэҕин<br>Тобулу көтөн ааста,<br>Чиккэйэн турар сиһин үөһүн<br>Быһа түһэн кэбистэ.<br>Итиниэхэ ити киһи<br>Кыһыл кыппыайкаҕа,<br>Таас <span class="description" id="1233">таалыйа</span> хонууга,<br>Уруйдаах толоон оттотугар,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4740
                    </td>
                    <td>
                        Тиэрэ баран түстэ да, өлөн хаалла...
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4741
                    </td>
                    <td>
                        Биһи киһибит саатын-саадаҕын<br>Хаҥас хооньньугар  туора кыбынна,<br>Ыарыппыт киһи быһыытынан өкчөччү тутунна,<br>Ойуулаах-оһуордаах оронугар<br>Тиэрэ баран түстэ да,<br>Утуйан хаалла.<br>Итиниэхэ  ити киһи<br>Тоҕус күннүк сири<br>Тоҕуста дук гынан ааһар
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4750
                    </td>
                    <td>
                        Чучугур Чуоҕур ат<br>Хараҕын <span class="description" id="1234">хараҕаччыта</span>,<br>Кулгааҕын <span class="description" id="1235">кураҕаччыта</span>,<br>Сүрэҕин сүүрүгүй чыычааҕа,<br>Быарын-быарыгын кырбый кыыла,<br>Үөһээ дойду диэкки өрө көтөн таҕыста.<br>Үөр туллук<br>Өрө көтөн тахсан эрэрин курдук<br>Үлүскэннээх үүт <span class="description" id="1236">дьөһүөл</span> ааттыгынан<br>Өрө көтөн таҕыста,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4760
                    </td>
                    <td>
                        <span class="description" id="1237">Сиэр</span> сылгы сиэллээх кутуругун<br>Сэлэйэ баттаабыт курдук<br>Сиэр <span class="description" id="1238">күрдьүгэс</span> ааттыгынан<br>Өрө <span class="description" id="1239">силэйэн</span> таҕыста,<br>Аҕыс хаттыгастаах<br>Араҕас маҕан халлаан<br>Арҕаһыгар тиийэ<br>Өрө көтөн таҕыста.<br>Үөһээ дойдуттан<br>Көҕөрөр күөх унаар ааттык
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4770
                    </td>
                    <td>
                        Таҥнары <span class="description" id="1240">саньньылыйан</span> түстэ,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4771
                    </td>
                    <td>
                        Бу ааттык устун,<br>Суруктаах халлаан уола Сорук Боллур,<br>Бэт түргэн түһүүлээх киһи,<br>Түһэн иһэр,<br>Кынатын тыаһа кытаанах баҕайытык<br>Сылыбыраччы көтөн кэллэ,<br><span class="description" id="1241">Хотоҕоһун</span> тыаһа<br>Холугураччы көтөн кэллэ,<br>Бэт түргэнник утарыта көссө түстүлэр.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4780
                    </td>
                    <td>
                        Били <span class="description" id="1242">кырбый</span> кыыл<br>Ат сүрэҕин сүүрүгүйэ,<br>Быарын быырыгыйа,<br>Хараҕын <span class="description" id="1243">хараҥаччыта</span>,<br>Кулгааҕын кураҕаччыта<br>Саҥалаах-иҥэлээх буола олордо:<br>— Чыыр-чыыр — диэтэ, —<br>Ыый-ыыйдарбын,<br>Аай-аайдарбын,<br>Ытаатахпын-соҥоотохпун,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4790
                    </td>
                    <td>
                        Ыллаатахпын-туойдахпын,<br>Суруктаах халлаан уола<br>Сорук Боллур тойон убайкаам,<br>Дорообо бокулуон!<br>Мин иччибин<br>Үрүҥ Эриэн тойон аҕалаах,<br>Эбириэччин эмээхсин ийэлээх<br>Тоҕус күннүк сири,<br>Тоҕуста дук гынан ааһар<br>Чучугур-чуоҕур аттаах
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4800
                    </td>
                    <td>
                        Тойон Дьобуруонтай бухатыыр
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4801
                    </td>
                    <td>
                        Арҕаа халлаан анныгар,<br>Аатыран үөскээбит<br>Сэттэ уон киирэр эйиэн иэйиэхсит<br>Биэрэгэр дьиэлэммит,<br>Аҕыс уон айгыстан түһэр<br>Айыыһыт <span class="description" id="1244">дьаарбаҥын</span> анныгар<br>Арҕахтанан олорбут,<br>Тоҕус уон хотой иэйиэхсит<br><span class="description" id="1245">Оппуоһун</span> анныгар
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4810
                    </td>
                    <td>
                        Олоҕуран үөскээбит<br>Тыллаах-өстөөх Хара Кулун аттаах<br>Сылгы уола Дыырай бухатыыр<br>Туһааннаах тойон иччибин<br>Өлөрөн-сүтэрэн кэбистэ.<br>Көмүскүүрүм эрэ көмүскэм уута буолла,<br>Харыһыйарым эрэ хараҕым уута буолла,<br>Эйиэхэ кэлэммин<br>Ытыы-соҥуу олоробун.<br>Бэт түргэнник
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4820
                    </td>
                    <td>
                        Өтөҕөлөөх Үрүҥ Айыы Тойоҥҥо,<br>Чыҥырыыр Дьылҕа Хаан оҕоньньорго<br>Этэн-кэпсээн көрүөххүн<br>Төһөлөөх-хаччалаах буолуой!» — диэтэ.<br>Соҕотох ууруулаах,<br>Ынырыктаах ыйаахтаах,<br>Сүрдээх <span class="description" id="1246">дьүүллээх</span>,<br><span class="description" id="1247">Үүс-аас</span> бэйэлээх,<br>Өтөҕөлөөх Үрүҥ Айыы Тойон оҕоньньор<br>Орулуур Одун Буурай
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4830
                    </td>
                    <td>
                        Дьыҥырыыр Дьылҕа Хаан
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4831
                    </td>
                    <td>
                        Аан алаһатыгар,<br><span class="description" id="1248">Көй</span> киинигэр,<br>Көмүс уйатыгар,<br>Суостуганнаах суо-хаан олоҕор<br>Олоро түстэ ити Сорук Боллур.<br>Ол гынан баран:<br>— Дьиэ-буо!<br>Өтөҕөлөөх Үрүҥ Айыы Тойон оҕоньньор,<br>Айыы дьонноро алдьатыспыттар үһү,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4840
                    </td>
                    <td>
                        Күн дьонноро өлөссүбүттэр үһү,<br>Онон бу аллараа<br>Аҕыс иилээх-саҕалаах,<br>Атааннаах-мөҥүөннээх,<br>Айгыр-силик аан ийэ дойдуга<br>Алдьархай бөҕө буолбут үһү.<br>Тоҕус күннүк сири<br>Тоҕуста олук гынан ааһар<br>Чучугур Чуоҕур аттаах<br>Тойон Дьобуруонтай бухатыыры,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4850
                    </td>
                    <td>
                        Сэттэ айыы кыыһа эйэлэһэн ииппит<br>Эдьиэлимэ Куо диэн ийэлээх,<br>Халлаан буойун бухатыыра,<br>Хаардыыр-мохсоҕол аҕалаах,<br>Тыллаах-өстөөх Хара Кулун аттаах<br>Сылгы уола Дыырай бухатыыр<br>Ол тойон Дьобуруонтайы<br>Өлөрөн кэбиспит үһү.<br>Ону мин иһиттим,<br>Чучугур чуоҕур ат
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4860
                    </td>
                    <td>
                        Таныытын татыйыга,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4861
                    </td>
                    <td>
                        Хараҕын хараҕаччыта,<br>Кулгааҕын кураҕаччыта,<br>Сүрэҕин сүүдүгүйэ,<br>Быарын-быыдыгый кыыла<br>Кырбый кыыл кэлэн<br>Миэхэ кэпсээтэ.<br>Ый ытыыны ытаабыт,<br>Сой-соҥууну соҥообут,<br>Куттаммыта-уолуйбута<br>Бэт буолбут, — диэтэ Сорук Боллур.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4870
                    </td>
                    <td>
                        Өтөҕөлөөх Үрүҥ Айыы Тойон<br>Оҕоньньор эттэ онуоха:<br>— Оо! Нокоо, Сорук Боллуор,<br>Дьэ бу үлүгэри көр эрэ!<br>Дьэ бэт түргэнник үс халлаан<br>Үс чүөмэр маҕан суруксуттарын аҕалтыы тат,<br>Ол гэннэ киэҥ халлаан<br>Үс айыы <span class="description" id="1249">дьаргыл</span> удаҕаныттан оччугуйдара<br>Айыы Дьаргыл удаҕана<br>Бэрт түргэнник кэлэ таттын,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4880
                    </td>
                    <td>
                        Үс мүрүс  маҕан халлаан гиэнэ<br>Үс күүстээх<br>Балаас бухатыыра кытта кэллиннэр,<br>Киэҥ халлаан ситинэҕин ол<br>Үс балаас бухатыырдар илдьэ кэллиннэр! — диэтэ.<br>Итиниэхэҕэ барытын эргийэ сүүрэн аҕалтаата.<br>Манна кэлэннэр<br>Үс чүөмэр маҥан суруксут<br>Сытар ынах саҕа<br>Дьыала кумааҕыны
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4890
                    </td>
                    <td>
                        Сыымайдыы олордулар,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4891
                    </td>
                    <td>
                        <span class="description" id="1250">Араҥа туос</span> курдук<br><span class="description" id="1251">Аркыыба</span> кумааҕыны<br>Арыйа олордулар.<br>Бу арыйан көрөн баран<br>Бу курдук диэн кэпсииллэр:<br>— Дьэ-буо!<br>Бу былыргы дьылга,<br>Урукку уларыйбыт хонукка,<br>Бу Өтөҕөлөөх Үрүҥ Айыы Тойон оҕоньньор,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4900
                    </td>
                    <td>
                        Үс кыыстаах эбиккин.<br><span class="description" id="1252">Оччугуй</span> кыыһыҥ<br>Сэттэ айыы кыыһа эйэлэһэн ииппит<br>Эдьиэлимэ Куо диэн дьахтар,<br>Халлаан күүстээх буойун бухатыыра буолбут<br>Хаардыыр Мохсоҕол<br>Кэргэнинэн кэпсэппит эбит.<br>Ол дьахтар<br>Тоҕус ыйдаах хат сырыттаҕына,<br>Кулун кымыһа тэрийбиккин.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4910
                    </td>
                    <td>
                        Бу тэрийбиккэр<br>Күөх халлаан уола<br><span class="description" id="1253">Күөкэримэ</span> суруксут баар эбит.<br>Үс нүөмэр маҥан суруксуттара кэлбиттэр эбит.<br>Маныахаҕа<br>Оһуор дьаҕыл ойуулаах,<br>Оһуор <span class="description" id="1254">бочугурас</span> ойоҕостоох,<br>Томторҕолоох айахтаах<br>Чороон <span class="description" id="1255">ымыйа</span> иһиккэ<br>Үөһээ <span class="description" id="1256">көбүөтүнэн</span>,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4920
                    </td>
                    <td>
                        Араҕас илгэнэн арыылаан
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4921
                    </td>
                    <td>
                        Айах туппут эбиккит.<br>Маны бу Эдьиэлимэ Куо түөһүгэр<br><span class="description" id="1257">Мараччы</span> көтөҕөн испит эбит.<br>Ол истэҕинэ ийэтин иһигэр баар<br>Тоҕус ыйдаах оҕо<br><span class="description" id="1258">Тараһа</span> бүтэй тэбэн<br>Тоҕо дьаккыппыт эбит.<br>Бу дьаккыппыта<br>Үс илии быһаҕас түспүт эбит.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4930
                    </td>
                    <td>
                        Мантан төрүүр сүөһү<br>Үс сыл хонугар төннүбүт эбит,<br>Кэлэр киһи субу <span class="description" id="1259">сибиир</span> гиэнэ<br>Үс сыл хонугар кэхтибит эбит.<br>Бу кэхтибититтэн<br>Куһаҕан мэник киһи үөскээбит диэн<br>Бу айыы дьаҕыл ойунунан Эдьиэлимэ Куону<br>Отто дойдуга түһэттэрбиттэр эбит.<br>Ол түһэттэрэннэр<br>Бу тоҕус ыйдаах оҕону
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4940
                    </td>
                    <td>
                        Итэҕэс <span class="description" id="1260">айыылааннар</span>,<br>Суорума соруктааннар,<br>Мэник киһи үөскээбит диэннэр,<br>Аҕыс салаалаах<br>Аал Луук Мас төрдүгэр,<br>Сылгы тиэргэнигэр<br>Ийэтин иһиттэн<br>Эмэрийэн-илбийэн түһэрбиттэр эбит.<br>Бу түһэрбиттэрин кэннэ<br>Аҕыс салаалаах
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4950
                    </td>
                    <td>
                        Аал Луук Мас иччитэ
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4951
                    </td>
                    <td>
                        Оһуор-ойуу,<br><span class="description" id="1261">Аан эскэл</span>,<br>Айҕал Мичик эмээхсин<br>Сылгы тиэргэниттэн булан ылан,<br>Икки суон <span class="description" id="1262">баараҕай</span> <br>Көмүс <span class="description" id="1263">ньилбэгэр</span> туора көтөҕөн,<br>Икки эбир <span class="description" id="1264">дьаҕыл</span> <br>Эмиийин эмсэхтэтэн,<br>От-мас күүстээх <span class="description" id="1265">сүмэһинин</span> аһатан
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4960
                    </td>
                    <td>
                        <span class="description" id="1266">Биэбэйдээн</span> ииппит эбит.<br>Бу иитэн баран<br>Улахан оҕо буолан эрдэҕинэ<br>Толкуйдуур-тойоннуур эбит<br>Бу эмээхсин:<br>— Оот-татай, оҕом барахсан<br>Киһиттэн төрөөбүтэ буоллар<br>Ийэлээх-аҕалаах буолуо этэ,<br>Мин кинини сылгы тиэргэниттэн буллум,<br>Оҕобор аат-суол биэрдэҕим диэн
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4970
                    </td>
                    <td>
                        Сэттэ уон эйиэн иэйэхситБиэрэгэр дьиэлэммит,<br>Аҕыс уон айгыстар айыыһыт<br>Дьаарбаҥын ааныгар <span class="description" id="1267">арҕахтаммыт</span>,<br>Тоҕус уон <span class="description" id="1268">суккуллан</span> түһэр<br>Хотой иэйиэхсит<br>Оппуоһун ааныгар олоҕурбут<br>Тыллаах-өстөөх<br>Хара Кулун аттаах<br>Сылгы уола Дыырай бухатыыр
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4980
                    </td>
                    <td>
                        Буол, <span class="description" id="1269">кукаам!</span> — диэбит.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4981
                    </td>
                    <td>
                        Итинтэн бу<br>Илин халлаан анныгар олохтоох,<br>Итии муора эккиннээх,<br><span class="description" id="1270">Эндэл</span> таас хайа <span class="description" id="1271">кэрискэлээх</span>,<br><span class="description" id="1272">Эбир</span> дуоссун хонуулаах,<br>Хоҥоруу дуоссун дойдулаах,<br>Үрүҥ Эриэн тойон аҕалаах,<br>Эбириэччин баай эмээхсин ийэлээх,<br>Тоҕус күннүк сири
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        4990
                    </td>
                    <td>
                        Тоҕуста дук гынан ааһар,<br>Чучугур-чуоҕур аттаах<br>Тойон Дьобуруонтай бухатыыр.<br>Бу бухатыыр<br>Төрдө-ууһа кимий диэннэр<br>Араҥа  туос курдук аркыыбаны<br>Арыйан көрдүлэр.<br>Бу Үрүҥ Эриэн тойон оҕоньньор<br>Аан дойду иэйиэхсититтэн<br>Ситимнээх киһи эбит,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5000
                    </td>
                    <td>
                        Аан дойду айыыһытыттан<br>Айдарбыт ханыылаах киһи эбит.<br>Аҕыс <span class="description" id="1273">былас</span> <br>Аалай солко суһуохтаах<br>Айталы Куо дьахтар<br>Сиргэ түспүт <span class="description" id="1274">сэрибиэйэ</span> <br>Кимиэхэ эбитий,<br>Окко түспүт оҥоһуута<br>Туохха эбитий диэн,<br>Сокуон бөҕөнү хостоотулар,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5010
                    </td>
                    <td>
                        Дьыала бөҕөнү ырыттылар.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5011
                    </td>
                    <td>
                        «Бу Одун Хаан оҥоһуута,<br>Тыйыс Хаан дьылҕата,<br>Мүччүрүйбэт бөҕө сокуона<br>Сылгы уола Дыырайга эбит.<br>Маны баран Тойон Дьобуруонтай бухатыыр<br>Былдьаһа сылдьыбыт.<br>Бу да буоллар Дьобуруонтай ыйааҕар<br>Өлбөт үөстээх,<br>Быстыбат тыыннаах киһи эбит.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5020
                    </td>
                    <td>
                        Маны харыһыйыахха, — диэтилэр,<br>Тилиннэрэн дойдутугар аҕалыахха! — диэтилэр.<br>Маны аҕаларга <span class="description" id="1275">оччугуй</span> <br>Айыы Дьарҕал удаҕаны атаардылар.<br>Харытынан охсуллар<br>Хампа-солкону кэттэ,<br>Сототунан охсуллар<br>Солко-<span class="description" id="1276">нуоҕайын</span> кэттэ,<br><span class="description" id="1277">Бэлэньньигинэн</span> охсуллар<br><span class="description" id="1278">Илбиргэс</span> солкотун иилиннэ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5030
                    </td>
                    <td>
                        Күөх от <span class="description" id="1279">былаайаҕын</span> тутта,<br>Көҥдөй от <span class="description" id="1280">дүҥүрүн</span> өрө тутта,<br>Киэҥ халлаан <span class="description" id="1281">ситимэҕин</span> таҥнары состо,<br>Үс <span class="description" id="1282">нүрүс</span> маҕан халлаан<br>Күүстээх бухатыырын батыһыннарда,<br><span class="description" id="1283">Анды</span> сымыытын курдук<br>Араҕас илгэни хармааныгар угунна,<br>Дүҥүрүн дыҥ-дыҥ оҕуста,<br>Атаҕын дыгак-игэк үктэннэ,<br>Отто дойдуга таҥнары көтөн
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5040
                    </td>
                    <td>
                        <span class="description" id="1284">Күүгүнээн</span> түһэн истэ,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5041
                    </td>
                    <td>
                        Туруу аттаныаҕыттан<br>Тойугун туойан түстэ,<br>Ырыатын ыллаан киирэн истэ:<br>— Урууй-урууй, айхал-айхал!<br>Айхал-мичил буоллун!<br>Уолан быстар уулаах,<br>Олохсуйан хагдарыйар оттоох,<br>Охтон баранар мастаах,<br>Сиҥнэн сиэмэтэ быстыбат,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5050
                    </td>
                    <td>
                        <span class="description" id="1285">Сиибиктэ</span> күөх от сирэмнээх,<br>Сиэмэлэс мас эккиннээх,<br>Хара тыа олбохтоох,<br>Дириҥ <span class="description" id="1286">далай</span> түһүлгэлээх,<br>Сиибиктэ от үктэллээх<br>Сиэр күрэҥ дьаҕыл дойду<br>Оҕото буолбут<br>Эриэн Тойон оҕоньньор аҕалаах,<br>Эбириэччин баай эмээхсин ийэлээх,<br>Тоҕус күннүк сири
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5060
                    </td>
                    <td>
                        Дук гынан ааһар<br>Чучугур чуоҕур аттаах<br>Тойон Дьобуруонтай бухатыыр.<br>Дьэ, нокоо!<br>Өлбүтэ үс сыл буолбут киһини<br>Үтүөрдэргэ <span class="description" id="1287">дьүһүттэриилээх</span> киһи кэллим,<br>Өлбүтэ сэттэ сыл буолбут киһини<br>Сэттэ төгүл эргийэн тахсан<br>Тириэрэн барарга <span class="description" id="1288">тэримдьилээх</span> киһибин,<br>Арахсыбыта аҕыс сыл буолбут киһини
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5070
                    </td>
                    <td>
                        Аннынан аҕыста <span class="description" id="1289">сүргүйэммин</span> 
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5071
                    </td>
                    <td>
                        Абырыырга аналлаах киһи кэллим,<br>Турбатаҕа тоҕус сыллаах киһини<br>Тоҕуста сүргүйэммин<br>Туруору дуомнуурга оҥоһуулаах киһи кэллим,<br>Дьэ харааччы көр,<br>Айаххын ат,<br>Анды сымыытын курдук<br>Араҕас илгэни<br>Айаххар тамнааттыыр күнүм буолла!
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5080
                    </td>
                    <td>
                        Урууй буоллун,<br>Айхал-мичил буоллун,<br>Улуу <span class="description" id="1290">дьаҥсах</span> буоллун!<br>Наадалаах дьаҥсаҕы<br><span class="description" id="1291">Дьаныйан</span> түһэр күнүм буолла, — диэн<br>Отто дойдуга кэлэн тура түстэ.<br>Өлбүт киһитигэр үс төгүл силлээтэ,<br>Үс төгүл аннынан сүргүйэн таҕыста,<br>Ити гынан баран:<br>— Өлбүтэ үс сыллаах киһини
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5090
                    </td>
                    <td>
                        Үс төгүл сүргүйдэхпинэ<br>Үтүөрдэргэ сүргүйэр киһи баарым.<br>Уой-дом! Уой-айхал! Уой-дьаҥалыс!<br>Улуутуйар улуу, хаалбат-сүппэт<br>Ааттаах айхалы арыйдаҕым буоллун!<br>Сэттэтэ силлээтэ,<br>Сэттэтэ аннынан эргийэн таҕыста.<br>Сэттээх-сэлээннээх суолу<br>Сэттэтэ эргийэммин тириэрэргэ<br>Силлиир ситэриилээх оҥоһуулаах эбитиэм!
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5100
                    </td>
                    <td>
                        Дьэ эрэ, эгий <span class="description" id="1292">буурай</span> 
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5101
                    </td>
                    <td>
                        Эккириир күнэ эргийдэ быһыылаах,<br>Уруй буурай ооньньуур күнэ<br>Оҥоһулуннаҕа буоллун.<br>Тоҕус сыллаах киһини<br>Тоҕуста <span class="description" id="1293">домнаан</span> туруорарга<br>Одун Буурайтан оҥоһулуннум эбитээ.<br>Ити кэнниттэн,<br>Үс түргэн холлорук дьүөгэм,<br>Бэттэх-бэттэх буолуҥ эрэ!
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5110
                    </td>
                    <td>
                        Сэттэ сыыдам холорук дьүөгэм,<br>Бэттэх-бэттэх буолуҥ,<br>Тоҕус буурай холлорук<br>Доҕуһуолум, бэттэх буолуҥ!<br>Хараарар хара дьулурҕа тойуктарым,<br>Хаарыан <span class="description" id="1294">сахха</span> хаалымаҥ эрэ.<br>Сэттэ дьэҥкэ тойук ырыаларым,<br>Эргийтэлээҥ эрэ.<br>Ити кэнниттэн<br><span class="description" id="1295">Уйгулаах</span> отто дойдуну
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5120
                    </td>
                    <td>
                        Кэтэбиллээх ийэ дойдубар<br>Кэскиллээх тыл диэммин<br>Кэрийэн көтөр күнүм буолла.<br>Сэттэ уон кэнэҕэски үйэҕэ<br><span class="description" id="1296">Кэччэрийбэт</span> <span class="description" id="1297">кэскилгэ</span>,<br><span class="description" id="1298">Кэнчээри</span> ыччакка<br>Иннэ диэммин этэр тылым<br>Аҕыйах да буоллар<br>Манныктар бааллар:<br>Ооньньоон түспүт сирбиттэн
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5130
                    </td>
                    <td>
                        Уйгулаах оһуор от
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5131
                    </td>
                    <td>
                        Унаарыйан олохсуйдун диэммин<br>Туойа турабын!<br>Көрүлээн түспүт сирбэр<br>Күөх от үүнэн өрүкүйдүн диэн<br>Үөтэ турабын!<br>Эккирээн түспүт сирбиттэн<br>Кэнчээри от ситэн үүннүн диэн,<br>Кэскиллээх тойугу кэнчээри ыччат<br>Иннэ диэн кэнийдэҕим буоллун!
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5140
                    </td>
                    <td>
                        Уой-дом! Уой-дуомал!<br>Айхал-мичик аан дойдуттан<br>Аҥаарыйан таҕыстын! — диирин кытары,<br>Түргэн холлорук <span class="description" id="1299">дьүөрэлэһэн</span> түстэ,<br>Сипсиэр холлорук <span class="description" id="1300">эркиннэһэн</span> түстэ,<br>Буурай холлорук доҕордоһон түстэ.<br>Сытар киһини туруору көтөҕөн таһаардылар.<br>Ити өлбүт киһини аттары бэйэлэри,<br>Күүстээх тыалынан өрө көтөхтөрөннөр,<br>Туһааннаах тус илин диэкки
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5150
                    </td>
                    <td>
                        Бэрт күүстээхтик өрө көтөҕөн <span class="description" id="1301">сөрөөн</span> <br>Тахсан бара турдулар.<br>Саха киһи сатаан арҕары көрбөт<br><span class="description" id="1302">Саппахтаах</span> сатыы буурай халлаанын<br>Алын кырыытынан аһары түһэннэр<br>Айаннаан-айаадыйан баран хааллылар.<br>Итиниэхэ дылы били<br>Аҕыс былас аалай солко суһуохтаах<br>Айталы Куо баараҕай көмүс баҕанатын<br>Илиитинэн кууспута кууспутунан,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5160
                    </td>
                    <td>
                        Атаҕынан кыпчыйбыта кыпчыйбытынан
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5161
                    </td>
                    <td>
                        Үөһээ үс хос үрэллибэт<br>Үрүҥ кутуу көмүс үрдүн<br>Өрө көрдө-көрбүтүнэн олорор.<br>Бу олорон көрбүтэ<br>Били мааҥы Сылгы уола Дыырай<br>Уҥа оронугар киирэн тиэрэ түһэн<br>Сыппыта баара.<br>Бу сыппыта сыппытынан<br>Сытар эбит ээ, кини.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5170
                    </td>
                    <td>
                        Бу дьахтар маны<br>Санааргыы-хомойо быһыылаан барда.<br>Били сытар киһи гиэнэ<br>Сирэйин ыраас сырдык сардаҥата<br>Дьиэтин үрэллибэт үрүҥ көмүс үрдүгэр<br>Үс үрүҥ көмүс <span class="description" id="1303">бүлүүсэ</span> курдук<br>Сирэйин күлүгэ үҥкүүлүү турар эбит.<br>Буурдук үтүө киһи эбит.<br>Маны көрөн баран<br>Бу дьахтар киһи ытыы-соҥуу олордо,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5180
                    </td>
                    <td>
                        Ыллыы-туойа былаастаата:<br>— Дьэ буо! Мин эрэйдээх<br>Кыыс оҕо төрөөммүн<br>Отто дойду онолҕонноох оҕото<br>Түбэспит эбит,<br>Ол түбэспитин сириксэн буолан<br>Силлэҥнээн сылдьыбыт<br>Аанай абам, туонай сүптүм<br>Баар да эбит, оҕолоор!<br>Мин эрэйдээх аны биирдэ төрөөммүн
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5190
                    </td>
                    <td>
                        Кыыс оҕо буоламмын,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5191
                    </td>
                    <td>
                        Саманнык үтүө киһини<br>Күн дьүөгэлэнэммин,<br>Көмүс доҕордономмун<br>Сыдьдьыам баара дуо?!<br>Бу күн дьүөгэбин<br>Муҥ саатар сымнаҕас оттоох<br>Оронун оҥорбут,<br>Сылаас аһын астаан аһаппыт<br>Халыҥ айыылаах,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5200
                    </td>
                    <td>
                        Хараҥа буруйдаах<br>Буоллаҕым дуо, оҕолоор?!<br>Мин эрэйдээх<br>Аны биирдэ төрөөммүн<br>Саманнык үтүө киһини<br>Тэллэххэ сытар тэҥнээх кэргэним диэммин<br>Сэргэстэһэн сылдьыам дуо, оҕолоор?!<br>Мин эрэйдээх<br>Кыыс оҕо буоламмын<br>Аны биирдэ төрөөммүн,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5210
                    </td>
                    <td>
                        Саманнык үтүө киһини<br>Хоойго сытар холоонноох доҕорум диэммин<br>Холонон сылдьыам дуо, оҕолоор?!<br>Мин эрэйдээх<br>Саманнык үтүө киһини<br>Суон баараҕай көмүс ньилбэгэр<br>Туора көтөхтөрөн олороммун<br>Уон балыа көмүс тарбахтарын<br>Таптаһа, кэпсэтэ олорбут<br>Халыҥ айыылаах, хараҥа буруйдаах
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5220
                    </td>
                    <td>
                        Буоллаҕым баҕас дуо?!
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5221
                    </td>
                    <td>
                        Тэҥнээх кэргэним диэммин<br>Кэриҥнээх киэҥ ороҥҥо<br>Кэккэлэһэн сытан турбут<br>Халыҥ айыым, хараҥа буруйум<br>Суох буолбута хомолтотун даа, оҕолоор! — дии олордо.<br>Ити диэн баран тура эккирээн<br>Таһардьа сүүрэн таҕыста.<br>Таһардьа араҕас ампаардарын<br>Аанын арыйа баттаата,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5230
                    </td>
                    <td>
                        Ампаарын иһигэр көтөн түстэ,<br>Кыталык кыыл кынатын силиитин<br>Кыдьымахтаан киллэрдэ,<br>Туруйа кыыл сототун силиитин<br>Муньньан киллэрдэ,<br>Таба, тайах сыатыттан<br>Хайыта быһан киллэрдэ,<br>Эһэ сыатынан элбэтэн киллэрдэ,<br>Олгуйга уулаата,<br>Уокка уурда,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5240
                    </td>
                    <td>
                        Ууллара баттаата.<br>Били Дыырай бухатыыр аттыгар<br>Марайа-марайа көтөҕөн аҕалла,<br>Куба кыыл <span class="description" id="1304">хотоҕой</span> <span class="description" id="1305">куоссунун</span> <br>Уһула тыытан ылла,<br>Били арыытын-сыатын<br>Дыырай бухатыыр айаҕар<br>Аҕала-аҕала кута сатыыр,<br>Аҕала-аҕала аһата сатыыр.<br>Өлө да сытара биллибэт,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5250
                    </td>
                    <td>
                        Утуйа да сытарын кыайан быһаарбат.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5251
                    </td>
                    <td>
                        Били быарын туһунан<br>Ох курдаттыы көтөн тахсыбыт бааһа баарынан<br>Бии куба кыыл хотоҕойунан<br>Уунуохтуу олордо.<br>Бу олордоҕуна<br>Үс кутуу көмүс үрдэ<br>Үрэллэ түһэргэ дылы гынна,<br>Аҕыс былас аалай солко суһуоҕуттан,<br>Тыҥырахтаах кыыл быһыыта харбаата,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5260
                    </td>
                    <td>
                        Үрэйэ тэппит сиринэн өрө көтүтэн таһаарда,<br>Бэт күүстээхтик көтөн түһэн барда.<br>Ити барбытын кэннэ<br>Ити киһи туран олоро түстэ<br><span class="description" id="1306">Бии</span> бааһа-үүтэ оһон хаалла,<br>Сүрэҕэ өлүөр эбит,<br>Быара тыыннаах,<br>Сиһин үөһэ бүтүн<br>Көҥдөйдөтөн хаалбыт киһи:<br>— һуой, доҕоор, бу тугуй?! — диэтэ да,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5270
                    </td>
                    <td>
                        Олоро түстэ.<br>Били бааһын үүтэ<br>Биэстээх хаччы саҕа<br>Бэргэ баас буолан<br>Мэличчи оһон хаалбыт.<br>Олорон эрэн одуулаан көрдө.<br>Арай иннигэр сыар-арыы<br>Ууламмыта баар, олохпос баар.<br>Били мааҥҥы аҕыс <span class="description" id="1307">былас</span> <br>Аалай солко суһуохтаах
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5280
                    </td>
                    <td>
                        Айталы Куо ханна даа
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5281
                    </td>
                    <td>
                        Суох буолан хаалбыт.<br>«Бай, доҕор, — дии санаата, —<br>Бу дьахтар утуйа дуу,<br>Уҥа дуу сыттахпына,<br>Бу сыаны-арыыны<br>Уулаан миигин кэлэн<br>Эмтии сатыы олорбут эбит ээ.<br>Киһи-сүөһү оҥороору<br>Буонна хайдаҕый, доҕоор,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5290
                    </td>
                    <td>
                        Бу ханна бардаҕай.<br>Өйдөөн өрө көрдө<br>Үс <span class="description" id="1308">үрэллибит</span> үрүҥ көмүс<br>Үрэйэ тэбиллэн хаалбыт суол баар.<br>Уолуйбут киһи быһыытынан<br>Дьиэтиттэн тахса ойон<br>Дьиэтин үрдүгэр ойон тахсан,<br>Көрө-истэ сырытта.<br>Бу сыдьдьан көрбүтэ —<br>Тыҥырахтаах кыыл быһыыта
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5300
                    </td>
                    <td>
                        Хоту дойдуттан кэлбиккэ <span class="description" id="1309">сыаналаата</span>.<br>Үрэллибэт үрүҥ көмүс үрдүн<br><span class="description" id="1310">Дьөлө</span> тэбинэн кэбиһэн баран,<br>Дьахтары суһуоҕуттан кытаахтаан<br>Түспүт сиринэн өрө көтөн тахсыбыт быһыылаах.<br>Хоту диэкки хайыһан<br>Кыыл <span class="description" id="1311">дабыдалын</span> суола тайанан көппүт.<br>Маны көрөн баран<br>Тоҕус тарбаҕын тосту баттаан<br>Туран тойоннуу турда:
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5310
                    </td>
                    <td>
                        — <span class="description" id="1312">Уот татай</span>, оҕолоор.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5311
                    </td>
                    <td>
                        Бу хайа дойдуттан хамсаан<br>Эмиэ туох дойду <span class="description" id="1313">дьуоҕатыттан</span><br>Туран кэлбит бэйэкэлэрэ буолуой, оҕолоор?<br>Бу хотугу дойдуттан<br>Аттаах аймаҕын аннараа өттүттэн,<br>Оҕустаах улууһун уҥуоргу өттүттэн,<br>Уот куптуй куорат хотугу өттүттэн,<br>Бу <span class="description" id="1314">бырах</span> барбыт бырааттаах,<br><span class="description" id="1315">Дьабыыл</span> барбыт дьахтардаах,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5320
                    </td>
                    <td>
                        <span class="description" id="1316">Кый</span>-барбыт кыыстаах,<br><span class="description" id="1317">Сөрүөстүгэс</span> уоллаах,<br><span class="description" id="1318">Өкөр</span> хара дьонноох,<br>Тимир тэмэлээт сылгылаах,<br>Хахай <span class="description" id="1319">буурай</span> ынахтаах,<br><span class="description" id="1320">Харса</span> <span class="description" id="1321">дьайаан</span> <span class="description" id="1322">сибиирдээх</span>,<br>Хаан <span class="description" id="1323">барылыкы</span> <span class="description" id="1324">байхаллаах</span>,<br><span class="description" id="1325">Хатан</span> буурай хонуулаах,<br>Уорааннаах уот муора <span class="description" id="1326">олбохтоох</span>,<br><span class="description" id="1327">Онолҕонноох</span> онолуку дойдулаах,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5330
                    </td>
                    <td>
                        Тимир Хороллообуй ийэлээх.<br>Аан Дуурай бухатыыр аҕалаах,<br>Илин өттүгэр уот <span class="description" id="1328">дуксуй</span> тумустаах,<br>Кэлин өттүгэр кутаа уот<br><span class="description" id="1329">Куйбуур</span> кутуруктаах,<br>Тоҕус тутуу тутум атахтаах<br>Тимир Нуорадьдьын диэн баар сурахтааҕа.<br>Мин диэтэх киһиэхэ<br>Киниттэн атын кыайан-хотон барыам диэн,<br>Быдьдьаан-талаан барар санааны сананан
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5340
                    </td>
                    <td>
                        Кэлиэн сөбө суох кэриҥнээх этэ.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5341
                    </td>
                    <td>
                        Уот татай, оҕолоор!<br>Ити аата эрэйим эбит,<br>Бу аата муҥум буоллаҕа.<br>Аны маны батыһан<br>Кылгас уҥуохпун<br>Ыкка ытыттарыахпар дылы,<br>Суон <span class="description" id="1330">дьоһун</span> уҥуохпун<br>Суор тоҥсуйуор диэри,<br>Биир сымыыт ханна сытыйбатай.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5350
                    </td>
                    <td>
                        Ир суолун ирдээн,<br>Тор суолун тордоон,<br>Суол хааны <span class="description" id="1331">тобулан</span>,<br>Ыллык хааны <span class="description" id="1332">тэлэйэн</span>,<br><span class="description" id="1333">Амнахтаах</span> аартыкпын эмиэ арыйан,<br><span class="description" id="1334">Көмнөхтөөх</span> суолбун көтөҕөн көрдөҕүм.<br><span class="description" id="1335">Аанай абам эбит, туонай сүптүм эбит</span>,— диэтэ.<br>Били мааҥы<br>Тыллаах-өстөөх Хара Кулун атыгар<br>Хап-бааччы хатана баттаан кэбистэ.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5360
                    </td>
                    <td>
                        Үрдүк <span class="description" id="1336">мындаатыгар</span> <br>Үрүҥ чыычаах курдук<br>Өрө ыстанан таххан олоро баттаата.<br>Били <span class="description" id="1337">хаҥырҕастаах</span> <span class="description" id="1338">тиэрбэстээх</span> <br>Аҕыс өлүү салаалаах айыы <span class="description" id="1339">сандырыыһа</span>,<br>Киэҥ халлаан <span class="description" id="1340">сапсылҕана</span> <br><span class="description" id="1341">Айыы далбарҕа кымньыытын</span> <br>Сулбу охсон ылан,<br>Атын киэнин күөс-күөс эти<br><span class="description" id="1342">Көҥүтэ</span> дайбааттаан,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5370
                    </td>
                    <td>
                        Солуур-солуур эти
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5371
                    </td>
                    <td>
                        Сулларыта охсуолаан,<br>Суон уҥуохтарын баһыгар<br>Туруорута саайталаан айаннаата.<br>Үүнэр мас<br>Үрүт өттүнэн көтүттэ,<br>Сыссар былыты<br>Алын кырыытынан сүүрэкэлэттэ.<br>Бэтэрээ өттө<br>Иирээн-мэнэрик сирин
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5380
                    </td>
                    <td>
                        Ийэтэх кырыытыгар түһэн кэбистэ.<br>Ойуун-удаҕан дойдутун<br>Уҥуоргу өттүгэр ойутан тиийдэ,<br>Аптаах-<span class="description" id="1343">дэриэтиньньик</span> сибиирин<br>Аннарааҥы кырыытын ааста,<br>Хотугу дойду буолла,<br>Уорааннаах уот Тумары байхал <span class="description" id="1344">оппуоһа</span> буолла,<br>Иҥсэлээх Иҥэри далай биэрэгэ буолла.<br>Маныаха дылы<br>Сайын диэни <span class="description" id="1345">самыырынан</span> билэр,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5390
                    </td>
                    <td>
                        Кыһын диэни <span class="description" id="1346">кырыатынан</span> билэр,<br>Күһүнү <span class="description" id="1347">өксүөнүнэн</span> көрөр,<br>Сааһы <span class="description" id="1348">хахсаатынан</span> билэр.<br>Эмиэ өр айаннаата быһыылаах.<br>Уот куптуй куорат<br>Хотугу өттүнэн<br><span class="description" id="1349">Куоһаран</span> түһэн истэ.<br>Бу баран иһэн<br>Биир сиргэ көрбүтэ —<br>Уорааннаах уот муора <span class="description" id="1350">туорайдаан</span> кэбистэ.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5400
                    </td>
                    <td>
                        Үрдүнэн көтүтэр биэрэк кыайан көстүбэтэ,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5401
                    </td>
                    <td>
                        Аннынан <span class="description" id="1351">сургуйар</span> сир суох буолла.<br>Хоту баран көрдө —<br>Уһугун булбата,<br>Соҕуруу баран көрдө —<br>Соҕуруу уһугун көрбөтө.<br>Бэри диэн бэркиһии турда,<br>Сөрү диэн сөҕө турда.<br>Бу, былыр аан дойдутугар эрдэҕинэ<br>Бухатыыры өлөрбүтэ-сүтэрбитэ баара,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5410
                    </td>
                    <td>
                        Ол киһи сүрэхтээх быарын көҥдөйүттэн<br>Үс хаһыытыыр хара суор<br>Үөһээ дойдуга үөһээ көппүттэрэ,<br>Онтон икки бастакы суор<br>Икки төгүллээн<br>Икки төгүл <span class="description" id="1352">буом-боһол</span> буола сылдьыбыттара.<br>Абынан тоһуйан<br>Албаһынан көрсөн сылдьыбыттарын<br>Ааһыталаан хаалбыттара баара.<br>Маны саныы түстэ, бу туран:
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5420
                    </td>
                    <td>
                        — Уот татай, оҕолоор!<br>Үс суор буолан куоппуттара,<br>Кэнники суора обургу,<br>Ааһар албаһа,<br>Куотар <span class="description" id="1353">кулан</span> кубулҕата<br>Субу буолара дуу?<br>Бу уорааннаах уот байҕал иччитэ<br>Соруйан бу <span class="description" id="1354">боһойдоотоҕо</span> дуу,<br>Уот байҕал иччитэ диэн<br>Бэлэхтэ биэрэн көрүөххэ дуу? — дии санаата.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5430
                    </td>
                    <td>
                        Ити гынан баран
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5431
                    </td>
                    <td>
                        Атыттан түһэ эккирээтэ,<br>Сиэллээх кутуругуттан үс <span class="description" id="1355">сүүмэх</span> кылы<br>Ойо тардан ылла,<br>Уорааннаах уот байҕал диэкки далбаатыы турда<br>Бу далбаатыы туран:<br>— Дьиэ-буо!<br>Уорааннаах уот муора иччитэ,<br><span class="description" id="1356">Уохтаах кылыннаах</span> <br>Отурулла ойун обургу,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5440
                    </td>
                    <td>
                        Дьэй эрэ, мин диэтэх киһи<br>Биэс тарбаҕым биэриитэ,<br>Уон тарбаҕым уунуута буолар күнэ кэллэ.<br>Хара тыа оттотунан<br>Ыллыктаах буолуох тустаах,<br>Дириҥ далай оттотунан<br>Биэрэктээх буолуох кэриҥнээх,<br>Аһаҕас аартыгы арыйан биэрдэргин —<br>Айаннаан көрүөм этэ,<br>Көҥдөй оппуоһу көҥүллээн биэрдэргин —
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5450
                    </td>
                    <td>
                        Күүлэйдээн таххыам этэ.<br>Алтан талаһаҕын<br>Анаан тардан биэрдэргин,<br>Көмүс талаһаны<br>Ууран тутан биэрдэргин.<br>Күн улууһугар<br>Күн улууһа киһи,<br>Онон эйигиттэн көҥүлү көрдөһө<br><span class="description" id="1357">Күртүөннээх</span> биэриим<br>Үс хара <span class="description" id="1358">маҥаас</span> 
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5460
                    </td>
                    <td>
                        Атыыр оҕус сүөһүнү
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5461
                    </td>
                    <td>
                        Бэлэх быраҕар күнүм буолла, — диэн баран,<br>Үс сүүмэх кылы ылан бырахта.<br>Маны бу уот муора<br><span class="description" id="1359">Күлүбүрэччи</span> салаан кэбиһэн баран,<br><span class="description" id="1360">Буукса</span> күүһүрэн убайда.<br>Итинтэн сэрэйэн өйдөннө ити киһи:<br>— Хоҥкуйар хоолдьугар дылы<br>Суоракка уган ылбыт курдук<br>Балай маҥаас өлүү <span class="description" id="1361">харгыйа</span> 
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5470
                    </td>
                    <td>
                        Хара суорун албаһа эбит буоллаҕа, — диэтэ.<br>Оччоҕуна айаҕымсах буолуох тустаах,<br>Маны өлөрөр-сүтэрэр эбит буолта буоллар,<br>Ааһар албастара бараныа этэ», — дии санаата.<br>Итигирдик дии санаан баран,<br>Этэ-саҥара, эҕэрдэлии-куоластыы,<br>Ыллыы-туойа турда.<br>Маҥнайгы хоһооно маннык:<br>— Үс өлүү хараарар хара <span class="description" id="1362">дьаҥсах</span> кыыла<br>Эргичийэн көрөр уоттаах
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5480
                    </td>
                    <td>
                        Эриэн моҕой кыыла обургу,<br>Чэй эрэ, эн айаххар аналлаах,<br>Эн суон куолайгар оҥоһуулаах,<br><span class="description" id="1363">Сымара</span> таас куттаххар<br>Сытыйа кэлбит<br>Тыллаах-өстөөх Хара Кулун аттаах<br>Сылгы уола Дыырай бухатыыр<br>Күн киһитэ ханна көтүөмүй,<br>Айыы киһитэ ханна ааһыамый,<br>Аллараа сыҥааххын аллараа дойдуга
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5490
                    </td>
                    <td>
                        Таҥнары <span class="description" id="1364">намылытан</span> түһэр эрэ,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5491
                    </td>
                    <td>
                        Үөһээ <span class="description" id="1365">чөмчөкөҕүн</span> үөһээ<br>Үрдүк хара аартыгын<br>Үөмэр үрдүк мындаатыгар<br>Өрө аньньан таһаараҥҥын<br>Күлүүстээн тут эрэ.<br>Дьэ айаххын ат,<br>Хараххын көр,<br>Мин диэтэх киһи аттыын бэйэлиин<br>Сыр гынар сыалаах,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5500
                    </td>
                    <td>
                        Хар гынар хара хааннаах<br>Албан дьаһах ааттаах киһи кэллим.<br>Биэс уон <span class="description" id="1366">билир</span> тиискэр,<br>Бэргэһэ буолар киһибин,<br>Уон <span class="description" id="1367">одулуун</span> хара тиискэр,<br><span class="description" id="1368">Уурумдьу</span> отто дойду уйгута<br>Бэйэбинэн оҥоһуллан кэллим,<br>Дьэ, кытаат эрэ! — диэтэ.<br>Били умайа турар уот муора<br>Баһыттан атаҕыттан
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5510
                    </td>
                    <td>
                        <span class="description" id="1369">Бардьыгыначчы</span> умулларга дылы гынна,<br>Хаһыытаан <span class="description" id="1370">хабырынар</span> <br>Харгыйа хаан аартык айаҕын саҕа<br>Айах быһыыта арылынна.<br>Маны көрөн баран<br>Биһиги киһибит аттыын бэйэлиин<br>Үс күннүк сиргэ<br>Кэннинэн <span class="description" id="1371">чугуруйан</span> турда.<br>Бу туран баран<br>Хаһыытыы-<span class="description" id="1372">үөгүлүү</span> түстэ.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5520
                    </td>
                    <td>
                        <span class="description" id="1373">Үлүскэннээх</span> үлүгэрдик <span class="description" id="1374">үүнүн</span> тутуста,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5521
                    </td>
                    <td>
                        Хатан үлүгэрдик хаһыытыы түстэ.<br>Атын кытаанахтык <span class="description" id="1375">кымньыылаата</span>.<br>Ат ол дойду сытар ынах саҕа<br>Сымара тааһыттан тэбинэн кэбистэ,<br>Күрбүү көмүс кынатын<br>Кыптыыйдаан кэбистэ,<br>Били кыыл айаҕын үүтүн устун баран<br>Аттыын бэйэлиин сулбу ойон түстүлэр.<br>Түстүлэр да, куртаҕын түгэҕиттэн иҥиннилэр.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5530
                    </td>
                    <td>
                        Маныаха бу кыыл<br>Үөһээ-аллараа сыҥааҕын <span class="description" id="1376">төлүтэ</span> түһэттээн<br>Аттаах киһини ыстыах буолбута,<br>Аннараатах диэкки ааһан хаалбыттар эбит ээ,<br>Сыҥааҕын тыаһа<br>Икки <span class="description" id="1377">суоруна</span> таас хайа<br>Утарыта быстан түспүтүн курдук<br>«Лаас» гына сыыһа ыстаан кэбистэ,<br>Кураанаҕы ытыран хаалла.<br>Бу киһи бу киирэн
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5540
                    </td>
                    <td>
                        Саар булгуньньах курдук<br>Сарайа тыыллан барда,<br>Туой булгуньньах курдук<br>Туолла үллэн таҕыста.<br>Аттыын бэйэлиин улааттылар,<br>Били эриэн моҕой кыыл да буоллар,<br><span class="description" id="1378">Киспэтэ</span> туолан барда,<br><span class="description" id="1379">Кэриҥ</span> бодото кыараан барда,<br>Тыына-быара кылгаан истэ.<br><span class="description" id="1380">Өөҕүргүү-өөҕүргүү</span> төттөрү таһаараары
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5550
                    </td>
                    <td>
                        <span class="description" id="1381">Кулгуйан</span> хотуолаан көрдө.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5551
                    </td>
                    <td>
                        Туох да иһин бэттэх диэкки биллибэт дьон буоллулар,<br><span class="description" id="1382">Түрдэстэ</span> түһэ-түһэ<br>Эмэһэтинэн <span class="description" id="1383">үннэ</span> сатаата,<br>Туох да иһин кэннин диэкки<br>Кэлбэт дьон буоллулар.<br>Субу сыдьдьан<br>Сэттэ <span class="description" id="1384">болгуоттан</span> <span class="description" id="1385">чээрэлээн</span> ылбыт,<br><span class="description" id="1386">Кыын</span> быатын быһыта сүүрэ сылдьар,<br>Тэриэккэлээх эти сэттэтэ эргийэр
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5560
                    </td>
                    <td>
                        Быһыйа быһахтаах этэ,<br>Мантыкатын сулбу <span class="description" id="1387">сүүдүйэ</span> баттаан ылла,<br>Иһин-үөһүн<br>Тута-тута турута быһа сырытта.<br>Кини да буоллар<br>Ис өттүгэр сүрэхтээх быардаах эбит,<br>Сүрэҕин оттотунан туора быһан ылла,<br>Хараарар хара быарын<br>Хайа баттаан кэбистэ,<br><span class="description" id="1388">Чиккэйэр</span> сиһин үөһүн
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5570
                    </td>
                    <td>
                        Оттотунан быһа баттаан кэбистэ,<br>Өлөн хаалла.<br>Сир сиринэн буола түстэ,<br>Дойду дойдунан буола түстэ,<br>Уот муора диэн ханна да суох эбит.<br>Итини ааһан<br>Түгэҕэ биллибэт Түмэри байҕал<br>Устата биллибэт Уот муора<br>Биэрэгэр тиийдэ да,<br>Итиннэ тиийэн хааттаран хаалан
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5580
                    </td>
                    <td>
                        Эргийэ хаамтара сырытта эмиэ.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5581
                    </td>
                    <td>
                        Бу сырыттаҕына<br>Үөһээ былыт быыһын диэкки<br>Бэт куһаҕан саҥалаах<br>Киһи саҥата саҥарар.<br>— <span class="description" id="1389">Эчикээйиэм, эчикээйиэм</span>,<br>Сэттэ уон <span class="description" id="1390">эйиэн</span> эйиэхсит<br>Киирэр биэрэгэр дьиэлээх,<br>Аҕыс уон айгыстар айыыһыт<br>Дьаарбаҥын айаҕар <span class="description" id="1391">арҕахтаах</span>, 
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5590
                    </td>
                    <td>
                        Тоҕус уон <span class="description" id="1392">суккуллан</span> түһэр<br>Хотой иэйээхсит<br>Оппуоһун ааныгар олоҕурбут,<br>Тыллаах-өстөөх Хара Кулун аттаах<br>Сылгы уола Дыырай бухатыыр,<br>Отто оҥоһуулаах дойдутун<br>Букатын төрөөбүт буолунай бухатыыра,<br>Тойокоом, тойокоом, тохтоо-болҕой эрэ!<br>Мин диэтэх киһини<br>Кимҥиний-хайаҕыный диэтэргин,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5600
                    </td>
                    <td>
                        Сэттэ ырыалаах былыт кыыһа<br>Ырыа Бээбийдээн мин буолабын.<br>Былыргы дьылга, урукку хонукка<br>Сүрдээх сүүнэ Сүҥ Дьааһын бухатыыр<br><span class="description" id="1393">Сүлдьүүлээх</span> сүрэхтээх быарын<br>Хостуу тардан ылаҥҥын<br>Албан ааппын ааттаабытыҥ,<br>Дьоһун сурахпын сураҕалаабытыҥ.<br>Мааны-күндү оҥороҥҥун<br>Үөһээ дойдуга айахпар быраҕан биэрбитиҥ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5610
                    </td>
                    <td>
                        Куурбут тумуспун уунуохтаабытыҥ,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5611
                    </td>
                    <td>
                        Хатырбыт айахпын <span class="description" id="1394">ньалҕарыппытыҥ</span>,<br>Луо-хаан куртаҕым буолугуйбута.<br>Сири-хаан куртаҕым <span class="description" id="1395">сириэдийбитэ</span>.<br>Ол үтүөтүгэр оҕобор, эйиэхэҕэ, этэн биэрэбин:<br>Уорааннаах уот байҕал биэрэгин туппут<br>Уоттаах Отурулла ойун обургу<br>Тоҕус уон мастаах <span class="description" id="1396">оҥочо</span> оҥостунан<br>Билигин киһини туораппыта,<br>Ону кэтэс.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5620
                    </td>
                    <td>
                        Тыллаах-өстөөх Хара Кулун аккын<br>Аан дойдугар бар диэҥҥин<br>Атааран кэбиһэ тат.<br>Ол атааран бараҥҥын<br>Отурулла ойун оҥочотугар олороҥҥун<br>Уҥуоргу биэрэгин булан көр эрэ.<br>Ол буллаххына<br>Тоҕус былас<br>Уот <span class="description" id="1397">дуксуур</span> тумустаах,<br>Сэттэ уон былас
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5630
                    </td>
                    <td>
                        Тимир дэлэкиир кынаттаах,<br>Отут быластаах<br>Кутаа уот <span class="description" id="1398">сугсурҕа</span> кутуруктаах<br>Тимир Нуорадьдьын бухатыыр<br>Олорор оппуоһа диэн<br>Тимир <span class="description" id="1399">күкүр таас</span> хайа үрдүгэр<br>Бур-бур буруо тахсыаҕа.<br>Эн диэтэх киһи,<br>Куотар <span class="description" id="1400">кубулҕат</span> бэйэҥ киэнэ буоллаҕа,<br>Ааһар албас обургу баһын билиэ дии саныыбын,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5640
                    </td>
                    <td>
                        Ириҥэ мэйиилээх
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5641
                    </td>
                    <td>
                        Иэдьигэй эттээх,<br>Тохтор <span class="description" id="1401">субай</span> хааннаах<br>Отто дойду оҕото<br>Утары көрөн туран<br>Кыайан охсуспатах киһитэ,<br>Бэйэҕин бэйэҥ билин.<br>Өрөгөй бөҕөҥ үрдээтин!<br>Соргу бөҕөҥ улааттын!<br>Алгыһым тиийдин,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5650
                    </td>
                    <td>
                        Мин диэтэх киһи<br>Инним-кэнним биллибэт.<br>Саныырым эрэ айаҕым иннэ,<br><span class="description" id="1402">Куудьуйарым</span> эрэ куолайым уунуоҕа.<br>Кэнэҕэһин кэнэҕэс<br>Кыайдаххына-хоттоххуна,<br>Биирдэ эмэтэ биэрэриҥ курдук<br>Биэрэр буолаар эрэ,<br>Быдан <span class="description" id="1403">тэгэл</span> быралыччы бырастыы! — диэтэ.<br>Ити киһи итини истэн баран
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5660
                    </td>
                    <td>
                        Атыттан түһэ эккирээтэ,<br>Атын сиэллээх кутуругуттан<br>Үс сүүмэх кылы тарыы тардан ылан<br>Хаҥас <span class="description" id="1404">хармааныгар</span> аньньан кэбистэ.<br>— Дьиэ-буо!<br>Дьоллоох соргулаах <span class="description" id="1405">соноҕоһум</span> оҕотоо,<br><span class="description" id="1406">Аҕыс иилээх-саҕалаах</span>,<br><span class="description" id="1407">Атааннаах-мөҥүөннээх</span> <br><span class="description" id="1408">Амыл-намыл</span> алааскар,<br><span class="description" id="1409">Айгыр-силик</span> <span class="description" id="1410">алаһаҕар</span> 
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5670
                    </td>
                    <td>
                        Айаннаан тиийэр буолаар.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5671
                    </td>
                    <td>
                        Хараҕыҥ уччуххайданнын,<br>Харыҥ быччыҥнаннын,<br>Хара сиэлиҥ <span class="description" id="1411">ханыыластын</span>,<br>Оҥочо көмүс кутуругуҥ доҕордостун,<br>Хат <span class="description" id="1412">таманнан</span>,<br>Халыҥ хаһалан,<br>Суон <span class="description" id="1413">сааллан</span>!<br>Быралыччы бырастыы! — диэн баран<br>Атынаан уурастылар, сылластылар.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5680
                    </td>
                    <td>
                        Атын ыытан кэбистэ.<br>Ити уорааннаах уот муораны<br><span class="description" id="1414">Халааньньы</span> хаама сырытта.<br>Бу сыдьдьан иһиттэҕинэ<br>Уу тыаһа диэн <span class="description" id="1415">күллүргэс</span>,<br><span class="description" id="1416">Эрдии</span> тыаһа <span class="description" id="1417">тиҥиргэс</span>,<br>Оҥочотугар олорбут <span class="description" id="1418">лиэһэй</span> киһи<br><span class="description" id="1419">Килэрийэр</span> бэрдин курдук,<br>Адьарай киһи атамаан бэрдин курдук,<br>Оҥочото син икки өттүнэн эрдиилээх быһыылаах.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5690
                    </td>
                    <td>
                        Икки эрдии тутааҕын<br>Соҕотох хомуһуннаах <span class="description" id="1420">куорай далаан</span> ытыһынан<br>Бобуччу туппут.<br>Эрдэн <span class="description" id="1421">тиҥийэн-таҥыйан</span> иһэр ээ киһи бөҕө.<br>Бу иһэн соҕотох да буоллар саҥара-иҥэрэ иһэр:<br>— һуой-һуой, һуот-татай, оҕолоор!<br>Бу <span class="description" id="1422">идэмэрдээх</span> илин халлаан уола,<br>Ыйдаҥалаах ытык халлаан ыччата,<br>Буолунай бухатыыра<br>Тимир Нуорадьдьыны туораттым эбээт, доҕоор!
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5700
                    </td>
                    <td>
                        Бу <span class="description" id="1423">баҕадьыкаан</span> киий диэн
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5701
                    </td>
                    <td>
                        Кокуоска эрэйбэт киһи.<br>Бэйикэй-бэйикэй!<br>Төннөр күннээх буоллаххына,<br>Эн да буолларгын,<br>Ыар дьыппа тылы этиэҕим,<br>Ыарахан санааны саныаҕым.<br>Куурбут тумсубун уунуохтаабат,<br>Хатырбыт айахпын ньулҕарыппат<br>Бу үлүгэр уорааннаах уот муораҕа
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5710
                    </td>
                    <td>
                        Күнүстэри-түүннэри сыдьдьар эрэйдээххэ<br>Тугу да билбэккэ<br>Бэрээдэгэ суох сылдьалларыттан<br>Ойоҕоһо да тостубат,<br>Сырайа да сааппат,<br>Былыр-былыргыттан<br>Кини бэйэлээх киһи<br>Сырытта эни, сыдьдьыбата эни.<br>Иньньэ диир саҥа баар,<br>Туох да бокуой суох
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5720
                    </td>
                    <td>
                        Эрдэн <span class="description" id="1424">баллырҕатан</span>,<br>Уун-утары бу тиийэн кэллэ.<br>Бу кэлэн оппуоһугар утары<br>Аньньынан кэбиһэн баран<br>Бу курдук диэн саҥалаах:<br>— <span class="description" id="1425">һой-буйака</span>,<br>Киирэр иэйиэхсит биэрэгэр дьиэлээх,<br>Тахсар айыыһыт дьаарбаҥар арҕахтаах,<br>Суккуллан түһэр хотой иэйиэхсит<br>Оппуоһугар олохтоох,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5730
                    </td>
                    <td>
                        Тыллаах-өстөөх Хара Кулун аттаах
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5731
                    </td>
                    <td>
                        Сылгы уола Дыырай бухатыыр,<br>Туспа дойду <span class="description" id="1426">кулубата</span>,<br>Атын <span class="description" id="1427">аркыыба</span> аҕата,<br><span class="description" id="1428">Чиэски</span> сибиир кинээһэ,<br>Дорообо бокулуон, доҕоор!<br>Ким дорооболостуҥ диэтэргин,<br>Уорааннаах уот муора иччитэ<br>Уот Кудулу эмээхсин ийэлээх этим,<br>Хаан-байҕал иччитэ буолбут
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5740
                    </td>
                    <td>
                        Аан Дуурай оҕоньньор аҕалаах баарым,<br>Бэйэм буоллахпына<br>Аан Дуурай оҕоньньор улахан уола<br>Уот муора биэрэгин кэтииргэ,<br>Кэлбиттэн бэриһиннэрэн аһыырга<br>Аналламмыт киһи этим,<br>Уот муора оппуоһун тутарга<br>Оҥоһуллубут киһибин.<br>Маны ким оҥорбутай диэтэргин,<br>Аҕыс бииһин ууһун
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5750
                    </td>
                    <td>
                        Баһын билбит,<br>Тоҕус бииһин ууһун<br>Сокуонун туппут,<br><span class="description" id="1429">Дьулурҕаннаах</span> <span class="description" id="1430">дьулурҕа</span> хара диэн<br>Үҥэр муоспут,<br>Күлэр <span class="description" id="1431">сүньньүбүт</span> <br>Анаан-минээн ыыппыт киһилэрэбин.<br>Дьэ, доҕоор,<br>Айыы сирин<br>Ааттаах киһитэ буоллаҕыҥ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5760
                    </td>
                    <td>
                        Күн улууһун
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5761
                    </td>
                    <td>
                        <span class="description" id="1432">Күөгэйэр</span> үтүөтэ буоллаҕыҥ,<br>Күлэр сүньньүн туппут<br>Күөгэйэр үтүөтэ сурахтааҕыҥ,<br>Туохтааххыный-ханныктааххыный,<br>Айахха быраҕан биэрэр<br>Астаах киһи буолаайаҕын,<br>Күөмэйгэ быраҕар<br>Үтүө <span class="description" id="1433">үптээх</span> киһи буолаайаҕын,<br>Аҕыс саха ааттаахтара,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5770
                    </td>
                    <td>
                        Тоҕус саха туйгуннара<br>Кэллилэр-бардылар эминэ тугуй,<br>Айыытын аймаҕа аһаталлар этэ,<br>Абааһытын аймаҕыттан<br>Абааһыта аҕыйах буолуо,<br>Тугу да сиэбэтэҕим сэттэ хонно,<br>Адьас аһаабатаҕым аҕыс хонно, — диэн баран<br>Илиитин тоһуйар,<br>Илиитэ соҕотох этэ буолан баран,<br>Үс <span class="description" id="1434">сүргүөхтээх</span> тимир <span class="description" id="1435">сөмүйэтин</span> 
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5780
                    </td>
                    <td>
                        <span class="description" id="1436">Сарбас</span> гына уунна.<br>Онуоха биһиги киһибит<br>Тыллаах-өстөөх буола турда:<br>— Дьэ-буо,<br>Мин диэтэх киһи эн обургуга<br>Хайдах кураанах сыдьдьыахпыный,<br>Биэрэк бэрдэ буоллаҕыҥ дии,<br>Уон тарбахпынан<br>Уунар күнүм буолла,<br>Биэс тарбахпынан
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5790
                    </td>
                    <td>
                        Биэрэр күнүм буолла,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5791
                    </td>
                    <td>
                        Үс хара маҥаас атыыр оҕус сүөһүнү<br>Эйиэхэ айаххар анаан аҕаллым,<br>Биэрэги чиэрэстээрэй диэммин,<br>Муораны уҥуордаарай диэммин,<br>Эн диэтэх киһиэхэ<br>Үс үҥэр хара күлүккэр<br>Үҥэн-сүктэн<br><span class="description" id="1437">Сүгүрүйэ-боҕуйа</span> турабын.<br>Дьэ илиигин уун,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5800
                    </td>
                    <td>
                        Хараххын көр.<br>Сотоҥ <span class="description" id="1438">мадьайыар</span> дылы,<br>Түөһүҥ <span class="description" id="1439">мөтөйүөр</span> дылы,<br>Төгүрүк ытыспынан<br><span class="description" id="1440">Түөрэхтиир</span> кэриэтэ,<br><span class="description" id="1441">Кэттэгэй</span> ытыспынан<br>Кэбиһэн эрэбин, — диэн баран,<br>Хаҥас илиитинэн<br>Хаҥас <span class="description" id="1442">хаппарыттан</span> ылан<br>Үс сүүмэх <span class="description" id="1443">кылы</span> ылан,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5810
                    </td>
                    <td>
                        «Үс хара маҥаас<br>Атыыр оҕус буол» — диэн<br>Абааһы киһиэхэ ылан бырахта.<br>Ол баран түөһүгэр түстэ,<br>Үс дьүһүннээх сүөһү буолан<br>Түөһүгэр көтөҕүллэ түстэ.<br>Баран били сүөһүтүн<br>Көтөхпүтүнэн олоро түстэ.<br>Дьэ аһаата-сиэтэ,<br>Элэдэһин-дуоһун ыйыһынна,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5820
                    </td>
                    <td>
                        <span class="description" id="1444">Элэй-балай</span> ыстаата,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5821
                    </td>
                    <td>
                        Бэрт өр гыммата —<br>Сотору бүтэрдэ:<br>«Тойокоом, тойокоом!<br>Оҥочоҕо киирэн олор эрэ!» — диэтэ.<br>Бэйэтэ оҥочобут хаба оттотугар олорон кэбистэ,<br>Бэйэтэ оттотунан <span class="description" id="1445">иэччэхтээх</span> эрдиитин<br>Куорай далаан ытыһынан хомуйа тутта.<br>Дьэ эрдэн тиҥиргэтии да таҥырҕатыы буолла,<br>Улуу муора уута
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5830
                    </td>
                    <td>
                        <span class="description" id="1446">Түллэҥниэр</span> дылы тардар эбит,<br>Аан дойдутун уутун <span class="description" id="1447">дьаккылдьытта</span>,<br>Муора уута <span class="description" id="1448">барылас</span> буолла,<br>Эрдии тыаһа тиҥинэс буолла.<br>Били баҕадьы көхсүн тыаһа<br>Тиҥиргэччи ынчыктаан татта,<br>Дьэ таҥнары тиҥийэн<br>Туһааннаах тус хоту диэкки бара турда.<br>Уҥуоргу өттүгэр,<br>Алдьархайдаах аартыгар,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5840
                    </td>
                    <td>
                        <span class="description" id="1449">Содуомнаах</span> оппуоһугар,<br>Иэдээннээх биэрэгэр<br>Оҥочотун тиийэн хантаччы астаран кэбистэ.<br>Маныаха биһи киһибит<br>Биэрэгэр ыстанан таҕыста.<br>Оҥочотугар олорбутунан эрэн<br>Бу абааһы киһитэ<br>Саҥалаах-иҥэлээх буола олордо:<br>— Һыат-татай, эминэ тугуй, оҕолоор,<br>Улаатыгар, улаатыгар, оҕолоор,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5850
                    </td>
                    <td>
                        Тыллаах-өстөөх Хара Кулун аттаах
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5851
                    </td>
                    <td>
                        Сылгы уола Дыырай бухатыыр,<br>Тойонноотор тойонуом,<br>Оҕолоотор оҕом,<br>Дьэ эрэ, өрөгөйүҥ үрдээтин,<br><span class="description" id="1450">Талаан</span> бөҕөҥ көтөҕүлүннүн!<br>Тоҕус саһааннаах<br>Уот Хороллоомуй эмээхсин ийэлээх,<br>Адьарай бастыҥа<br>Тимир Хомурдуостай оҕоньньор аҕалаах,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5860
                    </td>
                    <td>
                        Илин өттүгэр үс быластаах<br>Кутаа уот куорма кутуруктаах,<br>Тоҕус тутум атахтаах<br>Тимир Нуоралдьын бухатыыры<br>Былыр-былыргыттан<br>Оҥорбут айыытыгар<br>Сэтэ-сэлээнэ сиппитэ буолуо дии саныыбын.<br><span class="description" id="1451">Сэмэтэ-суҥхата</span> туолбута буолуо,<br>Күн улууһун <span class="description" id="1452">күөмчүлээбит</span> күтүр этэ,<br>Айыы улууһун атаҕастаабыт баҕадьы этэ.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5870
                    </td>
                    <td>
                        Былыр-былыргыттан<br>Мин эрэйдээҕи<br>Иннигэр-кэннигэр<br>Илби-салбы көтүттэ ини,<br>Бухатыырынан <span class="description" id="1453">дьулатан</span>,<br>Күүһүнэн куттаан<br>Көҥүлүнэн сырытта ини,<br><span class="description" id="1454">Кэҥсэ</span> эрэйдээх —<br>Кэтэһэ сатаабытым этэ да,<br>Күн бүгүнүгэр дылы
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5880
                    </td>
                    <td>
                        Кэбиһэн биэрэ илик,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5881
                    </td>
                    <td>
                        Манаһа сатаатым да,<br>Маарыҥҥыга дылы<br>Быраҕан биэрэ илик,<br>Оттотуттан охсоммун<br>Киһи уйадыппат киһитэ буолуо,<br>Анныттан алдьатаҥҥын<br>Хайаҕаһы булуоҥ суоҕа,<br>Дьэ, сэгэттэйим,<br>Мин тугу билиэмий,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5890
                    </td>
                    <td>
                        Бэйэҕин бэйэҥ билин,<br>Быралыччы бырастыы,<br>Төннөргөр киһи буоллаххына,<br>Миигиннэн да кэллэххинэ,<br>Хас көрдөҕүм аайы<br>Ас көрдүөм суоҕа — диэтэ.<br>Биһи киһибит<br>Тус хоту диэкки<br>Илэ бэйэтинэн сүүрдэ,<br>Бу сүүрэн иһэн
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5900
                    </td>
                    <td>
                        Хоту диэкки өйдөөн көрөн истэ,<br>Көҕөрөр күөх муора<br>Хабыллар хаба оттотуттан быһыылаах,<br>Сүрдээх сүүнэ улахан<br>Күтүр таас хайа<br>Өрө үүнэн тахсан турара баар эбит.<br>Хабыллар хаба оттотунан<br>Үөһээ <span class="description" id="1455">таллан таас</span> буурай оройо<br>Хайа ыстаммыкка дылы буолан көстөр.<br>Маны көрбүтэ —
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5910
                    </td>
                    <td>
                        Сүрдээх куһаҕан хап-хара,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5911
                    </td>
                    <td>
                        Сүрдээх хара дьүһүннээх <span class="description" id="1456">төлөн</span>,<br>Хара буруо <span class="description" id="1457">күдээрийэн</span> тахсарга дылы гынар.<br>Маны көрөн баран<br>Биһиги киһибит<br>Бу Тимир Нуоралдьын обургу<br>Күлэр хара <span class="description" id="1458">уоруга</span> <br>Субу олордоҕо дии диэтэ,<br>Үҥкүрүс гына түстэ,<br>Күөлэһис гына түстэ.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5920
                    </td>
                    <td>
                        Аҥаарыйар атыыр <span class="description" id="1459">өксөкү кыыл</span> <br>Аҥаарыйар бастыҥ үтүө дьүһүннээҕэ буолан,<br>Үөһээ дойду диэкки<br>Суксурҕа хара халлаанын<br>Өрө көтөн <span class="description" id="1460">дьирибинэйэн</span> таҕыста.<br>Били хара <span class="description" id="1461">күдэн</span> буруо<br>Хабыллар хаба оттотунан<br>Кынатын кыптыыйдыы тутан кэбиһэн баран<br>Суос-соҕотохто <span class="description" id="1462">үөлэһин</span> <span class="description" id="1463">үүтүнэн</span> <br>Таҥнары <span class="description" id="1464">сурулаан</span> түстэ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5930
                    </td>
                    <td>
                        Тимир <span class="description" id="1465">килэҥсэ</span> дьиэтигэр көтөн түстэ.<br>Бу киирэн бэйэтэ-бэйэтинэн буола түстэ.<br>Бу киирэн көрбүтэ —<br>Аҕыс былас суһуохтаах Айталы Куону<br>Тимир быаннан оттотунан быһа курдаан,<br>Тимир килэҥсэ истиэнэтигэр<br>Тимир быаннан эпсэри кэлгийэн кээспит.<br>Дьэ, манна<br>Икки айыы киһитэ көссүһэ түстүлэр.<br>Биһи киһибит эттэ:
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5940
                    </td>
                    <td>
                        — Дьэ, доҕоор,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5941
                    </td>
                    <td>
                        Урут кэлэн билбит-көрбүт киһи<br>Сүбэлээ-соргулаа, хайтах гынабыт?»<br>Сүүс киһи сүбэтэ диэн сүбэлэһэ олордулар,<br>Отут киһи соргута диэн<br>Соргулаһа олордулар.<br>Биһи киһибит<br>Дьахтары кэлгийбит быаларын тууран,<br>Быһыта тыытан кэбиһээри гынна.<br>«Дьэ бэйи, тохтоо эрэ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5950
                    </td>
                    <td>
                        Мантыкатын быһыта тыытан кэбистэхпитинэ,<br>Сатаан кэпсэтиэхпит суоҕа.<br>Ириҥэ мэйиилээх,<br>Иэдьэгэй эттээх,<br>Иэгэйэр икки атахтаах,<br>Отто дойду киһитэ<br>Кыайан сатаан,<br>Тэҥнэһэн сэндэйдэһэн охсуспатах<br>Киһитэ быһыылаах эбит.<br>Маны биһиги куотан даҕаны,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5960
                    </td>
                    <td>
                        Саһан даҕаны<br>Харыс устата<br><span class="description" id="1466">Халбарыйар</span> сирбит суох быһыылаах.<br>Бэйэтэ буоллаҕына миигин ойохтоноору,<br>Ый отут хонугар быһа муҥнаата.<br>Ону мин<br>Ааһар алып албаспынан,<br>Куотар үрүт кубулҕаппынан<br>Отут атыыр оҕус <span class="description" id="1467">үөл</span> тириитин<br>Отут хонукка куустардым,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5970
                    </td>
                    <td>
                        Бу отут үөл тириини
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5971
                    </td>
                    <td>
                        Отут хонукка кини ойохтонно,<br><span class="description" id="1468">Ньаассын</span> курдук<br>Имиллэн хаалыар диэри ойохтонно,<br>Бу гынан баран<br>Килэгир тимир истиэнэтигэр<br>Сэбин-сэбиргэлин<br>Оттотунан булгу көтөн кээспит,<br>Дьахтарга туттар сэбэ<br>Бу киһи гиэнэ суох буолбут ээ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5980
                    </td>
                    <td>
                        Ол наадатынан<br>«Сэп-сэбиргэл оҥотторо бардым», — диэн<br>Бэҕэһээ барбыта,<br>Ол барарыгар тыл этэ-этэ барбыт:<br>«<span class="description" id="1469">Курбуҥмуттан</span> куустаттарыам,<br>Биэс болгуонан бэйэлэтиэм,<br>Сэттэ болгуонан сэлээппэ оҥотторуом,<br><span class="description" id="1470">Хорҕолдьунунан</span> куолайдатыам,<br>Аны үс хонон баран<br>Халлааны сырдата <span class="description" id="1471">татыйык</span> чыычаахпар,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        5990
                    </td>
                    <td>
                        Күммүн таһаарар күөрэгэйбэр<br>Көстө кэлиэм буоллаҕа» — диэбитэ.<br>Маны хайдах гыныахха сөбүй диэн<br>Икки айыы дьоно сүбэлэспиттэр.<br>Дьахтар этэр эбит:<br>Хайа астахха<br>Хаан тахсыбат киһитэ буолуо,<br>Дьөлө астахха<br><span class="description" id="1472">Симэһин</span> сүүрбэт киһитэ буолуо,<br>Арай эн буолуох этиҥ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6000
                    </td>
                    <td>
                        Мин баҕа санаабар,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6001
                    </td>
                    <td>
                        Устата үөмэр үс саһааннаах,<br>Үс өттүнэн кырыылаах<br>Үрүҥ көмүс <span class="description" id="1473">үөрбэ</span> буолан<br>Оһох эҥээригэр<br>Сыстан туран көрөөр эрэ,<br>Аны икки хонон баран кэлиэҕэ<br>Эн тураргын билиэҕэ, — диир.<br>Биһи киһибит<br><span class="description" id="1474">Үҥкүрүс-күөлэһис</span> гына түстэ —
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6010
                    </td>
                    <td>
                        Уһуна үс саһааннаах,<br>Үс өттүнэн кырыылаах<br>Үрүҥ көмүс үөрбэ буолан<br>Оһоххо сыстан саһан турда.<br>Бу туран иһиттэҕинэ,<br>Үөлэс үүтүн устун<br>Абааһы бухатыырын саҥатын дуораана бу иһэр:<br>— Дьэ буйака-буйака,<br>Үс <span class="description" id="1475">ини-бии</span> өлүү бичик,<br>Кытатай бахсы Кыыра-Даххан,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6020
                    </td>
                    <td>
                        Хара салгылла,<br>Өлүү-бүдьүк уустарыгар тиийэммин<br>Били <span class="description" id="1476">өлүүньньүк</span> сэппин оҥоттордум эбээт.<br>Күөттээни уус обургу<br>Күөттээн биэрдэ,<br>Кытатай бахсы<br>Кытардан биэрдэ,<br>Балтаанай уус<br><span class="description" id="1477">Балталаан</span> биэрдэ,<br>Нарын уус таптайда,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6030
                    </td>
                    <td>
                        Алыҥычаан уус аалла,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6031
                    </td>
                    <td>
                        Дьэ, күнү таһаарар күөрэгэйбэр<br>Халлааны сырдатар татыйыкпар,<br>Ырыалаах-тойуктаах чооруоһум оҕотугар,<br><span class="description" id="1478">Кылбардыыр</span> чыычаахпар иһэбин эбээт.<br>Үөрүүлээх-көтүүлээх,<br>Үчүгэй үтүө күнүм<br>Үөскээтэҕэ буолуо, — диэтэ.<br>Бу диэн баран кини обургу<br>Төһө да хачча да гыммата,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6040
                    </td>
                    <td>
                        Таллан куоҕас кыыл<br>Аҥаарыйар атыыр буура буолан<br>Үөлэһин үүтүнэн соҕотохто<br>Таҥнары куугунаан түстэ.<br>Ити киирэн:<br>«Күммүн таһаарар күөрэгэйиэм,<br>Халлааммын сырдатар саҥалаах<br>Татыйык чыычааҕыам,<br>Тураахтыыгын дуу, доҕоруом?»<br>Үс төгүл түҥнэри холоруктаата,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6050
                    </td>
                    <td>
                        Ити гынан баран<br>Уруккута-уруккутунан,<br>Бэйэтэ-бэйэтинэн киһи буолла.<br>Сирэйин хаба оттотугар баар<br>Улуу оҕус сыарҕатын курдук<br>Оҥойо сытыйбыт соҕотох <span class="description" id="1479">таныы</span> үүттээх,<br>Онон сытырҕалаан көрдө.<br>— Дьэ, күнү таһаарар күөрэгэйим,<br>Туох үчүгэй үтүө<br>Миньньигэс сыта кэлэр, доҕоруом,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6060
                    </td>
                    <td>
                        Дьэ, чыычааҕыам, куһаҕан битим
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6061
                    </td>
                    <td>
                        Тоҕо аҕай быһыта тыыттаҕай?<br>Дьахтар эттэ:<br>— Дьэ, күн дьүөгээм,<br>Көмүс доҕоруом,<br>Эйигиннээҕэр бэйэм бэккэ куттанан олоробун,<br>Эн обургу тимир быанан<br>Оттобунан бобо тардаҥҥын,<br>Килэгир тимир истиэнэҕэ<br>Кэлгиэлээх буоламмын куотуох киһи
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6070
                    </td>
                    <td>
                        Хаамыы устата халбарыйар<br>Баҕалаах буолан турар,<br><span class="description" id="1480">Уллуҥах</span> устата уларыйар<br>Улахан суол буолан турабын.<br>Кут бөҕөм<br>Куттахпар түһэн турар.<br>Эн барбытыҥ кэннэ<br>Биир хонон баран<br><span class="description" id="1481">Үөлэспит</span> үүтүнэн<br><span class="description" id="1482">Үөрбэ</span> кэлэн түспүтэ.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6080
                    </td>
                    <td>
                        Ол түһэн баран<br>Оһохпут эҥээригэр<br>Өйөнөн турар быһыылаах,<br>Ону бараҥҥын оттотуттан тутаҥҥын<br>Тоһута тэпсэрдии сорунар буолаайаҕын,<br>Доҕорум эрэ буолларгын,<br>Ийэбэр эппэтэх иһирэх тылбын,<br>Аҕабар эппэтэх амарах өспүн<br>Өйдөөн-дьүүллээн тур,<br>Сүбэтэ <span class="description" id="1483">сөксүйүөх</span>,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6090
                    </td>
                    <td>
                        Санаата саксыйыах.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6091
                    </td>
                    <td>
                        Санаабычча-өйдөөбүччэ хамсанабыт диэн<br>Бэйэбитин былдьатыахпыт,<br>Абааһы да улууһуттан кэлбитин<br>Бэйэм билбэккэ олоробун,<br>Үөһээ үлүгэрдээх да улууһуттан<br>Үөһэ <span class="description" id="1484">үлүһүйэн</span> түспүтүн<br>Кыайан өйдөөбөккө олоробун,<br>Аллараа алдьархайдаах да аймаҕыттан<br>Хамсаан халбарыйан тахсыбытын
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6100
                    </td>
                    <td>
                        Кыайан сыаналаабакка турабын,<br>Эн обургу,<br>Күн дьүөгэм,<br>Көмүс доҕорум,<br>Тэллэххэ сытар тэҥнээх кэргэним,<br>Хооньньоһо сытар холоонноох доҕорум,<br>Тараһабар таралыйар табаарыһым,<br>Үрдүбэр үҥкүрүйэр үөлээннээҕим буоллаҕыҥ,<br>Сүүс киһи сүбэтин<br>Сүбэлэһиэх эрэ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6110
                    </td>
                    <td>
                        Отут киһи соргутун<br>Соргулаһан көрүөх.<br>Бу кэдэрги кэлгийбит<br>Бөҕө тимир быаҕын<br>Кэлэҥҥин төлөрүтэн көр.<br>Мин, айыы киһитэ ааттаах киһи,<br>Күөгэйэр күн улууһа дьүһүннээх киһи<br>Кинини бараммын<br>Иһиллээн-чинчийэн көрүүм эрэ,<br>Сүрдээх кутталлаах, ынырыктаах сэп
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6120
                    </td>
                    <td>
                        Киирэн турар быһыылаах,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6121
                    </td>
                    <td>
                        Бэйэҕин быдьдьатыаҥ,<br>Бэккэ сэрэн эрэ, — диэтэ.<br>Ону истэн баран:<br>— Оо, айыым аймахтара,<br>Күнүм улуустара<br>Былыр-былыргыттан даҕаны<br>Бэт үтүө өйдөөх,<br>Бэт сайаҕас санаалаах буолаллар этэ.<br>Ол иһин ити сүбэлээтэҕэ-амалаатаҕа
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6130
                    </td>
                    <td>
                        Үчүгэйин-үтүөтүн баҕаһын!<br>Ити миигин өлөн-сүтэн хаалыа диэн,<br>Харыһыйан, сэрэн, диэхтиир ээ,<br>Оҕом отут хонукка хооньньоспутугар<br>Таптаабыт да эбит, оҕолоор, — диэтэ.<br>Ол гынан баран<br><span class="description" id="1485">Суодаҕыс</span> гынан тиийэн<br>Бөҕө тимир быатын<br>Быһыта тыытан кэлгиэтин сүөрэн кэбистэ,<br>Ити гынан баран:
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6140
                    </td>
                    <td>
                        — Кукаам, мин ханна туруомуй,<br>Сэрэн диэбитиҥ ээ,<br>Айыы аймаҕа киһи,<br>Эн өйдөөх киһи,<br>Дьэ-эрэ, баран иһиллээн көр эрэ,<br>Аллараттан ааттаан тахсыбыт<br>Баҕайы үөрбэ турар дуу,<br>Үөһэттэн түспүт үөрбэ дуу, — диэтэ.<br>Айыы дьахтара эттэ:<br>— Дьэ, күн дьүөгээм,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6150
                    </td>
                    <td>
                        Чинчийэн көрөн бараммын
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6151
                    </td>
                    <td>
                        Үөһэттэн түспүт буоллаҕына<br>Биири сүбэлиэҕим,<br>Алларааттан тахсыбыт буоллаҕына<br>Биири сүбэлиэҕим, — диэтэ.<br>Дьэ үөһэ-аллараа тутуталаан көрдө,<br>Бу гынан баран<br>Абааһытыгар туппутунан туран кэпсээтэ:<br>— Дьэ ыраах ыырдаах киһи кэлбит,<br>Туспа дойдулаах урааҥхай эбит,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6160
                    </td>
                    <td>
                        Киһиттэн да атын эбит,<br>Абааһыттан да атын эбит.<br><span class="description" id="1486">Киҥкиниир</span> киэҥ халлаан гиэнэ<br>Иҥсэлээх <span class="description" id="1487">дьалына</span> буолбут,<br>Үрдүк халлаан гиэнэ<br>Мүччүргэннээх үөрбэтэ буолбут<br>Үрүҥ көмүс үөрбэ эбит.<br>Маны алгыһын таба этэн<br>Үөһэ үрүт дьалыныгар<br>Өрө кыйдыахха сөптөөх
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6170
                    </td>
                    <td>
                        Үөрбэ эбит,<br>Онтон атыҥҥа тоһута тэпсибитиҥ да иннигэр<br>Быстар тыынын кыайан көрбөтүм.<br>Элбэх гыннахха<br>Элбэх үөрбэ буоссу.<br>Куотар халлаан гиэнэ<br>Кубулҕаттаах дьэллик дьиибэтэ<br>Бу буолар эбит.<br>Айыы киһитэ ааттаах киһи<br>Айылааҕын мин алҕаан көрүүм бастаан,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6180
                    </td>
                    <td>
                        Эн миигин үтүктэн көрөөр эрэ,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6181
                    </td>
                    <td>
                        Туох диирбин барытын — диэтэ.<br>Дьахтар үөрбэтин туппутунан<br><span class="description" id="1488">Холумтаныгар</span> өрө ыттан таҕыста.<br>Абааһытын: «Кэл эрэ бэттэх,<br>Мин аттыбар», — диэтэ.<br>Абааһы били холумтаныгар<br>Суодаҕыс гынан таҕыста.<br>Дьахтар: «Дьэ-буо», — диир,<br>Абааһы ону үтүктэн «Дьэ-буо» диэтэ.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6190
                    </td>
                    <td>
                        — Үрүҥ көмүс үөрбэ,<br>Өрөгөйдөөх үөрбэ,<br>Туос араҥалааҕынан,<br><span class="description" id="1489">Торҕо</span> сииктээҕинэн<br>Үөһээ дойдуга<br>Өрө көтөн тахсаҥҥын,<br>Ыраах сиринэн ыырданаҥҥын,<br>Тэйиччи сиринэн тэлэкэчий эрэ!<br>Ол тиийэн бараҥҥын<br>Тоҕус саһааннаах
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6200
                    </td>
                    <td>
                        Уот Хороллобуй ийэлээх<br>Тимир Хомурдуостай аҕалаах,<br>Уот дуксуй тумустаах,<br>Күөх <span class="description" id="1490">салахай</span> тыыннаах,<br>Кутаа уот <span class="description" id="1491">куорма</span> кутуруктаах,<br>Тоҕус тутум атахтаах<br>Тимир Нуорадьдьын бухатыыры<br>Эргийэр киинигэр<br>Төбөтүн оройо буоллаҕа диэҥҥин<br>Таҥнары өҥөйөн көрөөр эрэ.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6210
                    </td>
                    <td>
                        Маны абааһы уола
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6211
                    </td>
                    <td>
                        Барытын үтүктэн иһэр.<br>Ол гынан баран<br>Бэйэтэ эмиэ эттэ:<br>— Оот-татай, оҕолоор,<br>Хайдах-хайдах дойдунуй, доҕоор, — диэтэ.<br>Дьахтар:<br>— Үрүҥ сүньньүнэн,<br><span class="description" id="1492">Сүрдьүүлээх</span> сүрэҕинэн,<br>Хара быарынан,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6220
                    </td>
                    <td>
                        Чиккэйэн турар сиһин үөһүнэн<br>Эмэһэтин үүтүнэн<br>Курдаттыы сүүрэн түһүөхтүн,<br>Төһөлөөх хаччалаах буолуой, — диэн баран<br>Үөрбэтин абааһытыгар туттарда.<br>— Мэ эрэ, доҕоор, — диэтэ.<br>Абааһы сап гыннаран ылла.<br>— Кыайар-хотор киһи, маны эн бырах эрэ,<br>Дьэ үчүгэйдик «кыый» диэн бырах диэтэ.<br>Тимир Нуорадьдьын «кыый»- диэн баран
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6230
                    </td>
                    <td>
                        Үөлэс үүтүнэн<br>Өрө быраҕан кыыгынатта,<br>Үс күннүк сири<br>Өрө быраҕан таһаарда.<br>Бу бырахпытын гиэннэ,<br>Дьахтар эттэ:<br>— Били баҕайы сэп<br>Хайа диэкки халбарыйда,<br>Үөлэскэ төбөҕүн угаҥҥын<br>Көрөн хаал эрэ! — диэтэ
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6240
                    </td>
                    <td>
                        Онуоха үөлэһин үүтүнэн
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6241
                    </td>
                    <td>
                        Баһын батары биэрдэ,<br>Ол туран аҕыйахтык саҥара турда:<br>— Ким билэр, доҕоор,<br>Тоҕо эрэ үчүгэйдик астымматым,<br>Куһаҕан ханнык эрэ<br>Халы-мааргы тойугу<br>Туойдубут ээ, бадаҕа.<br>Иньньэ диэн баран<br>Көрө сатаан эрдэҕинэ,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6250
                    </td>
                    <td>
                        Үрүҥ көмүс үөрбэ<br>Үс күннүк сиртэн<br>Таҥнары түһэн кылыһыйан кэллэ,<br>Төбөтүн оройунан<br>Үрүҥ сүньньүн үүтүн устун<br>Сүрэҕин тобулу сүүрэн,<br>Хааннаах хара быарын хайа түһэн,<br>Чиккэйэн турар<br>Сиһин үөһүн быһа түһэн<br>Эмэһэтин үүтүнэн
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6260
                    </td>
                    <td>
                        Курдаттыы сүүрэн таҕыста.<br>Тиэрэ баран түстэ да,<br>Онно өлөн хаалла.<br>Айыы дьонноро<br>Хара тыыннарын харыйданнылар,<br>Үрүҥ тыыннарын өллөйдөннүлэр,<br>Үөрүү-көтүү буолла,<br>Хараҥа хаайыыттан халбарыйдылар,<br>Суон түрмэттэн төлөрүйдүлэр.<br>Үҥкүрүс гына түстүлэр,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6270
                    </td>
                    <td>
                        Таптайыы көмүс дабыдалланнылар,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6271
                    </td>
                    <td>
                        Кутуу көмүс хотоҕойдоннулар,<br>Мөһүүрэ көмүс түүлээх,<br><span class="description" id="1493">Өлбүргэлээх</span> үрүҥ көмүс өҥнөөх,<br><span class="description" id="1494">Тордохтоох</span> <span class="description" id="1495">хоҥоруулаах</span>,<br>Араҥас көмүс кутуруктаах,<br>Кылбайар кыһыл көмүс<br>Хобо чуораан <span class="description" id="1496">чымыдааллаах</span> <br>Аан дойдуларын диэкки айаннаан,<br>Аҕыс былас
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6280
                    </td>
                    <td>
                        Аалай солко суһуохтаах<br>Айталы Куо диэн дьахтар бастаата,<br>Тыллаах-өстөөх Хара Кулун аттаах<br>Сылгы уола Дыырай бухатыыр<br>Кэнники буолла.<br>Бу гынан баран<br>Абааһы сибиирин халлаана —<br><span class="description" id="1497">Күдэрик</span> хара халлааны,<br>Үрдүк өрөһөтүгэр<br>Өрө көтөн таҕыстылар,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6290
                    </td>
                    <td>
                        Абааһы сирин<br>Айыы сирин икки ардыгар<br>Үс нүрүс маҕан халлаан<br>Отто <span class="description" id="1498">туонатыгар</span>,<br>Соҕотохто таҥнары сурулаан түстүлэр,<br>Эмиэ да өрө көтөн тахсан истилэр,<br>Киҥкиниир киэҥ халлаан<br>Кэтит кирбиитин кэтэхтэринэн кэтиэлээтилэр,<br>Кынаттарын кыптыыйдаатылар,<br>Орулуос кус кынатын тыаһын курдук
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6300
                    </td>
                    <td>
                        «Куус» гына түстүлэр,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6301
                    </td>
                    <td>
                        Түүтээҕэр чэпчэкитик,<br>Охтооҕор түргэнник<br>Эмдэй-сэмдэй түсүһэн<br>Айаннаан истилэр.<br>Уу харахтаах утары көрбөтө,<br>Уон тыҥырахтаах утары ууммата,<br>Биэс тарбахтаах диэлийбэтэ,<br>Татаар тыллаах таба эппэтэ,<br><span class="description" id="1499">Мэҥийэр</span> бэлиэ бэлэстээх
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6310
                    </td>
                    <td>
                        Сытаан саҥарбата,<br>Саха киһи <span class="description" id="1500">арҕары</span> көрөн таһаарбат<br>Саппахтаах сатыы буурай халлааныгар<br>Өрө көтөн тэһийэн таҕыстылар.<br><span class="description" id="1501">Саппахтаах</span> сатыы буурай халлаан<br>Үрүт былытын үөһээ <span class="description" id="1502">тоһуутугар</span> <br>Өрө көтөн таҕыстылар.<br>Ити тахсаннар<br>Былыт үөһээ тоһуутун<br>Кэтэхтэринэн кэтиэлээн таҕыстылар,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6320
                    </td>
                    <td>
                        Кынаттарын кыптыыйдаан бараннар<br>Аҕыс иилээх-саҕалаах,<br>Атааннаах-мөҥүөннээх<br>Айгыр силик<br>Аан ийэ дойдубут эргийэр киинэ,<br><span class="description" id="1503">Туналыйар</span> ньуура<br>Дьокдьойор саала<br>Саманан буолаарай диэн,<br>Кынаттарын кытыыйдыы тутан баран,<br>Таҥнары куугунаан түстүлэр.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6330
                    </td>
                    <td>
                        Кытыыта биллибэт
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6331
                    </td>
                    <td>
                        Кыталык кыстыыр,<br>Кыырпах сыстыбат<br>Кыйдан маҕан кырдалларыгар<br>Тулата көстүбэт<br>Туруйа тохтуур,<br>Тобурах түспэтэх<br><span class="description" id="1504">Дьулагыр</span> маҕан хонуутугар,<br>Айыыһыт арбадьдьыйар<br>Араҕас маҥан хонуутугар,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6340
                    </td>
                    <td>
                        Иэйиэхсит иэнигийэр<br>Иччилээх <span class="description" id="1505">иэримэ</span> хонуутугар<br>Таҥнары <span class="description" id="1506">сурулаан</span> түһэн тохтоотулар.<br>Аҕыс салаалаах Аал Дууп Мастарыгар<br>Өрө хааман таҕыстылар.<br>Ити тахсан тураннар<br><span class="description" id="1507">Сыппай сиэллээх</span> сылгы сүөһүттэн<br>Аҕыс <span class="description" id="1508">сүүмэх</span> кылы ыллылар,<br>Дьахтар киһи күнү утары<br>Эргийэ хааман кэлэн ыллаата:
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6350
                    </td>
                    <td>
                        — Дьиэ-буо!<br>Аҕыс иилээх-саҕалаах,<br>Атааннаах-мөҥүөннээх<br><span class="description" id="1509">Айгыр силик</span> <br>Амыл-намыл алааһым иччитэ<br>Кэлэн эриллэр маһа,<br>Ийэ хара тиитэ,<br>Айыыһыта кэлэн аалынар маһа<br>Аҕыс салаалаах<br>Аал Дууп Мас иччитэ буолбут,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6360
                    </td>
                    <td>
                        Оһуор ойуу хоруол
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6361
                    </td>
                    <td>
                        Аҥаарыйар Аан Эскэл<br>Айхал Мичик эмээхсин эбэкэм,<br>Ким хайа кэллиҥ диэтэргин,<br>Үрүҥ Эриэн тойон оҕоньньор аҕалаах,<br>Эбириэччин баай эмээхсин ийэлээх,<br>Аҕыс былас аалай солко суһуохтаах<br>Айталы Куо диэн дьахтар дьаалы киһи<br>Аат ааттааммын,<br>Ат мииньньэммин
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6370
                    </td>
                    <td>
                        Дьуон <span class="description" id="1510">дьаҕадыйан</span> кэлэн турабын.<br>Ол кэлэммин<br>Киһи буолар кэскил,<br>Саха буолар соргу,<br>Сүөһү буолар төлкө<br>Буолаарай диэммин<br><span class="description" id="1511">Ситии</span> баайан эрэбин,<br>Сиэл ыйаан эрэбин.<br>Мин туспар<br>Илин бырааныҥ иэйиэхсит буоллун,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6380
                    </td>
                    <td>
                        Арҕаа бырааныҥ айыыһыт буоллун.<br>Тыал түспэт<br>Сылаас быттыккар кыбытан көр,<br>Холорук тохтообот<br>Дьоллоох хонноххор <span class="description" id="1512">хорҕотон</span> көр!<br>Аас маҕан сиэли <span class="description" id="1513">хоодьдьугар</span> баайбыт<br>Ыһыах хамыйаҕа<br><span class="description" id="1514">Эбир дьаҕыл</span> хамыйаҕынан*<br>Ас биэрэн эрэбин.<br>«Чуох!» — диэн баран
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6390
                    </td>
                    <td>
                        Араҕас илгэни өрө ыһан биэрдэ.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6391
                    </td>
                    <td>
                        Ити кэлэн көй кииннэригэр<br>Көмүс уйаларыгар,<br>Алтан дьаакыр халҕаннарыгар,<br>Модурууннаах модун хаан<br>Боруоктарын атыллаатылар.<br>Хардаҕас маһы<br>Хайыта-тырыта сыстылар.<br>Араллааннаах аан күҥкүй оһохторун<br>Үөһээ хабарҕатыгар дылы
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6400
                    </td>
                    <td>
                        Уоту оттон тигинэтэн кэбистилэр.<br>Таҥалайдаах ыаҕайаҕа<br>Маҕан биэни барылаччы ыатылар,<br>Кугас биэни куугуначчы ыатылар,<br>Ийэ биэни этэттээн ыллылар,<br>Улаан сылгыны уйгулаан ыллылар,<br>Сириэһиннээх сири иһиккэ<br>Күөгүлээх күөмэйи олортулар,<br>Синьньэлээх биһээйэҕинэн лиһийдилэр,<br>Кэрэмэс ойуулаах кэриэн ымыйаҕа,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6410
                    </td>
                    <td>
                        Оһуор ойуулаах чороон айахха куттулар,<br>Мандар ойуулаах матаарчахха бааралаатылар.<br>Дьахтар киһи томторҕолоох<br>Чороон ымыйатын мараччы көтөхтө,<br>Сиэл <span class="description" id="1515">дэлбиргэлээх</span> <br>Эбир хамыйаҕы туора тутта,<br>Оттоку туһааннаах тойон өһүөтүн анныгар<br>Тобуктаан олордо,<br>Аҥаар атаҕын сиртэн үктэннэ,<br>Аҥаар атаҕын тобуктаан олордо,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6420
                    </td>
                    <td>
                        Сиэл дэлбиргэлээх
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6421
                    </td>
                    <td>
                        Эбир дьаҕыл хамыйаҕын<br>Чороонун айаҕар туора уурда,<br>Үс төгүл бокулуон уурда уонна<br>Бу курдук ырыалаах-тойуктаах буола олордо:<br>— Дьэ-буо!<br>Үүт дьөһүөл аартыктаах<br>Аас маҕан сылгы сиэллээх кутуругун<br>Арыйа баттаабыт курдук<br>Маҕан <span class="description" id="1516">дьаралык</span> аартыктаах,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6430
                    </td>
                    <td>
                        Чороон дьуолкалаах,<br><span class="description" id="1517">Кэриэн</span> эккээйилээх,<br>Хаан дьаралык атыырдаах,<br>Сэйбэри маҕан биэлээх,<br>Кугас кулун кумаардаах,<br><span class="description" id="1518">Саалыр</span> кулун сахсырҕалаах,<br>Эриэн кулун тигээччилээх,<br><span class="description" id="1519">Күрэҥ</span> кулун күүгэстээх.<br>Сиргэмтэҕинэн сиэдэрэйдээн,<br>Хаҥылынан ханыылаан,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6440
                    </td>
                    <td>
                        Элэмэһинэн эгэлгэлээн,<br>Кугас сылгынан булкуурдаан,<br>Уйгулаах орто дойдуга<br>Сылгы-сүөһү кутун-сүрүн<br>Орто дойдуга уруйдаан биэрээччи<br>Түүлээх түһүлгэ,<br>Араҕас далбарга<br>Уордаах Дьөһөгөй тойон эһэбит,<br>Албан ааккын ааттаан,<br>Дьоһун сураххын сураан,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6450
                    </td>
                    <td>
                        Эн тускуҥ диэн
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6451
                    </td>
                    <td>
                        Кэнники төрүүр кэнчээри ыччат<br>Кэччэрийбэккэ олорон<br>Маннык кэскили тэрийдиннэр диэммин<br>Кэскил кэбиһэ олоробун!<br>Итигирдик диэн үс төгүл улаханнык уруйдаата.<br>Эбир дьаҕыл хамыйаҕынан<br>Оттоку тойон өһүө баһыгар<br>Өрө ыһан биэрдэ.<br>Ити гынан баран
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6460
                    </td>
                    <td>
                        Эргиллэн <span class="description" id="1520">дьанысханнаах</span> аан иннигэр<br>Бокулуон ууран сүгүрүйэн олордо.<br>Эмиэ туспа ыллаан барда:<br>— Дьиэ-буо!<br>Сытар ынах саҕа<br>Сымара таас <span class="description" id="1521">модьоҕом</span> иччитэ,<br>Хаардаах бугул от саҕа саҕаһалаах,<br>Хара тый быарын саҕа хататтаах,<br><span class="description" id="1522">Эскэл</span> тый быарын саҕа эстэриилээх,<br>Көмөрөөньньүк тэллэхтээх,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6470
                    </td>
                    <td>
                        Күүркэньньик суорҕаннаах,<br><span class="description" id="1523">Көмөр</span> сыттыктаах,<br>Күннүк усталаах үрүҥ <span class="description" id="1524">күдэн</span> тыыннаах,<br>Сэттэ быластаах кыһыл кыым кымньыылаах,<br>Харыс сото<br>Хаччы бытык,<br>Аҥаарыйар Аан-Уххан<br>Тойон оҕоньньор эһэккэм, аһаа-сиэ! — диэтэ.<br>Үс сиргэ арыылаах кымыһы кутан биэрдэ,<br>Ити кэнниттэн:
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6480
                    </td>
                    <td>
                        — Иэримэ дьиэ иччитэ,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6481
                    </td>
                    <td>
                        Иэрэли-Бахсы,<br>Баарыма балаҕан иччитэ,<br>Баараҕай-Бахсы, аһаа-сиэ!<br>Эмиэ уокка биир сиргэ ас кутан биэрдэ.<br>Ол кэнниттэн:<br>— Дириҥ далай иччитэ,<br>Тоҕус былас куойалаах,<br>Уон былас маҥкылаах,<br>Түөрт былас түөрэйдээх,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6490
                    </td>
                    <td>
                        Муҥха ийэтэ тэллэхтээх,<br>Кыната суорҕаннаах,<br>Ситим баттыыр торуоскалаах,<br><span class="description" id="1525">Үтүмэх</span> дьөллүргэлээх<br>Сүҥкэ далай иччитэ<br>Хотун ийэкэм, аһаа-сиэ! — диэтэ.<br>Уокка эмиэ биир сиргэ ас кутан биэрдэ.<br>Ол кэнниттэн:<br>— Баай хара тыа баһаардаах,<br><span class="description" id="1526">Куруҥ</span> хара тыа куораттаах,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6500
                    </td>
                    <td>
                        Кыһыл саһыл кымньыылаах,<br>Күөх тииҥ көтөллөөх,<br>Хара улар <span class="description" id="1527">сарбыньньахтаах</span>,<br>Эрдэҕэс улар <span class="description" id="1528">илбиргэстээх</span>,<br>Курупааскы көтөр <span class="description" id="1529">туоһахталаах</span>,<br>Бочугурас куортуктаах,<br>Кырынаас бытырыыстаах<br>Баай хара тыам иччитэ,<br>Баай Барыылаах тойон эһэм, аһаа-сиэ! — диэтэ.<br>Уокка ас кутан биэрдэ эмиэ.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6510
                    </td>
                    <td>
                        Ол кэнниттэн:
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6511
                    </td>
                    <td>
                        — Элбэрээхсит эмээхсин,<br><span class="description" id="1530">Осхордьут</span> уол,<br><span class="description" id="1531">Тыҥкырайдьыт</span> кыыс,<br>Кыланыкы-часкыйдаан аһааҥ-сиэҥ! — диэн баран<br>Эмиэ уокка ас кутта.<br>Ити гынан<br><span class="description" id="1532">Саамал</span> кымыһынан санааларын тарҕаттылар,<br><span class="description" id="1533">Көйүү</span> кымыһынан көхсүлэрин көньньүөртүлэр,<br>Халыҥ хаһанан хаччы кэбистилэр,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6520
                    </td>
                    <td>
                        Суон саалынан <span class="description" id="1534">суомас</span> уурдулар,<br>Дьоһун мүһэнэн <span class="description" id="1535">мохсуо</span> бырахтылар.<br>Дьэ үөрүү-көтүү буолла.<br>Сылгы уола Дыырай:<br>— Улаатыгар, оҕолоор, — диир.<br>Бу үөһээ дойду<br><span class="description" id="1536">Үлүскэннээх</span> үс бииһин ууһун<br>Нөрүөн көссөн көрдүм да,<br>Өлбөтүм-сүппэтим,<br>Аллараа аҕыс бииһин ууһун
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6530
                    </td>
                    <td>
                        Ааттаахтарын кытары эмиэ<br>Хассыһан көрдүм да эмиэ,<br>Өлбөтүм-сүппэтим, доҕор,<br>Итиэннэ кэлбэтэхтэринэ,<br>Үчүгэйдик олордорбун<br>Киһи буолар кэскил диэн<br>Тэринэн көрүөм этэ,<br>Саха буолар салааһын диэн<br>Салаллан көрүөххэ сөп диэн этэ.<br>Айыы бухатыырдарын
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6540
                    </td>
                    <td>
                        Ааттаахтарын кытары эмиэ
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6541
                    </td>
                    <td>
                        <span class="description" id="1537">Адарайдаһан</span> көрөн сылдьыбытым.<br>Үс саханы үөскэтэр<br>Төлкөлөөх киһи буоллаҕым дуу,<br>Биэс саханы бииһэтэр<br>Кэскиллээх киһи буоллаҕым,<br>Аҕыс саханы аҥаарытар<br>Аналлаах буоллаҕым дуу,<br>Тоҕус саханы туругурдар<br><span class="description" id="1538">Одун</span> хаантан оҥоһуулаах киһи буоллаҕым, — диэн.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6550
                    </td>
                    <td>
                        Халааньньы хаама сырытта.<br>Итинтэн көрбүтэ —<br>Кэмнээх кэрэ маҕан күнэ<br>Ситэн тиийэн кэлбит,<br>Киэһэ буолан хаалла.<br>Бичиктээх <span class="description" id="1539">биллириктэригэр</span> киирэннэр,<br>Синьньэлээх <span class="description" id="1540">дьэрэксээн</span> тэллэхтэрин<br>Тэлгэтэн кэбистилэр,<br><span class="description" id="1541">Чыҥырҕастаах</span> сыттыктарын<br>Сыттыы баттаатылар,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6560
                    </td>
                    <td>
                        Аллараа таҥаһы арадьдьыта тэптилэр,<br>Отто таҥаһы уларытан бардылар,<br>Үөһээ таҥаһы үрэйэн-сарайан кэбистилэр.<br>Дуобаттаах суорҕаны саба тардыннылар,<br>Уураспыттарын үөһэ уураһар дьон буоллулар,<br>Сылласпыттарын үөһэ сыллаһан бардылар,<br>Тарбахтара диэн таптаһан барда,<br>Уостара диэн <span class="description" id="1542">оҕорҕоһон</span> барда.<br>Эр киһи буоллаҕына<br>Аттаныах буутун атыллыы охсон таҕыста,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6570
                    </td>
                    <td>
                        Кымньыылыах буутун кыпсытан ылла.
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6571
                    </td>
                    <td>
                        Дьахтар үрдүгэр<br>Тоҕус мастаах хойуук оҥочону<br>Умсары бырахпыт курдук<br>Дьим-бааччы баттыы түстэ.<br>Кулун бөҕөлүү тэбиэлээтэ,<br><span class="description" id="1543">Куомньалык</span> бөҕөлүү мөҥүстэ,<br>Бэдьэҥ-бэдьэҥ сиэлэ ооньньуу сытта,<br>Лэп-лэп эккирээтэ,<br>Үс түүннээх күнү мэлдьи
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6580
                    </td>
                    <td>
                        Уурайбакка-тохтообокко<br>Үлэ-хамнас бөҕө буолла.<br>Ол кэнниттэн<br><span class="description" id="1544">Адарай</span> орон тулуйбата,<br>Алдьанан барда,<br>Туорай бөҕө тулуйбата<br>Тоһута тэбинэн бардылар,<br>Баһык-уһук диэн баранан барда,<br>Тэбик-уһук диэн кээһэнэн барда,<br>Истиэнэ бөҕө <span class="description" id="1545">иҥнэстэн</span> бараары гынна.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6590
                    </td>
                    <td>
                        Бухатыыр киһи баҕайы<br>Уохтаах-күүстээх үлэлээх киһи эбит,<br>Түннүккэ тиийэ тахха-тахха,<br>Түһэ-түһэ түһүтэлээн барда.<br>Субу тыаһыттан хотоннооҕу<br>Ынах сүөһү үргэн бардылар,<br>Быаларын быһыта тыытан ыллылар,<br>Харсыһыы, айдаан буолла,<br>Орулаһыы-сарылаһыы буолла,<br>Онтон кыыһыраннар
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6600
                    </td>
                    <td>
                        Улахан дуолан атыыр оҕустар
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6601
                    </td>
                    <td>
                        Күүстээх модьу быаларын<br>Тис-тас гына быһыта тыытан ыллылар,<br>Хассыспытынан бардылар.<br>Улахан атыыр оҕустар<br>Харсыһыылара баҕайы манна кэлэн<br>Тамыйаҕы хампы үктээн кэбистилэр,<br><span class="description" id="1546">Тамыйах</span> сарылаата, иннэ кэлэн<br>Тиҥэһэни дэлби үктээтилэр —<br><span class="description" id="1547">Тиҥэһэ</span> орулаата,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6610
                    </td>
                    <td>
                        Тыһаҕас сүөһүнү быһыта тэпсэн бардылар.<br>Хотон иһигэр<br>Курулуур кумах буолан барда,<br>Барча бадараан үөскээтэ,<br>Атыыр оҕус атыыр оҕуһу туоратта,<br>Туораабыт оҕус<br>Хотон <span class="description" id="1548">холлоҕоһун</span> тосту көттө,<br>Таһырдьа ыстанна.<br>Бу тахсыбыт хайаҕаһынан<br>Сүөһү барыта даҕаны
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6620
                    </td>
                    <td>
                        Таһырдьа ой да ой буолла,<br>Таһырдьа ыстан да ыстан буолла.<br>Бу сүөһү орулаһыытыттан<br>Сүөһү сиргэнэ-сиргэнэлэр,<br>Ынах ынаҕы муоһугар түһэрэн истэ,<br>Оҕус оҕуһу муоһугар түһэрэн барда.<br>Аан дойдуга биир гына<br>Аймалҕан бөҕө үөскээтэ.<br>Мантан сиргэнэн<br>Сыһыыга баар сылгы сүөһүлэр
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6630
                    </td>
                    <td>
                        <span class="description" id="1549">Таныыларын</span> тыаһа киэҥ халлаан,
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6631
                    </td>
                    <td>
                        Эмэһэлэрин тыаһа кэтит <span class="description" id="1550">үтүгэн</span>,<br>Хара тыаҕа сыссан таҕыстылар,<br><span class="description" id="1551">Өрөһөтүн</span> хайа көтөн<br>Умсарыта баран өлүтэлээн истилэр.<br>Сорох сылгы чөҥөчөккө<br>Үтүрү түһэн өллө,<br>Сорох сылгы <span class="description" id="1552">арыҥах</span> маска<br>Хантаччы ыйанан хаалла.<br>Хара тыа барча бадараан буолла.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6640
                    </td>
                    <td>
                        Хара тыа маҕан куобахтара<br>Сылгыттан үргэннэр<br><span class="description" id="1553">Сыһыыга</span> сыссан киирдилэр.<br>Ити дьоннор ити кэнниттэн<br>Тохтоотулар, уоскуйдулар,<br>Эр киһи тураары гынан көрдө,<br>Арай дьахтар кытта өндөйөн таххыталыыр.<br>Оттон: «Хайдаҕый бу?» — диэн<br>Дьахтар тураары гынан көрдө,<br>Эр киһи кытта <span class="description" id="1554">сыһаҕастаһан</span> кэллэ.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6650
                    </td>
                    <td>
                        Арахсыспакка хам сыстыһан хаалбыттар.<br>«Хайтах буоллахпытый?» — диэн,<br>Өйдөтөлөөн көрдүлэр.<br>Ол көрбүттэрэ:<br>Икки киһи <span class="description" id="1555">өрөҕөтө</span> бастаан<br>Иккиэн холбуу сиикэй баас<br>Буолан хаалбыт эбит.<br>Ол кэнниттэн хам оһон хаалбыт эбит.<br>Иккиэн утарыта биир киһи буола<br>Хам сыстыһан хаалбыттар.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6660
                    </td>
                    <td>
                        Маны кэлэннэр
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`, 
`<html>
    <head>
        <meta name="viewport" content="width=650">
        <script type="text/javascript">
            document.addEventListener("DOMContentLoaded", () => {
                var descriptions = document.getElementsByClassName("description");
                if (descriptions != undefined && descriptions.length > 0) 
                {
                    for (var i = 0; i < descriptions.length; i++) 
                    {
                        descriptions[i].addEventListener("click", function () {
                            SendMessage(this.id);
                        });
                        var sub = document.createElement('sup');
                        sub.innerHTML = "<small>" + descriptions[i].id + "</small>";
                        descriptions[i].parentNode.insertBefore(sub, descriptions[i].nextSibling);
                    }
                }
            });

            function SendMessage(id)
            {
                if (window.ReactNativeWebView == null) {
                    window.parent.postMessage(id);
                }
                else {
                    window.ReactNativeWebView.postMessage(id);
                }
            }
        </script>
        <style>
            .description 
            {
                font-weight: bold;
            }
        </style>
    </head>
    <body>
        <div style="margin: auto; width: 630px; border: 1px solid black;">
            <table style="font-family: 'Times New Roman'; font-size: 14pt; padding-left: 40px; padding-top: 50px; padding-bottom: 50px;">
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6661
                    </td>
                    <td>
                        Онтон-мантан сыдьдьаннар<br>Эмээхсин дьахталлар көрдүлэр.<br>Маны бу эмээхситтэр<br>Ынах ыан аҕала-аҕала ыскайдаатылар,<br>Сылгыны ыан аҕала-аҕала ыскайдаатылар.<br>Ол ыскайдыы-ыскайдыы<br>Хайаларын да тириитэ<br>Хайаларыгар да барбат гына<br>Сытыы быһаҕынан сүлэ сырыттылар.
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6670
                    </td>
                    <td>
                        Үрүҥ көмүс <span class="description" id="1556">төһүүнэн</span> <br><span class="description" id="1557">Үҥкүрүтэ</span> сыдьдьан сүллүлэр.<br>Сүлэн сүлэннэр<br><span class="description" id="1558">Сэлиэнэй</span> чааскы айаҕын саҕаны<br>Истэрин ортотугар ордордулар.<br>Бу хаалбытын кэннэ<br>Бу дьон ойута тыытыһан араҕыстылар.<br>Онтукалара киһи киинэ буолан<br>Оҥоччу оһон хаалла...<br>Дьэ үс саха үөскээн барбыта онтон,
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6680
                    </td>
                    <td>
                        Биэс саха диэн бииһээбитэ,<br>Сэттэ саха ситэн,<br>Аҕыс саха аҥаарыйан,<br>Тоҕус саха туругуран,<br>Дьол-соргу олбохтонон,<br>Айхал-мичил аргыстанан<br>Күн бүгүнүгэр дылы
                    </td>
                </tr>
                <tr>
                    <td style="vertical-align: top; width: 50px;">
                        6687
                    </td>
                    <td>
                        Үөскээн-төрөөн олороллоро эбитэ үһү!
                    </td>
                </tr>
            </table>
        </div>
    </body>
</html>`
]